import React, { useRef, useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FilterListAltIcon from "@mui/icons-material/FilterListAlt";
import TableViewIcon from "@mui/icons-material/TableView";
import { FilterButton } from "../SXStyle.jsx";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import FormatColorResetIcon from "@mui/icons-material/FormatColorReset";

import FormGroup from "@mui/material/FormGroup";
import DateTimePicker from "./DateTimePicker.js";
import Checkbox from "./Checkbox.js";
import BaseSvg from "./BaseSvg.js";
import TooltipComponent from "./TooltipComponent.js";
import TooltipPComponent from "./TooltipPComponent.js";
import TooltipOPComponent from "./TooltipOPComponent.js";
import TooltipGComponent from "./TooltipGComponent.js";
import TableComponent from "./TableComponent.js";

import {
  fechaAExcelNumero,
  convierteMinusculas,
  quitarCeros,
  valoresInicialesNiveles,
  valoresInicialesPiramides,
  valoresInicialesGruas,
  valoresInicialesOP,
} from "../functions/functions.js";
import { today, getLocalTimeZone, parseDate } from "@internationalized/date";

import "./style.css";

function Svg2Component({ datosExcel }) {
  const svgRef = useRef(null);

  //niveles del diagrama
  const [colors, setColors] = useState(valoresInicialesNiveles());

  const [pyramidColors, setPyramidColors] = useState(valoresInicialesPiramides());

  const [gruasColors, setGruasColors] = useState(valoresInicialesGruas());

  const [opColors, setOPColors] = useState(valoresInicialesOP());

  //filtros
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState({

    areaTodas: false,
    areaEPO: false,
    areaINT: false,
    areaMDL: false,
    areaMHS: false,
    areaMLminus: false,
    areaML_: false,
    areaMLL: false,
    areaMLU: false,
    areaMLU: false,
    areaMML: false,
    areaNIV: false,
    areaSTA: false,
    areaSTO: false,

    materialTodas: false,
    materialIncremental: false,
    materialMineral: false,
    materialSubincremental: false,
    materialTepetate: false,

    movimientoTodas: false,
    movimientoTumbado: false,
    movimientoProduccion: false,
    movimientoTepetate: false,
    movimientoRemanejo: false,
    movimientoAlimentacion: false,
    movimientoMHS: false,
    movimientoBanda: false,

    desarrolloTodas: false,
    desarrolloVertical: false,
    desarrolloLateral: false,
    desarrolloDesborde: false,
    desarrolloDescabece: false,
    desarrolloDespate: false,
    desarrolloEncapille: false,
    desarrolloMHS: false,
    desarrolloBL: false,
  });

  //filtros de fecha 
  const [filtrosSeleccionadosFechas, setFiltrosSeleccionadosFecha] = useState({
    fecha: null,
    fechaInicio: null,
    fechaFinal: null,
    strfechaInicio: "",
    strfechaFinal: "",
  })

  //activa la vista del modulo de filtros disponibles
  const [filtroVisible, setFiltroVisible] = useState(false);

  //activa la vista de la tabla dado las cifras seleccionadas
  const [tablaVisible, setTablaVisible] = useState(false);
  const [iconoTabla, setIconoTabla] = useState(true);

  //contiene los datos ya filtrados por fecha-material-zona y por nivel (resultado ya final)
  const [datosProcesados, setDatosProcesados] = useState([]);

  const [datosProcesadosExcel, setDatosProcesadosExcel] = useState([]);

  //cifras de los registros seleccionados
  const [cifrasSeleccionadas, setCifrasSeleccionadas] = useState([]);

  const [indeterminateArea, setIndeterminateArea] = useState(false);
  const [indeterminateMateriales, setIndeterminateMateriales] = useState(false);
  const [indeterminateMovimiento, setIndeterminateMovimiento] = useState(false);
  const [indeterminateDesarrollo, setIndeterminateDesarrollo] = useState(false);

  //aplica zoom
  const [scale, setScale] = useState(0.95);
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState(null);

  const zoomStep = 0.2;
  const maxZoom = 4;
  const minZoom = 0.95;

  //efecto de loading
  const [openLoader, setOpenLoader] = useState(true);

  /* Cambia el color de cada seccion al dar clic
    #eaeaea = color gris
    #99D9EA = color verde  
  */
  const handleColor = (name) => {
    setColors((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        color:
          prev[name].color === prev[name].originalColor
            ? "#248f7a"
            : prev[name].originalColor, //cambia el color del rectangulo bordeado
        stroke: prev[name].stroke === undefined ? "#2b2b2b" : undefined, //cambia el color a negritas del label
        strokeWidth: prev[name].strokeWidth === undefined ? "0.3" : undefined,
      },
    }));
  };

  /* Cambia el color de cada piramide al dar clic */
  const handlePyramidColor = (name) => {
    setPyramidColors((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        color_1:
          prev[name].color_1 === prev[name].original_1
            ? "#00A2E8" //fuerte
            : prev[name].original_1,
        color_2:
          prev[name].color_2 === prev[name].original_2
            ? "#99D9EA" //palido
            : prev[name].original_2,
      },
    }));
  };

  /* 
  Cambia el color de los OP */
  const handleOPColor = (name) => {
    setOPColors((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        color:
          prev[name].color === prev[name].original
            ? "#00a2e8"
            : prev[name].original,
      },
    }));
  };

  /* Cambia el color de las gruas al dar clic*/
  const handGruasColor = (name) => {
    setGruasColors((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        color:
          prev[name].color === prev[name].original
            ? "#00A2E8"
            : prev[name].original,
      },
    }));
  };

  /* Funciones para hacer zoom in y zoom out*/
  const handleZoomIn = () => {
    setScale((prev) => Math.min(prev + zoomStep, maxZoom));
  };

  const handleZoomOut = () => {
    const newScale = Math.max(scale - zoomStep, minZoom);
    setScale(newScale);
    if (newScale === 0.95) {
      setTranslate({ x: 0, y: 0 }); // resetea la posición si vuelve a zoom 1
    }
  };

  //llena los valores por default para los filtros (dia de hoy)
  function llenarValoresPorDefault() {
    
    return {
      areaTodas: false,
      areaEPO: false,
      areaINT: false,
      areaMDL: false,
      areaMHS: false,
      areaMLminus: false,
      areaML_: false,
      areaMLL: false,
      areaMLU: false,
      areaMLU: false,
      areaMML: false,
      areaNIV: false,
      areaSTA: false,
      areaSTO: false,

      materialTodas: false,
      materialIncremental: false,
      materialMineral: false,
      materialSubincremental: false,
      materialTepetate: false,

      movimientoTodas: false,
      movimientoTumbado: false,
      movimientoProduccion: false,
      movimientoTepetate: false,
      movimientoRemanejo: false,
      movimientoAlimentacion: false,
      movimientoMHS: false,
      movimientoBanda: false,

      desarrolloTodas: false,
      desarrolloVertical: false,
      desarrolloLateral: false,
      desarrolloDesborde: false,
      desarrolloDescabece: false,
      desarrolloDespate: false,
      desarrolloEncapille: false,
      desarrolloMHS: false,
      desarrolloBL: false,
    };
  }

  function llenarValoresFechaDefault () {
    //const fechaDeseada = today(getLocalTimeZone());
    const fechaDeseada = parseDate("2025-10-03");

    const dia = fechaDeseada.day;
    const mes = fechaDeseada.month;
    const anio = fechaDeseada.year;

    const fecha = {
      start: fechaDeseada,
      end: fechaDeseada,
    };

    const excelDate = fechaAExcelNumero(anio, mes, dia);
    const strFecha = `${dia}/${mes}/${anio}`;

    return {
      fecha,
      fechaInicio: excelDate,
      fechaFinal: excelDate,
      strfechaInicio: strFecha,
      strfechaFinal: strFecha,
    };
  }

  //llena los valores por default para los filtros 
  function limpiarFiltrosSeleccionados() {
    return {
      areaTodas: false,
      areaEPO: false,
      areaINT: false,
      areaMDL: false,
      areaMHS: false,
      areaMLminus: false,
      areaML_: false,
      areaMLL: false,
      areaMLU: false,
      areaMLU: false,
      areaMML: false,
      areaNIV: false,
      areaSTA: false,
      areaSTO: false,

      materialTodas: false,
      materialIncremental: false,
      materialMineral: false,
      materialSubincremental: false,
      materialTepetate: false,

      movimientoTodas: false,
      movimientoTumbado: false,
      movimientoProduccion: false,
      movimientoTepetate: false,
      movimientoRemanejo: false,
      movimientoAlimentacion: false,
      movimientoMHS: false,
      movimientoBanda: false,

      desarrolloTodas: false,
      desarrolloVertical: false,
      desarrolloLateral: false,
      desarrolloDesborde: false,
      desarrolloDescabece: false,
      desarrolloDespate: false,
      desarrolloEncapille: false,
      desarrolloMHS: false,
      desarrolloBL: false,
    };
  }

  const areaKeys = [
    "areaEPO",
    "areaINT",
    "areaMDL",
    "areaMHS",
    "areaMLminus",
    "areaML_",
    "areaMLL",
    "areaMLU",
    "areaMML",
    "areaNIV",
    "areaSTA",
    "areaSTO",
  ];

  const materialKeys = [
    "materialIncremental",
    "materialMineral",
    "materialSubincremental",
    "materialTepetate",
  ];

  const movimientoKeys = [
    "movimientoTumbado",
    "movimientoProduccion",
    "movimientoTepetate",
    "movimientoRemanejo",
    "movimientoAlimentacion",
    "movimientoMHS",
    "movimientoBanda",
  ];

  const desarrolloKeys = [
    "desarrolloTodas",
    "desarrolloVertical",
    "desarrolloLateral",
    "desarrolloDesborde",
    "desarrolloDescabece",
    "desarrolloDespate",
    "desarrolloEncapille",
    "desarrolloMHS",
    "desarrolloBL",
  ];

  //llena los valores por default
  useEffect(() => {
    if (datosExcel.length > 0) {

      //llena a la fecha actual de los filtros seleccionados
      setFiltrosSeleccionadosFecha(llenarValoresFechaDefault());

      setFiltrosSeleccionados(llenarValoresPorDefault());

      setOpenLoader(false); //oculta el loader
    }
  }, [datosExcel]);


  //filtra la informacion en base a fechas y pinta checkbox, ops, destinos
  useEffect(() => {
    if (datosExcel.length === 0) return;
    if (!filtrosSeleccionadosFechas || Object.keys(filtrosSeleccionadosFechas).length === 0)
      return;

    //reinicia datos procesados
    setDatosProcesados([]);

    // Reinicia colores al estado inicial
    setColors(valoresInicialesNiveles());

    //1- filtra por fecha
    const fechaInicio = filtrosSeleccionadosFechas.fechaInicio;
    const fechaFinal = filtrosSeleccionadosFechas.fechaFinal;

    const datosxFechaExcel = datosExcel.filter((row) => {
      const fechaExcel = row[2];

      const fechasFiltradas =
        fechaInicio == null ||
        fechaFinal == null ||
        (fechaExcel >= fechaInicio && fechaExcel <= fechaFinal);

      return fechasFiltradas;
    });

    //2- En base al filtrado de fechas devuelve los catalogos con informacion
    let areas = [];
    let materiales = [];
    let movimientos = [];
    let desarrollos = [];

    //filtros seleccionados
    let filtrosArea = [];
    let filtrosMaterial = [];
    let filtrosMovimiento = [];
    let filtrosDesarrollo = [];

    datosxFechaExcel.forEach((row, index) => {
      const area = row[5];
      const tipoMaterial = row[14];
      const tipoMovimiento = row[4];
      const tipoDesarrollo = row[6];

      areas.push(area);
      materiales.push(tipoMaterial);
      movimientos.push(tipoMovimiento);
      desarrollos.push(tipoDesarrollo);
    });

    //catalogos unicos en base al filtro de fechas
    areas = [...new Set(areas)];
    materiales = [...new Set(materiales)];
    movimientos = [...new Set(movimientos)];
    desarrollos = [...new Set(desarrollos)];

    // Crear un objeto temporal para acumular los cambios
    let filtrosSeleccionadosTemp = {...limpiarFiltrosSeleccionados() };
   
    // ----------- areas -------------
    areas.forEach((item, index) => {
      if (item === "EPO") {
        filtrosSeleccionadosTemp.areaEPO = true;
        filtrosArea.push("EPO");
      }
      if (item === "INT") {
        filtrosSeleccionadosTemp.areaINT = true;
        filtrosArea.push("INT");
      }
      if (item === "MDL") {
        filtrosSeleccionadosTemp.areaMDL = true;
        filtrosArea.push("MDL");
      }
      if (item === "MHS") {
        filtrosSeleccionadosTemp.areaMHS = true;
        filtrosArea.push("MHS");
      }
      if (item === "ML-") {
        filtrosSeleccionadosTemp.areaMLminus = true;
        filtrosArea.push("ML-");
      }
      if (item === "MLL") {
        filtrosSeleccionadosTemp.areaMLL = true;
        filtrosArea.push("MLL");
      }
      if (item === "MLU") {
        filtrosSeleccionadosTemp.areaMLU = true;
        filtrosArea.push("MLU");
      }
      if (item === "MML") {
        filtrosSeleccionadosTemp.areaMML = true;
        filtrosArea.push("MML");
      }
      if (item === "NIV") {
        filtrosSeleccionadosTemp.areaNIV = true;
        filtrosArea.push("NIV");
      }
      if (item === "STA") {
        filtrosSeleccionadosTemp.areaSTA = true;
        filtrosArea.push("STA");
      }
      if (item === "STO") {
        filtrosSeleccionadosTemp.areaSTO = true;
        filtrosArea.push("STO");
      }
    });

    // si hay alguna area en false
    const algunAreaEnFalse = areaKeys.some(
      (key) => filtrosSeleccionados[key] === false
    );
    algunAreaEnFalse ? setIndeterminateArea(true) : setIndeterminateArea(false);

    // ----------- materiales -------------
    materiales.forEach((item, index) => {
      if (item === "INCREMENTAL") {
        filtrosSeleccionadosTemp.materialIncremental = true;
        filtrosMaterial.push("INCREMENTAL");
      }
      if (item === "MINERAL") {
        filtrosSeleccionadosTemp.materialMineral = true;
        filtrosMaterial.push("MINERAL");
      }
      if (item === "SUBINCREMENTAL") {
        filtrosSeleccionadosTemp.materialSubincremental = true;
        filtrosMaterial.push("SUBINCREMENTAL");
      }
      if (item === "TEPETATE") {
        filtrosSeleccionadosTemp.materialTepetate = true;
        filtrosMaterial.push("TEPETATE");
      }
    });

    // si hay algun material en false
    const algunMaterialFalse = materialKeys.some(
      (key) => filtrosSeleccionados[key] === false
    );
    algunMaterialFalse
      ? setIndeterminateMateriales(true)
      : setIndeterminateMateriales(false);

    // ----------- movimientos -------------
    movimientos.forEach((item, index) => {
      if (item === "01_MINERAL_TUMBADO") {
        filtrosSeleccionadosTemp.movimientoTumbado = true;
        filtrosMovimiento.push("01_MINERAL_TUMBADO");
      }
      if (item === "02_PRODUCCION") {
        filtrosSeleccionadosTemp.movimientoProduccion = true;
        filtrosMovimiento.push("02_PRODUCCION");
      }
      if (item === "03_PRODUCCION_TEPETATE") {
        filtrosSeleccionadosTemp.movimientoTepetate = true;
        filtrosMovimiento.push("03_PRODUCCION_TEPETATE");
      }
      if (item === "04_REMANEJO") {
        filtrosSeleccionadosTemp.movimientoRemanejo = true;
        filtrosMovimiento.push("04_REMANEJO");
      }
      if (item === "05_ALIMENTACION") {
        filtrosSeleccionadosTemp.movimientoAlimentacion = true;
        filtrosMovimiento.push("05_ALIMENTACION");
      }
      if (item === "06_ENTRADA A MHS") {
        filtrosSeleccionadosTemp.movimientoMHS = true;
        filtrosMovimiento.push("06_ENTRADA A MHS");
      }
      if (item === "06_MOVIMIENTO BANDA") {
        filtrosSeleccionadosTemp.movimientoBanda = true;
        filtrosMovimiento.push("06_MOVIMIENTO BANDA");
      }
    });

    // si hay algun movimiento en false
    const algunMovimientoFalse = movimientoKeys.some(
      (key) => filtrosSeleccionados[key] === false
    );
    algunMovimientoFalse
      ? setIndeterminateMovimiento(true)
      : setIndeterminateMovimiento(false);

    // ----------- desarrollos -------------
    desarrollos.forEach((item, index) => {
      if (item === "DESARROLLO VERTICAL") {
        filtrosSeleccionadosTemp.desarrolloVertical = true;
        filtrosDesarrollo.push("DESARROLLO VERTICAL");
      }
      if (item === "DESARROLLO LATERAL") {
        filtrosSeleccionadosTemp.desarrolloLateral = true;
        filtrosDesarrollo.push("DESARROLLO LATERAL");
      }
      if (item === "DESBORDE") {
        filtrosSeleccionadosTemp.desarrolloDesborde = true;
        filtrosDesarrollo.push("DESBORDE");
      }
      if (item === "DESCABECE") {
        filtrosSeleccionadosTemp.desarrolloDescabece = true;
        filtrosDesarrollo.push("DESCABECE");
      }
      if (item === "DESPATE") {
        filtrosSeleccionadosTemp.desarrolloDespate = true;
        filtrosDesarrollo.push("DESPATE");
      }
      if (item === "ENCAPILLE") {
        filtrosSeleccionadosTemp.desarrolloEncapille = true;
        filtrosDesarrollo.push("ENCAPILLE");
      }
      if (item === "MHS") {
        filtrosSeleccionadosTemp.desarrolloMHS = true;
        filtrosDesarrollo.push("MHS");
      }
      if (item === "PRODUCCION BL") {
        filtrosSeleccionadosTemp.desarrolloBL = true;
        filtrosDesarrollo.push("PRODUCCION BL");
      }
    });

    // si hay algun desarrollo en false
    const algunDesarrolloFalse = desarrolloKeys.some(
      (key) => filtrosSeleccionados[key] === false
    );
    algunDesarrolloFalse
      ? setIndeterminateDesarrollo(true)
      : setIndeterminateDesarrollo(false);

    // 3. Filtra los datos según los filtros de los catalogos
    const resultDatosFiltrados = datosxFechaExcel.filter((row) => {
      const area = row[5];
      const tipoMaterial = row[14]; //
      const tipoMovimiento = row[4];
      const tipoDesarrollo = row[6];

      const areasFiltradas =
        filtrosArea.length === 0 || filtrosArea.includes(area) || !area;

      const materialesFiltrados =
        filtrosMaterial.length === 0 || filtrosMaterial.includes(tipoMaterial) || !tipoMaterial;

      const movimientoFiltrados =
        filtrosMovimiento.length === 0 || filtrosMovimiento.includes(tipoMovimiento) || !tipoMovimiento;

      const desarrolloFiltrados =
        filtrosDesarrollo.length === 0 || filtrosDesarrollo.includes(tipoDesarrollo) || !tipoDesarrollo;
      
      return (
        areasFiltradas &&
        materialesFiltrados &&
        movimientoFiltrados &&
        desarrolloFiltrados
      );
    });


    // 4. Detecta niveles válidos y únicos (de los colores que tenemos disponibles y el excel devuelto)

    /*Nota: 
      Origen_ es 7  seria ahora 48
      destino_ es 10  seria ahora 49
    */
    const nuevosNiveles = [];
    resultDatosFiltrados.forEach((item) => {
     
      if (
        item[48] &&
        item[48] !== "#¡VALOR!" &&
        item[49] &&
        item[49] !== "#¡VALOR!"
      ) {
        const nivel = item[49];
        let numero = item[48];

        //filtra en base al excel
        const yaExiste = nuevosNiveles.some(
          (n) => n.nivel === nivel && n.numero === numero
        );

        if (!yaExiste) {
          nuevosNiveles.push({ nivel, numero });
        }
      }
    });

    // 5. Agrupa por nivel y número
    const datosAgrupados = nuevosNiveles.map((item) => {
      const data = resultDatosFiltrados.filter(
        (row) => row[48] === item.numero && row[49] === item.nivel
      );
      return {
        numero: item.numero,
        nivel: item.nivel,
        data: data,
      };
    });

    // 5.5 Agrupa estos por solo nivel:
    const nivelesEspeciales = [
      "SUP_TPO_1800",
      "ML-01",
      "ML-02",
      "ML-04",
      "ML-05",
      "MLL_ETC_0684_01", 
      "STACKER 01",
      "STACKER 02",
    ];

    const nivelesEspecialesRB = ["RB1", "RB2", "RB3", "RB4", "RB5", "QUEBRADORA A100"];

    // Mapea todos los niveles especiales a su objeto agrupado
    const objetosEspeciales = nivelesEspeciales.map((nivel) =>
      agrupaPorNivel(nivel, datosAgrupados)
    );
    
    const objectosEspecialesRB = nivelesEspecialesRB.map((nivel) =>
      agrupaPorRBNivel(nivel, datosAgrupados)
    );

    //  agrupados normales y luego los especiales:
    const normales = datosAgrupados.filter(
      (obj) =>
        !nivelesEspeciales.includes(obj.nivel) &&
        !nivelesEspecialesRB.includes(obj.nivel)
    );

    // 5.6 Agrupa ahora los OP
    const filtrado_op7 = datosAgrupados.filter((obj) => obj.nivel === "OP7");

    // Mezcla sus arreglos de data en uno solo (reduce + concatena)
    const data_op7 = filtrado_op7.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );

    //Agrupa el objeto
    const objecto_op7 = {
      nivel: "0P7",
      numero: "0P7",
      data: data_op7,
    };

    //
    const filtrado_op8 = datosAgrupados.filter((obj) => obj.nivel === "OP8");

    // Mezcla sus arreglos de data en uno solo (reduce + concatena)
    const data_op8 = filtrado_op8.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );

    //Agrupa el objeto
    const objecto_op8 = {
      nivel: "0P8",
      numero: "0P8",
      data: data_op8,
    };

    const finalDatosAgrupados = [
      ...normales,
      ...objetosEspeciales,
      ...objectosEspecialesRB,
      objecto_op7,
      objecto_op8,
    ];

    // 6. Colorea los niveles con datos
    const nuevosColores = { ...valoresInicialesNiveles() };
    normales.forEach((item) => {
      const key = `rect_${convierteMinusculas(item.nivel)}_${quitarCeros(
        item.numero
      )}`;
      nuevosColores[key] = {
        ...nuevosColores[key],
        color: "#248f7a",
      };
    });

    //6.1 Colorea los niveles piramides
    const nuevosColoresPiramides = { ...valoresInicialesPiramides() };

    objetosEspeciales.forEach((item) => {
      if (item.data.length > 0) {
        nuevosColoresPiramides[item.clave] = {
          ...nuevosColoresPiramides[item.clave],
          color_1: "#00A2E8",
          color_2: "#99D9EA",
        };
      }
    });

    //6.2 colorea las gruas
    const nuevosColoresGruas = { ...valoresInicialesGruas() };
    objectosEspecialesRB.forEach((item) => {
      if (item.data.length > 0) {

        if(item.nivel === "QUEBRADORA A100")
        {
          nuevosColoresGruas["GENERADORA100"] = {
            ...nuevosColoresGruas["GENERADORA100"],
            color: "#00A2E8",
          };
        }
        else
        {
          nuevosColoresGruas[item.nivel] = {
            ...nuevosColoresGruas[item.nivel],
            color: "#00A2E8",
          };
        }
      }
    });

    //6.4 colorea los ops
  
    let opsColors = {};

    if (objecto_op8.data.length > 0) {
      opsColors = {
        ...opsColors,
        OP8: {
          nivel: "0P8",
          numero: "0P8",
          color: "#00a2e8",
          original: "#cb9636"
        }
      };
    }
    else
    {
      opsColors = {
        ...opsColors,
        OP8: {
          nivel: "0P8",
          numero: "0P8",
          color: "#cb9636",
          original: "#cb9636"
        }
      };
    }

    if (objecto_op7.data.length > 0) {
      opsColors = {
        ...opsColors,
        OP7: {
          nivel: "0P7",
          numero: "0P7",
          color: "#00a2e8",
          original: "#cb9636"
        }
      };
    }
    else
    {
      opsColors = {
        ...opsColors,
        OP7: {
          nivel: "0P8",
          numero: "0P8",
          color: "#cb9636",
          original: "#cb9636"
        }
      };
    }

    setDatosProcesadosExcel(datosxFechaExcel);
    setDatosProcesados(finalDatosAgrupados);
    setColors(nuevosColores);
    setOPColors(opsColors);
    setPyramidColors(nuevosColoresPiramides);
    setGruasColors(nuevosColoresGruas);
    
    //agrega una solo actualizacion al final de los filtros seleccionados
    setFiltrosSeleccionados(filtrosSeleccionadosTemp);

  }, [filtrosSeleccionadosFechas.fecha]);


  //filtra la informacion de los catalogos
  useEffect(() => {
    
    if (datosProcesadosExcel.length === 0) return;
    if (!filtrosSeleccionados || Object.keys(filtrosSeleccionados).length === 0)
      return;

    //reinicia datos procesados
    setDatosProcesados([]);

    // Reinicia colores al estado inicial
    setColors(valoresInicialesNiveles());

    // 1. Extrae filtros seleccionados
    let filtrosArea = [];
    let filtrosMaterial = [];
    let filtrosMovimiento = [];
    let filtrosDesarrollo = [];

    //zona
    if (filtrosSeleccionados.areaEPO) filtrosArea.push("EPO");
    if (filtrosSeleccionados.areaINT) filtrosArea.push("INT");
    if (filtrosSeleccionados.areaMDL) filtrosArea.push("MDL");
    if (filtrosSeleccionados.areaMHS) filtrosArea.push("MHS");
    if (filtrosSeleccionados.areaMLminus) filtrosArea.push("ML-");
    if (filtrosSeleccionados.areaMLL) filtrosArea.push("MLL");
    if (filtrosSeleccionados.areaMLU) filtrosArea.push("MLU");
    if (filtrosSeleccionados.areaMML) filtrosArea.push("MML");
    if (filtrosSeleccionados.areaNIV) filtrosArea.push("NIV");
    if (filtrosSeleccionados.areaSTA) filtrosArea.push("STA");
    if (filtrosSeleccionados.areaSTO) filtrosArea.push("STO");

    //material
    if (filtrosSeleccionados.materialIncremental) filtrosMaterial.push("INCREMENTAL");
    if (filtrosSeleccionados.materialMineral) filtrosMaterial.push("MINERAL");
    if (filtrosSeleccionados.materialSubincremental) filtrosMaterial.push("SUBINCREMENTAL");
    if (filtrosSeleccionados.materialTepetate) filtrosMaterial.push("TEPETATE");

    //movimiento
    if (filtrosSeleccionados.movimientoTumbado) filtrosMovimiento.push("01_MINERAL_TUMBADO");
    if (filtrosSeleccionados.movimientoProduccion) filtrosMovimiento.push("02_PRODUCCION");
    if (filtrosSeleccionados.movimientoTepetate) filtrosMovimiento.push("03_PRODUCCION_TEPETATE");
    if (filtrosSeleccionados.movimientoRemanejo) filtrosMovimiento.push("04_REMANEJO");
    if (filtrosSeleccionados.movimientoAlimentacion) filtrosMovimiento.push("05_ALIMENTACION");
    if (filtrosSeleccionados.movimientoMHS) filtrosMovimiento.push("06_ENTRADA A MHS");
    if (filtrosSeleccionados.movimientoBanda) filtrosMovimiento.push("06_MOVIMIENTO BANDA");

   
    //desarrollo
    if (filtrosSeleccionados.desarrolloVertical) filtrosDesarrollo.push("DESARROLLO VERTICAL");
    if (filtrosSeleccionados.desarrolloLateral) filtrosDesarrollo.push("DESARROLLO LATERAL");
    if (filtrosSeleccionados.desarrolloDesborde) filtrosDesarrollo.push("DESBORDE");
    if (filtrosSeleccionados.desarrolloDescabece) filtrosDesarrollo.push("DESCABECE");
    if (filtrosSeleccionados.desarrolloDespate) filtrosDesarrollo.push("DESPATE");
    if (filtrosSeleccionados.desarrolloEncapille) filtrosDesarrollo.push("ENCAPILLE");
    if (filtrosSeleccionados.desarrolloMHS) filtrosDesarrollo.push("MHS");
    if (filtrosSeleccionados.desarrolloBL) filtrosDesarrollo.push("PRODUCCION BL");

    
    // 2. Filtra los datos según los filtros
    const resultDatosFiltrados = datosProcesadosExcel.filter((row) => {
      const area = row[5];
      const tipoMaterial = row[14]; //
      const tipoMovimiento = row[4];
      const tipoDesarrollo = row[6];
     
      const areasFiltradas =
        filtrosArea.length === 0 || filtrosArea.includes(area) || !area;

      const materialesFiltrados =
        filtrosMaterial.length === 0 || filtrosMaterial.includes(tipoMaterial) || !tipoMaterial;

      const movimientoFiltrados =
        filtrosMovimiento.length === 0 || filtrosMovimiento.includes(tipoMovimiento) || !tipoMovimiento;

      const desarrolloFiltrados =
        filtrosDesarrollo.length === 0 || filtrosDesarrollo.includes(tipoDesarrollo) || !tipoDesarrollo;

      return (
        areasFiltradas &&
        materialesFiltrados &&
        movimientoFiltrados &&
        desarrolloFiltrados
      );
    });

    // 3. Detecta niveles válidos y únicos (de los colores que tenemos disponibles y el excel devuelto)

    //origen_ es 7  seria ahora 48
    //destino_ es 10  seria ahora 49
    const nuevosNiveles = [];
    resultDatosFiltrados.forEach((item) => {
      if (
        item[48] &&
        item[48] !== "#¡VALOR!" &&
        item[49] &&
        item[49] !== "#¡VALOR!"
      ) {
        const nivel = item[49];
        let numero = item[48];

        //filtra en base al excel
        const yaExiste = nuevosNiveles.some(
          (n) => n.nivel === nivel && n.numero === numero
        );

        if (!yaExiste) {
          nuevosNiveles.push({ nivel, numero });
        }
      }
    });

    // 4. Agrupa por nivel y número
    const datosAgrupados = nuevosNiveles.map((item) => {
      const data = resultDatosFiltrados.filter(
        (row) => row[48] === item.numero && row[49] === item.nivel
      );
      return {
        numero: item.numero,
        nivel: item.nivel,
        data: data,
      };
    });

    // 4.5 Agrupa estos por solo nivel:
    const nivelesEspeciales = [
      "SUP_TPO_1800",
      "ML-01",
      "ML-02",
      "ML-04",
      "ML-05",
      "MLL_ETC_0684_01",
      "STACKER 01",
      "STACKER 02",
    ];

    const nivelesEspecialesRB = ["RB1", "RB2", "RB3", "RB4", "RB5", "QUEBRADORA A100"];

    // Mapea todos los niveles especiales a su objeto agrupado
    const objetosEspeciales = nivelesEspeciales.map((nivel) =>
      agrupaPorNivel(nivel, datosAgrupados)
    );

    const objectosEspecialesRB = nivelesEspecialesRB.map((nivel) =>
      agrupaPorRBNivel(nivel, datosAgrupados)
    );

    //  agrupados normales y luego los especiales:
    const normales = datosAgrupados.filter(
      (obj) =>
        !nivelesEspeciales.includes(obj.nivel) &&
        !nivelesEspecialesRB.includes(obj.nivel)
    );

    // 4.6 Agrupa ahora los OP
    const filtrado_op7 = datosAgrupados.filter((obj) => obj.nivel === "OP7");

    // Mezcla sus arreglos de data en uno solo (reduce + concatena)
    const data_op7 = filtrado_op7.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );

    //Agrupa el objeto
    const objecto_op7 = {
      nivel: "0P7",
      numero: "0P7",
      data: data_op7,
    };

    //
    const filtrado_op8 = datosAgrupados.filter((obj) => obj.nivel === "OP8");

    // Mezcla sus arreglos de data en uno solo (reduce + concatena)
    const data_op8 = filtrado_op8.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );

    //Agrupa el objeto
    const objecto_op8 = {
      nivel: "0P8",
      numero: "0P8",
      data: data_op8,
    };

    const finalDatosAgrupados = [
      ...normales,
      ...objetosEspeciales,
      ...objectosEspecialesRB,
      objecto_op7,
      objecto_op8,
    ];

    // 5. Colorea los niveles con datos
    const nuevosColores = { ...valoresInicialesNiveles() };
    normales.forEach((item) => {
      const key = `rect_${convierteMinusculas(item.nivel)}_${quitarCeros(
        item.numero
      )}`;
      nuevosColores[key] = {
        ...nuevosColores[key],
        color: "#248f7a",
      };
    });

    //5.1 Colorea los niveles piramides
    const nuevosColoresPiramides = { ...valoresInicialesPiramides() };

    objetosEspeciales.forEach((item) => {
      if (item.data.length > 0) {
        nuevosColoresPiramides[item.clave] = {
          ...nuevosColoresPiramides[item.clave],
          color_1: "#00A2E8",
          color_2: "#99D9EA",
        };
      }
    });

    //5.2 colorea las gruas
    const nuevosColoresGruas = { ...valoresInicialesGruas() };
    objectosEspecialesRB.forEach((item) => {
      if (item.data.length > 0) {

        if(item.nivel === "QUEBRADORA A100")
        {
          nuevosColoresGruas["GENERADORA100"] = {
            ...nuevosColoresGruas["GENERADORA100"],
            color: "#00A2E8",
          };
        }
        else
        {
          nuevosColoresGruas[item.nivel] = {
            ...nuevosColoresGruas[item.nivel],
            color: "#00A2E8",
          };
        }
      }
    });

    
    // 5.3 colorea los ops

    let opsColors = {};

    if (objecto_op8.data.length > 0) {
      opsColors = {
        ...opsColors,
        OP8: {
          nivel: "0P8",
          numero: "0P8",
          color: "#00a2e8",
          original: "#cb9636"
        }
      };
    }
    else
    {
      opsColors = {
        ...opsColors,
        OP8: {
          nivel: "0P8",
          numero: "0P8",
          color: "#cb9636",
          original: "#cb9636"
        }
      };
    }

    if (objecto_op7.data.length > 0) {
      opsColors = {
        ...opsColors,
        OP7: {
          nivel: "0P7",
          numero: "0P7",
          color: "#00a2e8",
          original: "#cb9636"
        }
      };
    }
    else
    {
      opsColors = {
        ...opsColors,
        OP7: {
          nivel: "0P8",
          numero: "0P8",
          color: "#cb9636",
          original: "#cb9636"
        }
      };
    }

    setDatosProcesados(finalDatosAgrupados);
    setColors(nuevosColores);
    setPyramidColors(nuevosColoresPiramides);
    setGruasColors(nuevosColoresGruas);
    setOPColors(opsColors);

  }, [filtrosSeleccionados]);


  // Función utilitaria para agrupar por nivel
  function agrupaPorNivel(nivel, datosAgrupados) {
    const filtrados = datosAgrupados.filter((obj) => obj.nivel === nivel);
    const dataUnida = filtrados.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );
    return {
      nivel: nivel,
      clave: obtenerClaveEnBaseNivelP(nivel),
      numero: "StockPiles ",
      data: dataUnida,
    };
  }

  function obtenerClaveEnBaseNivelP(nivel) {
    const mapaNiveles = {
      "SUP_TPO_1800": "SUP_TP0",
      "STACKER 01": "STK_01",
      "STACKER 02": "STK_02",
      "MLL_ETC_0684_01": "MLL_ETC_0684_01",
      "ML-01": "ML_01",
      "ML-02": "ML_02",
      "ML-04": "ML_04",
      "ML-05": "ML_05",
    };
    return mapaNiveles[nivel] || null;
  }

  function agrupaPorRBNivel(nivel, datosAgrupados) {
    const filtrados = datosAgrupados.filter((obj) => obj.nivel === nivel);
    const dataUnida = filtrados.reduce(
      (acc, curr) => acc.concat(curr.data),
      []
    );
    return {
      nivel: nivel,
      numero: "RockBraker ",
      data: dataUnida,
    };
  }

 
  //obtiene las cifras generales
  useEffect(() => {
    let arrayCifras = [];
    if (datosProcesados?.length > 0) {
      //calcula cifras generales
      datosProcesados.forEach((item) => {
        let _numero = item.numero;
        let _nivel = item.nivel;

        //variables de cifras generales
        let totalToneladas = 0;
        let sumAuEq_Gr_t = 0; //AuEq Gr/t
        let sumAu_Gr_t = 0; // Au Gr/t
        let sumCu_pct = 0; // Cu%
        let sumFe_pct = 0; //fe%

        item.data.forEach((registro) => {
          const toneladas = Number(registro[13]) || 0;
          const auEq_Gr_t = Number(registro[17]) || 0;
          totalToneladas += toneladas;

          sumAu_Gr_t += toneladas * Number(registro[18]) || 0; //='Au * tons'/Toneladas
          sumCu_pct += toneladas * (Number(registro[21]) || 0); //='Cu% * tons '/Toneladas
          sumAuEq_Gr_t += toneladas * auEq_Gr_t; //='AuEq * tons'/Toneladas
          sumFe_pct += toneladas * (Number(registro[22]) || 0);
        });

        const dividir = (total) =>
          totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";

        arrayCifras.push({
          numero: _numero,
          nivel: _nivel,
          sumTonelada: totalToneladas.toFixed(2),
          AuEq_Gr_t: dividir(sumAuEq_Gr_t),
          Au_Gr_t: dividir(sumAu_Gr_t),
          Cu_pct: dividir(sumCu_pct),
          Fe_pct: dividir(sumFe_pct),
        });
      });

    } //fin del if

    setCifrasSeleccionadas(arrayCifras);
  }, [datosProcesados]);

  //para ver el icono de la tabla
  useEffect(() => {
    if (filtroVisible) setIconoTabla(false);
    else setIconoTabla(true);
  }, [filtroVisible]);

  return (
    <div
      style={{ position: "relative" }}
      className="mt-2 p-2 w-full h-[calc(80vh)] mx-auto items-center bg-fondo_blanco"
    >
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Botones de zoom */}
      <div className="absolute flex-end flex flex-col gap-2 ">
        <IconButton onClick={handleZoomIn}>
          <AddCircleOutlineIcon className="text-gris" size="large" />
        </IconButton>

        <IconButton onClick={handleZoomOut} sx={{ marginTop: "-15px" }}>
          <RemoveCircleOutlineIcon className="text-gris" size="large" />
        </IconButton>
      </div>

      {/* Boton para filtrar */}
      <div className="absolute flex-end flex flex-col gap-2 right-0">
        <div className="flex">
          {/* Modulo de filtros */}
          {filtroVisible && (
            <div
              className="overflow-y-scroll overflow-x-hidden max-h-[400px] p-4 rounded-lg shadow-lg  bg-ceniza_light border-gray-600 mt-1 w-[300px] 
                transition-all duration-300 ease-out transform opacity-0 scale-95 animate-fadeIn"
              style={{ marginRight: "-36px" }}
            >
              {/* FECHA  */}
              <DateTimePicker
                filtrosSeleccionados={filtrosSeleccionadosFechas}
                setFiltrosSeleccionados={setFiltrosSeleccionadosFecha}
              />

              {/* Zona */}
              <FormGroup>
                <p className="flex items-center p-1 text-sm gap-x-2 mt-3 text-blanco font-semibold border-t border-b border-blanco shadow-inner">
                  Zona
                </p>
                <div className="flex flex-col h-[120px] overflow-y-scroll">
                  <div>
                    <Checkbox
                      label="TODAS"
                      name="areaTodas"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                      indeterminate={indeterminateArea}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="EPO"
                      name="areaEPO"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="INT"
                      name="areaINT"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MDL"
                      name="areaMDL"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MHS"
                      name="areaMHS"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="ML-"
                      name="areaMLminus"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MLL"
                      name="areaMLL"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MLU"
                      name="areaMLU"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MML"
                      name="areaMML"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="NIV"
                      name="areaNIV"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="STA"
                      name="areaSTA"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="STO"
                      name="areaSTO"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                </div>
              </FormGroup>

              {/* MATERIAL */}
              <FormGroup>
                <p className="flex items-center p-1 text-sm gap-x-2 mt-3 text-blanco font-semibold border-t border-b border-blanco shadow-inner">
                  Material
                </p>
                <div className="flex flex-col h-[120px] overflow-y-scroll">
                  <div>
                    <Checkbox
                      label="TODAS"
                      name="materialTodas"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                      indeterminate={indeterminateMateriales}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="INCREMENTAL"
                      name="materialIncremental"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MINERAL"
                      name="materialMineral"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>

                  <div>
                    <Checkbox
                      label="SUBINCREMENTAL"
                      name="materialSubincremental"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>

                  <div>
                    <Checkbox
                      label="TEPETATE"
                      name="materialTepetate"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                </div>
              </FormGroup>

              {/* MOVIMIENTO */}
              <FormGroup>
                <p className="flex items-center p-1 text-sm gap-x-2 mt-3 text-blanco font-semibold border-t border-b border-blanco shadow-inner">
                  Movimiento
                </p>
                <div className="flex flex-col h-[120px] overflow-y-scroll">
                  <div>
                    <Checkbox
                      label="TODAS"
                      name="movimientoTodas"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                      indeterminate={indeterminateMovimiento}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="01_MINERAL_TUMBADO"
                      name="movimientoTumbado"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="02_PRODUCCION"
                      name="movimientoProduccion"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="03_PRODUCCION_TEPETATE"
                      name="movimientoTepetate"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="04_REMANEJO"
                      name="movimientoRemanejo"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="05_ALIMENTACION"
                      name="movimientoAlimentacion"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="06_ENTRADA A MHS"
                      name="movimientoMHS"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="06_MOVIMIENTO BANDA"
                      name="movimientoBanda"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                </div>
              </FormGroup>

              {/* DESARROLLO */}
              <FormGroup>
                <p className="flex items-center p-1 text-sm gap-x-2 mt-3 text-blanco font-semibold border-t border-b border-blanco shadow-inner">
                  Desarrollo
                </p>
                <div className="flex flex-col h-[120px] overflow-y-scroll">
                  <div>
                    <Checkbox
                      label="TODAS"
                      name="desarrolloTodas"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                      indeterminate={indeterminateDesarrollo}
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="DESARRLLO VERTICAL"
                      name="desarrolloVertical"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="DESARROLLO LATERAL"
                      name="desarrolloLateral"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="DESBORDE"
                      name="desarrolloDesborde"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="DESCABECE"
                      name="desarrolloDescabece"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="DESPATE"
                      name="desarrolloDespate"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="ENCAPILLE"
                      name="desarrolloEncapille"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                  <div>
                    <Checkbox
                      label="MHS"
                      name="desarrolloMHS"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>

                  <div>
                    <Checkbox
                      label="PRODUCCION BL"
                      name="desarrolloBL"
                      filtrosSeleccionados={filtrosSeleccionados}
                      setFiltrosSeleccionados={setFiltrosSeleccionados}
                     
                    />
                  </div>
                </div>
              </FormGroup>

              <IconButton
                onClick={() => {
                  setColors(valoresInicialesNiveles);
                }}
                size="small"
                sx={{ ...FilterButton, ml: "90%" }}
              >
                <FormatColorResetIcon className="text-gris " size="large" />
              </IconButton>
            </div>
          )}

          <div>
            <IconButton
              onClick={() => (
                setFiltroVisible(!filtroVisible), setTablaVisible(false)
              )}
              size="small"
              sx={FilterButton}
            >
              <FilterListAltIcon className="text-gris" size="large" />
            </IconButton>
          </div>
        </div>
      </div>

      {/* Boton para ver cifras de tablas */}
      {iconoTabla && (
        <div className="absolute flex-end flex flex-col gap-2 right-0 mt-[100px]">
          <div className="flex">
            {/* Modulo de filtros */}
            {tablaVisible && (
              <div className="max-h-[250px] overflow-y-auto">
                <TableComponent cifrasSeleccionadas={cifrasSeleccionadas} />
              </div>
            )}

            <div>
              <IconButton
                onClick={() => (
                  setTablaVisible(!tablaVisible), setFiltroVisible(false)
                )}
                size="small"
                sx={FilterButton}
              >
                <TableViewIcon className="text-gris" size="large" />
              </IconButton>
            </div>
          </div>
        </div>
      )}

      {/* SVG */}
      <BaseSvg
        svgRef={svgRef}
        scale={scale}
        setScale={setScale}
        translate={translate}
        setTranslate={setTranslate}
        dragStart={dragStart}
        setDragStart={setDragStart}
      >
        <g
          transform={`translate(${translate.x}, ${translate.y}) scale(${scale})`}
        >
          <g id="_ORE_BIN" fill="#ebb24b" data-name="% ORE BIN">
            <path d="M315.5 459.1h11.2v6.9h-11.2zM284.1 459.1h11.2v6.9h-11.2z"></path>
          </g>
          <g
            id="ORE_BIN"
            fill="none"
            stroke="#5e7076"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.69"
            data-name="ORE BIN"
          >
            <path d="M284.1 453.5V466l3.5 6.8M295.3 453.5V466l-3.5 6.8M315.5 453.5V466l3.6 6.8M326.7 453.5V466l-3.5 6.8"></path>
          </g>
          <g id="CONVEYOR">
            <circle cx="137.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="142.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="147.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="152.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="157.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="162.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="167.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="172.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="177.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="182.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="187.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="192.9" cy="445.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="197.7" cy="444.2" r="0.8" fill="#5e7076"></circle>
            <circle cx="202.5" cy="442.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="206.8" cy="441.6" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="m208.8 442.7-19.1 5.4h-52.9a1.58 1.58 0 0 1-1.6-1.6 1.58 1.58 0 0 1 1.6-1.6h52.5l18.6-5.2a1.57 1.57 0 0 1 2 1.2 1.49 1.49 0 0 1-1.1 1.8Z"
            ></path>
            <circle cx="208" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="213" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="218" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="222.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="227.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="232.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="237.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="242.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="247.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="252.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="257.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="262.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="267.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="272.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="277.5" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="282.5" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="M283.6 448.1H207a1.58 1.58 0 0 1-1.6-1.6 1.58 1.58 0 0 1 1.6-1.6h76.6a1.58 1.58 0 0 1 1.6 1.6 1.58 1.58 0 0 1-1.6 1.6Z"
            ></path>
            <circle cx="330.1" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="335.1" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="340.1" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="345" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="350" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="355" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="359.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="364.9" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="369.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="374.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="379.8" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="384.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="389.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="394.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="399.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="404.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="409.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="414.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="419.7" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="424.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="429.6" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <circle cx="434.5" cy="446.5" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="M436.3 448.1H328.8a1.54 1.54 0 0 1-1.5-1.5v-.3a1.54 1.54 0 0 1 1.5-1.5h107.6a1.54 1.54 0 0 1 1.5 1.5v.3a1.63 1.63 0 0 1-1.6 1.5Z"
            ></path>
            <circle cx="291" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="295.9" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="300.9" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="305.9" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="310.8" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="315.8" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="320.8" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="325.7" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="330.7" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="335.7" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="340.6" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="345.6" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="350.5" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="355.5" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="360.5" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="365.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="370.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="375.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="M376.9 493.3h-87a1.58 1.58 0 0 1-1.6-1.6 1.58 1.58 0 0 1 1.6-1.6h87a1.58 1.58 0 0 1 1.6 1.6 1.58 1.58 0 0 1-1.6 1.6Z"
            ></path>
            <circle cx="552.7" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="557.6" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="562.6" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="567.6" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="572.5" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="577.5" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <circle cx="582.5" cy="482.9" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="M583.4 484.5h-31.8a1.58 1.58 0 0 1-1.6-1.6 1.58 1.58 0 0 1 1.6-1.6h31.8a1.58 1.58 0 0 1 1.6 1.6 1.58 1.58 0 0 1-1.6 1.6Z"
            ></path>
            <circle cx="570.5" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="575.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="580.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="585.4" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="590.3" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="595.3" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="600.2" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <circle cx="605.2" cy="491.7" r="0.8" fill="#5e7076"></circle>
            <path
              fill="none"
              stroke="#5e7076"
              strokeMiterlimit="10"
              strokeWidth="0.58"
              d="M606.7 493.3h-37.5a1.58 1.58 0 0 1-1.6-1.6 1.58 1.58 0 0 1 1.6-1.6h37.5a1.58 1.58 0 0 1 1.6 1.6 1.58 1.58 0 0 1-1.6 1.6Z"
            ></path>
          </g>
          <g
            id="LINES"
            fill="none"
            stroke="#5e7076"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.73"
          >
            <path d="M266 488.1h2.5"></path>
            <path strokeDasharray="4.85 4.85" d="M273.3 488.1h104.4"></path>
            <path d="M380.1 488.1h2.5M527.5 488.4h2.5"></path>
            <path strokeDasharray="5.21 5.21" d="M535.2 488.4h49.5"></path>
            <path d="M587.3 488.4h2.5M47.2 12.1V173M107.9 82.7v91.2l9.1 6M123.7 192.5v59.6M117.3 189.5l4.1 4M130.1 189.5l-4.1 4M238.9 418.9V434M232.5 415.9l4.1 4M245.3 415.9l-4.1 4M339 401.5V434M332.6 398.5l4.1 4M345.4 398.5l-4.1 4M433.3 401.5V434M426.9 398.5l4.1 4M439.7 398.5l-4.1 4M544.9 388.9l-9.1-5.9V254.7M551.7 401.5v67.6M545.3 398.5l4.1 4M558.1 398.5l-4.1 4M223.1 207.6v192.7l9.1 6M321.43 153.24 323.2 383l9.1 5.9M416.6 127.54l.8 255.46 9.1 5.9M504.5 65.1v178.5M137.6 261.7V434M586.2 484.5H665M704.5 484.5v-81.9M775.1 402.6v-6.5M704.5 443.4h6.5M704.5 467.4h6.5M704.5 402.6h82M704.5 420.7h6.5"></path>
          </g>
          <g id="TEXTS" fill="#5e7076">
            <path d="M125.5 240.5c-.1 0-.1 0-.1-.1s0-.2.1-.2l6.2-2.3v-.9a.2.2 0 0 1 .4 0v1.1h-.1zM537.6 363.4c-.1 0-.1 0-.1-.1s0-.2.1-.2l6.2-2.3v-.9a.2.2 0 0 1 .4 0v1.1h-.1zM508.1 153.9c-.1 0-.1 0-.1-.1s0-.2.1-.2l6.2-2.3v-.9a.2.2 0 1 1 .4 0v1.1h-.1zM419.8 360.2c-.1 0-.1 0-.1-.1s0-.2.1-.2l6.2-2.3v-.9a.2.2 0 1 1 .4 0v1.1h-.1zM332.5 339.6v1.1h-.1l-6.5 2.4c-.1 0-.1 0-.1-.1s0-.2.1-.2l6.2-2.3v-.9M225.5 242.8c-.1 0-.1 0-.1-.1s0-.2.1-.2l9.7-3.5v-.9a.2.2 0 0 1 .4 0v1.1h-.1zM34.9 95.5a.22.22 0 0 1-.2-.2v-1.1h.1l9.8-3.6c.1 0 .2 0 .2.1s0 .2-.1.2L35 94.4v.9c.1.1 0 .2-.1.2M225.5 277.7c-.1 0-.1 0-.1-.1s0-.2.1-.2l9.7-3.5v-.9a.2.2 0 0 1 .4 0v1.1h-.1zM110 100.4c-.1 0-.1 0-.1-.1s0-.2.1-.2l9.7-3.5v-.9a.2.2 0 1 1 .4 0v1.1h-.1zM553.4 426.5c-.1 0-.1 0-.1-.1s0-.2.1-.2l9.7-3.5v-.9a.2.2 0 1 1 .4 0v1.1h-.1zM135.5 313.2l-6.4-2.3v-1.1a.2.2 0 1 1 .4 0v.9l6.2 2.3c.1 0 .1.1.1.2ZM237.3 431.7l-6.3-2.3h-3.8c-.1 0-.1-.1-.1-.2s.1-.1.2-.1h3.9l6.3 2.3c.1 0 .1.1.1.2-.2 0-.2.1-.3.1M338.05 427.6l-6.3-2.3h-3.8c-.1 0-.1-.1-.1-.2s.1-.1.2-.1h3.9l6.3 2.3c.1 0 .1.1.1.2a.8.8 0 0 1-.3.1M431.6 424.9l-6.3-2.3h-3.8c-.1 0-.1-.1-.1-.2s.1-.1.2-.1h3.9l6.3 2.3c.1 0 .1.1.1.2-.2.1-.2.1-.3.1M625.9 483c-.1 0-.2-.1-.1-.2l1.6-4.3v-2.4c0-.1.1-.1.2-.1s.1.1.1.2v2.5l-1.6 4.3a.14.14 0 0 0-.2 0M508.1 81.5q-.15-.3 0-.3l9.7-3.5v-.9a.2.2 0 0 1 .4 0v1.1h-.1z"></path>
          </g>
          <g id="CHUTE_AND_FEEDER" data-name="CHUTE AND FEEDER">
            <path
              fill="#5e7076"
              d="M146.1 444.3v-1.8h-.8v1.8h-.7v.5h2.2v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m138.375 443.715 1.91-1.909.282.283-1.909 1.91zM137.826 443.417l.464-2.253.392.081-.464 2.253z"
            ></path>
            <circle cx="138" cy="444" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m147.6 441.5-11.3-1.5a.32.32 0 0 1-.3-.3v-.1a.32.32 0 0 1 .3-.3l11.3 1.5a.32.32 0 0 1 .3.3v.1a.32.32 0 0 1-.3.3M135.504 441.544l.169-1.287 10.692 1.404-.17 1.287z"
            ></path>
            <path
              fill="#397979"
              d="M139.3 435.9v-.8h.2v-.4H136v.4h.2v3.9h4.6v-2.6z"
            ></path>
            <path
              fill="#5e7076"
              d="M247.4 444.3v-1.8h-.8v1.8h-.7v.5h2.1v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m239.544 443.648 1.909-1.91.283.284-1.91 1.909zM239.042 443.403l.463-2.252.392.08-.463 2.253z"
            ></path>
            <circle cx="239.3" cy="444" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m248.8 441.5-11.3-1.5a.32.32 0 0 1-.3-.3v-.1a.32.32 0 0 1 .3-.3l11.3 1.5a.32.32 0 0 1 .3.3v.1c.1.2-.1.3-.3.3M237.612 441.664l.17-1.289 10.707 1.414-.17 1.289z"
            ></path>
            <path
              fill="#397979"
              d="M240.5 435.9v-.8h.2v-.4h-3.5v.4h.2v3.9h4.6v-2.6z"
            ></path>
            <path
              fill="#5e7076"
              d="M297.8 483.5v-1.8h-.7v1.8h-.7v.5h2.1v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m290.082 482.912 1.91-1.91.282.283-1.91 1.91zM289.535 482.614l.464-2.253.391.081-.463 2.253z"
            ></path>
            <circle cx="289.7" cy="483.2" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m299.3 480.7-11.3-1.5a.32.32 0 0 1-.3-.3v-.1a.32.32 0 0 1 .3-.3l11.3 1.5a.32.32 0 0 1 .3.3v.1a.27.27 0 0 1-.3.3M288.02 480.867l.171-1.29 10.707 1.414-.17 1.289z"
            ></path>
            <path
              fill="#397979"
              d="M291 475.1v-.8h.2v-.4h-3.5v.4h.2v3.9h4.6v-2.6z"
            ></path>
            <path
              fill="#5e7076"
              d="M329.5 483.5v-1.8h-.7v1.8h-.7v.5h2.1v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m321.777 482.917 1.91-1.91.282.283-1.909 1.91zM321.235 482.615l.464-2.253.392.08-.464 2.254z"
            ></path>
            <circle cx="321.4" cy="483.2" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m331 480.7-11.3-1.5a.32.32 0 0 1-.3-.3v-.1a.32.32 0 0 1 .3-.3L331 480a.32.32 0 0 1 .3.3v.1a.27.27 0 0 1-.3.3M319.72 480.86l.17-1.29 10.707 1.414-.17 1.289z"
            ></path>
            <path
              fill="#397979"
              d="M322.7 475.1v-.8h.2v-.4h-3.5v.4h.2v3.9h4.6v-2.6z"
            ></path>
            <path
              fill="#5e7076"
              d="M330.4 444.3v-1.8h.8v1.8h.7v.5h-2.2v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m335.912 442.042.283-.283 1.909 1.91-.283.282zM337.88 441.176l.392-.08.464 2.252-.392.081z"
            ></path>
            <circle cx="338.5" cy="444" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m328.9 441.5 11.3-1.5a.32.32 0 0 0 .3-.3v-.1a.32.32 0 0 0-.3-.3l-11.3 1.5a.32.32 0 0 0-.3.3v.1a.32.32 0 0 0 .3.3M329.293 441.677 340 440.263l.17 1.289-10.707 1.413z"
            ></path>
            <path
              fill="#397979"
              d="M340.5 434.7H337v.4h.2v.8l-1.5.5v2.6h4.6v-3.9h.2z"
            ></path>
            <path
              fill="#5e7076"
              d="M424.9 444.3v-1.8h.8v1.8h.6v.5h-2.1v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m430.392 442.037.283-.282 1.91 1.909-.284.283zM432.38 441.176l.392-.08.464 2.252-.392.08z"
            ></path>
            <circle cx="433" cy="444" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m423.4 441.5 11.3-1.5a.32.32 0 0 0 .3-.3v-.1a.32.32 0 0 0-.3-.3l-11.3 1.5a.32.32 0 0 0-.3.3v.1a.27.27 0 0 0 .3.3M423.79 441.67l10.707-1.414.17 1.289-10.707 1.413z"
            ></path>
            <path
              fill="#397979"
              d="M435 434.7h-3.5v.4h.2v.8l-1.5.5v2.6h4.6v-3.9h.2z"
            ></path>
            <path
              fill="#5e7076"
              d="M560.1 480.8V479h-.8v1.8h-.6v.5h2.1v-.5z"
            ></path>
            <path
              fill="#63afcf"
              d="m552.38 480.201 1.91-1.909.282.283-1.91 1.91zM551.84 479.903l.464-2.253.391.081-.463 2.253z"
            ></path>
            <circle cx="552" cy="480.5" r="0.8" fill="#5e7076"></circle>
            <path
              fill="#a50011"
              d="m561.6 478-11.3-1.5a.32.32 0 0 1-.3-.3v-.1a.32.32 0 0 1 .3-.3l11.3 1.5a.32.32 0 0 1 .3.3v.1a.27.27 0 0 1-.3.3M550.342 478.16l.17-1.29 10.707 1.414-.17 1.289z"
            ></path>
            <path
              fill="#397979"
              d="M553.3 472.4v-.8h.2v-.4H550v.4h.2v3.9h4.6v-2.6z"
            ></path>
          </g>
          <g id="LEVELS_05" data-name="LEVELS 05">
            <g id="waste_745">
              <path
                id="LINE"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M511.4 396h37.2"
              ></path>

              <TooltipComponent
                nivel={colors["rect_waste_745"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_745"
                  d="M566.7 417.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_745"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_745")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_745"
                stroke={colors["rect_label_waste_745"]?.stroke}
                strokeWidth={colors["rect_label_waste_745"]?.strokeWidth}
              >
                <path d="M491.76 399.52v.23l-1.13 2.37h-.36l1.13-2.3h-1.28v-.29ZM493.21 402.12v-.71h-1.2v-.23l1.16-1.66h.38v1.62h.36v.27h-.36v.71Zm0-1v-1.28c-.08.16-.14.27-.21.39l-.64.88h.85ZM495.73 399.82h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.25 1.25 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .55.14.58.58 0 0 0 .62-.56c0-.34-.23-.58-.75-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM497.2 399.43h.35v2.4h1.15v.29h-1.5ZM500.48 400.86h-1v1h1.17v.29h-1.52v-2.69h1.46v.24h-1.19v.85h1ZM501.69 402.12l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM504.72 400.86h-1v1h1.16v.29h-1.51v-2.69h1.45v.24h-1.1v.85h1ZM505.29 399.43h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_waste_745">
                <path d="M489.9 389.14a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.69.69 0 0 1 .37.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.23v1.11h-.48Zm.48 1.19h.3c.33 0 .53-.17.53-.44s-.2-.43-.52-.44a1.5 1.5 0 0 0-.31 0ZM494.56 390.43a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM497.26 390.7v-1.13c-.09.33-.21.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05v1.15l-.13 1.11h-.46l.18-2.69h.64l.36 1.08c.09.32.18.63.24.94.07-.3.16-.63.26-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_745">    
                <path
                  fill="#dc2e1a"
                  d="m529.5 391.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                

                <path
                  fill="#5e7076"
                  d="M519.5 393a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.32 1.32 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M525.7 394.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M525 392.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zc.1.1.1 0 0 0m-2.9.2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.3.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="526.9" cy="393.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="521.5" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="517.5" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="527.3" cy="393.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_785">
              <path
                id="LINE-2"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M511.4 343h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_785"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_785"
                  d="M566.7 364.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_785"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_785")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_785"
                stroke={colors["rect_label_waste_785"]?.stroke}
                strokeWidth={colors["rect_label_waste_785"]?.strokeWidth}
              >
                <path d="M491.91 346.8v.23l-1.13 2.37h-.38l1.12-2.3h-1.27v-.29ZM492.24 348.7a.75.75 0 0 1 .52-.7.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.65.65 0 0 1-.42.6.71.71 0 0 1 .52.67.8.8 0 0 1-.89.75c-.54.05-.87-.27-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .52-.47m-1-1.3c0 .26.19.4.49.48a.51.51 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM495.88 347.1h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.24 1.24 0 0 1-.64-.16l.08-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM497.4 346.7h.35v2.4h1.15v.29h-1.5ZM500.63 348.14h-1v1h1.17v.29h-1.52v-2.73h1.45v.29h-1.1v.85h1ZM501.84 349.4l-.89-2.69h.38l.42 1.32c.12.37.22.7.29 1a8 8 0 0 1 .31-1l.45-1.33h.37l-1 2.69ZM504.87 348.14h-1.05v1h1.17v.29h-1.52v-2.73h1.46v.29h-1.11v.85h1.05ZM505.4 346.7h.35v2.4h1.15v.29h-1.5ZM491.1 351.42a2.91 2.91 0 0 0 0 3.26h-.27a2.52 2.52 0 0 1-.53-1.62 2.58 2.58 0 0 1 .53-1.64ZM492.28 354.2l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1a10 10 0 0 1 .31-1l.45-1.33h.37l-1 2.69ZM494.26 351.51v2.69h-.35v-2.69ZM495.31 353.35l-.28.85h-.36l.92-2.69h.41l.92 2.69h-.37l-.29-.85Zm.88-.27-.26-.77c-.06-.18-.1-.34-.14-.5a5 5 0 0 1-.14.49l-.26.78ZM498.17 351.54a4 4 0 0 1 .67 0 1.12 1.12 0 0 1 .78.22.67.67 0 0 1 .21.51.73.73 0 0 1-.51.69.71.71 0 0 1 .4.55 4.4 4.4 0 0 0 .2.74h-.36a5 5 0 0 1-.18-.64c-.08-.37-.22-.52-.54-.53h-.33v1.17h-.34Zm.34 1.23h.36c.37 0 .61-.2.61-.51s-.25-.5-.62-.51a1.2 1.2 0 0 0-.35 0ZM500.78 353.35l-.28.85h-.36l.91-2.69h.42l.92 2.69h-.37l-.29-.85Zm.88-.27-.27-.77c0-.18-.09-.34-.13-.5a5 5 0 0 1-.14.49l-.26.78ZM505.04 353.02v-1.16c-.09.31-.2.65-.34 1l-.47 1.3h-.27l-.44-1.28c-.12-.38-.23-.73-.3-1 0 .33 0 .78-.06 1.18l-.07 1.16h-.33l.19-2.69h.44l.46 1.3c.11.33.2.63.27.91.07-.27.17-.57.29-.91l.48-1.3h.44l.17 2.69h-.34ZM505.99 351.54a3.7 3.7 0 0 1 .67 0 1.07 1.07 0 0 1 .75.22.72.72 0 0 1 .24.56.78.78 0 0 1-.21.58 1.1 1.1 0 0 1-.82.29 1.3 1.3 0 0 1-.29 0v1.08h-.34Zm.34 1.3a1.2 1.2 0 0 0 .29 0c.42 0 .68-.21.68-.58s-.25-.53-.64-.53a1.3 1.3 0 0 0-.33 0ZM507.88 354.7a2.86 2.86 0 0 0 0-3.26h.28a2.81 2.81 0 0 1 0 3.26Z"></path>
              </g>
              <g id="label2_waste_785">
                <path d="M490.18 336.14a5 5 0 0 1 .74-.06 1.3 1.3 0 0 1 .84.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM494.84 337.43a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM497.54 337.7v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.42l-.36-1.15a11 11 0 0 1-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_785">
                <path
                  fill="#dc2e1a"
                  d="m528.3 338.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M518.3 340a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.32 1.32 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M524.5 341.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M523.8 339.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.2v.7H517v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c0 .1-.1.2-.3.2"
                ></path>
                <circle cx="525.7" cy="340.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="520.3" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="516.3" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="526.1" cy="340.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_835">
              <path
                id="LINE-3"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M511.4 307.6h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_835"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_835"
                  d="M566.7 329.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_835"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_835")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_835"
                stroke={colors["rect_label_waste_835"]?.stroke}
                strokeWidth={colors["rect_label_waste_835"]?.strokeWidth}
              >
                <path d="M490.04 313.29a.75.75 0 0 1 .52-.69.63.63 0 0 1-.42-.58.73.73 0 0 1 .81-.69.65.65 0 0 1 .33 1.25.73.73 0 0 1 .52.67.8.8 0 0 1-.89.76.77.77 0 0 1-.87-.72m1.4 0c0-.32-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .48-.47Zm-1-1.3c0 .26.19.4.49.48a.53.53 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM492.21 313.55a1.2 1.2 0 0 0 .58.16c.45 0 .59-.28.59-.5s-.34-.52-.68-.52h-.19v-.26h.19c.26 0 .58-.14.58-.44s-.13-.39-.45-.39a.94.94 0 0 0-.52.17l-.1-.26a1.25 1.25 0 0 1 .68-.2c.52 0 .75.3.75.62a.64.64 0 0 1-.48.61.68.68 0 0 1 .58.67c0 .41-.33.78-1 .78a1.2 1.2 0 0 1-.67-.18ZM495.73 311.7h-1l-.1.67h.21a1.16 1.16 0 0 1 .56.14.75.75 0 0 1 .37.67.9.9 0 0 1-1 .89 1.25 1.25 0 0 1-.65-.16l.09-.27a1.13 1.13 0 0 0 .55.15.58.58 0 0 0 .62-.57c0-.34-.23-.57-.75-.57h-.36l.17-1.24h1.24ZM497.2 311.26h.35v2.44h1.15v.29h-1.5ZM500.48 312.7h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.19v.85h1ZM501.69 313.95l-.88-2.69h.37l.42 1.33c.12.36.22.69.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM504.72 312.7h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM505.29 311.26h.35v2.44h1.16v.29h-1.51ZM490.95 315.98a2.65 2.65 0 0 0-.5 1.64 2.7 2.7 0 0 0 .5 1.62h-.27a2.77 2.77 0 0 1 0-3.26ZM492.13 318.75l-.88-2.69h.37l.42 1.33c.12.36.22.69.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM494.12 316.06v2.69h-.35v-2.69ZM495.16 317.91l-.28.84h-.36l.92-2.69h.42l.92 2.69h-.38l-.29-.84Zm.88-.28-.26-.77c-.06-.18-.1-.34-.14-.49 0 .16-.08.32-.13.48l-.27.78ZM498.02 316.1a3.3 3.3 0 0 1 .67-.06 1.12 1.12 0 0 1 .78.22.68.68 0 0 1 .21.51.72.72 0 0 1-.51.69.67.67 0 0 1 .4.54 4 4 0 0 0 .2.74h-.37a3.3 3.3 0 0 1-.17-.64c-.08-.37-.23-.51-.55-.52h-.28v1.16h-.35Zm.35 1.22h.35c.37 0 .61-.2.61-.51s-.25-.5-.62-.5a1.2 1.2 0 0 0-.34 0ZM500.63 317.91l-.28.84h-.36l.91-2.69h.42l.92 2.69h-.37l-.29-.84Zm.88-.28-.27-.77-.13-.49a4 4 0 0 1-.14.48l-.26.78ZM504.9 317.57v-1.16c-.09.31-.2.65-.34 1l-.47 1.31h-.27l-.44-1.29c-.12-.38-.23-.72-.3-1 0 .33 0 .78-.06 1.19l-.07 1.15h-.33l.19-2.69h.44l.46 1.3c.11.33.2.63.27.91.08-.27.17-.57.29-.91l.48-1.3h.45l.16 2.69h-.34ZM505.84 316.09a4 4 0 0 1 .67-.05 1.12 1.12 0 0 1 .75.22.74.74 0 0 1 .24.57.77.77 0 0 1-.21.57 1.1 1.1 0 0 1-.82.3 1.1 1.1 0 0 1-.28 0v1.08h-.35Zm.35 1.3a1 1 0 0 0 .28 0c.43 0 .68-.21.68-.58s-.25-.53-.64-.53a2 2 0 0 0-.32 0ZM507.74 319.24a2.76 2.76 0 0 0 .5-1.64 2.7 2.7 0 0 0-.5-1.62h.27a2.6 2.6 0 0 1 .52 1.63 2.64 2.64 0 0 1-.52 1.63Z"></path>
              </g>
              <g id="label2_waste_835">
                <path d="M489.9 300.84a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.69.69 0 0 1 .24.54.72.72 0 0 1-.49.68.69.69 0 0 1 .37.52 7 7 0 0 0 .21.75h-.5a3.3 3.3 0 0 1-.18-.63c-.08-.36-.21-.47-.49-.48h-.23v1.11h-.48Zm.48 1.19h.3c.33 0 .53-.17.53-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM494.56 302.13a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM497.26 302.4v-1.13c-.09.33-.21.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05v1.15l-.13 1.11h-.46l.18-2.69h.64l.36 1.08c.09.32.18.64.24.94.07-.3.16-.63.26-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_835">
                <path
                  fill="#dc2e1a"
                  d="m528.3 303.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M518.3 304.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.32 1.32 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M524.5 306.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M523.8 304.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.2v.7H517v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zc.1.1.1 0 0 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c0 .2-.1.2-.3.2"
                ></path>
                <circle cx="525.7" cy="305.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="520.3" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="516.3" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="526.1" cy="305.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_910">
              <path
                id="LINE-4"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M480.1 254.7h55.7"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_910"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_910"
                  d="M535.3 276.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_910"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_910")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_910"
                stroke={colors["rect_label_waste_910"]?.stroke}
                strokeWidth={colors["rect_label_waste_910"]?.strokeWidth}
              >
                <path d="M458.64 262.21a1 1 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.16 1.16 0 0 0 .34-.69.76.76 0 0 1-.62.28.75.75 0 0 1-.76-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.1a1.67 1.67 0 0 1-.45 1.22 1.33 1.33 0 0 1-.76.34 1.2 1.2 0 0 1-.32 0Zm.13-1.49a.5.5 0 0 0 .5.55.57.57 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.16-.78-.53-.78s-.48.26-.48.61ZM461.25 260.19l-.45.24-.07-.26.57-.31h.3v2.6h-.34ZM464.27 261.14c0 .88-.33 1.37-.91 1.37s-.85-.48-.86-1.34.38-1.35.91-1.35.86.49.86 1.32m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.41-.53 1.11ZM465.56 259.77h.35v2.4h1.15v.29h-1.5ZM468.84 261.2h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.15v.85h1ZM470.05 262.46l-.89-2.69h.38l.42 1.33c.12.36.22.69.29 1a8 8 0 0 1 .31-1l.45-1.33h.39l-1 2.69ZM473.08 261.2h-1v1h1.17v.29h-1.51v-2.69h1.45v.29h-1.11v.85h1ZM473.65 259.77h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_waste_910">
                <path d="M458.82 247.44a5 5 0 0 1 .75-.05 1.27 1.27 0 0 1 .83.21.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM463.48 248.7a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.51-.76 1.06ZM466.18 249v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_910_2">
                <path
                  fill="#dc2e1a"
                  d="m495.9 250.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M485.9 251.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M492.2 253.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M491.5 251.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7H486v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="493.3" cy="252.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="487.9" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="483.9" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="493.7" cy="252.3" r="0.1" fill="#ebb24b"></circle>
              </g>
              <g id="carrito_waste_910_1">
                <path
                  fill="#dc2e1a"
                  d="m535.8 250.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M525.8 251.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M532.1 253.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M531.4 251.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="533.2" cy="252.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="527.8" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="523.8" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="533.6" cy="252.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_1010">
              <path
                id="LINE-5"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M480.1 183.4h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_1010"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_1010"
                  d="M535.3 205.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_1010"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_1010")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_1010"
                stroke={colors["rect_label_waste_1010"]?.stroke}
                strokeWidth={colors["rect_label_waste_1010"]?.strokeWidth}
              >
                <path d="m459.46 187.38-.45.24-.07-.27.57-.3h.29v2.65h-.33ZM462.47 188.32c0 .89-.33 1.37-.9 1.37s-.85-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.46-.53 1.12ZM463.56 187.38l-.45.24-.07-.27.57-.3h.3v2.65h-.34ZM466.58 188.32c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.46-.52 1.12ZM467.87 186.96h.35v2.4h1.18v.34h-1.5ZM471.15 188.39h-1v1h1.17v.31h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM472.4 189.7l-.89-2.69h.38l.42 1.32c.12.37.22.7.29 1a8 8 0 0 1 .31-1l.45-1.33h.37l-1 2.69ZM475.4 188.39h-1v1h1.17v.31h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM475.96 186.96h.35v2.4h1.15v.34h-1.5ZM459.57 191.7a2.7 2.7 0 0 0-.5 1.64 2.65 2.65 0 0 0 .5 1.62h-.28a2.58 2.58 0 0 1-.52-1.62 2.65 2.65 0 0 1 .52-1.64ZM460.74 194.45l-.88-2.69h.38l.42 1.32c.12.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM462.73 191.76v2.69h-.33v-2.69ZM463.78 193.6l-.28.85h-.36l.91-2.69h.42l.92 2.69h-.37l-.29-.85Zm.88-.27-.27-.77c0-.18-.09-.34-.13-.5a5 5 0 0 1-.14.49l-.26.78ZM466.63 191.79a4.4 4.4 0 0 1 .67-.06 1.06 1.06 0 0 1 .78.23.64.64 0 0 1 .22.51.73.73 0 0 1-.51.69.7.7 0 0 1 .39.55 5 5 0 0 0 .21.74h-.36a4.5 4.5 0 0 1-.18-.65c-.08-.36-.22-.51-.54-.52h-.33v1.17h-.35Zm.35 1.23h.36c.37 0 .61-.2.61-.51s-.26-.5-.62-.51a1.2 1.2 0 0 0-.35 0ZM469.24 193.6l-.27.85h-.37l.92-2.69h.42l.92 2.69h-.37l-.29-.85Zm.89-.27-.27-.77c-.06-.18-.1-.34-.14-.5a4 4 0 0 1-.13.49l-.27.78ZM473.51 193.27v-1.17c-.09.32-.21.66-.34 1l-.48 1.3h-.29l-.44-1.28c-.13-.38-.23-.73-.31-1 0 .34 0 .79-.05 1.19l-.07 1.16h-.33l.19-2.69h.44l.46 1.3c.11.33.2.63.27.91.07-.28.17-.57.29-.91l.48-1.3h.44l.17 2.69h-.34ZM474.45 191.79a4 4 0 0 1 .67-.06 1.08 1.08 0 0 1 .76.23.72.72 0 0 1 .24.56.82.82 0 0 1-.21.58 1.12 1.12 0 0 1-.83.29 1.2 1.2 0 0 1-.28 0v1.08h-.35Zm.35 1.3a1.2 1.2 0 0 0 .29 0c.42 0 .68-.21.68-.58s-.26-.53-.64-.53a1.3 1.3 0 0 0-.33 0ZM476.4 194.93a2.91 2.91 0 0 0 0-3.26h.28a2.81 2.81 0 0 1 0 3.26Z"></path>
              </g>
              <g id="label2_waste_1010">
                <path d="M458.54 176.64a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.69.69 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 7 7 0 0 0 .21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.48Zm.48 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.31ZM463.2 177.93a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM465.9 178.2v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.37l-.36-1.15a11 11 0 0 1-.27-1c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.61l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_1010">
                <path
                  fill="#dc2e1a"
                  d="m496.9 179.2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M486.9 180.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M493.2 181.9a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M492.5 180.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7H487v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.3-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="494.4" cy="180.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="488.9" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="484.9" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="494.7" cy="181" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_1060">
              <path
                id="LINE-6"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M480.1 147.5h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_1060"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_1060"
                  d="M535.3 169.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_1060"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_1060")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_1060"
                stroke={colors["rect_label_waste_1060"]?.stroke}
                strokeWidth={colors["rect_label_waste_1060"]?.strokeWidth}
              >
                <path d="m459.2 151.13-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM462.21 152.07c0 .89-.32 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM464.02 151.05a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.8.8 0 0 1 1.42.54.87.87 0 0 1-.87.91c-.55 0-.92-.43-.92-1.1a1.6 1.6 0 0 1 .45-1.17 1.35 1.35 0 0 1 .83-.39 1.2 1.2 0 0 1 .25 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.58.58 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .42.21.74.57.74s.47-.25.47-.62M466.32 152.07c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.52-.42.52-1.08-.16-1.06-.52-1.06-.53.42-.53 1.12ZM467.61 150.7h.35v2.4h1.15v.29h-1.5ZM470.9 152.14h-1v1h1.17v.29h-1.57v-2.73h1.46v.28h-1.11v.86h1ZM472.1 153.4l-.88-2.69h.38l.41 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM475.13 152.14h-1v1h1.17v.29h-1.52v-2.73h1.45v.28h-1.1v.86h1ZM475.7 150.7h.35v2.4h1.16v.29h-1.51ZM459.31 155.42a2.67 2.67 0 0 0-.5 1.64 2.7 2.7 0 0 0 .5 1.62h-.27a2.52 2.52 0 0 1-.53-1.62 2.58 2.58 0 0 1 .53-1.64ZM460.49 158.2l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM462.48 155.51v2.69h-.35v-2.69ZM463.52 157.35l-.28.85h-.36l.92-2.69h.41l.92 2.69h-.37l-.29-.85Zm.88-.27-.26-.78c-.06-.17-.1-.33-.14-.49 0 .16-.08.33-.13.49l-.27.78ZM466.4 155.54a4 4 0 0 1 .67-.06 1.07 1.07 0 0 1 .78.23.67.67 0 0 1 .21.51.7.7 0 0 1-.51.68.71.71 0 0 1 .4.55 4.4 4.4 0 0 0 .2.74h-.36a4 4 0 0 1-.17-.65c-.08-.36-.23-.51-.55-.52h-.32v1.17h-.35Zm.35 1.23h.35c.37 0 .61-.2.61-.51s-.25-.51-.62-.51a2 2 0 0 0-.34 0ZM468.99 157.35l-.28.85h-.31l.91-2.69h.42l.92 2.69h-.37l-.29-.85Zm.88-.27-.27-.78c-.05-.17-.09-.33-.13-.49a5 5 0 0 1-.14.49l-.26.78ZM473.26 157.02c0-.38-.05-.83-.05-1.17-.09.32-.2.66-.34 1l-.47 1.3h-.27l-.44-1.28c-.12-.38-.23-.73-.3-1 0 .34 0 .79-.06 1.19l-.07 1.16h-.33l.19-2.69h.44l.46 1.3c.11.33.2.63.27.91.08-.28.17-.57.29-.91l.48-1.3h.44l.17 2.69h-.34ZM474.2 155.54a3.6 3.6 0 0 1 .67-.06 1.07 1.07 0 0 1 .75.23.72.72 0 0 1 .24.56.78.78 0 0 1-.21.58 1.1 1.1 0 0 1-.82.29 1.3 1.3 0 0 1-.29 0v1.08h-.34Zm.34 1.3a1.2 1.2 0 0 0 .29 0c.43 0 .68-.21.68-.58s-.25-.53-.64-.53a1.3 1.3 0 0 0-.33 0ZM476.1 158.7a2.91 2.91 0 0 0 0-3.26h.3a2.6 2.6 0 0 1 .52 1.63 2.64 2.64 0 0 1-.52 1.63Z"></path>
              </g>
              <g id="label2_waste_1060">
                <path d="M458.54 140.44a5 5 0 0 1 .74-.05 1.25 1.25 0 0 1 .83.21.69.69 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM463.2 141.7a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.51-.76 1.06ZM465.9 142v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.37l-.36-1.15a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.61l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_1060">
                <path
                  fill="#dc2e1a"
                  d="m496.9 143.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M486.9 144.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M493.2 146a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M492.5 144.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7H487v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="494.4" cy="145" r="0.1" fill="#ebb24b"></circle>
                <circle cx="488.9" cy="145.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="484.9" cy="145.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="494.7" cy="145.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_1110">
              <path
                id="LINE-7"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m504.5 118.1-9.1-6h-15.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_1110"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_1110"
                  d="M535.3 133.8h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_1110"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_1110")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_1110"
                stroke={colors["rect_label_waste_1110"]?.stroke}
                strokeWidth={colors["rect_label_waste_1110"]?.strokeWidth}
              >
                <path d="m459.48 115.83-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM461.53 115.83l-.45.24-.06-.27.56-.3h.3v2.6h-.34ZM463.58 115.83l-.46.24-.06-.27.57-.3h.29v2.6h-.34ZM466.6 116.77c0 .89-.33 1.37-.9 1.37s-.86-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM467.9 115.41h.34v2.4h1.16v.29h-1.5ZM471.18 116.84h-1v1h1.17v.29h-1.52v-2.69h1.46v.26h-1.11v.85h1ZM472.4 118.1l-.88-2.69h.38l.42 1.32c.11.37.21.7.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM475.4 116.84h-1v1h1.17v.29h-1.52v-2.69h1.46v.26h-1.11v.85h1ZM475.99 115.41h.35v2.4h1.15v.29h-1.5ZM459.59 120.12a2.91 2.91 0 0 0 0 3.26h-.27a2.58 2.58 0 0 1-.53-1.62 2.7 2.7 0 0 1 .53-1.64ZM460.77 122.9l-.88-2.69h.38l.41 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM462.76 120.21v2.69h-.36v-2.69ZM463.8 122.05l-.28.85h-.36l.92-2.69h.42l.92 2.69h-.38l-.28-.85Zm.89-.27-.27-.77c-.06-.18-.1-.34-.14-.5 0 .16-.08.33-.13.49l-.27.78ZM466.66 120.24a4 4 0 0 1 .67-.06 1.12 1.12 0 0 1 .78.23.67.67 0 0 1 .21.51.71.71 0 0 1-.51.69.67.67 0 0 1 .4.54 4 4 0 0 0 .21.74h-.37a4 4 0 0 1-.17-.64c-.08-.37-.23-.52-.54-.53h-.33v1.17h-.35Zm.35 1.23h.39c.37 0 .61-.2.61-.51s-.25-.5-.62-.51a1.1 1.1 0 0 0-.34 0ZM469.27 122.05l-.28.85h-.36l.92-2.69h.41l.92 2.69h-.37l-.29-.85Zm.88-.27-.26-.77c-.06-.18-.1-.34-.14-.5 0 .16-.08.33-.13.49l-.27.78ZM473.54 121.7v-1.17c-.09.32-.2.66-.34 1l-.47 1.3h-.33l-.44-1.28a10 10 0 0 1-.31-1.05v1.19l-.08 1.16h-.33l.19-2.69h.45l.45 1.3a9 9 0 0 1 .28.91c.07-.28.16-.57.28-.91l.48-1.3h.45l.16 2.69h-.34ZM474.48 120.24a4 4 0 0 1 .67-.06 1.07 1.07 0 0 1 .75.23.72.72 0 0 1 .24.56.78.78 0 0 1-.21.58 1.08 1.08 0 0 1-.82.29 1.2 1.2 0 0 1-.28 0v1.08h-.35Zm.35 1.3a1.1 1.1 0 0 0 .29 0c.42 0 .67-.21.67-.58s-.25-.53-.63-.53a1.2 1.2 0 0 0-.33 0ZM476.4 123.38a2.91 2.91 0 0 0 0-3.26h.27a2.81 2.81 0 0 1 0 3.26Z"></path>
              </g>
              <g id="label2_waste_1110">
                <path d="M458.82 105.14a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM463.48 106.43a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM466.18 106.7v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1v1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_1110">
                <path
                  fill="#dc2e1a"
                  d="m496.9 108-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M486.9 109.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M493.2 110.6a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M492.5 109.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7H487v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="494.4" cy="109.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="488.9" cy="110.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="484.9" cy="110.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="494.7" cy="109.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="waste_1185">
              <path
                id="LINE-8"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M480.1 59.1h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_waste_1185"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_waste_1185"
                  d="M535.3 80.8h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_waste_1185"]?.color}
                  onMouseDown={(e) => handleColor("rect_waste_1185")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_waste_1185"
                stroke={colors["rect_label_waste_1185"]?.stroke}
                strokeWidth={colors["rect_label_waste_1185"]?.strokeWidth}
              >
                <path d="m459.48 63.47-.45.24-.07-.27.57-.3h.3v2.56h-.34ZM461.53 63.47l-.45.24-.06-.27.56-.3h.3v2.56h-.34ZM462.79 65.08a.76.76 0 0 1 .51-.7.64.64 0 0 1-.41-.58.74.74 0 0 1 .8-.7.67.67 0 0 1 .76.64.66.66 0 0 1-.43.61.71.71 0 0 1 .52.67.79.79 0 0 1-.88.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .52-.48Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM466.4 63.43h-1l-.1.67h.21a1.1 1.1 0 0 1 .57.14.74.74 0 0 1 .37.66.91.91 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.28ZM467.9 63.04h.35v2.4h1.15v.26h-1.5ZM471.18 64.47h-1v1h1.17v.23h-1.52V63h1.46v.29h-1.11v.86h1ZM472.4 65.7l-.88-2.7h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.34h.37l-1 2.7ZM475.4 64.47h-1v1h1.17v.23h-1.52V63h1.46v.29h-1.11v.86h1ZM475.99 63.04h.35v2.4h1.15v.26h-1.5Z"></path>
              </g>
              <g id="label2_waste_1185">
                <path d="M458.54 52.34a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25V55h-.48Zm.48 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.31ZM463.2 53.63a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.34 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.34m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.07ZM465.9 53.9v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.37l-.41-1.12a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.66l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.13 2.69h-.48Z"></path>
              </g>
              <g id="carrito_waste_1185">
                <path
                  fill="#dc2e1a"
                  d="m496.9 55-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M486.9 56.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M493.2 57.6a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M492.5 56.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7V55H487v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3V57h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="494.4" cy="56.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="488.9" cy="57.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="484.9" cy="57.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="494.7" cy="56.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <path d="m542.29 349.44-.58-2.35h.46l.23 1.07c.06.29.11.58.15.82 0-.25.1-.53.17-.83l.25-1.06h.43l.23 1.08c.06.28.11.54.14.8 0-.26.1-.53.16-.82l.24-1.06h.44l-.63 2.35h-.46l-.25-1.11c0-.26-.1-.49-.13-.74 0 .25-.09.48-.16.75l-.27 1.1ZM544.95 347.12a3.6 3.6 0 0 1 .66-.05 1.1 1.1 0 0 1 .69.19.68.68 0 0 1 .23.53.72.72 0 0 1-.2.53 1 1 0 0 1-.74.25h-.19v.88h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.19-.4-.48-.4h-.25ZM546.81 349.44v-.26l.27-.25c.54-.49.79-.76.79-1.06a.36.36 0 0 0-.41-.39.84.84 0 0 0-.48.19l-.13-.3a1.17 1.17 0 0 1 .7-.23.67.67 0 0 1 .75.68c0 .4-.29.72-.68 1.09l-.2.17h.98v.35ZM541.33 351.22a2.5 2.5 0 0 0-.4 1.43 2.5 2.5 0 0 0 .4 1.41h-.32a2.38 2.38 0 0 1-.42-1.41 2.42 2.42 0 0 1 .42-1.43ZM541.67 351.32a4 4 0 0 1 .66-.05 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .21.47.62.62 0 0 1-.43.59.62.62 0 0 1 .33.46 5 5 0 0 0 .18.66h-.44a3.3 3.3 0 0 1-.16-.56c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.3c.29 0 .47-.15.47-.39s-.18-.37-.46-.37a1.3 1.3 0 0 0-.27 0ZM545.75 352.44a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.19 1.13 1.13 0 0 1 1.12-1.24 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.25.86.66.86s.65-.39.65-.88-.22-.86-.65-.86-.66.43-.66.92ZM548.11 352.7v-1c-.08.29-.18.61-.28.91l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1.95h-.4l.15-2.36h.57l.31 1a8 8 0 0 1 .21.82c.07-.26.15-.55.24-.83l.33-.94h.39l.14 2.36h-.42ZM548.87 354.06a2.78 2.78 0 0 0 0-2.84h.31a2.38 2.38 0 0 1 .43 1.42 2.4 2.4 0 0 1-.43 1.42ZM541.26 355.96l-.42.21-.07-.32.55-.28h.36v2.27h-.42ZM543.91 355.93h-.87l-.07.45h.16a1 1 0 0 1 .55.15.64.64 0 0 1 .3.58.83.83 0 0 1-.92.78 1.3 1.3 0 0 1-.6-.13l.09-.33a1 1 0 0 0 .5.12.44.44 0 0 0 .49-.41c0-.26-.19-.43-.64-.43h-.31l.14-1.15h1.18ZM545.9 355.57v.28l-1 2h-.45l1-1.9h-1.05v-.36ZM547.02 356.7v-.51h.38v.25a.58.58 0 0 1 .52-.29.48.48 0 0 1 .47.32.64.64 0 0 1 .21-.22.6.6 0 0 1 .34-.1c.28 0 .57.2.57.74v1h-.42v-.94c0-.28-.1-.45-.3-.45a.32.32 0 0 0-.3.23.7.7 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.29-.41a.36.36 0 0 0-.32.25.6.6 0 0 0 0 .14v1h-.42ZM555.4 410.7l-.57-2.35h.45l.23 1.07c.06.28.11.58.15.81 0-.24.1-.52.17-.82l.25-1.06h.46l.23 1.08c.06.28.11.54.14.8 0-.27.1-.53.16-.82l.25-1.06h.43l-.63 2.35h-.46l-.24-1.11a7 7 0 0 1-.14-.74c0 .25-.09.47-.16.74l-.27 1.11ZM558.04 408.32a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.67.67 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.88h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.18-.4-.48-.4h-.25ZM560.63 410.7v-.26l.27-.25c.53-.5.78-.77.79-1.07a.36.36 0 0 0-.41-.38.83.83 0 0 0-.49.19l-.12-.31a1.13 1.13 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.69 1.09l-.19.17h.93v.36ZM564.03 408.23a2.76 2.76 0 0 0 0 2.83h-.31a2.35 2.35 0 0 1-.43-1.41 2.38 2.38 0 0 1 .43-1.42ZM564.89 410.7l-.58-2.35h.46l.22 1.07c.06.28.12.58.16.81 0-.24.1-.52.17-.82l.25-1.06h.45l.24 1.08c0 .28.1.54.14.8 0-.27.09-.53.16-.82l.24-1.06h.44l-.64 2.35h-.46l-.24-1.11a7 7 0 0 1-.13-.74 8 8 0 0 1-.15.74l-.22 1.11ZM567.55 408.33a3.4 3.4 0 0 1 .63-.05 1.13 1.13 0 0 1 .67.15.51.51 0 0 1 .24.44.54.54 0 0 1-.39.51.59.59 0 0 1 .48.58.62.62 0 0 1-.23.49 1.35 1.35 0 0 1-.87.21 3.3 3.3 0 0 1-.53 0Zm.42.93h.22c.3 0 .47-.14.47-.34s-.17-.32-.44-.32h-.25Zm0 1.08h.23c.28 0 .53-.1.53-.39s-.25-.39-.54-.39h-.22ZM570.14 408.77l-.41.21-.08-.33.56-.27h.36v2.32h-.42ZM571.29 411.06a2.76 2.76 0 0 0 0-2.83h.31a2.36 2.36 0 0 1 .43 1.42 2.42 2.42 0 0 1-.43 1.41ZM558.96 412.43a2.5 2.5 0 0 0-.39 1.42 2.57 2.57 0 0 0 .39 1.41h-.31a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM559.3 414.38a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.63-.35-.63-.69.32-.67.83-.67a1.2 1.2 0 0 1 .57.12l-.11.34a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.15-.39.28s.14.27.45.39.61.36.61.7-.29.71-.89.71a1.4 1.4 0 0 1-.64-.15ZM561.56 412.5v2.35h-.43v-2.35ZM561.9 414.61l1.2-1.75H562v-.35h1.66v.25l-1.19 1.73h1.21v.36h-1.78ZM565.4 413.81h-.89v.69h1v.35h-1.43v-2.35h1.32v.35h-.94v.6h.94ZM565.84 412.53a4.5 4.5 0 0 1 .68-.05 1.43 1.43 0 0 1 1 .27 1.06 1.06 0 0 1 .37.87 1.18 1.18 0 0 1-.37.93 1.5 1.5 0 0 1-1.06.32 4 4 0 0 1-.58 0Zm.43 2h.24a.8.8 0 0 0 .89-.9.75.75 0 0 0-.84-.82 1 1 0 0 0-.29 0ZM568.03 415.26a2.76 2.76 0 0 0 0-2.83h.31a2.54 2.54 0 0 1 0 2.83ZM561.4 417.14h-.87l-.07.45h.17a1 1 0 0 1 .55.15.64.64 0 0 1 .29.57.82.82 0 0 1-.91.79 1.3 1.3 0 0 1-.61-.14l.09-.32a1.2 1.2 0 0 0 .5.12.44.44 0 0 0 .49-.41c0-.26-.19-.44-.64-.44h-.31l.15-1.14h1.17ZM563.4 417.9c0 .73-.29 1.19-.83 1.19s-.8-.48-.81-1.17.3-1.18.83-1.18.81.49.81 1.16m-1.21 0c0 .55.16.84.39.84s.39-.31.39-.85-.13-.84-.39-.84-.38.3-.38.87ZM564.49 417.86v-.51h.37v.25a.59.59 0 0 1 .52-.29.49.49 0 0 1 .47.31.7.7 0 0 1 .21-.21.63.63 0 0 1 .35-.1c.28 0 .56.19.56.74v1h-.42v-.94c0-.28-.09-.45-.3-.45a.32.32 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.29-.41a.35.35 0 0 0-.31.24.4.4 0 0 0 0 .14v1h-.42ZM486.99 236.18a4 4 0 0 1 .65 0 1.12 1.12 0 0 1 .73.19.6.6 0 0 1 .2.48.61.61 0 0 1-.43.58.62.62 0 0 1 .33.46 6 6 0 0 0 .19.66h-.44a2.5 2.5 0 0 1-.16-.56c-.07-.31-.18-.41-.43-.41h-.23v1h-.43Zm.43 1h.25c.29 0 .47-.15.47-.38s-.18-.38-.46-.38h-.26ZM490.3 237.46h-.9v.69h1v.36h-1.42v-2.36h1.42v.36h-1v.6h.89ZM492.77 237.55v-1c-.07.29-.17.61-.27.91l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1.95h-.4l.15-2.36h.57l.31.95c.08.28.16.56.21.82.06-.26.15-.55.24-.82l.32-.95h.56l.14 2.36h-.42ZM494.11 236.15v1.37c0 .46.19.68.48.68s.49-.21.49-.68v-1.37h.44v1.35c0 .72-.38 1.05-1 1.05s-.89-.31-.89-1.05v-1.35ZM497.7 238.44a1.6 1.6 0 0 1-.61.1 1.11 1.11 0 0 1-1.2-1.18 1.18 1.18 0 0 1 1.26-1.24 1.3 1.3 0 0 1 .57.1l-.1.34a1.1 1.1 0 0 0-.46-.09.79.79 0 0 0-.82.87.77.77 0 0 0 .82.84 1.3 1.3 0 0 0 .47-.08ZM498.07 236.15h.42v1.09a3 3 0 0 1 .18-.26l.61-.83h.53l-.81 1 .86 1.36h-.46l-.67-1.08-.21.25v.83h-.42ZM489.52 240.29a2.5 2.5 0 0 0-.39 1.42 2.6 2.6 0 0 0 .39 1.41h-.31a2.59 2.59 0 0 1 0-2.83ZM489.87 240.38a4 4 0 0 1 .66-.05 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .2.48.6.6 0 0 1-.42.58.62.62 0 0 1 .33.46 4 4 0 0 0 .18.66h-.44a3.3 3.3 0 0 1-.16-.56c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.26c.29 0 .47-.15.47-.38s-.18-.38-.46-.38a1.3 1.3 0 0 0-.27 0ZM493.95 241.51a1.12 1.12 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.25.86.66.86s.65-.39.65-.88-.22-.86-.65-.86-.66.42-.66.91ZM496.31 241.75v-1c-.08.28-.18.6-.28.9l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.91v1l-.05.95h-.4l.16-2.36h.56l.31 1c.08.28.16.56.21.82.07-.26.15-.55.24-.82l.33-1h.55l.14 2.36h-.45ZM497.07 243.12a2.53 2.53 0 0 0 .39-1.42 2.5 2.5 0 0 0-.39-1.41h.33a2.32 2.32 0 0 1 .43 1.41 2.38 2.38 0 0 1-.43 1.42ZM515.4 65.78l-.57-2.35h.45l.23 1.07c.06.28.11.58.15.82 0-.25.1-.53.17-.83l.25-1.06h.46l.23 1.08c.06.28.11.54.14.8 0-.26.1-.53.16-.82l.24-1.06h.44l-.63 2.35h-.46l-.26-1.08a7 7 0 0 1-.14-.74c0 .25-.09.47-.16.74l-.27 1.11ZM518.05 63.46a3.6 3.6 0 0 1 .66-.05 1 1 0 0 1 .69.19.67.67 0 0 1 .23.52.7.7 0 0 1-.2.54 1 1 0 0 1-.74.25h-.21v.89h-.43Zm.43 1.09a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM520.59 63.9l-.42.21-.07-.33.55-.27h.36v2.27h-.41ZM509.77 67.56a2.42 2.42 0 0 0-.4 1.42 2.5 2.5 0 0 0 .4 1.41h-.32a2.33 2.33 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM510.11 67.7a4 4 0 0 1 .66 0 1.05 1.05 0 0 1 .72.19.6.6 0 0 1 .21.47.63.63 0 0 1-.43.59.6.6 0 0 1 .33.45 4 4 0 0 0 .18.66h-.44a3 3 0 0 1-.16-.55c-.07-.31-.18-.41-.42-.42h-.22v1h-.43Zm.43 1h.26c.29 0 .47-.16.47-.39s-.18-.38-.46-.38a1.3 1.3 0 0 0-.27 0ZM514.19 68.78a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.25.87.66.87s.65-.39.65-.88-.22-.87-.65-.87-.69.43-.69.91ZM516.55 69.02v-1c-.08.29-.18.61-.28.9l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v2h-.4l.16-2.35h.56l.31.94c.08.28.16.56.21.82.07-.25.15-.54.24-.82l.33-.94h.55l.14 2.35h-.42ZM517.31 70.39a2.5 2.5 0 0 0 .39-1.41 2.53 2.53 0 0 0-.39-1.42h.31a2.54 2.54 0 0 1 0 2.83ZM519.82 68.1l-.42.21-.07-.33.55-.27h.36v2.27h-.41ZM522.46 68.07h-.87l-.07.45h.17a1.06 1.06 0 0 1 .55.15.64.64 0 0 1 .29.57.82.82 0 0 1-.91.79 1.4 1.4 0 0 1-.61-.13l.09-.33a1.2 1.2 0 0 0 .5.12.44.44 0 0 0 .49-.41c0-.26-.19-.44-.64-.44a1.4 1.4 0 0 0-.31 0l.15-1.15h1.17ZM524.5 68.83c0 .73-.29 1.19-.83 1.19s-.8-.48-.81-1.17.3-1.18.83-1.18.81.49.81 1.16m-1.21 0c0 .56.15.84.39.84s.39-.31.39-.85-.13-.84-.39-.84-.39.3-.39.87ZM524.85 68.79v-.51h.36v.25a.61.61 0 0 1 .53-.29.49.49 0 0 1 .47.32.7.7 0 0 1 .2-.22.65.65 0 0 1 .35-.1c.28 0 .57.19.57.74v1h-.42v-.94c0-.28-.1-.45-.3-.45a.31.31 0 0 0-.3.23.3.3 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.3-.41a.35.35 0 0 0-.31.24 1 1 0 0 0 0 .15v1h-.42ZM507.69 74.18v-2.35h.49l.61 1a7 7 0 0 1 .4.79V71.8h.4v2.35h-.45l-.61-1a6 6 0 0 1-.42-.81v1.8399999999999999ZM511.65 73.31a.84.84 0 0 1-.87.91.82.82 0 0 1-.85-.88.83.83 0 0 1 .88-.9.82.82 0 0 1 .84.87m-1.28 0c0 .33.16.58.42.58s.42-.24.42-.58-.12-.58-.42-.58-.39.32-.39.6ZM514.4 74.11a1.5 1.5 0 0 1-.61.11 1.12 1.12 0 0 1-1.21-1.19 1.19 1.19 0 0 1 1.27-1.24 1.5 1.5 0 0 1 .57.1l-.1.35a1.1 1.1 0 0 0-.46-.1.78.78 0 0 0-.82.87.77.77 0 0 0 .82.85 1.3 1.3 0 0 0 .47-.09ZM516.4 73.31a.84.84 0 0 1-.87.91.82.82 0 0 1-.85-.88.83.83 0 0 1 .88-.9.82.82 0 0 1 .84.87m-1.28 0c0 .33.16.58.42.58s.42-.24.42-.58-.12-.58-.42-.58-.47.32-.47.6ZM516.71 72.99v-.51h.38v.26a.61.61 0 0 1 .54-.3c.3 0 .61.19.61.73v1h-.43v-1c0-.24-.09-.43-.33-.43a.35.35 0 0 0-.33.25.6.6 0 0 0 0 .14v1h-.43ZM518.71 72.99v-.51h.37v.26a.62.62 0 0 1 .55-.3c.29 0 .6.19.6.73v1h-.43v-1c0-.24-.09-.43-.33-.43a.36.36 0 0 0-.33.25.6.6 0 0 0 0 .14v1h-.43ZM521.02 73.45a.46.46 0 0 0 .52.44 1.2 1.2 0 0 0 .47-.08l.06.3a1.5 1.5 0 0 1-.59.11.81.81 0 0 1-.88-.86.85.85 0 0 1 .84-.92.83.83 0 0 1 .71 1Zm.74-.3a.35.35 0 0 0-.36-.45.42.42 0 0 0-.4.41ZM523.77 74.13a1.3 1.3 0 0 1-.48.09.82.82 0 0 1-.88-.87.88.88 0 0 1 1-.91 1.2 1.2 0 0 1 .41.08l-.08.32a.75.75 0 0 0-.32-.06.55.55 0 0 0 0 1.1.8.8 0 0 0 .34-.07ZM524.63 71.99v.49h.41v.32h-.41v.75c0 .21.06.32.22.32h.17v.32a.8.8 0 0 1-.31 0 .52.52 0 0 1-.37-.14.7.7 0 0 1-.14-.48v-.8h-.24v-.32h.24v-.39ZM525.65 73.45c0 .31.25.44.53.44a1.2 1.2 0 0 0 .47-.08l.06.3a1.6 1.6 0 0 1-.59.11.8.8 0 0 1-.88-.86.85.85 0 0 1 .83-.92.83.83 0 0 1 .72 1Zm.75-.3a.36.36 0 0 0-.35-.41.42.42 0 0 0-.4.41ZM528.72 71.7v2.48h-.32v-.27a.61.61 0 0 1-.55.31.78.78 0 0 1-.73-.87.81.81 0 0 1 .76-.91.57.57 0 0 1 .48.22v-.96Zm-.43 1.49a.4.4 0 0 0 0-.11.37.37 0 0 0-.37-.31c-.27 0-.43.25-.43.56s.16.55.43.55a.38.38 0 0 0 .37-.31.5.5 0 0 0 0-.13ZM516.1 138.75l-.57-2.35h.45l.23 1.07c.06.29.11.58.15.82 0-.25.1-.53.17-.83l.25-1.06h.46l.23 1.08c.06.28.11.54.14.8 0-.26.1-.53.16-.82l.24-1.06h.44l-.63 2.35h-.42l-.24-1.11a7 7 0 0 1-.14-.74c0 .25-.09.48-.16.75l-.27 1.1ZM518.76 136.43a3.6 3.6 0 0 1 .66 0 1.1 1.1 0 0 1 .69.19.68.68 0 0 1 .23.53.7.7 0 0 1-.2.53 1 1 0 0 1-.74.25h-.21v.88h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.19-.4-.48-.4h-.25ZM521.3 136.87l-.42.21-.07-.32.55-.28h.36v2.27h-.41ZM513.72 140.6h.43v2h1v.36h-1.4ZM517.4 141.75a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.13-1.23 1.09 1.09 0 0 1 1.09 1.19m-1.76 0c0 .48.24.86.65.86s.65-.39.65-.88-.22-.86-.65-.86-.65.43-.65.92ZM518.14 142.95l-.57-2.35h.45l.23 1.07c.06.29.11.59.15.82 0-.25.1-.53.17-.83l.25-1.06h.46l.23 1.08c.06.28.11.54.14.8 0-.26.1-.53.16-.82l.24-1.06h.44l-.63 2.35h-.46l-.24-1.1a8 8 0 0 1-.14-.75c0 .25-.09.48-.16.75l-.27 1.1ZM522.12 141.91h-.89v.69h1v.35h-1.43v-2.35h1.37v.35h-.94v.61h.89ZM522.61 140.63a4 4 0 0 1 .65-.05 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .21.47.62.62 0 0 1-.43.59.62.62 0 0 1 .33.46 6 6 0 0 0 .18.65h-.44a3 3 0 0 1-.16-.55c-.07-.31-.18-.41-.42-.41h-.22v1h-.42Zm.42 1h.26c.29 0 .47-.15.47-.39s-.18-.37-.46-.37a1.4 1.4 0 0 0-.27 0ZM515.07 145.27l-.42.21-.07-.32.55-.28h.36v2.27h-.42ZM517.22 147.15v-.57h-1v-.28l.93-1.42h.51v1.37h.29v.33h-.29v.57Zm0-.9v-1.01c-.07.14-.13.26-.2.38l-.41.62h.61ZM518.15 147.15v-.26l.27-.25c.54-.49.79-.76.79-1.06a.36.36 0 0 0-.4-.39.9.9 0 0 0-.49.19l-.13-.3a1.18 1.18 0 0 1 .7-.24.67.67 0 0 1 .75.69c0 .4-.28.72-.68 1.09l-.2.17h.93v.35ZM520.83 145.96v-.51h.37v.25a.58.58 0 0 1 .52-.29.48.48 0 0 1 .47.32.7.7 0 0 1 .21-.22.6.6 0 0 1 .34-.1c.29 0 .57.2.57.74v1h-.42v-.94c0-.28-.1-.45-.3-.45a.32.32 0 0 0-.3.23.7.7 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.29-.41a.33.33 0 0 0-.31.25.3.3 0 0 0 0 .14v1h-.42Z"></path>
            <g id="RB5">
              <path
                id="container"
                fill="#cb9636"
                d="M599.2 394.24a2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75h-22.1a2.89 2.89 0 0 1-2.95-2.75"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label" fill="#50514e">
                <path d="M550.24 373.15a7 7 0 0 1 1.12-.09 1.9 1.9 0 0 1 1.25.33 1 1 0 0 1 .34.81 1.07 1.07 0 0 1-.73 1 1 1 0 0 1 .56.78 9 9 0 0 0 .32 1.12h-.76a5 5 0 0 1-.27-.95c-.12-.53-.31-.7-.73-.71h-.37v1.66h-.73Zm.73 1.78h.43c.5 0 .81-.26.81-.66s-.31-.65-.79-.65a2 2 0 0 0-.46 0ZM553.65 373.15a6 6 0 0 1 1.08-.09 2 2 0 0 1 1.16.26.85.85 0 0 1 .41.76.93.93 0 0 1-.67.87 1 1 0 0 1 .82 1 1.08 1.08 0 0 1-.39.83 2.25 2.25 0 0 1-1.5.37 6.4 6.4 0 0 1-.91-.05Zm.75 1.55h.37c.52 0 .8-.24.8-.58s-.29-.55-.75-.55a2 2 0 0 0-.42 0Zm0 1.86a2 2 0 0 0 .39 0c.47 0 .89-.18.89-.68s-.41-.66-.92-.66h-.36ZM559.4 373.85h-1.5l-.11.78h.28a1.74 1.74 0 0 1 .94.25 1.12 1.12 0 0 1 .51 1 1.42 1.42 0 0 1-1.57 1.35 2.15 2.15 0 0 1-1-.23l.15-.56a1.9 1.9 0 0 0 .86.21.76.76 0 0 0 .84-.71c0-.45-.33-.75-1.11-.75a4 4 0 0 0-.53 0l.25-2h2Z"></path>
              </g>
            </g>
            <path d="M502.6 485.98a1.6 1.6 0 0 0 .73.19c.36 0 .56-.17.56-.41s-.16-.37-.54-.51-.82-.44-.82-.88.41-.87 1.07-.87a1.6 1.6 0 0 1 .73.15l-.14.45a1.26 1.26 0 0 0-.6-.15c-.35 0-.5.19-.5.37s.17.34.58.49.78.47.78.91-.37.91-1.15.91a1.8 1.8 0 0 1-.82-.19ZM505.53 484.01h-.87v-.46h2.3v.46h-.88v2.57h-.55ZM507.59 485.7l-.26.86h-.57l1-3h.64l1 3h-.59l-.28-.86Zm.87-.42-.24-.74c-.06-.19-.11-.4-.15-.57 0 .17-.09.38-.15.56l-.23.75ZM509.84 486.58v-3h.64l.78 1.3a8 8 0 0 1 .52 1 12 12 0 0 1 0-1.25v-1.06h.51v3h-.57l-.8-1.33c-.19-.34-.39-.71-.54-1.05v2.38ZM513.47 484.01h-.87v-.46h2.3v.46h-.88v2.57h-.55ZM516.94 485.24h-1.14v.88h1.28v.46h-1.83v-3h1.76v.45h-1.21v.78h1.14ZM519.74 486.49a1.9 1.9 0 0 1-.79.14 1.43 1.43 0 0 1-1.55-1.53 1.52 1.52 0 0 1 1.62-1.6 1.8 1.8 0 0 1 .74.13l-.12.45a1.4 1.4 0 0 0-.6-.12 1 1 0 0 0-1.06 1.11 1 1 0 0 0 1.06 1.09 1.5 1.5 0 0 0 .6-.11ZM501.05 488.99a4.3 4.3 0 0 1 .81-.07 1.47 1.47 0 0 1 .87.2.63.63 0 0 1 .31.57.7.7 0 0 1-.5.65.77.77 0 0 1 .61.75.79.79 0 0 1-.29.63 1.68 1.68 0 0 1-1.13.28 5 5 0 0 1-.68 0Zm.55 1.2h.29c.38 0 .6-.18.6-.44s-.22-.42-.57-.42a1.1 1.1 0 0 0-.32 0Zm0 1.39h.3c.35 0 .67-.13.67-.5s-.31-.5-.69-.5h-.28ZM504.22 491.98v-1.28l-1-1.77h.64l.36.78c.1.22.18.39.26.6.08-.2.16-.38.26-.61l.37-.77h.62l-1 1.75v1.28ZM509.75 490.43a1.44 1.44 0 0 1-1.46 1.6 1.41 1.41 0 0 1-1.4-1.54 1.46 1.46 0 0 1 1.45-1.59 1.4 1.4 0 0 1 1.41 1.53m-2.27 0c0 .61.31 1.11.84 1.11s.84-.5.84-1.14-.28-1.11-.84-1.11-.84.56-.84 1.19ZM510.68 489.41h-.86v-.46h2.29v.46h-.87v2.57h-.56ZM513.02 488.95v1.21h1.28v-1.21h.55v3h-.55v-1.34h-1.28v1.34h-.56v-3ZM517.18 490.63h-1.14v.89h1.28v.46h-1.84v-3h1.77v.45h-1.21v.78h1.14ZM517.8 488.99a5 5 0 0 1 .84-.07 1.43 1.43 0 0 1 .94.25.76.76 0 0 1 .26.61.8.8 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.55a4.4 4.4 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.25v1.25h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.49-.59-.49a1.3 1.3 0 0 0-.35 0ZM520.4 491.38a1.6 1.6 0 0 0 .74.19c.35 0 .55-.17.55-.41s-.16-.37-.54-.51-.82-.45-.82-.88.41-.87 1.07-.87a1.6 1.6 0 0 1 .73.15l-.13.45a1.3 1.3 0 0 0-.61-.15c-.35 0-.5.19-.5.37s.18.34.58.49.78.47.78.91-.37.91-1.15.91a1.7 1.7 0 0 1-.82-.2ZM463.96 491.1a2.6 2.6 0 0 1-.76.13 1.23 1.23 0 0 1-.92-.32 1.12 1.12 0 0 1-.33-.86 1.19 1.19 0 0 1 1.31-1.22 1.55 1.55 0 0 1 .62.11l-.09.34a1.4 1.4 0 0 0-.54-.1.85.85 0 0 0 0 1.7.75.75 0 0 0 .32-.05v-.59h-.41v-.33h.83ZM464.83 488.85v1.37c0 .46.19.68.48.68s.5-.21.5-.68v-1.37h.43v1.35c0 .72-.38 1-1 1s-.89-.3-.89-1v-1.35ZM467.09 490.54l-.2.66h-.49l.76-2.35h.55l.76 2.35h-.46l-.21-.66Zm.68-.33-.19-.58-.12-.44c0 .14-.07.3-.11.44l-.18.58ZM469.4 488.85h.43v1.53c0 .65-.31.86-.78.86a1.3 1.3 0 0 1-.36-.05v-.35a1 1 0 0 0 .27 0c.24 0 .39-.11.39-.52ZM471.59 490.16h-.88v.69h1v.35h-1.42v-2.35h1.37v.35h-.94v.61h.88ZM472.07 490.7a1.2 1.2 0 0 0 .57.15c.27 0 .43-.13.43-.33s-.12-.28-.42-.39-.64-.34-.64-.68.33-.68.84-.68a1.26 1.26 0 0 1 .56.12l-.1.35a1 1 0 0 0-.47-.12c-.28 0-.39.15-.39.29s.14.26.45.38.61.37.61.7-.29.71-.9.71a1.3 1.3 0 0 1-.63-.15ZM474.93 489.21h-.67v-.36h1.78v.36h-.64v2h-.43ZM476.74 488.85v1.37c0 .46.2.68.49.68s.49-.21.49-.68v-1.37h.43v1.35c0 .72-.37 1-.94 1s-.9-.3-.9-1v-1.35ZM478.65 491.2v-2.35h.49l.61 1a7 7 0 0 1 .4.79v-1.8199999999999998h.4v2.35h-.45l-.61-1c-.15-.26-.31-.55-.43-.81v1.8399999999999999ZM481.01 491.2v-2.35h.5l.6 1a6 6 0 0 1 .41.79v-1.8199999999999998h.4v2.35h-.52l-.62-1c-.15-.26-.3-.55-.42-.81v1.8399999999999999ZM484.7 490.16h-.89v.69h1v.35h-1.41v-2.35h1.37v.35h-.94v.61h.89ZM485.18 488.85h.43v2h1v.36h-1.4Z"></path>
            <g id="mll_ett_0589">
              <path d="M569.4 475.7c0-.38-.05-.83-.05-1.16-.09.31-.2.65-.34 1l-.47 1.31h-.27l-.43-1.29a10 10 0 0 1-.31-1c0 .33 0 .78-.05 1.18l-.08 1.16h-.33l.19-2.69h.44l.46 1.3c.11.33.21.63.28.91.07-.27.16-.57.28-.91l.48-1.3h.45l.16 2.69h-.41ZM570.32 474.14h.35v2.4h1.15v.29h-1.5ZM572.21 474.14h.35v2.4h1.15v.29h-1.5ZM575.79 477.13v.2h-2v-.2ZM577.49 475.57h-1.09v1h1.17v.29h-1.47v-2.69h1.45v.29h-1.15v.85h1.05ZM578.64 474.43h-.82v-.29h2v.29h-.83v2.4h-.35ZM580.78 474.43h-.82v-.29h2v.29h-.82v2.4h-.35ZM583.95 477.13v.2h-2v-.2ZM585.86 475.5c0 .89-.33 1.38-.9 1.38s-.86-.48-.86-1.34.37-1.35.9-1.35.86.51.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM587.73 474.53h-1l-.1.67h.22a1 1 0 0 1 .55.14.74.74 0 0 1 .38.67.91.91 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.23-.58-.75-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM588.2 476.17a.73.73 0 0 1 .52-.69.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.68.68 0 0 1-.42.61.72.72 0 0 1 .52.67.81.81 0 0 1-.89.76.77.77 0 0 1-.87-.72m1.4 0c0-.32-.22-.47-.57-.57a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .52-.47Zm-1-1.3c0 .26.19.4.49.48a.52.52 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM590.49 476.58a1.5 1.5 0 0 0 .29 0 1 1 0 0 0 .54-.25 1.16 1.16 0 0 0 .34-.69.77.77 0 0 1-.61.28.75.75 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.09a1.6 1.6 0 0 1-.45 1.22 1.25 1.25 0 0 1-.75.35 1.3 1.3 0 0 1-.33 0Zm.13-1.49a.5.5 0 0 0 .5.55.58.58 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.16-.78-.53-.78s-.48.24-.48.63"></path>
            </g>
            <g id="_097-CV-004" data-name="097-CV-004">
              <path d="M530.12 484.25c0 .88-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.48.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.52.41-.52 1.12ZM530.65 485.33a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .54-.25 1.2 1.2 0 0 0 .35-.7.74.74 0 0 1-.61.28.75.75 0 0 1-.77-.79.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.09a1.63 1.63 0 0 1-.45 1.22 1.3 1.3 0 0 1-.75.35 2 2 0 0 1-.32 0Zm.12-1.49a.5.5 0 0 0 .5.55.58.58 0 0 0 .51-.27.3.3 0 0 0 0-.13c0-.45-.17-.79-.54-.79s-.47.27-.47.64M534.18 482.98v.23l-1.13 2.37h-.36l1.12-2.3h-1.27v-.29ZM535.47 484.37v.26h-1v-.26ZM537.83 485.49a1.6 1.6 0 0 1-.71.13 1.26 1.26 0 0 1-1.33-1.36 1.34 1.34 0 0 1 1.41-1.42 1.4 1.4 0 0 1 .64.12l-.09.28a1.3 1.3 0 0 0-.54-.11 1 1 0 0 0-1 1.11 1 1 0 0 0 1 1.08 1.35 1.35 0 0 0 .57-.11ZM538.91 485.58l-.88-2.7h.37l.42 1.33c.11.37.21.69.29 1 .08-.31.19-.65.31-1l.46-1.34h.37l-1 2.7ZM541.3 484.37v.26h-1v-.26ZM543.33 484.25c0 .88-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.48.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.41-.53 1.12ZM545.4 484.25c0 .88-.33 1.37-.9 1.37s-.86-.47-.86-1.33.37-1.35.9-1.35.86.48.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.55.41-.55 1.12ZM546.79 485.58v-.71h-1.21v-.23l1.16-1.66h.38v1.62h.37v.27h-.37v.71Zm0-1v-1.29a4 4 0 0 1-.22.38l-.63.89h.85Z"></path>
            </g>
            <path d="M562.81 500.15h-.68v-.37h1.78v.37h-.67v2h-.43ZM564.62 499.78v1.38c0 .46.19.67.48.67s.5-.21.5-.67v-1.38h.43v1.35c0 .72-.38 1.05-.94 1.05s-.9-.31-.9-1.05v-1.35ZM566.52 502.14v-2.36h.49l.61 1a6.5 6.5 0 0 1 .4.79v-1.83h.4v2.36h-.45l-.61-1a7 7 0 0 1-.42-.81v1.8399999999999999ZM568.89 502.14v-2.36h.51l.61 1a8 8 0 0 1 .4.79v-1.83h.4v2.36h-.45l-.62-1a9 9 0 0 1-.42-.81v1.8399999999999999ZM572.57 501.09h-.89v.69h1v.36h-1.43v-2.36h1.37v.36h-.94v.6h.89ZM573.06 499.78h.43v2h1v.36h-1.39ZM577.2 502.07a1.6 1.6 0 0 1-.61.11 1.12 1.12 0 0 1-1.21-1.19 1.18 1.18 0 0 1 1.26-1.24 1.24 1.24 0 0 1 .57.1l-.09.34a1.1 1.1 0 0 0-.46-.09.78.78 0 0 0-.82.87.77.77 0 0 0 .82.85 1.3 1.3 0 0 0 .47-.09ZM579.56 500.94a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.14 1.14 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.25.86.66.86s.65-.38.65-.88-.22-.86-.65-.86-.66.43-.66.91ZM579.94 502.14v-2.36h.46l.61 1a8 8 0 0 1 .4.79v-1.83h.4v2.36h-.41l-.62-1a9 9 0 0 1-.42-.81v1.8399999999999999ZM582.84 502.14l-.76-2.36h.47l.32 1.07c.09.3.17.58.23.86.06-.28.15-.56.24-.85l.34-1.08h.46l-.82 2.36ZM585.72 501.09h-.88v.69h1v.36h-1.44v-2.36h1.37v.36h-.94v.6h.88ZM586.75 502.14v-1l-.74-1.38h.49l.28.61.21.46c.06-.15.13-.29.21-.46l.28-.61h.49l-.78 1.37v1ZM590.18 500.94a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.14 1.14 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.1 1.2m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.67.43-.67.91ZM590.55 499.82a4 4 0 0 1 .65 0 1.12 1.12 0 0 1 .73.18.61.61 0 0 1 .2.48.63.63 0 0 1-.43.59.58.58 0 0 1 .33.45 5 5 0 0 0 .19.66h-.44a2.4 2.4 0 0 1-.16-.56c-.07-.3-.18-.4-.43-.41h-.21v1h-.43Zm.43 1h.25c.29 0 .47-.16.47-.39s-.18-.38-.46-.38h-.26ZM569.03 504.02a3.5 3.5 0 0 1 .63-.05 1.13 1.13 0 0 1 .67.15.48.48 0 0 1 .24.44.55.55 0 0 1-.39.51.6.6 0 0 1 .25 1.06 1.27 1.27 0 0 1-.87.22 3.3 3.3 0 0 1-.53 0Zm.43.93h.22c.3 0 .46-.14.46-.34s-.17-.33-.44-.33a1 1 0 0 0-.24 0Zm0 1.08h.22c.28 0 .53-.1.53-.4s-.24-.38-.54-.38h-.21ZM571.49 506.34v-1l-.74-1.38h.49l.28.61.21.46c.06-.15.13-.29.21-.46l.28-.61h.49l-.79 1.37v1ZM575.79 505.14a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.44-.65.91ZM576.52 504.35h-.68v-.37h1.79v.37h-.68v2h-.43ZM578.33 503.98v1h1v-1h.43v2.36h-.43v-1h-1v1h-.43v-2.36ZM581.57 505.29h-.89v.7h1v.35h-1.43v-2.36h1.37v.36h-.94v.6h.89ZM582.06 504.02a4 4 0 0 1 .65-.05 1.06 1.06 0 0 1 .73.19.61.61 0 0 1 .2.47.63.63 0 0 1-.43.59.58.58 0 0 1 .33.45 6 6 0 0 0 .18.66h-.44a4 4 0 0 1-.16-.56c-.06-.3-.18-.4-.42-.41h-.22v1h-.42Zm.42 1h.26c.29 0 .47-.16.47-.39s-.18-.38-.46-.38a1.4 1.4 0 0 0-.27 0ZM584.04 505.87a1.2 1.2 0 0 0 .57.15c.27 0 .43-.13.43-.32s-.12-.28-.42-.39-.64-.35-.64-.69.32-.67.84-.67a1.3 1.3 0 0 1 .56.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.28 0-.39.14-.39.28s.13.27.45.39.6.36.6.7-.28.71-.89.71a1.5 1.5 0 0 1-.64-.15ZM583.4 486.4a3.5 3.5 0 0 1 .54 0 .94.94 0 0 1 .58.13.42.42 0 0 1 .2.38.48.48 0 0 1-.33.44.52.52 0 0 1 .21.92 1.1 1.1 0 0 1-.75.19 2.4 2.4 0 0 1-.45 0Zm.36.8h.19c.26 0 .4-.12.4-.29s-.14-.28-.38-.28a.8.8 0 0 0-.21 0Zm0 .93h.2c.23 0 .45-.09.45-.34s-.21-.33-.46-.33h-.19ZM585.08 486.37h.37v1.72h.84v.31h-1.21ZM624.07 470.23h-.22a.81.81 0 0 0-.76.67.64.64 0 0 1 .51-.22.69.69 0 0 1 .7.74.79.79 0 0 1-.8.81.86.86 0 0 1-.86-1 1.42 1.42 0 0 1 .39-1 1.26 1.26 0 0 1 .81-.33.6.6 0 0 1 .22 0Zm-.2 1.22a.4.4 0 0 0-.4-.45.42.42 0 0 0-.37.24.4.4 0 0 0 0 .13c0 .3.14.55.42.55s.35-.22.35-.47M624.59 471.96a.26.26 0 0 1 .27-.27.25.25 0 0 1 .26.27.26.26 0 0 1-.26.28.27.27 0 0 1-.27-.28M625.4 471.62a.61.61 0 0 1 .42-.59.57.57 0 0 1-.34-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.6.6 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.31-.81-.62m1.2 0c0-.23-.17-.36-.43-.43a.41.41 0 0 0-.33.4.36.36 0 0 0 .38.37.35.35 0 0 0 .34-.36Zm-.71-1.11c0 .19.15.3.37.36a.36.36 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM628.09 469.85h.42v1.08l.18-.26.61-.82h.53l-.81 1 .87 1.35h-.49l-.66-1.08-.22.25v.83h-.42ZM630.13 471v-.5h.37v.25a.59.59 0 0 1 .52-.29.51.51 0 0 1 .48.31.7.7 0 0 1 .21-.21.63.63 0 0 1 .35-.1c.28 0 .56.19.56.74v1h-.42v-.94c0-.28-.09-.45-.3-.45a.32.32 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.29-.41a.35.35 0 0 0-.31.24.4.4 0 0 0 0 .15v1h-.42ZM646 436.37a1.46 1.46 0 0 0 .73.2c.36 0 .56-.17.56-.42s-.16-.36-.54-.5-.82-.45-.82-.88.41-.87 1.07-.87a1.6 1.6 0 0 1 .73.15l-.13.44a1.4 1.4 0 0 0-.61-.14c-.35 0-.5.19-.5.37s.17.34.58.49.78.47.78.9-.37.92-1.15.92a1.76 1.76 0 0 1-.82-.2ZM648.93 434.41h-.87v-.46h2.34v.46h-.88v2.57h-.55ZM650.99 436.12l-.26.86h-.57l1-3h.71l1 3h-.59l-.28-.86Zm.87-.42-.24-.75c-.05-.18-.1-.39-.15-.57 0 .18-.09.39-.14.57l-.24.75ZM655.33 436.89a2.1 2.1 0 0 1-.79.14 1.44 1.44 0 0 1-1.55-1.53 1.53 1.53 0 0 1 1.63-1.6 1.7 1.7 0 0 1 .73.13l-.12.44a1.5 1.5 0 0 0-.59-.12 1 1 0 0 0-1.07 1.12 1 1 0 0 0 1.06 1.09 1.6 1.6 0 0 0 .61-.11ZM655.79 433.95h.61v1.39c.07-.12.15-.22.22-.33l.79-1.06h.69l-1 1.29 1.11 1.74h-.64l-.86-1.39-.27.32v1.07h-.56ZM660.11 435.63h-1.14v.89h1.28v.46h-1.85v-3h1.77v.45h-1.21v.78h1.14ZM660.73 433.99a5 5 0 0 1 .84-.07 1.37 1.37 0 0 1 .94.25.76.76 0 0 1 .26.61.8.8 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.57a3.5 3.5 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.28v1.25h-.55Zm.55 1.33h.33c.37 0 .61-.19.61-.49s-.24-.49-.59-.49a1.3 1.3 0 0 0-.35 0ZM652.4 439.38a6 6 0 0 1 .85-.06 1.37 1.37 0 0 1 .89.25.87.87 0 0 1 .3.67.92.92 0 0 1-.26.69 1.33 1.33 0 0 1-1 .32 1.1 1.1 0 0 1-.27 0v1.15h-.51Zm.55 1.42a1 1 0 0 0 .27 0c.42 0 .67-.2.67-.56s-.23-.51-.62-.51h-.32ZM657.31 442.24a3.1 3.1 0 0 1-1 .17 1.6 1.6 0 0 1-1.18-.41 1.46 1.46 0 0 1-.43-1.11 1.55 1.55 0 0 1 1.69-1.58 2 2 0 0 1 .81.15l-.13.44a1.65 1.65 0 0 0-.69-.13 1 1 0 0 0-1.1 1.09 1 1 0 0 0 1.05 1.1 1.2 1.2 0 0 0 .42-.06v-.76h-.53v-.44h1.07ZM676.7 476.45a1.44 1.44 0 0 1-1.45 1.6 1.4 1.4 0 0 1-1.4-1.54 1.46 1.46 0 0 1 1.44-1.59 1.4 1.4 0 0 1 1.41 1.53m-2.27 0c0 .62.32 1.12.85 1.12s.83-.5.83-1.14-.28-1.11-.83-1.11-.88.55-.88 1.17ZM677.17 475.01a5 5 0 0 1 .84-.07 1.4 1.4 0 0 1 .94.25.76.76 0 0 1 .26.61.79.79 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.57a4.4 4.4 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.28v1.25h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.49-.59-.49a1.3 1.3 0 0 0-.35 0ZM681.4 476.7h-1.14v.89h1.28v.46h-1.84v-3h1.77v.45h-1.21v.78h1.14ZM683.59 477.14l-.26.86h-.57l1-3h.64l1 3h-.6l-.27-.86Zm.87-.42-.23-.74c-.06-.19-.11-.4-.16-.57 0 .17-.09.38-.14.56l-.24.75ZM685.85 478v-3h.63l.78 1.3a9 9 0 0 1 .52 1 12 12 0 0 1 0-1.25v-1.06h.51v3h-.57l-.79-1.33a11 11 0 0 1-.55-1.05v2.38ZM688.89 475.01a5.5 5.5 0 0 1 .88-.07 1.87 1.87 0 0 1 1.24.35 1.37 1.37 0 0 1 .47 1.12 1.57 1.57 0 0 1-.47 1.21 2 2 0 0 1-1.37.41 7 7 0 0 1-.75 0Zm.55 2.57h.31a1 1 0 0 0 1.15-1.16 1 1 0 0 0-1.08-1.06 1.6 1.6 0 0 0-.38 0ZM670.74 483.4l-.74-3h.59l.29 1.37c.08.37.15.76.2 1.06 0-.32.13-.68.22-1.06l.33-1.37h.58l.3 1.39c.07.36.14.7.18 1 .06-.34.13-.68.21-1l.31-1.37h.57l-.82 3h-.56l-.31-1.43a9 9 0 0 1-.18-1 9 9 0 0 1-.2 1l-.36 1.43ZM674.52 482.54l-.25.86h-.58l1-3h.7l1 3h-.6l-.27-.86Zm.88-.42-.24-.74c-.06-.19-.11-.4-.16-.57 0 .17-.09.38-.14.56l-.24.75ZM676.77 482.8a1.6 1.6 0 0 0 .73.19c.35 0 .55-.17.55-.41s-.15-.37-.54-.51-.82-.45-.82-.88.42-.87 1.08-.87a1.55 1.55 0 0 1 .72.15l-.13.45a1.26 1.26 0 0 0-.6-.15c-.36 0-.51.19-.51.37s.18.34.58.49.78.47.78.91-.36.91-1.15.91a1.6 1.6 0 0 1-.81-.2ZM679.7 480.83h-.87v-.46h2.29v.46h-.87v2.57h-.55ZM683.17 482.05h-1.14v.89h1.28v.46h-1.83v-3h1.76v.45h-1.21v.78h1.14ZM684.72 480.41a5 5 0 0 1 .85-.07 1.4 1.4 0 0 1 .93.25.76.76 0 0 1 .26.61.79.79 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.57a4.4 4.4 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.27v1.25h-.56Zm.56 1.34h.32c.38 0 .61-.2.61-.5s-.23-.49-.59-.49a1.2 1.2 0 0 0-.34 0ZM689.97 481.85a1.43 1.43 0 0 1-1.45 1.6 1.41 1.41 0 0 1-1.4-1.54 1.46 1.46 0 0 1 1.45-1.59 1.4 1.4 0 0 1 1.4 1.53m-2.26.05c0 .61.31 1.11.84 1.11s.84-.5.84-1.14-.28-1.11-.84-1.11-.84.51-.84 1.14M692.63 483.31a1.9 1.9 0 0 1-.79.14 1.44 1.44 0 0 1-1.55-1.53 1.53 1.53 0 0 1 1.63-1.6 1.7 1.7 0 0 1 .73.13l-.12.44a1.5 1.5 0 0 0-.59-.11 1 1 0 0 0-1.07 1.11 1 1 0 0 0 1.06 1.09 1.6 1.6 0 0 0 .61-.11ZM693.09 480.37h.56v1.39l.22-.33.79-1.06h.74l-1.09 1.33 1.09 1.7h-.64l-.86-1.39-.27.32v1.07h-.56ZM673.4 486.23h-.87v-.46h2.29v.46h-.87v2.57h-.55ZM675.16 485.81a5 5 0 0 1 .85-.07 1.4 1.4 0 0 1 .93.25.76.76 0 0 1 .26.61.79.79 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.57a4.4 4.4 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.28v1.25h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.49-.59-.49a1.3 1.3 0 0 0-.35 0ZM678.4 487.94l-.25.86h-.58l1-3h.7l1 3h-.6l-.27-.86Zm.88-.42-.24-.74c-.06-.19-.11-.4-.16-.57 0 .17-.09.38-.14.56l-.23.75ZM680.62 488.8v-3h.63l.79 1.3a9 9 0 0 1 .51 1 12 12 0 0 1 0-1.26v-1.05h.52v3h-.58l-.79-1.33c-.19-.34-.39-.71-.54-1v2.38ZM683.65 488.2a1.6 1.6 0 0 0 .73.19c.36 0 .56-.17.56-.42s-.16-.36-.54-.5-.82-.45-.82-.88.41-.87 1.07-.87a1.6 1.6 0 0 1 .73.15l-.14.45a1.26 1.26 0 0 0-.6-.15c-.35 0-.5.19-.5.37s.17.34.58.49.78.47.78.91-.37.91-1.15.91a1.65 1.65 0 0 1-.82-.2ZM686 485.77h1.75v.45h-1.2v.84h1.12v.45h-1.12v1.29H686ZM689.98 487.45h-1.14v.89h1.28v.46h-1.83v-3h1.76v.45h-1.21v.78h1.14ZM690.6 485.81a5 5 0 0 1 .8-.11 1.4 1.4 0 0 1 .94.25.76.76 0 0 1 .26.61.79.79 0 0 1-.55.75.74.74 0 0 1 .42.58 8 8 0 0 0 .24.85h-.57a4.4 4.4 0 0 1-.2-.72c-.09-.39-.23-.52-.55-.53h-.28v1.25h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.49-.59-.49a1.3 1.3 0 0 0-.35 0ZM671.18 493.6a1.6 1.6 0 0 0 .74.19c.35 0 .55-.17.55-.42s-.16-.36-.54-.5-.82-.45-.82-.88.41-.87 1.07-.87a1.6 1.6 0 0 1 .73.15l-.13.45a1.3 1.3 0 0 0-.61-.15c-.35 0-.5.19-.5.37s.18.34.58.49.78.47.78.91-.37.91-1.15.91a1.7 1.7 0 0 1-.82-.2ZM674.11 491.63h-.86v-.46h2.29v.46h-.87v2.57h-.56ZM678.46 492.7a1.44 1.44 0 0 1-1.45 1.6 1.4 1.4 0 0 1-1.4-1.54 1.46 1.46 0 0 1 1.44-1.59 1.4 1.4 0 0 1 1.41 1.53m-2.27.05c0 .61.32 1.11.85 1.11s.83-.5.83-1.14-.28-1.11-.83-1.11-.85.46-.85 1.09ZM681.11 494.11a1.9 1.9 0 0 1-.79.14 1.43 1.43 0 0 1-1.54-1.53 1.52 1.52 0 0 1 1.62-1.6 1.7 1.7 0 0 1 .73.13l-.12.45a1.3 1.3 0 0 0-.59-.12 1 1 0 0 0-1.02 1.12 1 1 0 0 0 1 1.09 1.6 1.6 0 0 0 .61-.11ZM681.58 491.17h.55v1.39l.22-.32.8-1.07h.68l-1 1.29 1.11 1.74h-.65l-.86-1.39-.27.33v1.06h-.55ZM684.2 491.2a5.6 5.6 0 0 1 .85-.06 1.37 1.37 0 0 1 .89.25.87.87 0 0 1 .3.67.92.92 0 0 1-.26.69 1.35 1.35 0 0 1-1 .33h-.27v1.14h-.55Zm.55 1.42a1 1 0 0 0 .27 0c.41 0 .67-.2.67-.56s-.24-.51-.62-.51a1.2 1.2 0 0 0-.32 0ZM687.27 491.17v3h-.56v-3ZM687.9 491.17h.56v2.53h1.24v.46h-1.8ZM691.82 492.85h-1.15v.85h1.28v.46h-1.83v-3h1.77v.45h-1.22v.78h1.15ZM692.4 493.6a1.6 1.6 0 0 0 .73.19c.35 0 .55-.17.55-.42s-.15-.36-.54-.5-.82-.45-.82-.88.42-.87 1.08-.87a1.55 1.55 0 0 1 .72.15l-.13.45a1.26 1.26 0 0 0-.6-.15c-.36 0-.51.19-.51.37s.18.34.58.49.79.47.79.91-.37.91-1.16.91a1.7 1.7 0 0 1-.82-.2ZM724.66 384.21l-.26.85h-.57l1-3h.71l1 3h-.59l-.28-.85Zm.87-.42-.24-.75c-.06-.19-.11-.39-.15-.57-.05.18-.09.39-.15.57l-.23.75ZM726.91 382.07a5 5 0 0 1 .84-.06 1.43 1.43 0 0 1 .94.24.76.76 0 0 1 .26.61.8.8 0 0 1-.55.76.74.74 0 0 1 .42.59 7 7 0 0 0 .24.84h-.57a3.2 3.2 0 0 1-.2-.71c-.09-.4-.23-.53-.55-.53h-.28v1.24h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.48-.59-.49a2 2 0 0 0-.35 0ZM731.17 383.7h-1.14v.89h1.28v.45h-1.84v-3h1.77v.46h-1.21v.78h1.14ZM732.4 384.21l-.26.85h-.57l1-3h.71l1 3h-.59l-.28-.85Zm.87-.42-.24-.75c-.06-.19-.11-.39-.15-.57-.05.18-.09.39-.15.57l-.23.75ZM726.94 388.04l-.54.27-.1-.42.72-.35h.46v2.92h-.54ZM730.55 388.98c0 .94-.36 1.53-1.07 1.53s-1-.61-1-1.5.38-1.52 1.07-1.52 1 .63 1 1.49m-1.55 0c0 .71.2 1.08.5 1.08s.5-.4.5-1.1-.16-1.08-.5-1.08-.5.4-.5 1.13ZM732.97 388.98c0 .94-.37 1.53-1.07 1.53s-1-.61-1-1.5.39-1.52 1.07-1.52 1 .63 1 1.49m-1.56 0c0 .71.2 1.08.5 1.08s.5-.4.5-1.1-.16-1.08-.49-1.08-.52.4-.52 1.13Z"></path>
            <g id="WASTE">
              <path
                id="container-2"
                fill="#cb9636"
                d="M569 251.2a3 3 0 0 1 3.15-2.75h23.65a3 3 0 0 1 3.2 2.75 2.94 2.94 0 0 1-3.2 2.8h-23.69a3 3 0 0 1-3.11-2.8"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-2" fill="#50514e" data-name="label">
                <path d="m519.13 233.7-1-4h.78l.39 1.83c.1.5.19 1 .26 1.41.07-.42.18-.9.3-1.41l.43-1.83h.78l.4 1.86c.1.48.18.93.24 1.37.07-.45.17-.91.27-1.41l.42-1.82h.75l-1.09 4h-.78l-.42-1.9a13 13 0 0 1-.23-1.28c-.07.43-.15.82-.27 1.28l-.47 1.9ZM524.17 232.51l-.34 1.14h-.76l1.29-4h.94l1.32 4h-.8l-.36-1.14Zm1.17-.56-.32-1c-.08-.25-.15-.52-.21-.76-.06.24-.12.52-.19.76l-.32 1ZM527.17 232.85a2.1 2.1 0 0 0 1 .25c.47 0 .74-.22.74-.55s-.21-.48-.72-.67c-.67-.24-1.09-.6-1.09-1.17s.55-1.16 1.43-1.16a2.1 2.1 0 0 1 1 .2l-.18.59a1.7 1.7 0 0 0-.81-.19c-.47 0-.67.25-.67.49s.24.45.78.66c.7.27 1 .62 1 1.2s-.49 1.21-1.54 1.21a2.4 2.4 0 0 1-1.09-.25ZM531.07 230.23h-1.15v-.62h3.05v.62h-1.16v3.47h-.74ZM535.71 231.86h-1.53v1.18h1.71v.66h-2.49v-4h2.36v.61h-1.62v1h1.53Z"></path>
              </g>
            </g>
          </g>
          <g id="LEVELS_04" data-name="LEVELS 04">
            <g id="OP8_1085">
              <path
                id="LINE-9"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M391.2 118.3h15.3l10.1 9.24"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_1085"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_1085"
                  d="M447.4 140h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_1085"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_1085")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op8_1085"
                stroke={colors["rect_label_op8_1085"]?.stroke}
                strokeWidth={colors["rect_label_op8_1085"]?.strokeWidth}
              >
                <path d="m371.19 121.7-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM374.21 122.7c0 .88-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.46.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.39-.53 1.08M374.5 123.34a.76.76 0 0 1 .51-.7.63.63 0 0 1-.41-.58.73.73 0 0 1 .8-.69c.51 0 .76.31.76.63a.65.65 0 0 1-.43.61.71.71 0 0 1 .52.67.79.79 0 0 1-.88.75c-.54.01-.87-.33-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.55.55 0 0 0-.47.53.49.49 0 0 0 .52.5.48.48 0 0 0 .52-.49Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM378.13 121.7h-1l-.1.66h.21a1.1 1.1 0 0 1 .57.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM379.61 121.3h.35v2.4h1.15v.29h-1.5ZM382.89 122.7h-1.05v1h1.17v.29h-1.52v-2.7h1.46v.29h-1.11v.86h1.05ZM384.09 124l-.88-2.7h.38l.42 1.33c.11.37.21.69.28 1 .08-.31.19-.65.31-1l.46-1.34h.34l-1 2.7ZM387.12 122.7h-1v1h1.17v.29h-1.52v-2.7h1.46v.29h-1.11v.86h1ZM387.7 121.3h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_1085">
                <path d="M370.25 111.54a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM374.91 112.83a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM377.61 113.1v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.37l-.36-1.15a11 11 0 0 1-.27-1c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_1085">
                {colors["rect_op8_1085"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_1085">
                      <path
                        fill="#7c6956"
                        d="m407.27 111.92-.51.5a.69.69 0 0 1-.55.21h-.12a.7.7 0 0 1-.47-1.17.64.64 0 0 1 .4-.22l.88-.16M405.27 113.9a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.05a.72.72 0 0 1 .15.84l-.14.29M406.19 113.38l.59.1.73-.26.5-.55-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m406.19 113.38.59.1-.04.23M407.62 113.71l-.11-.49.5-.55.13.81M408.14 113.48l-.52.23"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m407.62 113.71-.11-.49-.73.26-.04.23"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m408 114.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M398 115.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M404.3 116.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M403.6 115.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="405.5" cy="115.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="400" cy="116.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="396" cy="116.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="405.8" cy="115.9" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_1060">
              <path
                id="LINE-10"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M391.64 146.9h15.3l9.66 7.73"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_1060"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_1060"
                  d="M446.84 168.5h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_1060"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_1060")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_1060"
                stroke={colors["rect_label_op8_1060"]?.stroke}
                strokeWidth={colors["rect_label_op8_1060"]?.strokeWidth}
              >
                <path d="m370.91 150.23-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM373.92 151.17c0 .89-.32 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM375.73 150.15a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.75.75 0 0 1 .62-.3.77.77 0 0 1 .79.84.87.87 0 0 1-.87.91c-.55 0-.91-.43-.91-1.1a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39 1.2 1.2 0 0 1 .25 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.58.58 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .42.21.74.58.74s.46-.25.46-.57ZM378.03 151.17c0 .89-.33 1.37-.9 1.37s-.86-.47-.87-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.52-.42.52-1.08-.16-1.06-.52-1.06-.53.42-.53 1.12ZM379.32 149.81h.35v2.4h1.16v.29h-1.51ZM382.61 151.24h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM383.81 152.5l-.88-2.69h.38l.41 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM386.84 151.24h-1v1h1.17v.29h-1.52v-2.69h1.45v.29h-1.1v.85h1ZM387.4 149.81h.34v2.4h1.16v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_1060">
                <path d="M370.24 140.04a5 5 0 0 1 .74-.06 1.3 1.3 0 0 1 .84.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.12h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM374.9 141.33a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM377.6 141.6v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_1060">
                {colors["rect_op8_1060"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_1060">
                      <path
                        fill="#7c6956"
                        d="m407.4 140.25-.51.5a.69.69 0 0 1-.55.21h-.12a.7.7 0 0 1-.47-1.17.74.74 0 0 1 .4-.23l.88-.16M405.4 142.23a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.68.68 0 0 1 .51.2h.05a.7.7 0 0 1 .15.83l-.14.29M406.34 141.71l.59.1.73-.26.5-.55-.6-.02-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m406.34 141.71.59.1-.04.23M407.77 142.04l-.11-.49.5-.55.13.81M408.29 141.82l-.52.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m407.77 142.04-.11-.49-.73.26-.04.23"
                      ></path>
                    </g>             
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m408.4 142.7-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M398.4 143.9a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M404.74 145.3a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M404.04 143.8a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.64v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h1.4Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1-.04-.1-.04 0Zm-.1.8h-.6v-.2h.6zc.06-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="405.94" cy="144.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="400.44" cy="145.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="396.44" cy="145.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="406.24" cy="144.5" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_1010">
              <path
                id="LINE-11"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M390.48 182.4h17.69"
                data-name="LINE"
              ></path>
              <path
                id="LINE-12"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m408.63 182.53 7.97 9.77"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_1010"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_1010"
                  d="M445.68 204.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_1010"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_1010")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_1010"
                stroke={colors["rect_label_op8_1010"]?.stroke}
                strokeWidth={colors["rect_label_op8_1010"]?.strokeWidth}
              >
                <path d="m370.91 185.79-.45.25-.07-.27.57-.3h.3v2.59h-.34ZM373.92 186.7c0 .88-.33 1.37-.9 1.37s-.85-.48-.86-1.33.38-1.36.9-1.36.86.53.86 1.32m-1.41 0c0 .67.21 1.06.53 1.06s.53-.42.53-1.08-.17-.98-.53-.98-.53.37-.53 1.08ZM375.01 185.79l-.45.25-.07-.27.57-.3h.3v2.59h-.34ZM378.03 186.7c0 .88-.33 1.37-.91 1.37s-.85-.48-.86-1.33.38-1.36.91-1.36.86.53.86 1.32m-1.41 0c0 .67.21 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.45-.53 1.16ZM379.32 185.37h.35v2.4h1.15v.29h-1.5ZM382.61 186.8h-1v1h1.17v.29h-1.52v-2.69h1.46v.3h-1.11v.85h1ZM383.81 188.06l-.88-2.69h.37l.42 1.33c.12.36.22.69.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM386.84 186.8h-1v1H387v.29h-1.51v-2.69h1.45v.3h-1.1v.85h1ZM387.4 185.37h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op8_1010">
                <path d="M370.25 175.48a4 4 0 0 1 .74-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.67.68.68 0 0 1 .37.52 6 6 0 0 0 .22.76h-.51a3.5 3.5 0 0 1-.18-.64c-.08-.35-.21-.47-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.18.54-.45s-.21-.43-.53-.43a1 1 0 0 0-.3 0ZM374.91 176.76a1.28 1.28 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.45.74-1-.25-1-.74-1-.76.48-.76 1.04ZM377.61 177.04v-1.14c-.09.33-.2.7-.32 1l-.4 1.16h-.37l-.36-1.15a10 10 0 0 1-.27-1.05c0 .36 0 .79-.05 1.15l-.06 1.09h-.46l.18-2.7h.65l.35 1.08c.09.32.18.64.24.94.07-.29.16-.62.27-.94l.37-1.08h.64l.15 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op8_1010">
                {colors["rect_op8_1010"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_1010">
                      <path
                        fill="#7c6956"
                        d="m406.85 175.95-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.74.74 0 0 1 .4-.23l.88-.16M404.85 177.93a.68.68 0 0 1-.62-.33.67.67 0 0 1 .52-1.05.7.7 0 0 1 .51.19l.05.05a.71.71 0 0 1 .15.83l-.14.29M405.77 177.41l.59.11.73-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m405.77 177.41.59.11-.04.23M407.2 177.74l-.11-.49.5-.54.13.81M407.72 177.52l-.52.22"
                      ></path>
                      <path fill="#8d7e70" d="m407.2 177.74-.11-.49-.73.27-.04.23"></path>
                    </g>            
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m407.67 178.14-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.34a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M397.67 179.34a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M403.97 180.7a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.64Z"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M403.27 179.24a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.37v-.2H394v.2h.3v1.5h-.6v.4l.6.4h1.8v-.44a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h1.4Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.24l.6.1c-.1-.1 0-.1 0 .04m-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.17.2-.3.2"
                ></path>
                <circle cx="405.17" cy="179.83" r="0.1" fill="#ebb24b"></circle>
                <circle cx="399.67" cy="180.73" r="0.1" fill="#ebb24b"></circle>
                <circle cx="395.67" cy="180.73" r="0.1" fill="#ebb24b"></circle>
                <circle cx="405.47" cy="179.93" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_960">
              <path
                id="LINE-13"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M392.2 215.4h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_960"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_960"
                  d="M447.4 237.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_960"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_960")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op8_960"
                stroke={colors["rect_label_op8_960"]?.stroke}
                strokeWidth={colors["rect_label_op8_960"]?.strokeWidth}
              >
                <path d="M370.63 221.15a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.2 1.2 0 0 0 .34-.69.77.77 0 0 1-.61.28.76.76 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.09a1.67 1.67 0 0 1-.45 1.22 1.28 1.28 0 0 1-.76.35 2 2 0 0 1-.32 0Zm.13-1.49a.5.5 0 0 0 .5.55.6.6 0 0 0 .51-.27.25.25 0 0 0 0-.13c0-.45-.16-.78-.53-.78s-.48.26-.48.67ZM373.96 219.05a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.75.75 0 0 1 .62-.3.77.77 0 0 1 .79.84.87.87 0 0 1-.87.91c-.55 0-.91-.43-.91-1.1a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39 1.2 1.2 0 0 1 .25 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.58.58 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .42.21.74.58.74s.46-.25.46-.62M376.26 220.07c0 .89-.33 1.37-.9 1.37s-.86-.47-.87-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM377.55 218.7h.35v2.4h1.16v.29h-1.51ZM380.84 220.14h-1.05v1h1.17v.29h-1.56v-2.73h1.46v.28h-1.11v.86h1.05ZM382.04 221.4l-.88-2.69h.38l.41 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.4l-1 2.69ZM385.07 220.14h-1v1h1.17v.29h-1.52v-2.73h1.45v.28h-1.1v.86h1ZM385.65 218.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_960">
                <path d="M370.53 208.7a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM375.19 210.03a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM377.89 210.3v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.62l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_960">
                {colors["rect_op8_960"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_960">
                      <path
                        fill="#7c6956"
                        d="m408.02 209.15-.51.5a.69.69 0 0 1-.55.21h-.12a.7.7 0 0 1-.44-1.16.73.73 0 0 1 .4-.22l.88-.16M406.02 211.13a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.06a.7.7 0 0 1 .15.83l-.14.29M406.94 210.61l.59.1.73-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m406.94 210.61.59.1-.04.23M408.37 210.94l-.11-.5.5-.54.13.81M408.89 210.71l-.52.23"
                      ></path>
                      <path fill="#8d7e70" d="m408.37 210.94-.11-.5-.73.27-.04.23"></path>
                    </g>      
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409 211.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399 212.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M405.3 213.9a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M404.6 212.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.2h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.3h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="406.5" cy="213" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401" cy="213.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397" cy="213.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="406.8" cy="213.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_935">
              <path
                id="LINE-14"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M392.34 235.5h15.3l9.76 6.01"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_935"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_935"
                  d="M447.54 257.2h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_935"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_935")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_935"
                stroke={colors["rect_label_op8_935"]?.stroke}
                strokeWidth={colors["rect_label_op8_935"]?.strokeWidth}
              >
                <path d="M371.2 241.17a1.6 1.6 0 0 0 .28 0 .93.93 0 0 0 .54-.25 1.17 1.17 0 0 0 .35-.69.78.78 0 0 1-.62.28.75.75 0 0 1-.77-.8.9.9 0 0 1 .89-.92c.53 0 .86.43.86 1.1a1.63 1.63 0 0 1-.45 1.22 1.3 1.3 0 0 1-.75.34 1.3 1.3 0 0 1-.32 0Zm.12-1.5a.5.5 0 0 0 .5.55.59.59 0 0 0 .52-.27.4.4 0 0 0 0-.13c0-.44-.17-.78-.54-.78s-.48.26-.48.66ZM373.13 241.01a1.2 1.2 0 0 0 .57.16c.45 0 .59-.28.59-.5 0-.37-.33-.52-.67-.52h-.22v-.26h.2c.26 0 .58-.14.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.26a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .57.67c0 .41-.32.78-.94.78a1.26 1.26 0 0 1-.68-.18ZM376.65 239.11h-1l-.1.67h.21a1.07 1.07 0 0 1 .56.15.72.72 0 0 1 .37.66.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.22-.57-.74-.57h-.36l.16-1.24h1.25ZM378.12 238.7h.35v2.4h1.15v.29h-1.5ZM381.4 240.15h-1v1h1.16v.29h-1.51v-2.74h1.45v.29h-1.1v.85h1ZM382.6 241.41l-.88-2.69h.38l.42 1.33c.11.36.21.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM385.64 240.15h-1.05v1h1.17v.29h-1.52v-2.74h1.46v.29h-1.11v.85h1.05ZM386.21 238.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_935">
                <path d="M370.81 228.44a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM375.48 229.7a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.51-.77 1.06ZM378.17 230v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_935">
                {colors["rect_op8_935"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_935">
                      <path
                        fill="#7c6956"
                        d="m408.02 229.25-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.7.7 0 0 1 .4-.23l.88-.16M406.02 231.23a.7.7 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.76.76 0 0 1 .51.2h.05a.71.71 0 0 1 .15.83l-.14.29M406.94 230.71l.59.11.73-.27.5-.55-.61-.02-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m406.94 230.71.59.11-.04.22M408.37 231.04l-.11-.49.5-.55.13.82M408.89 230.82l-.52.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m408.37 231.04-.11-.49-.73.27-.04.22"
                      ></path>
                    </g>   
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409.14 231.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.14 232.6a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M405.4 234a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.56.6Z"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M404.74 232.5a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.44v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.64v-.2h.6v.2Zm-.5-.2v-.2h.6v.2Zm0-.3v-.1h.6v.2h-.6Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="406.64" cy="233" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401.14" cy="233.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397.14" cy="233.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="406.94" cy="233.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_910">
              <path
                id="LINE-15"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M393 254.7h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_910"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_910"
                  d="M448.3 276.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_910"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_910")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_910"
                stroke={colors["rect_label_op8_910"]?.stroke}
                strokeWidth={colors["rect_label_op8_910"]?.strokeWidth}
              >
                <path d="M371.4 260.16a1.5 1.5 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.16 1.16 0 0 0 .34-.69.76.76 0 0 1-.62.28.75.75 0 0 1-.76-.8.89.89 0 0 1 .89-.92c.53 0 .85.43.85 1.1a1.67 1.67 0 0 1-.44 1.22 1.33 1.33 0 0 1-.76.34 1.2 1.2 0 0 1-.32 0Zm.13-1.5a.49.49 0 0 0 .5.55.57.57 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.17-.78-.53-.78s-.52.26-.52.67ZM373.97 258.13l-.45.25-.07-.27.57-.3h.3v2.59h-.34ZM376.99 259.08c0 .88-.33 1.37-.91 1.37s-.85-.48-.86-1.34.38-1.35.91-1.35.86.49.86 1.32m-1.41 0c0 .67.2 1.06.52 1.06s.53-.42.53-1.09-.16-1.05-.52-1.05-.53.41-.53 1.12ZM378.28 257.7h.35v2.4h1.15v.29h-1.5ZM381.56 259.14h-1v1h1.17v.29h-1.52v-2.73h1.46v.29h-1.11v.85h1ZM382.77 260.4l-.89-2.69h.38l.42 1.33c.12.36.22.69.29 1a8 8 0 0 1 .31-1l.45-1.33h.37l-1 2.69ZM385.8 259.14h-1v1h1.17v.29h-1.57v-2.73h1.46v.29h-1.11v.85h1ZM386.4 257.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_910">
                <path d="M370.69 247.64a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM375.4 248.93a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.81.48-.81 1.03ZM378.06 249.2v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.56l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_910">
                {colors["rect_op8_910"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_910">
                      <path
                        fill="#7c6956"
                        d="m408.95 248.2-.51.5a.69.69 0 0 1-.55.21h-.12a.7.7 0 0 1-.47-1.17.8.8 0 0 1 .4-.22l.88-.16M406.95 250.18a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.68.68 0 0 1 .51.2h.05a.7.7 0 0 1 .15.83l-.14.29M407.87 249.66l.59.1.73-.26.5-.55-.61-.02-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m407.87 249.66.59.1-.04.23M409.3 249.99l-.11-.49.5-.55.13.81M409.82 249.76l-.52.23"
                      ></path>
                      <path fill="#8d7e70" d="m409.3 249.99-.11-.49-.73.26-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409.9 250.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.8 251.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.22 1.22 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M406.1 253.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6c-.1.3-.3.6-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M405.4 251.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zc.1.1.1 0 0 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c0 .2-.1.2-.3.2"
                ></path>
                <circle cx="407.3" cy="252.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401.9" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397.9" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="407.7" cy="252.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_885">
              <path
                id="LINE-16"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M393 272.3h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_885"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_885"
                  d="M448.3 294h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.5 2.5 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_885"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_885")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_885"
                stroke={colors["rect_label_op8_885"]?.stroke}
                strokeWidth={colors["rect_label_op8_885"]?.strokeWidth}
              >
                <path d="M371.29 277.32a.74.74 0 0 1 .51-.7.65.65 0 0 1-.42-.58.74.74 0 0 1 .81-.7.68.68 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.8.8 0 0 1-.88.76c-.55 0-.87-.32-.87-.7m1.39 0c0-.31-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.46.46 0 0 0 .52-.48Zm-1-1.3c0 .26.19.4.49.48a.5.5 0 0 0 .4-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.41.39ZM373.34 277.32a.74.74 0 0 1 .51-.7.64.64 0 0 1-.41-.58.73.73 0 0 1 .8-.7.68.68 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.79.79 0 0 1-.88.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.57-.57a.56.56 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .52-.48Zm-1-1.3c0 .26.2.4.49.48a.5.5 0 0 0 .4-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM376.97 275.7h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.66.9.9 0 0 1-1 .89 1.25 1.25 0 0 1-.65-.16l.09-.27a1.06 1.06 0 0 0 .55.15.58.58 0 0 0 .62-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM378.4 275.28h.35v2.42h1.16v.3h-1.51ZM381.73 276.7h-1.05v1h1.17v.29h-1.52v-2.7h1.46v.29h-1.11v.86h1.05ZM382.93 277.98l-.88-2.7h.35l.41 1.33a10 10 0 0 1 .29 1c.08-.32.19-.65.31-1l.45-1.34h.38l-1 2.7ZM385.96 276.7h-1v1h1.17v.29h-1.52v-2.7h1.45v.29h-1.1v.86h1ZM386.54 275.28h.35v2.42h1.15v.3h-1.5Z"></path>
              </g>
              <g id="label2_op8_885">
                <path d="M371.09 265.54a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.5a3 3 0 0 1-.19-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM375.76 266.83a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.25-1-.75-1-.77.48-.77 1.03ZM378.46 267.1v-1.13c-.09.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05v1.15l-.06 1.08h-.45l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_885">
                {colors["rect_op8_885"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_885">
                      <path
                        fill="#7c6956"
                        d="m408.96 266.02-.5.51a.68.68 0 0 1-.55.2h-.12a.71.71 0 0 1-.48-1.17.68.68 0 0 1 .4-.23l.88-.16M406.97 268.01a.69.69 0 0 1-.57-.31.67.67 0 0 1 .51-1.05.68.68 0 0 1 .5.19l.06.05a.73.73 0 0 1 .15.84l-.15.29M407.89 267.49l.59.1.72-.27.5-.54-.6-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m407.89 267.49.59.1-.04.23M409.32 267.82l-.12-.5.5-.54.13.81M409.83 267.59l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m409.32 267.82-.12-.5-.72.27-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409.9 268.2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.8 269.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.19 1.19 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M406.1 270.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6q-.15.6-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M405.4 269.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.2-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c0 .1-.1.2-.3.2"
                ></path>
                <circle cx="407.3" cy="269.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401.9" cy="270.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397.9" cy="270.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="407.7" cy="270" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_860">
              <path
                id="LINE-17"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m417.4 295.9-9.1-5.9H393"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_860"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_860"
                  d="M448.3 311.7h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.5 2.5 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_860"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_860")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_860"
                stroke={colors["rect_label_op8_860"]?.stroke}
                strokeWidth={colors["rect_label_op8_860"]?.strokeWidth}
              >
                <path d="M371.29 295.79a.74.74 0 0 1 .51-.7.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.67.67 0 0 1 .76.64.64.64 0 0 1-.43.6.71.71 0 0 1 .52.67.8.8 0 0 1-.88.75c-.54.01-.87-.31-.87-.69m1.4 0c0-.31-.23-.46-.58-.56a.55.55 0 0 0-.46.53.47.47 0 0 0 .51.5.48.48 0 0 0 .53-.49Zm-1-1.3c0 .26.2.4.49.48a.5.5 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM374.85 294.1a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.75.75 0 0 1 .62-.3.77.77 0 0 1 .79.84.87.87 0 0 1-.87.91c-.55 0-.91-.43-.91-1.1a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39 1.2 1.2 0 0 1 .25 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.59.59 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .43.21.74.58.74s.46-.25.46-.62M377.15 295.12c0 .89-.33 1.37-.9 1.37s-.86-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM378.4 293.76h.35v2.4h1.16v.29h-1.51ZM381.73 295.19h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM382.93 296.45l-.88-2.69h.35l.41 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM385.96 295.19h-1v1h1.17v.29h-1.52v-2.69h1.45v.29h-1.1v.85h1ZM386.54 293.76h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_860">
                <path d="M371.4 282.94a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.68.7.7 0 0 1 .38.52 4.5 4.5 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM376.08 284.23a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.47-.76 1.03ZM378.78 284.5v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.55l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_860">
                {colors["rect_op8_860"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_860">
                      <path
                        fill="#7c6956"
                        d="m409.1 283.75-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.74.74 0 0 1 .4-.23l.88-.16M407.1 285.7a.7.7 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.76.76 0 0 1 .51.2l.05.05a.7.7 0 0 1 .15.83l-.14.29M408.02 285.21l.59.1.73-.26.5-.55-.6-.02-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m408.02 285.21.59.1-.04.24M409.45 285.54l-.11-.49.5-.55.13.82M409.97 285.32l-.52.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m409.45 285.54-.11-.49-.73.26-.04.24"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409.9 285.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.8 287a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.22 1.22 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M406.1 288.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6c-.1.3-.3.6-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M405.4 287a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9a.45.45 0 0 1 .5 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.2v-.2h.6v.2Zm0-.3v-.1h.6v.2h-.6Zm.2.8h-.2v-.2h.5c0 .1-.1.2-.3.2"
                ></path>
                <circle cx="407.3" cy="287.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401.9" cy="288.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397.9" cy="288.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="407.7" cy="287.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_835">
              <path
                id="LINE-18"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M393.11 307.6h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_835"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_835"
                  d="M448.41 329.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_835"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_835")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_835"
                stroke={colors["rect_label_op8_835"]?.stroke}
                strokeWidth={colors["rect_label_op8_835"]?.strokeWidth}
              >
                <path d="M371.96 313.3a.76.76 0 0 1 .51-.7.62.62 0 0 1-.41-.58.73.73 0 0 1 .81-.69.67.67 0 0 1 .75.64.66.66 0 0 1-.43.61.72.72 0 0 1 .53.67.8.8 0 0 1-.89.76c-.54-.01-.87-.31-.87-.71m1.4 0c0-.32-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .56-.48Zm-1-1.3c0 .26.2.4.5.48a.52.52 0 0 0 .39-.47.41.41 0 0 0-.44-.43.42.42 0 0 0-.41.4ZM374.13 313.55a1.2 1.2 0 0 0 .57.16c.45 0 .59-.28.59-.5s-.33-.52-.67-.52h-.22v-.26h.2c.26 0 .58-.14.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.26a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .57.67c0 .41-.32.78-.94.78a1.26 1.26 0 0 1-.68-.18ZM377.65 311.7h-1l-.1.67h.21a1.07 1.07 0 0 1 .56.15.72.72 0 0 1 .37.66.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.22-.57-.74-.57h-.36l.16-1.24h1.25ZM379.12 311.26h.35v2.44h1.15v.29h-1.5ZM382.4 312.7h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM383.6 313.95l-.88-2.69h.38l.42 1.33c.11.36.21.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM386.64 312.7h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM387.21 311.26h.35v2.44h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_835">
                <path d="M371.81 300.84a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.68.68 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.51a4.4 4.4 0 0 1-.18-.63c-.07-.36-.2-.47-.48-.48h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM376.48 302.13a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM379.18 302.4v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_835">
                {colors["rect_op8_835"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_835">
                      <path
                        fill="#7c6956"
                        d="m408.95 301.22-.5.5a.72.72 0 0 1-.55.21h-.13a.71.71 0 0 1-.47-1.17.62.62 0 0 1 .4-.22l.88-.16M406.96 303.2a.7.7 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.7.7 0 0 1 .51.19l.05.05a.72.72 0 0 1 .16.84l-.15.29M407.88 302.68l.59.1.72-.27.5-.54-.6-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m407.88 302.68.59.1-.04.23M409.31 303.01l-.12-.5.5-.54.13.81M409.82 302.78l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m409.31 303.01-.12-.5-.72.27-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m410.01 303.5-.6.9-1.2 1.4h-.6l-.8.7-.3.2c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6h.5z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.91 304.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.22 1.22 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M406.21 306.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M405.51 304.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c0 .2-.1.2-.3.2"
                ></path>
                <circle cx="407.41" cy="305.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="402.01" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="398.01" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="407.81" cy="305.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_810">
              <path
                id="LINE-19"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M393 325.3h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_810"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_810"
                  d="M448.3 347h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.5 2.5 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_810"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_810")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_810"
                stroke={colors["rect_label_op8_810"]?.stroke}
                strokeWidth={colors["rect_label_op8_810"]?.strokeWidth}
              >
                <path d="M371.96 331.04a.76.76 0 0 1 .51-.7.63.63 0 0 1-.41-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.64.64 0 0 1-.43.6.71.71 0 0 1 .53.67.8.8 0 0 1-.89.75c-.54-.03-.87-.31-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .56-.49Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.41.37ZM374.81 329.43l-.41.27-.07-.27.57-.3h.3v2.57h-.34ZM377.82 330.37c0 .89-.33 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.54.41-.54 1.12ZM379.12 329.01h.35v2.4h1.15v.29h-1.5ZM382.4 330.44h-1v1h1.16v.26h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM383.6 331.7l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM386.64 330.44h-1.05v1h1.17v.26h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM387.21 329.01h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_810">
                <path d="M372.09 318.64a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.2-.43-.52-.44a1.5 1.5 0 0 0-.31 0ZM376.76 319.93a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.74-1-.76.48-.76 1.03ZM379.46 320.2v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_810">
                {colors["rect_op8_810"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_810">
                      <path
                        fill="#7c6956"
                        d="m409.1 318.91-.5.51a.72.72 0 0 1-.55.21h-.12a.71.71 0 0 1-.48-1.17.62.62 0 0 1 .4-.22l.88-.16M407.11 320.9a.7.7 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.68.68 0 0 1 .5.19l.06.05a.73.73 0 0 1 .15.84l-.15.29M408.03 320.38l.59.1.72-.27.51-.54-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m408.03 320.38.59.1-.04.23M409.46 320.71l-.12-.5.51-.54.12.81M409.97 320.48l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m409.46 320.71-.12-.5-.72.27-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409.9 321.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399.8 322.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.19 1.19 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M406.1 323.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6q-.15.6-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M405.4 322.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.2-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c0 .1-.1.2-.3.2"
                ></path>
                <circle cx="407.3" cy="322.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401.9" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397.9" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="407.7" cy="323" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_785">
              <path
                id="LINE-20"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m416.6 348.85-9.1-5.9h-15.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_785"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_785"
                  d="M447.4 364.55h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_785"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_785")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_785"
                stroke={colors["rect_label_op8_785"]?.stroke}
                strokeWidth={colors["rect_label_op8_785"]?.strokeWidth}
              >
                <path d="M373.68 346.8v.23l-1.13 2.37h-.36l1.12-2.3h-1.27v-.29ZM374.01 348.7a.75.75 0 0 1 .52-.7.63.63 0 0 1-.41-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.64.64 0 0 1-.43.6.71.71 0 0 1 .53.67.8.8 0 0 1-.89.75c-.55.05-.88-.27-.88-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .51-.47Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.46.43ZM377.65 347.1h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.16-1.25h1.25ZM379.12 346.7h.35v2.4h1.15v.29h-1.5ZM382.4 348.14h-1v1h1.16v.29h-1.51v-2.73h1.45v.29h-1.1v.85h1ZM383.6 349.4l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM386.64 348.14h-1.05v1h1.17v.29h-1.52v-2.73h1.46v.29h-1.11v.85h1.05ZM387.21 346.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_785">
                <path d="M372.4 335.89a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.69.69 0 0 1 .37.52 7 7 0 0 0 .21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.48Zm.48 1.19h.3c.33 0 .53-.17.53-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM377.04 337.18a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.52-.76 1.03ZM379.74 337.45v-1.13c-.09.33-.21.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.5l.18-2.69h.64l.36 1.08c.09.32.18.64.24.94.07-.3.16-.63.26-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_785">
                {colors["rect_op8_785"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_785">
                      <path
                        fill="#7c6956"
                        d="m408.05 336.61-.5.51a.71.71 0 0 1-.55.21h-.12a.71.71 0 0 1-.48-1.17.64.64 0 0 1 .4-.22l.88-.16M406.06 338.6a.71.71 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.67.67 0 0 1 .5.19l.06.05a.72.72 0 0 1 .15.84l-.14.29M406.98 338.08l.59.1.73-.27.5-.54-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m406.98 338.08.59.1-.04.23M408.41 338.41l-.11-.5.5-.54.13.81M408.92 338.18l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m408.41 338.41-.11-.5-.73.27-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m409 338.75-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M399 339.95a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M405.3 341.45a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M404.6 339.85a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="406.5" cy="340.45" r="0.1" fill="#ebb24b"></circle>
                <circle cx="401" cy="341.35" r="0.1" fill="#ebb24b"></circle>
                <circle cx="397" cy="341.35" r="0.1" fill="#ebb24b"></circle>
                <circle cx="406.8" cy="340.55" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_745">
              <path
                id="LINE-21"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M408.3 396h22.4"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_745"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_745"
                  d="M463.5 417.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_745"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_745")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_745"
                stroke={colors["rect_label_op8_745"]?.stroke}
                strokeWidth={colors["rect_label_op8_745"]?.strokeWidth}
              >
                <path d="M389.2 399.9v.23l-1.13 2.37h-.36l1.12-2.3h-1.27v-.29ZM390.65 402.5v-.71h-1.25v-.23l1.16-1.66h.38v1.62h.46v.27h-.37v.71Zm0-1v-1.21c-.08.15-.14.27-.22.39l-.63.88h.85ZM393.17 400.2h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.16-1.25h1.25ZM394.64 399.81h.35v2.4h1.15v.29h-1.5ZM397.92 401.24h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM399.12 402.5l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM402.16 401.24h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM402.73 399.81h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_745">
                <path d="M387.33 389.44a4 4 0 0 1 .75-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.67.69.69 0 0 1 .38.52 5 5 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.63c-.07-.35-.2-.47-.48-.47h-.25v1.1h-.49Zm.49 1.19h.29c.34 0 .54-.18.54-.45s-.21-.43-.52-.43a1 1 0 0 0-.31 0ZM392 390.7a1.28 1.28 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.5-.77 1.06ZM394.7 391v-1.14c-.09.33-.2.7-.32 1l-.39 1.16h-.38l-.36-1.15c-.1-.34-.2-.71-.27-1v1.15l-.06 1.08h-.52l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.29.17-.62.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_745">
                {colors["rect_op8_745"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_745">
                      <path
                        fill="#7c6956"
                        d="m423.98 389.79-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.73.73 0 0 1 .41-.23l.87-.16M421.99 391.77a.71.71 0 0 1-.63-.33.68.68 0 0 1 .52-1.06.74.74 0 0 1 .51.2l.05.05a.72.72 0 0 1 .16.83l-.15.29M422.9 391.25l.6.11.72-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m422.9 391.25.6.11-.05.22M424.34 391.58l-.12-.49.5-.54.13.81M424.85 391.36l-.51.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m424.34 391.58-.12-.49-.72.27-.05.22"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m425.1 391.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M415.1 393a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M421.4 394.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M420.7 392.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="422.6" cy="393.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="417.1" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="413.1" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="422.9" cy="393.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP8_735">
              <path
                id="LINE-22"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M377.25 413.15h53.45"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op8_735"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op8_735"
                  d="M432.45 434.85h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op8_735"]?.color}
                  onMouseDown={(e) => handleColor("rect_op8_735")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op8_735"
                stroke={colors["rect_label_op8_735"]?.stroke}
                strokeWidth={colors["rect_label_op8_735"]?.strokeWidth}
              >
                <path d="M357.15 416.7v.24l-1.13 2.36h-.36l1.12-2.3h-1.27v-.3ZM357.6 418.9a1.2 1.2 0 0 0 .57.16c.45 0 .59-.28.59-.5 0-.37-.33-.52-.67-.52h-.2v-.27h.2c.26 0 .58-.13.58-.43s-.13-.4-.46-.4a1 1 0 0 0-.52.18l-.09-.26a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .58.67c0 .41-.33.78-1 .78a1.26 1.26 0 0 1-.68-.18ZM361.12 417h-1l-.1.67h.21a1.16 1.16 0 0 1 .56.14.75.75 0 0 1 .37.67.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.14.56.56 0 0 0 .61-.56c0-.34-.22-.57-.74-.57h-.36l.16-1.25h1.25ZM362.59 416.61h.35v2.4h1.15v.29h-1.5ZM365.87 418.04h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM367.07 419.3l-.88-2.69h.38l.42 1.33c.12.36.21.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.36l-1 2.69ZM370.11 418.04h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM370.68 416.61h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op8_735">
                <path d="M355.28 406.09a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM359.95 407.38a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM362.65 407.7v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op8_735">
                {colors["rect_op8_735"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="10 0"
                      dur="5s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op8_735">
                      <path
                        fill="#7c6956"
                        d="m393.08 406.77-.51.5a.69.69 0 0 1-.55.21h-.12a.71.71 0 0 1-.47-1.17.67.67 0 0 1 .41-.22l.87-.16M391.08 408.75a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19h.05a.74.74 0 0 1 .16.84l-.15.29M392 408.23l.6.1.72-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m392 408.23.6.1-.04.23M393.44 408.56l-.12-.5.5-.54.13.81M393.95 408.33l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m393.44 408.56-.12-.5-.72.27-.04.23"></path>
                    </g> 
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m393.45 409.85-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6"
                ></path>
                <path
                  fill="#5e7076"
                  d="M384.05 410.25a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M390.4 411.7a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.65.55Z"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M389.65 410.15a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.35v.2h.3v1.5h-.6v.4l.6.4h1.8v-.35a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.55v-.2h.6v.2Zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.15-.2.2-.3.2"
                ></path>
                <circle cx="391.55" cy="410.65" r="0.1" fill="#ebb24b"></circle>
                <circle cx="386.05" cy="411.55" r="0.1" fill="#ebb24b"></circle>
                <circle cx="382.05" cy="411.55" r="0.1" fill="#ebb24b"></circle>
                <circle cx="391.85" cy="410.85" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <path d="M414.33 420.5a1.11 1.11 0 0 1-1.13 1.2 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.23m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM414.7 419.37a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.83h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM416.53 421.12a.61.61 0 0 1 .42-.59.57.57 0 0 1-.34-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.6.6 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.31-.81-.62m1.2 0c0-.23-.17-.36-.42-.43a.41.41 0 0 0-.34.4.36.36 0 0 0 .38.37.35.35 0 0 0 .38-.36Zm-.71-1.11c0 .19.15.3.37.36a.37.37 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM410.96 423.48a2.5 2.5 0 0 0-.39 1.42 2.57 2.57 0 0 0 .39 1.41h-.31a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM411.3 425.43a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.63-.35-.63-.69.32-.67.83-.67a1.3 1.3 0 0 1 .57.11l-.11.35a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.14-.39.28s.14.27.45.39.61.36.61.7-.29.71-.89.71a1.4 1.4 0 0 1-.64-.15ZM413.56 423.54v2.36h-.43v-2.36ZM413.9 425.7l1.2-1.75H414v-.36h1.66v.26l-1.19 1.73h1.21v.36h-1.78ZM417.4 424.86h-.89v.69h1v.35h-1.43v-2.36h1.32v.36h-.94v.6h.94ZM417.84 423.58a4.5 4.5 0 0 1 .68-.05 1.43 1.43 0 0 1 1 .27 1.06 1.06 0 0 1 .37.86 1.19 1.19 0 0 1-.37.94 1.56 1.56 0 0 1-1.06.32 4 4 0 0 1-.58 0Zm.43 2h.24a.8.8 0 0 0 .89-.9.75.75 0 0 0-.84-.82 1 1 0 0 0-.29 0ZM420.03 426.31a2.76 2.76 0 0 0 0-2.83h.31a2.54 2.54 0 0 1 0 2.83ZM411.93 430.1v-.26l.27-.25c.53-.5.78-.77.79-1.07a.36.36 0 0 0-.41-.38.78.78 0 0 0-.48.19l-.13-.31a1.13 1.13 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.69 1.09l-.19.17h.93v.36ZM414.48 428.22l-.41.21-.08-.33.56-.27h.35v2.27h-.41ZM416.49 428.9v-.5h.37v.25a.59.59 0 0 1 .52-.29.49.49 0 0 1 .47.31.7.7 0 0 1 .21-.21.63.63 0 0 1 .35-.1c.28 0 .56.19.56.74v1h-.42v-.94c0-.29-.09-.45-.3-.45a.32.32 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.09-.41-.29-.41a.34.34 0 0 0-.31.24.3.3 0 0 0 0 .14v1h-.42ZM440.93 421.5a1.11 1.11 0 0 1-1.13 1.2 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.23m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM441.3 420.37a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.83h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM443.13 422.12a.61.61 0 0 1 .42-.59.57.57 0 0 1-.34-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.6.6 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.31-.81-.62m1.2 0c0-.23-.17-.36-.43-.43a.41.41 0 0 0-.33.4.36.36 0 0 0 .38.37.35.35 0 0 0 .38-.36Zm-.71-1.11c0 .19.15.3.37.36a.37.37 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM438.4 426.5a.9.9 0 0 0 .43.13c.19 0 .28-.08.28-.19s-.08-.18-.28-.25-.48-.3-.47-.5.24-.53.64-.53a1 1 0 0 1 .45.1l-.08.3a.8.8 0 0 0-.36-.09c-.16 0-.24.07-.24.18s.08.16.3.23.45.27.45.52-.24.54-.69.54a1.1 1.1 0 0 1-.52-.12ZM440.17 426.17c0 .31.25.44.53.44a1.3 1.3 0 0 0 .47-.08l.06.3a1.6 1.6 0 0 1-.6.11.8.8 0 0 1-.87-.87.83.83 0 0 1 .83-.91.74.74 0 0 1 .73.83 1 1 0 0 1 0 .18Zm.75-.3a.37.37 0 0 0-.36-.42.42.42 0 0 0-.39.42ZM442.92 426.85a1.2 1.2 0 0 1-.48.09.82.82 0 0 1-.87-.87.87.87 0 0 1 .94-.91 1.2 1.2 0 0 1 .42.08l-.08.32a.8.8 0 0 0-.33-.06.55.55 0 0 0 0 1.1.9.9 0 0 0 .33-.07ZM444.04 425.82v.3h-.89v-.3ZM444.3 426.9v-.26l.27-.25c.53-.5.78-.77.79-1.07a.36.36 0 0 0-.41-.38.78.78 0 0 0-.48.19l-.13-.31a1.13 1.13 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.69 1.09l-.19.17h.93v.36ZM425.63 321.9a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM426 320.77a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.89H426Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM427.83 322.51a.61.61 0 0 1 .42-.58.57.57 0 0 1-.34-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.6.6 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.31-.81-.63m1.2 0c0-.24-.17-.36-.42-.43a.41.41 0 0 0-.34.4.36.36 0 0 0 .38.37.35.35 0 0 0 .38-.35Zm-.71-1.11c0 .19.15.3.37.36a.37.37 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM423.09 326.9a.9.9 0 0 0 .43.13c.19 0 .28-.08.28-.19s-.07-.18-.28-.25-.48-.3-.47-.5.24-.53.64-.53a1 1 0 0 1 .45.1l-.08.3a.8.8 0 0 0-.36-.09c-.16 0-.24.07-.24.18s.08.16.3.23.45.27.45.52-.24.54-.69.54a1.1 1.1 0 0 1-.52-.12ZM424.87 326.57c0 .31.25.44.53.44a1.3 1.3 0 0 0 .47-.08l.06.3a1.6 1.6 0 0 1-.6.11.81.81 0 0 1-.87-.87.83.83 0 0 1 .83-.91.74.74 0 0 1 .73.83 1 1 0 0 1 0 .18Zm.75-.3a.37.37 0 0 0-.36-.42.42.42 0 0 0-.39.42ZM427.62 327.25a1.2 1.2 0 0 1-.48.09.82.82 0 0 1-.87-.87.87.87 0 0 1 .94-.91 1.2 1.2 0 0 1 .42.08l-.08.32a.8.8 0 0 0-.32-.06.55.55 0 0 0 0 1.1 1 1 0 0 0 .34-.07ZM428.74 326.22v.3h-.89v-.3ZM429.67 325.42l-.41.21-.08-.33.56-.27h.36v2.27h-.42ZM425.53 344.75a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.13-1.23 1.09 1.09 0 0 1 1.09 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM425.9 343.62a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.89h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM427.73 345.37a.61.61 0 0 1 .42-.59.57.57 0 0 1-.34-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.6.6 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.29-.81-.62m1.2 0c0-.23-.17-.36-.42-.43a.41.41 0 0 0-.34.4.36.36 0 0 0 .38.37.35.35 0 0 0 .38-.36Zm-.71-1.11c0 .19.15.3.37.36a.37.37 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM422.93 347.7a2.42 2.42 0 0 0-.4 1.42 2.5 2.5 0 0 0 .4 1.41h-.32a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM423.27 347.83a4 4 0 0 1 .66-.05 1.05 1.05 0 0 1 .72.19.58.58 0 0 1 .21.47.63.63 0 0 1-.43.59.58.58 0 0 1 .33.45 4 4 0 0 0 .18.66h-.44a3 3 0 0 1-.16-.56c-.07-.3-.18-.4-.42-.41h-.22v1h-.43Zm.43 1h.26c.29 0 .47-.16.47-.39s-.18-.38-.46-.38a1.3 1.3 0 0 0-.27 0ZM427.4 348.95a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.25.86.66.86s.65-.38.65-.88-.22-.86-.65-.86-.71.43-.71.91ZM429.71 349.19v-1c-.08.29-.18.6-.28.9l-.35 1h-.33l-.31-1c-.09-.31-.18-.63-.24-.92v1l-.05.95h-.4l.15-2.36h.5l.31 1c.08.28.16.56.21.82.07-.26.15-.54.24-.82l.33-1h.55l.14 2.36h-.42ZM430.47 350.56a2.76 2.76 0 0 0 0-2.83h.31a2.54 2.54 0 0 1 0 2.83ZM422.86 352.47l-.46.23-.07-.33.55-.27h.36v2.27h-.42ZM425.45 352.38h-.22a.8.8 0 0 0-.76.67.64.64 0 0 1 .51-.22.69.69 0 0 1 .7.74.79.79 0 0 1-.81.81.86.86 0 0 1-.85-1 1.42 1.42 0 0 1 .39-1 1.33 1.33 0 0 1 .81-.34.8.8 0 0 1 .22 0Zm-.2 1.22a.4.4 0 0 0-.4-.45.42.42 0 0 0-.37.24.23.23 0 0 0 0 .13c0 .3.15.55.43.55s.34-.2.34-.47M427.32 352.38h-.21a.82.82 0 0 0-.77.67.67.67 0 0 1 .52-.22.68.68 0 0 1 .69.74.79.79 0 0 1-.8.81.87.87 0 0 1-.86-1 1.38 1.38 0 0 1 .4-1 1.3 1.3 0 0 1 .81-.34.7.7 0 0 1 .21 0Zm-.2 1.22a.4.4 0 0 0-.39-.45.41.41 0 0 0-.37.24.23.23 0 0 0 0 .13c0 .3.15.55.43.55s.33-.2.33-.47M428.62 353.15v-.5h.37v.25a.58.58 0 0 1 .52-.29.49.49 0 0 1 .47.31.7.7 0 0 1 .21-.21.6.6 0 0 1 .34-.1c.29 0 .57.19.57.74v1h-.42v-.94c0-.29-.1-.45-.3-.45a.31.31 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.3-.41a.32.32 0 0 0-.3.24.4.4 0 0 0 0 .14v1h-.42ZM436.77 348.21h1.36v.35h-.93v.65h.86v.35h-.86v1h-.43ZM438.55 348.24a4 4 0 0 1 .65-.05 1.12 1.12 0 0 1 .73.19.59.59 0 0 1 .2.47.62.62 0 0 1-.43.59.62.62 0 0 1 .33.46 4 4 0 0 0 .19.65h-.45a4 4 0 0 1-.16-.55c-.06-.31-.17-.41-.42-.41h-.22v1h-.42Zm.42 1h.26c.29 0 .47-.15.47-.39s-.18-.37-.46-.38a1.3 1.3 0 0 0-.27 0Z"></path>
            <g
              id="label_op8_720"
              stroke={colors["rect_label_op8_720"]?.stroke}
              strokeWidth={colors["rect_label_op8_720"]?.strokeWidth}
            >
              <path d="M442.09 449.23v.24l-1.14 2.36h-.36l1.13-2.3h-1.27v-.3ZM442.45 451.83v-.21l.27-.27c.67-.63 1-1 1-1.36a.46.46 0 0 0-.51-.51.87.87 0 0 0-.55.22l-.11-.25a1.1 1.1 0 0 1 .73-.26.72.72 0 0 1 .79.75c0 .49-.34.87-.89 1.4l-.21.19h1.17v.29ZM446.23 450.51c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.34.37-1.35.9-1.35.86.51.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.41-.53 1.11ZM447.52 449.14h.35v2.4h1.16v.29h-1.51ZM450.81 450.57h-1.05v1h1.17v.29h-1.53v-2.69h1.46v.29h-1.11v.85h1.05ZM452.01 451.83l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.42l-1 2.69ZM455.04 450.57h-1v1h1.17v.29h-1.52v-2.69h1.46v.29H454v.85h1ZM455.62 449.14h.35v2.4h1.15v.29h-1.5Z"></path>
            </g>
            <g id="RB4">
              <path
                id="container-3"
                fill="#cb9636"
                d="M480 396.12a2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 2.95 2.75 2.81 2.81 0 0 1-2.95 2.75H483a2.89 2.89 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-3" fill="#50514e" data-name="label">
                <path d="M431.04 375.03a7 7 0 0 1 1.12-.09 1.84 1.84 0 0 1 1.24.33 1 1 0 0 1 .35.81 1.06 1.06 0 0 1-.73 1 1 1 0 0 1 .56.78 9 9 0 0 0 .32 1.13h-.76a5.3 5.3 0 0 1-.27-1c-.12-.53-.31-.7-.73-.71h-.37v1.67h-.73Zm.73 1.78h.44c.5 0 .81-.26.81-.66s-.31-.65-.79-.65a2 2 0 0 0-.46 0ZM434.45 375.03a6 6 0 0 1 1.08-.09 2 2 0 0 1 1.16.26.85.85 0 0 1 .41.76.93.93 0 0 1-.67.87 1 1 0 0 1 .82 1 1.05 1.05 0 0 1-.39.83 2.26 2.26 0 0 1-1.5.37 6.5 6.5 0 0 1-.91-.05Zm.74 1.6h.37c.52 0 .8-.25.8-.59s-.29-.55-.75-.55a2 2 0 0 0-.42 0Zm0 1.85a2 2 0 0 0 .39 0c.47 0 .89-.18.89-.68s-.41-.66-.92-.66h-.36ZM439.4 379.02v-1h-1.8v-.49l1.59-2.42h.88v2.35h.5v.56h-.5v1Zm0-1.55v-1.7400000000000002c-.12.24-.22.44-.35.66l-.71 1.06Z"></path>
              </g>
            </g>
            <g id="OP8">
              <path
                id="container-4"
                fill="#cb9636"
                d="M506.94 443.35a2.9 2.9 0 0 1 2.95-2.75H532a2.89 2.89 0 0 1 2.94 2.75 2.82 2.82 0 0 1-2.94 2.75h-22.11a2.9 2.9 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-4" fill="#50514e" data-name="label">
                <path d="M461.57 424.18a1.91 1.91 0 0 1-1.93 2.13 1.88 1.88 0 0 1-1.87-2.06 1.94 1.94 0 0 1 1.93-2.11 1.86 1.86 0 0 1 1.87 2.04m-3 .06c0 .82.42 1.48 1.13 1.48s1.11-.66 1.11-1.51-.41-1.51-1.13-1.51-1.13.71-1.13 1.54ZM462.21 422.25a7.5 7.5 0 0 1 1.13-.08 1.8 1.8 0 0 1 1.19.33 1.15 1.15 0 0 1 .39.9 1.25 1.25 0 0 1-.34.91 1.76 1.76 0 0 1-1.28.44 2 2 0 0 1-.36 0v1.52h-.73Zm.73 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.31-.68-.82-.68a3 3 0 0 0-.43 0ZM465.34 425.24a1.09 1.09 0 0 1 .73-1 1 1 0 0 1-.59-.86 1.16 1.16 0 0 1 1.3-1.07c.84 0 1.22.5 1.22 1a1 1 0 0 1-.6.88 1.06 1.06 0 0 1 .75 1c0 .69-.59 1.16-1.42 1.16s-1.39-.56-1.39-1.11m2.06 0c0-.4-.29-.61-.73-.73a.7.7 0 0 0-.57.68.61.61 0 0 0 .65.63.59.59 0 0 0 .65-.61Zm-1.22-1.89c0 .32.26.51.64.61a.64.64 0 0 0 .48-.59.56.56 0 0 0-1.12 0Z"></path>
              </g>
            </g>
            <g id="OP8-2" data-name="OP8">
              <TooltipOPComponent
                nivel={opColors["OP8"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handleOPColor("OP8")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="container-5"
                    fill={opColors["OP8"].color}
                    d="M479.15 251.2a2.89 2.89 0 0 1 3-2.75h22.1a2.89 2.89 0 0 1 2.95 2.75 2.82 2.82 0 0 1-3 2.8h-22.1a2.89 2.89 0 0 1-3-2.75"
                    data-name="container"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                </g>
              </TooltipOPComponent>
              <g id="label-5" fill="#50514e" data-name="label">
                <path d="M433.78 232.03a1.91 1.91 0 0 1-1.94 2.13 1.87 1.87 0 0 1-1.86-2.06 1.93 1.93 0 0 1 1.92-2.11 1.87 1.87 0 0 1 1.88 2.04m-3 .06c0 .82.42 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.68-1.14 1.51ZM434.4 230.1a7.6 7.6 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.13 1.13 0 0 1 .4.9 1.2 1.2 0 0 1-.35.91 1.74 1.74 0 0 1-1.27.44 2 2 0 0 1-.36 0v1.52h-.74Zm.74 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.32-.68-.83-.68a3 3 0 0 0-.42 0ZM437.55 233.09a1.08 1.08 0 0 1 .73-1 .93.93 0 0 1-.59-.86 1.16 1.16 0 0 1 1.3-1.07c.84 0 1.22.5 1.22 1a1 1 0 0 1-.6.88 1.07 1.07 0 0 1 .75 1c0 .69-.59 1.16-1.43 1.16s-1.38-.56-1.38-1.11m2.05 0c0-.4-.29-.61-.72-.73a.7.7 0 0 0-.58.68.62.62 0 0 0 .66.63.58.58 0 0 0 .64-.61Zm-1.2-1.92c0 .32.26.51.63.61a.64.64 0 0 0 .49-.59.52.52 0 0 0-.56-.55.51.51 0 0 0-.56.53"></path>
              </g>
            </g>
          </g>
          <g id="LEVELS_03" data-name="LEVELS 03">
            <g id="OP7_1060">
              <path
                id="LINE-23"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.7 147.3H314l7.43 5.94"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_1060"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_1060"
                  d="M353.9 168.9h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_1060"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_1060")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_1060"
                stroke={colors["rect_label_op7_1060"]?.stroke}
                strokeWidth={colors["rect_label_op7_1060"]?.strokeWidth}
              >
                <path d="m277.9 151.23-.45.24-.07-.27.57-.3h.29v2.6h-.34ZM280.92 152.17c0 .89-.33 1.37-.9 1.37s-.85-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM282.73 151.15a1.4 1.4 0 0 0-.27 0 1 1 0 0 0-.9.92.79.79 0 0 1 1.41.54.86.86 0 0 1-.86.91c-.55 0-.92-.43-.92-1.1a1.6 1.6 0 0 1 .44-1.17 1.38 1.38 0 0 1 .83-.39 1.3 1.3 0 0 1 .26 0Zm-.1 1.5a.53.53 0 0 0-.54-.6.56.56 0 0 0-.5.32.34.34 0 0 0 0 .16c0 .42.2.74.57.74s.47-.25.47-.57ZM285.03 152.17c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.42 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM286.32 150.81h.35v2.4h1.15v.29h-1.5ZM289.6 152.24h-1v1h1.17v.29h-1.52v-2.69h1.45v.29h-1.1v.85h1ZM290.81 153.5l-.89-2.69h.38l.42 1.32c.12.37.22.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM293.84 152.24h-1.05v1h1.17v.29h-1.56v-2.69h1.46v.29h-1.11v.85h1.05ZM294.4 150.81h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_1060">
                <path d="M276.96 140.54a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.47a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11H277Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM281.63 141.83a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM284.32 142.1v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1v1.15l-.2 1.06h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.41Z"></path>
              </g>
              <g id="carrito_op7_1060">
                {colors["rect_op7_1060"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_1060">
                      <path
                        fill="#7c6956"
                        d="m314.52 140.92-.5.5a.72.72 0 0 1-.55.21h-.07a.71.71 0 0 1-.48-1.17.62.62 0 0 1 .4-.22l.88-.16M312.53 142.9a.71.71 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.67.67 0 0 1 .5.19l.06.05a.72.72 0 0 1 .15.84l-.14.29M313.45 142.38l.59.1.72-.26.51-.55-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.45 142.38.59.1-.04.23M314.88 142.71l-.12-.49.51-.55.12.81M315.39 142.48l-.51.23"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m314.88 142.71-.12-.49-.72.26-.04.23"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.5 143.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.5 144.3a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.8 145.7a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.1 144.2a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="313" cy="144.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.5" cy="145.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.5" cy="145.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.3" cy="144.9" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_960">
              <path
                id="LINE-24"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M297.65 219.2h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_960"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_960"
                  d="M352.85 240.9h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_960"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_960")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_960"
                stroke={colors["rect_label_op7_960"]?.stroke}
                strokeWidth={colors["rect_label_op7_960"]?.strokeWidth}
              >
                <path d="M277.76 225.1a1.6 1.6 0 0 0 .29 0 .93.93 0 0 0 .54-.25 1.16 1.16 0 0 0 .34-.69.74.74 0 0 1-.61.28.75.75 0 0 1-.77-.8.89.89 0 0 1 .85-.94c.53 0 .86.43.86 1.1a1.63 1.63 0 0 1-.45 1.22 1.33 1.33 0 0 1-.76.34 1.2 1.2 0 0 1-.32 0Zm.13-1.5a.5.5 0 0 0 .5.55.56.56 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.16-.78-.53-.78s-.48.26-.48.63M281.09 222.99a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.79.79 0 0 1 1.41.54.88.88 0 0 1-.87.92c-.55 0-.91-.44-.91-1.11a1.62 1.62 0 0 1 .44-1.17 1.47 1.47 0 0 1 .83-.39h.25Zm-.1 1.5a.52.52 0 0 0-.53-.59.59.59 0 0 0-.51.32.3.3 0 0 0 0 .15c0 .43.21.75.58.75s.46-.26.46-.63M283.4 224.02c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.34.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.41.53-1.08-.17-1.06-.53-1.06-.54.41-.54 1.11ZM284.68 222.7h.35v2.4h1.16v.29h-1.51ZM287.97 224.08h-1.05v1h1.17v.29h-1.52v-2.67h1.46v.29h-1.11v.85h1.05ZM289.17 225.34l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM292.2 224.08h-1v1h1.17v.29h-1.52v-2.67h1.45v.29h-1.1v.85h1ZM292.78 222.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_960">
                <path d="M277.24 212.24a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.5a3 3 0 0 1-.19-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM281.91 213.53a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.75-1-.75.48-.75 1.03ZM284.61 213.8v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.45l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op7_960">
                {colors["rect_op7_960"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_960">
                      <path
                        fill="#7c6956"
                        d="m313.48 212.91-.51.51a.69.69 0 0 1-.55.21h-.12a.71.71 0 0 1-.47-1.17.67.67 0 0 1 .41-.22l.87-.16M311.48 214.9a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.05a.74.74 0 0 1 .16.84l-.15.29M312.4 214.38l.6.1.72-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m312.4 214.38.6.1-.05.23M313.83 214.71l-.11-.5.5-.54.13.81M314.35 214.48l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m313.83 214.71-.11-.5-.72.27-.05.23"></path>
                    </g>    
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m314.45 215.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M304.45 216.3a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M310.75 217.7a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M310.05 216.2a4.2 4.2 0 0 0-1.2-.4h-.8v-.2h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.3h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="311.95" cy="216.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="306.45" cy="217.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="302.45" cy="217.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="312.25" cy="216.9" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_935">
              <path
                id="LINE-25"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.61 236h15.3l8.83 6.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_935"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_935"
                  d="M353.81 257.7h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_935"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_935")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_935"
                stroke={colors["rect_label_op7_935"]?.stroke}
                strokeWidth={colors["rect_label_op7_935"]?.strokeWidth}
              >
                <path d="M277.93 242.05a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .54-.25 1.2 1.2 0 0 0 .35-.69.81.81 0 0 1-.62.28.76.76 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.09a1.63 1.63 0 0 1-.45 1.22 1.25 1.25 0 0 1-.75.35 2 2 0 0 1-.32 0Zm.12-1.49a.5.5 0 0 0 .5.55.61.61 0 0 0 .52-.27.4.4 0 0 0 0-.13c0-.45-.17-.78-.54-.78s-.48.26-.48.63M279.86 241.9a1.2 1.2 0 0 0 .57.16.51.51 0 0 0 .59-.5c0-.37-.33-.52-.67-.52h-.2v-.27h.2c.26 0 .58-.13.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.25a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.66.66 0 0 1-.48.61.66.66 0 0 1 .57.66c0 .42-.32.78-.94.78a1.37 1.37 0 0 1-.68-.17ZM283.4 240h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.57c0-.33-.23-.57-.74-.57a2 2 0 0 0-.37 0l.17-1.25h1.29ZM284.85 239.61h.35v2.4h1.2v.29h-1.5ZM288.13 241.04h-1v1h1.16v.29h-1.51v-2.69h1.45v.28h-1.1v.86h1ZM289.33 242.3l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM292.4 241.04h-1.05v1h1.17v.29H291v-2.69h1.4v.28h-1.11v.86h1.11ZM292.94 239.61h.35v2.4h1.11v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_935">
                <path d="M277.53 228.94a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.5.68.67.67 0 0 1 .38.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.48Zm.48 1.19h.3c.33 0 .53-.17.53-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM282.19 230.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.47-.76 1.03ZM284.89 230.5v-1.13c-.09.33-.21.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.21-.71-.28-1.05v1.15l-.06 1.08h-.46l.18-2.69h.58l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op7_935">
                {colors["rect_op7_935"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_935">
                      <path
                        fill="#7c6956"
                        d="m314.58 229.75-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.73.73 0 0 1 .41-.23l.87-.16M312.58 231.7a.7.7 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.74.74 0 0 1 .51.2h.05a.72.72 0 0 1 .16.83l-.15.29M313.5 231.21l.6.11.72-.27.5-.55-.6-.02-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.5 231.21.6.11-.04.22M314.94 231.54l-.12-.49.5-.55.13.82M315.45 231.32l-.51.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m314.94 231.54-.12-.49-.72.27-.04.22"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.4 231.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.4 233.1a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.71 234.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.01 233a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.61v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.1h.6v.2h-.6Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="312.91" cy="233.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.41" cy="234.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.41" cy="234.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.21" cy="233.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_910">
              <path
                id="LINE-26"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m322.81 260.24-9.51-6.56H298"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_910"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_910"
                  d="M353.2 275.27h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_910"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_910")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_910"
                stroke={colors["rect_label_op7_910"]?.stroke}
                strokeWidth={colors["rect_label_op7_910"]?.strokeWidth}
              >
                <path d="M277.93 258.99a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .54-.25 1.2 1.2 0 0 0 .35-.69.78.78 0 0 1-.62.28.75.75 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.1a1.6 1.6 0 0 1-.45 1.21 1.25 1.25 0 0 1-.75.35 1.3 1.3 0 0 1-.32 0Zm.12-1.49a.5.5 0 0 0 .5.55.61.61 0 0 0 .52-.27.4.4 0 0 0 0-.13c0-.45-.17-.78-.54-.78s-.48.26-.48.63M280.54 256.97l-.45.24-.07-.26.57-.31h.3v2.6h-.34ZM283.55 257.92c0 .88-.33 1.37-.9 1.37s-.85-.48-.86-1.34.38-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.41-.53 1.11ZM284.85 256.55h.35v2.4h1.2v.29h-1.5ZM288.13 257.98h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.83h1ZM289.33 259.24l-.88-2.69h.38l.42 1.33c.11.36.21.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM292.4 257.98h-1.05v1h1.17v.29H291v-2.69h1.4v.29h-1.11v.83h1.11ZM292.94 256.55h.35v2.4h1.11v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_910">
                <path d="M277.53 246.62a4 4 0 0 1 .74-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.67.7.7 0 0 1 .37.52c.09.34.16.65.21.76h-.5a3.5 3.5 0 0 1-.18-.64c-.08-.35-.21-.47-.49-.47h-.25v1.11h-.48Zm.48 1.19h.3c.33 0 .53-.18.53-.45s-.2-.43-.52-.43a1 1 0 0 0-.31 0ZM282.19 247.9a1.28 1.28 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.45.74-1-.25-1-.74-1-.76.49-.76 1.04ZM284.89 248.18v-1.14c-.09.33-.21.7-.32 1l-.4 1.16h-.38l-.35-1.15a10 10 0 0 1-.28-1.05c0 .36 0 .79-.05 1.15l-.06 1.09h-.46l.18-2.7h.63l.36 1.08c.09.32.18.64.24.94.08-.29.17-.62.27-.94l.38-1.08h.64l.15 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op7_910">
                {colors["rect_op7_910"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_910">
                      <path
                        fill="#7c6956"
                        d="m313.88 247.42-.5.51a.73.73 0 0 1-.56.21h-.12a.71.71 0 0 1-.47-1.17.73.73 0 0 1 .41-.23l.87-.15M311.89 249.41a.73.73 0 0 1-.63-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.05a.74.74 0 0 1 .16.84l-.15.29M312.81 248.89l.59.1.72-.27.5-.54-.6-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m312.81 248.89.59.1-.04.23M314.24 249.22l-.12-.5.5-.54.13.81M314.75 248.99l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m314.24 249.22-.12-.5-.72.27-.04.23"></path>
                    </g>  
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m314.8 249.47-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M304.8 250.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.57ZM311.1 252.17a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M310.4 250.57a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.53h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h1.4Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="312.3" cy="251.17" r="0.1" fill="#ebb24b"></circle>
                <circle cx="306.8" cy="252.07" r="0.1" fill="#ebb24b"></circle>
                <circle cx="302.8" cy="252.07" r="0.1" fill="#ebb24b"></circle>
                <circle cx="312.6" cy="251.27" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_885">
              <path
                id="LINE-27"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.75 271.49h15.3l8.76 8.12"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_885"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_885"
                  d="M354 293.19h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_885"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_885")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_885"
                stroke={colors["rect_label_op7_885"]?.stroke}
                strokeWidth={colors["rect_label_op7_885"]?.strokeWidth}
              >
                <path d="M277.53 276.81a.75.75 0 0 1 .51-.7.63.63 0 0 1-.42-.58.73.73 0 0 1 .81-.69.67.67 0 0 1 .76.64.66.66 0 0 1-.43.61.72.72 0 0 1 .52.67.8.8 0 0 1-.88.76.77.77 0 0 1-.87-.71m1.4 0c0-.31-.22-.46-.58-.56a.56.56 0 0 0-.46.53.47.47 0 0 0 .51.5.48.48 0 0 0 .53-.49Zm-1-1.3c0 .27.2.41.49.49a.52.52 0 0 0 .4-.48.45.45 0 0 0-.89 0ZM279.58 276.81a.77.77 0 0 1 .51-.7.62.62 0 0 1-.41-.58.72.72 0 0 1 .8-.69.67.67 0 0 1 .76.64.66.66 0 0 1-.43.61.72.72 0 0 1 .52.67.8.8 0 0 1-.88.76.77.77 0 0 1-.87-.71m1.4 0c0-.31-.22-.46-.57-.56a.56.56 0 0 0-.47.53.52.52 0 0 0 1 0Zm-1-1.3c0 .27.2.41.49.49a.52.52 0 0 0 .4-.48.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM283.21 275.17h-1l-.1.67h.21a1.13 1.13 0 0 1 .56.14.73.73 0 0 1 .37.67.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.14.58.58 0 0 0 .61-.56c0-.34-.23-.58-.75-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM284.68 274.78h.35v2.4h1.16v.29h-1.51ZM287.97 276.21h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM289.17 277.47l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM292.2 276.21h-1v1h1.17v.29h-1.52v-2.69h1.45v.29h-1.1v.85h1ZM292.78 274.78h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_885">
                <path d="M277.81 264.53a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5.4 5.4 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM282.47 265.82a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM285.17 266.09v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.37l-.36-1.15a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.7h.65l.35 1.09c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.09h.64l.15 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op7_885">
                {colors["rect_op7_885"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_885">
                      <path
                        fill="#7c6956"
                        d="m314.72 265.2-.5.51a.71.71 0 0 1-.55.21h-.12a.71.71 0 0 1-.48-1.17.64.64 0 0 1 .4-.22l.88-.16M312.73 267.19a.71.71 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.67.67 0 0 1 .5.19h.06a.72.72 0 0 1 .15.84l-.14.29M313.65 266.67l.59.1.72-.27.51-.54-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.65 266.67.59.1-.04.23M315.08 267l-.12-.5.51-.54.13.81M315.59 266.77l-.51.23"
                      ></path>
                      <path fill="#8d7e70" d="m315.08 267-.12-.5-.72.27-.04.23"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.55 267.39-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.55 268.59a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.85 269.99a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.55.6Z"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.15 268.49a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-.99a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0Zm-3 .2c.1 0 .2.1.3.2h-.5v-.19Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.05.1-.2.2-.3.2"
                ></path>
                <circle cx="313.05" cy="268.99" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.55" cy="269.99" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.55" cy="269.99" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.35" cy="269.19" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_835">
              <path
                id="LINE-28"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.55 308.95h14.3l10 7"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_835"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_835"
                  d="M353.85 329.47h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_835"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_835")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_835"
                stroke={colors["rect_label_op7_835"]?.stroke}
                strokeWidth={colors["rect_label_op7_835"]?.strokeWidth}
              >
                <path d="M277.67 313.76a.75.75 0 0 1 .52-.7.66.66 0 0 1-.42-.59.73.73 0 0 1 .81-.69.65.65 0 0 1 .33 1.25.73.73 0 0 1 .52.67.8.8 0 0 1-.89.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.46.46 0 0 0 .52-.52Zm-1-1.3c0 .26.19.4.49.48a.51.51 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM279.84 314.01a1.1 1.1 0 0 0 .58.17.52.52 0 0 0 .59-.51c0-.36-.34-.52-.68-.52h-.19v-.26h.19c.26 0 .58-.13.58-.44s-.13-.39-.45-.39a.94.94 0 0 0-.52.17l-.1-.26a1.25 1.25 0 0 1 .68-.2c.52 0 .75.31.75.62a.66.66 0 0 1-.48.62.69.69 0 0 1 .58.67c0 .42-.33.78-1 .78a1.2 1.2 0 0 1-.67-.18ZM283.4 312.11h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.66.9.9 0 0 1-1 .89 1.25 1.25 0 0 1-.65-.16l.09-.27a1.06 1.06 0 0 0 .55.15.58.58 0 0 0 .62-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.29ZM284.83 311.7h.35v2.4h1.15v.3h-1.5ZM288.11 313.15h-1v1h1.17v.29h-1.52v-2.74h1.46v.29h-1.11v.86h1ZM289.32 314.42l-.92-2.72h.37l.42 1.33a10 10 0 0 1 .29 1c.08-.32.19-.65.31-1l.45-1.33h.37l-1 2.7ZM292.4 313.15h-1v1h1.16v.29h-1.51v-2.74h1.35v.29h-1.1v.86h1ZM292.92 311.7h.35v2.4h1.13v.3h-1.51Z"></path>
              </g>
              <g id="label2_op7_835">
                <path d="M277.66 301.9a4 4 0 0 1 .75-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.67.71.71 0 0 1 .38.52 4.2 4.2 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.63c-.08-.35-.2-.47-.48-.47h-.25v1.1h-.49Zm.49 1.19h.25c.33 0 .54-.18.54-.45s-.21-.43-.53-.43a1 1 0 0 0-.3 0ZM282.32 303.18a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.52-.76 1.04ZM285.02 303.46v-1.14c-.09.33-.2.7-.32 1l-.39 1.16h-.38l-.36-1.15c-.1-.34-.2-.71-.27-1.05 0 .35 0 .79-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.29.16-.62.27-.94l.37-1.08h.6l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op7_835">
                {colors["rect_op7_835"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_835">
                      <path
                        fill="#7c6956"
                        d="m313.4 302.57-.51.51a.69.69 0 0 1-.55.2h-.12a.7.7 0 0 1-.47-1.16.73.73 0 0 1 .41-.23l.87-.16M311.4 304.55a.7.7 0 0 1-.62-.33.67.67 0 0 1 .52-1 .7.7 0 0 1 .51.19h.05a.72.72 0 0 1 .16.83l-.15.29M312.31 304.03l.58.11.73-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m312.31 304.03.58.11-.03.23M313.74 304.36l-.12-.49.5-.54.13.81M314.25 304.14l-.51.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m313.74 304.36-.12-.49-.73.27-.03.23"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#5e7076"
                  d="M304.4 306.05a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M310.65 307.45a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="m313.75 305.7-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6M309.95 305.95a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.55v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0Zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="311.85" cy="306.45" r="0.1" fill="#ebb24b"></circle>
                <circle cx="306.35" cy="307.35" r="0.1" fill="#ebb24b"></circle>
                <circle cx="302.35" cy="307.35" r="0.1" fill="#ebb24b"></circle>
                <circle cx="312.15" cy="306.65" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_810">
              <path
                id="LINE-29"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.8 325.3h15.3l8.75 6.4"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_810"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_810"
                  d="M354 347h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_810"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_810")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_810"
                stroke={colors["rect_label_op7_810"]?.stroke}
                strokeWidth={colors["rect_label_op7_810"]?.strokeWidth}
              >
                <path d="M278.24 330.7a.76.76 0 0 1 .51-.7.63.63 0 0 1-.41-.58.73.73 0 0 1 .8-.69.67.67 0 0 1 .76.64.64.64 0 0 1-.43.6.71.71 0 0 1 .52.67.79.79 0 0 1-.88.75c-.54.05-.87-.27-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.55.55 0 0 0-.47.53.52.52 0 0 0 1 0Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.43ZM281.09 329.13l-.45.24-.07-.27.57-.3h.26v2.6h-.33ZM284.1 330.08c0 .88-.33 1.36-.9 1.36s-.85-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.41-.53 1.11ZM285.4 328.7h.35v2.4h1.15v.29h-1.5ZM288.68 330.14h-1v1h1.17v.29h-1.52v-2.73h1.46v.29h-1.11v.85h1ZM289.88 331.4l-.88-2.7h.4l.42 1.32c.11.37.21.7.29 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM292.91 330.14h-1v1h1.17v.29h-1.52v-2.73h1.46v.29h-1.11v.85h1ZM293.49 328.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_810">
                <path d="M278.4 318.24a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM283.04 319.53a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM285.73 319.8v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1 0 .35 0 .78-.05 1.15l-.06 1.08h-.5l.18-2.7h.65l.35 1.09c.1.32.18.64.25.94.07-.3.17-.63.27-.95l.37-1.08h.64l.16 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op7_810">
                {colors["rect_op7_810"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_810">
                      <path
                        fill="#7c6956"
                        d="m314.6 319.05-.51.51a.69.69 0 0 1-.55.2h-.14a.7.7 0 0 1-.47-1.16.74.74 0 0 1 .4-.23l.88-.16M312.6 321.03a.7.7 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.74.74 0 0 1 .51.2l.05.05a.72.72 0 0 1 .16.83l-.15.29M313.52 320.51l.59.11.73-.27.5-.54-.6-.03-.6.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.52 320.51.59.11-.04.23M314.95 320.84l-.11-.49.5-.54.13.81M315.47 320.62l-.52.22"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m314.95 320.84-.11-.49-.73.27-.04.23"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.6 321.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.6 322.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.9 323.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.2 322.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="313.1" cy="322.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.6" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.6" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.4" cy="323" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_785">
              <path
                id="LINE-30"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m323.2 348.9-9.1-5.9h-15.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_785"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_785"
                  d="M354 364.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_785"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_785")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_785"
                stroke={colors["rect_label_op7_785"]?.stroke}
                strokeWidth={colors["rect_label_op7_785"]?.strokeWidth}
              >
                <path d="M280.52 346.51v.19l-1.12 2.41h-.36l1.12-2.3h-1.27v-.29ZM280.85 348.45a.76.76 0 0 1 .52-.7.63.63 0 0 1-.42-.58.73.73 0 0 1 .81-.69.65.65 0 0 1 .33 1.25.72.72 0 0 1 .52.67.81.81 0 0 1-.89.76.77.77 0 0 1-.87-.71m1.4 0c0-.32-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .52-.47Zm-1-1.3c0 .26.19.4.49.48a.53.53 0 0 0 .4-.48.45.45 0 0 0-.89 0M284.49 346.81h-1l-.1.67h.21a1.16 1.16 0 0 1 .56.14.75.75 0 0 1 .37.67.9.9 0 0 1-1 .89 1.24 1.24 0 0 1-.64-.16l.08-.27a1.2 1.2 0 0 0 .56.14.56.56 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM285.96 346.42h.35v2.4h1.15v.29h-1.5ZM289.24 347.85h-1v1h1.16v.29h-1.52v-2.69h1.45v.25h-1.1v.85h1ZM290.45 349.11l-.89-2.69h.38l.42 1.33c.12.36.22.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM293.48 347.85h-1.08v1h1.17v.29h-1.52v-2.69h1.46v.25h-1.11v.85h1.05ZM294.05 346.42h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_785">
                <path d="M278.65 335.94a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.68.68 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.49Zm.49 1.19h.26c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM283.32 337.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.74-1-.76.47-.76 1.03ZM286.02 337.5v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.55l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op7_785">
                {colors["rect_op7_785"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_785">
                      <path
                        fill="#7c6956"
                        d="m314.64 336.75-.5.51a.7.7 0 0 1-.55.2h-.13a.7.7 0 0 1-.47-1.16.73.73 0 0 1 .41-.23l.88-.16M313.11 338.7h-.46a.68.68 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.74.74 0 0 1 .51.2l.05.05a.72.72 0 0 1 .16.83l-.15.29M313.57 338.21l.59.11.72-.27.5-.55-.6-.02-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.57 338.21.59.11-.04.23-.69.03M315.51 338.32l-.51.22-.12-.49.5-.55z"
                      ></path>
                      <path
                        fill="#8d7e70"
                        d="m314.12 338.55.88-.01-.12-.49-.72.27z"
                      ></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.6 338.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.6 340a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.9 341.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.2 339.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="313.1" cy="340.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.6" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.6" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.4" cy="340.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_760">
              <path
                id="LINE-31"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.8 360.6h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_760"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_760"
                  d="M354 382.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_760"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_760")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_760"
                stroke={colors["rect_label_op7_760"]?.stroke}
                strokeWidth={colors["rect_label_op7_760"]?.strokeWidth}
              >
                <path d="M281.02 364.63v.24l-1.14 2.36h-.36l1.13-2.3h-1.25v-.29ZM282.87 364.88a1.3 1.3 0 0 0-.27 0 1 1 0 0 0-.9.92.78.78 0 0 1 .63-.3.77.77 0 0 1 .78.84.87.87 0 0 1-.86.92c-.56 0-.92-.44-.92-1.11a1.6 1.6 0 0 1 .44-1.17 1.4 1.4 0 0 1 .83-.39h.25Zm-.11 1.5a.52.52 0 0 0-.53-.59.59.59 0 0 0-.51.32.3.3 0 0 0 0 .15c0 .43.2.75.57.75s.47-.26.47-.63M285.16 365.91c0 .88-.33 1.37-.9 1.37s-.85-.48-.86-1.34.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.41-.53 1.11ZM286.46 364.54h.35v2.4h1.15v.29h-1.5ZM289.74 365.97h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.84h1ZM290.94 367.23l-.88-2.69h.34l.42 1.33c.11.36.21.69.29 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM293.97 365.97h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.84h1ZM294.55 364.54h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_760">
                <path d="M278.94 353.84a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 7 7 0 0 0 .21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.27v1.11h-.48Zm.48 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.31 0ZM283.6 355.13a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM286.3 355.4v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05 0 .35 0 .78-.05 1.15l-.12 1.11h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.39Z"></path>
              </g>
              <g id="carrito_op7_760">
                {colors["rect_op7_760"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_760">
                      <path
                        fill="#7c6956"
                        d="m314.83 354.28-.51.51a.66.66 0 0 1-.55.2h-.12a.71.71 0 0 1-.47-1.17.73.73 0 0 1 .41-.23l.87-.16M313.3 356.25h-.47a.73.73 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.05a.74.74 0 0 1 .16.84l-.15.29M313.75 355.75l.6.1.72-.27.5-.54-.6-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.75 355.75.6.1-.04.23-.69.04M315.7 355.85l-.51.23-.12-.5.5-.54z"
                      ></path>
                      <path fill="#8d7e70" d="M314.31 356.08h.88l-.12-.5-.72.27z"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.6 356.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.6 357.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.9 359.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.2 357.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="313.1" cy="358.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.6" cy="359.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.6" cy="359.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.4" cy="358.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="op7_745">
              <path
                id="LINE-32"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.8 396h37.1"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_745"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_745"
                  d="M354 417.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_745"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_745")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_745"
                stroke={colors["rect_label_op7_745"]?.stroke}
                strokeWidth={colors["rect_label_op7_745"]?.strokeWidth}
              >
                <path d="M280.8 399.52v.23l-1.13 2.37h-.36l1.12-2.3h-1.27v-.29ZM282.25 402.12v-.71h-1.2v-.23l1.16-1.66h.38v1.62h.36v.27h-.36v.71Zm0-1v-1.28c-.08.16-.14.27-.21.39l-.64.88h.85ZM284.77 399.82h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.25 1.25 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .55.14.58.58 0 0 0 .62-.56c0-.34-.23-.58-.75-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM286.24 399.43h.35v2.4h1.15v.29h-1.5ZM289.52 400.86h-1v1h1.17v.29h-1.52v-2.69h1.46v.24h-1.11v.85h1ZM290.73 402.12l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM293.76 400.86h-1v1h1.16v.29h-1.52v-2.69h1.45v.24h-1.1v.85h1ZM294.33 399.43h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op7_745">
                <path d="M278.94 388.94a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.27v1.11h-.48Zm.48 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.31 0ZM283.6 390.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.47-.76 1.03ZM286.3 390.5v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05 0 .35 0 .78-.05 1.15l-.12 1.11h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.39Z"></path>
              </g>
              <g id="carrito_op7_745">
                {colors["rect_op7_745"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_745">
                      <path
                        fill="#7c6956"
                        d="m314.58 389.62-.5.5a.72.72 0 0 1-.55.21h-.13a.71.71 0 0 1-.48-1.17.62.62 0 0 1 .4-.22l.88-.16M312.59 391.6a.7.7 0 0 1-.62-.33.68.68 0 0 1 .51-1.06.67.67 0 0 1 .5.19l.06.05a.73.73 0 0 1 .15.84l-.14.29M313.51 391.08l.59.1.72-.26.51-.55-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.51 391.08.59.1-.04.23-.68.04M315.45 391.18l-.51.23-.12-.49.51-.55z"
                      ></path>
                      <path fill="#8d7e70" d="M314.06 391.41h.88l-.12-.49-.72.26z"></path>
                    </g>
                  </>
                )}
                <path
                  fill="#dc2e1a"
                  d="m315.6 391.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M305.6 393a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M311.9 394.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M311.2 392.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="313.1" cy="393.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="307.6" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="303.6" cy="394.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="313.4" cy="393.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP7_735">
              <path
                id="LINE-33"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M298.05 413.25h15.3l23.75-.05"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op7_735"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op7_735"
                  d="M353.25 435h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op7_735"]?.color}
                  onMouseDown={(e) => handleColor("rect_op7_735")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>
              <g
                id="label_op7_735"
                stroke={colors["rect_label_op7_735"]?.stroke}
                strokeWidth={colors["rect_label_op7_735"]?.strokeWidth}
              >
                <path d="M280.8 417.3v.23l-1.13 2.37h-.36l1.13-2.3h-1.27v-.29ZM281.25 419.5a1.2 1.2 0 0 0 .58.16.51.51 0 0 0 .59-.5c0-.37-.34-.52-.68-.52h-.19v-.27h.19c.26 0 .58-.13.58-.44s-.13-.39-.45-.39a.94.94 0 0 0-.52.17l-.1-.25a1.27 1.27 0 0 1 .68-.2c.52 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .58.66c0 .42-.33.78-.95.78a1.3 1.3 0 0 1-.67-.17ZM284.77 417.6h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.25 1.25 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .55.14.58.58 0 0 0 .62-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM286.24 417.21h.35v2.4h1.16v.29h-1.51ZM289.53 418.64h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.28h-1.11v.86h1.05ZM290.73 419.9l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM293.76 418.64h-1v1h1.16v.29h-1.52v-2.69h1.45v.28h-1.1v.86h1ZM294.34 417.21h.34v2.4h1.16v.29h-1.5Z"></path>
              </g>
              <g id="label2_op7_735">
                <path d="M279.22 406.19a5 5 0 0 1 .74-.06 1.3 1.3 0 0 1 .84.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5.4 5.4 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM283.88 407.48a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM286.58 407.75v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
             <g id="carrito_op7_735">
              {colors["rect_op7_735"]?.color === "#248f7a" && (
                  <>
                    <animateTransform
                      attributeName="transform"
                      type="translate"
                      from="0 0"
                      to="5 0"
                      dur="2s"
                      repeatCount="indefinite"
                    />
                    <g id="piedritas_op7_735">
                      <path
                        fill="#7c6956"
                        d="m314.31 406.06-.51.51a.69.69 0 0 1-.55.21h-.12a.7.7 0 0 1-.47-1.17.7.7 0 0 1 .4-.23l.88-.15M312.31 408.05a.71.71 0 0 1-.62-.33.68.68 0 0 1 .52-1.06.7.7 0 0 1 .51.19l.05.05a.72.72 0 0 1 .15.84l-.14.29M313.23 407.53l.59.1.73-.27.5-.54-.61-.03-.59.29z"
                      ></path>
                      <path
                        fill="#675343"
                        d="m313.23 407.53.59.1-.04.23-.68.04M315.18 407.63l-.52.23-.11-.5.5-.54z"
                      ></path>
                      <path fill="#8d7e70" d="M313.78 407.86h.88l-.11-.5-.73.27z"></path>
                    </g>
                  </>
                )}
              <path
                fill="#dc2e1a"
                d="m315.3 408.35-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
              ></path>
              <path
                fill="#5e7076"
                d="M305.2 412.55a1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5 1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1"
              ></path>
              <circle cx="305.3" cy="411.05" r="0.6" fill="#5e7076"></circle>
              <path
                fill="#5e7076"
                d="M310.1 412.7a1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3v-.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3"
              ></path>
              <circle cx="310.1" cy="411.05" r="0.6" fill="#5e7076"></circle>
              <path
                fill="#dc2e1a"
                d="M310.9 409.45a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H304v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.69 1.69 0 0 1 1.7-1.7 1.63 1.63 0 0 1 1.7 1.7v.4h1.6v-.95a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h1.4Zm-3 .2c.1 0 .2.1.3.2h-.5v-.15Zm.3.4-.6.1v-.2zm0 .8h-.6v-.15h.6v.2Zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
              ></path>
              <circle cx="312.8" cy="410.05" r="0.1" fill="#ebb24b"></circle>
              <circle cx="307.3" cy="410.95" r="0.1" fill="#ebb24b"></circle>
              <circle cx="303.3" cy="410.95" r="0.1" fill="#ebb24b"></circle>
              <circle cx="313.1" cy="410.15" r="0.1" fill="#ebb24b"></circle>
            </g>
            </g>
            <path d="M331.33 333.27a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.39.65-.88-.22-.87-.65-.87-.65.44-.65.93ZM331.7 332.15a3.6 3.6 0 0 1 .66-.05 1.1 1.1 0 0 1 .69.19.67.67 0 0 1 .23.52.73.73 0 0 1-.2.54 1 1 0 0 1-.74.25.7.7 0 0 1-.21 0v.89h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.19-.4-.48-.4h-.25ZM335.12 332.2v.28l-1 2h-.45l1-1.91h-1.08v-.36ZM328.73 336.25a2.5 2.5 0 0 0-.4 1.43 2.54 2.54 0 0 0 .4 1.41h-.33a2.61 2.61 0 0 1 0-2.84ZM329.07 336.35a4 4 0 0 1 .66 0 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .21.47.62.62 0 0 1-.43.59.62.62 0 0 1 .33.46 4 4 0 0 0 .18.65h-.44a3 3 0 0 1-.16-.55c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.26c.29 0 .47-.15.47-.39s-.18-.37-.46-.38a1 1 0 0 0-.27 0ZM333.15 337.47a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.25.86.66.86s.65-.39.65-.88-.22-.87-.65-.87-.65.44-.65.93ZM335.51 337.7v-1c-.08.29-.18.61-.28.91l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1.94h-.4l.16-2.35h.56l.31.94c.08.28.16.56.21.82.07-.25.15-.54.24-.82l.33-.94h.55l.14 2.35h-.42ZM336.27 339.09a2.78 2.78 0 0 0 0-2.84h.31a2.36 2.36 0 0 1 .43 1.42 2.4 2.4 0 0 1-.43 1.42ZM322.03 423.8a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.87-.22-.87-.65-.87-.65.43-.65.91ZM322.4 422.7a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.89h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM325.82 422.7v.27l-1 2h-.42l1-1.91h-1.08v-.36ZM318.66 426.78a2.5 2.5 0 0 0-.39 1.42 2.57 2.57 0 0 0 .39 1.41h-.26a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM319 428.7a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.63-.35-.63-.69.32-.67.83-.67a1.25 1.25 0 0 1 .56.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.15-.39.28s.14.27.45.39.61.36.61.7-.29.71-.89.71a1.4 1.4 0 0 1-.64-.15ZM321.26 426.84v2.36h-.43v-2.36ZM321.6 428.96l1.2-1.75h-1.1v-.36h1.7v.26l-1.19 1.73h1.19v.36h-1.8ZM325.05 428.16h-.89v.69h1v.35h-1.43v-2.36h1.37v.36h-.94v.6h.89ZM325.54 426.88a4.5 4.5 0 0 1 .68-.05 1.45 1.45 0 0 1 1 .27 1 1 0 0 1 .37.87 1.18 1.18 0 0 1-.37.93 1.56 1.56 0 0 1-1.06.32 4 4 0 0 1-.58 0Zm.43 2h.24a.8.8 0 0 0 .89-.9.75.75 0 0 0-.84-.82 1 1 0 0 0-.29 0ZM327.73 429.61a2.76 2.76 0 0 0 0-2.83h.31a2.54 2.54 0 0 1 0 2.83Z"></path>
            <g id="RB1">
              <path
                id="container-6"
                fill="#cb9636"
                d="M385 393.93a2.89 2.89 0 0 1 2.95-2.75H410a2.89 2.89 0 0 1 2.95 2.75 2.82 2.82 0 0 1-2.95 2.75h-22.1a2.89 2.89 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-6" fill="#50514e" data-name="label">
                <path d="M336.03 372.84a6 6 0 0 1 1.12-.09 1.9 1.9 0 0 1 1.24.32 1 1 0 0 1 .35.82 1.07 1.07 0 0 1-.73 1 1 1 0 0 1 .56.79 10 10 0 0 0 .32 1.12h-.76a5.4 5.4 0 0 1-.27-.95c-.12-.53-.31-.7-.73-.71h-.37v1.66h-.73Zm.73 1.78h.44c.5 0 .81-.26.81-.67s-.31-.64-.79-.64a2.2 2.2 0 0 0-.46 0ZM339.4 372.84a6 6 0 0 1 1.08-.09 2 2 0 0 1 1.16.26.85.85 0 0 1 .41.76.93.93 0 0 1-.67.87 1 1 0 0 1 .82 1 1.09 1.09 0 0 1-.39.84 2.26 2.26 0 0 1-1.5.37 8 8 0 0 1-.91-.05Zm.73 1.59h.38c.52 0 .8-.24.8-.58s-.29-.56-.75-.56a1.8 1.8 0 0 0-.43 0Zm0 1.85a2 2 0 0 0 .4 0c.47 0 .89-.18.89-.68s-.41-.66-.92-.66h-.37ZM343.89 373.59l-.72.36-.12-.56.95-.47h.61v3.9h-.71Z"></path>
              </g>
            </g>
            <g id="OP7">
              <TooltipOPComponent
                nivel={opColors["OP7"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handleOPColor("OP7")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="container-7"
                    fill={opColors["OP7"].color}
                    d="M382.9 268.57a2.9 2.9 0 0 1 3-2.75H408a2.9 2.9 0 0 1 2.95 2.75 2.81 2.81 0 0 1-2.95 2.75h-22.1a2.89 2.89 0 0 1-3-2.75"
                    data-name="container"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                </g>
              </TooltipOPComponent>
              <g id="label-7" fill="#50514e" data-name="label">
                <path d="M337.53 249.41a1.91 1.91 0 0 1-1.94 2.12 1.87 1.87 0 0 1-1.86-2.05 1.94 1.94 0 0 1 1.92-2.12 1.87 1.87 0 0 1 1.88 2.05m-3 .05c0 .83.41 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.68-1.14 1.51ZM338.16 247.48a6.4 6.4 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.12 1.12 0 0 1 .4.89 1.24 1.24 0 0 1-.35.92 1.78 1.78 0 0 1-1.27.43 2 2 0 0 1-.36 0v1.53h-.74Zm.74 1.88a1.2 1.2 0 0 0 .36 0c.55 0 .89-.28.89-.75s-.32-.69-.83-.69a1.8 1.8 0 0 0-.42 0ZM344.03 247.57v.47l-1.63 3.43h-.77l1.64-3.28h-1.87v-.61Z"></path>
              </g>
            </g>
          </g>
          <g id="LEVELS_02" data-name="LEVELS 02">
            <g id="OP5_735">
              <path
                id="LINE-34"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 413.6h37.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_735"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_735"
                  d="M253.9 435.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_735"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_735")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_735"
                stroke={colors["rect_label_op5_735"]?.stroke}
                strokeWidth={colors["rect_label_op5_735"]?.strokeWidth}
              >
                <path d="M179.18 418.1v.23l-1.13 2.37h-.36l1.12-2.3h-1.27v-.29ZM179.63 420.3a1.2 1.2 0 0 0 .57.16.51.51 0 0 0 .59-.5c0-.37-.33-.52-.67-.52h-.2v-.27h.2c.26 0 .58-.13.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.25a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.66.66 0 0 1-.48.61.66.66 0 0 1 .57.66c0 .42-.32.78-.94.78a1.37 1.37 0 0 1-.68-.17ZM183.15 418.4h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.16-1.25h1.25ZM184.62 418.01h.35v2.4h1.15v.29h-1.5ZM187.9 419.44h-1v1h1.16v.26h-1.51v-2.69H188v.29h-1.1v.85h1ZM189.1 420.7l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM192.14 419.44h-1.05v1h1.17v.26h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM192.71 418.01h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op5_735">
                <path d="M177.59 406.44a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.5a2.7 2.7 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.49Zm.49 1.19h.32c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM182.26 407.7a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.75-1-.75.51-.75 1.06ZM184.96 408v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.45l.18-2.69h.54l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_735">
                <path
                  fill="#dc2e1a"
                  d="m215.5 409.4-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 410.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 412.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 410.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="411.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="412.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="412.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="411.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_760">
              <path
                id="LINE-35"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 360.6H214l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_760"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_760"
                  d="M253.9 382.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_760"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_760")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_760"
                stroke={colors["rect_label_op5_760"]?.stroke}
                strokeWidth={colors["rect_label_op5_760"]?.strokeWidth}
              >
                <path d="M179.05 364.63v.24l-1.14 2.36h-.36l1.13-2.3h-1.28v-.29ZM180.89 364.88a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.79.79 0 0 1 1.41.54.88.88 0 0 1-.87.92c-.55 0-.91-.44-.91-1.11a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39h.25Zm-.1 1.5a.52.52 0 0 0-.53-.59.6.6 0 0 0-.51.31.4.4 0 0 0 0 .16c0 .43.21.75.58.75s.46-.26.46-.63M183.19 365.91c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.34.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.41-.53 1.11ZM184.48 364.54h.35v2.4h1.16v.29h-1.51ZM187.77 365.97h-1.05v1h1.17v.29h-1.49v-2.69h1.46v.29h-1.11v.84h1.05ZM188.97 367.23l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM192 365.97h-1v1h1.17v.29h-1.52v-2.69h1.46v.29H191v.84h1ZM192.58 364.54h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op5_760">
                <path d="M177.46 353.84a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.68.7.7 0 0 1 .38.52 4.5 4.5 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM182.12 355.13a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM184.82 355.4v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_760">
                <path
                  fill="#dc2e1a"
                  d="m215.5 356.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 357.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 359.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 357.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="358.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="359.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="359.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="358.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_785">
              <path
                id="LINE-36"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 343H214l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_785"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_785"
                  d="M253.9 364.6h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_785"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_785")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_785"
                stroke={colors["rect_label_op5_785"]?.stroke}
                strokeWidth={colors["rect_label_op5_785"]?.strokeWidth}
              >
                <path d="M179.18 346.47v.23l-1.13 2.37h-.37l1.13-2.3h-1.27v-.29ZM179.51 348.41a.76.76 0 0 1 .51-.7.63.63 0 0 1-.41-.58.73.73 0 0 1 .81-.69.64.64 0 0 1 .32 1.24.73.73 0 0 1 .53.68.8.8 0 0 1-.89.75c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.57-.56a.56.56 0 0 0-.47.53.48.48 0 0 0 .52.49.46.46 0 0 0 .52-.48Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.4-.42.41.41 0 0 0-.46.39ZM183.14 346.76h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.23-.57-.74-.57a2 2 0 0 0-.37 0l.17-1.25h1.24ZM184.62 346.37h.35v2.4h1.15v.3h-1.5ZM187.9 347.8h-1v1h1.16v.29h-1.51v-2.7H188v.31h-1.1v.86h1ZM189.1 349.07l-.88-2.7h.38l.42 1.33c.11.37.21.69.29 1a10 10 0 0 1 .3-1l.46-1.34h.37l-1 2.7ZM192.14 347.8h-1.05v1h1.17v.29h-1.52v-2.7h1.46v.31h-1.11v.86h1.05ZM192.71 346.37h.35v2.4h1.15v.3h-1.5Z"></path>
              </g>
              <g id="label2_op5_785">
                <path d="M177.59 335.94a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.68.68 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.5a3 3 0 0 1-.19-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.32c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM182.26 337.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.25-1-.75-1-.77.47-.77 1.03ZM184.96 337.5v-1.13c-.09.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.45l.18-2.69h.54l.35 1.08a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_785">
                <path
                  fill="#dc2e1a"
                  d="m215.5 338.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 340a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 341.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 339.9a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="340.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="341.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="340.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_810">
              <path
                id="LINE-37"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m223.1 331.2-9.1-5.9h-15.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_810"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_810"
                  d="M253.9 347h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_810"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_810")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_810"
                stroke={colors["rect_label_op5_810"]?.stroke}
                strokeWidth={colors["rect_label_op5_810"]?.strokeWidth}
              >
                <path d="M177.04 330.54a.75.75 0 0 1 .52-.7.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.65.65 0 0 1-.42.6.71.71 0 0 1 .52.67.8.8 0 0 1-.89.75c-.51.01-.87-.31-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .48-.49Zm-1-1.3c0 .26.19.4.49.48a.51.51 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM179.89 328.93l-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM182.91 329.87c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.42-.53 1.12ZM184.2 328.51h.35v2.4h1.15v.29h-1.5ZM187.48 329.94h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.19v.87h1ZM188.69 331.2l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM191.72 329.94h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.87h1ZM192.29 328.51h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op5_810">
                <path d="M177.59 318.54a5 5 0 0 1 .75 0 1.25 1.25 0 0 1 .83.21.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.5a2.7 2.7 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.49Zm.49 1.19h.32c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM182.26 319.83a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.75-1-.75.48-.75 1.03ZM184.96 320.1v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.45l.18-2.69h.54l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_810">
                <path
                  fill="#dc2e1a"
                  d="m215.5 321.1-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 322.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 323.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 322.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="322.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="323.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="323" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_835">
              <path
                id="LINE-38"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 307.6H214l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_835"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_835"
                  d="M253.9 329.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_835"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_835")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_835"
                stroke={colors["rect_label_op5_835"]?.stroke}
                strokeWidth={colors["rect_label_op5_835"]?.strokeWidth}
              >
                <path d="M177.18 313.76a.74.74 0 0 1 .51-.7.64.64 0 0 1-.41-.59.72.72 0 0 1 .8-.69.68.68 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.79.79 0 0 1-.88.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.58-.57a.56.56 0 0 0-.46.54.48.48 0 0 0 .52.49.47.47 0 0 0 .52-.52Zm-1-1.3c0 .26.2.4.49.48a.5.5 0 0 0 .4-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM179.34 314.01a1.1 1.1 0 0 0 .58.17.52.52 0 0 0 .59-.51c0-.36-.33-.52-.67-.52h-.2v-.26h.2c.25 0 .58-.13.58-.44s-.14-.39-.46-.39a.94.94 0 0 0-.52.17l-.09-.26a1.2 1.2 0 0 1 .68-.2c.51 0 .74.31.74.62a.66.66 0 0 1-.48.62.69.69 0 0 1 .58.67c0 .42-.32.78-.95.78a1.25 1.25 0 0 1-.67-.18ZM182.86 312.11h-1l-.1.67h.21a1.1 1.1 0 0 1 .57.14.74.74 0 0 1 .37.66.91.91 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM184.34 311.7h.35v2.4h1.15v.3h-1.5ZM187.62 313.15h-1.05v1h1.17v.29h-1.52v-2.74h1.46v.29h-1.11v.86h1.05ZM188.82 314.42l-.88-2.7h.38l.42 1.33c.11.36.21.69.28 1 .08-.32.19-.65.31-1l.46-1.33h.37l-1 2.7ZM191.85 313.15h-1v1h1.17v.29h-1.52v-2.74h1.46v.29h-1.11v.86h1ZM192.4 311.7h.35v2.4h1.15v.3h-1.5Z"></path>
              </g>
              <g id="label2_op5_835">
                <path d="M177.59 300.64a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.5a3 3 0 0 1-.19-.64c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.32c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM182.26 301.93a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.25-1-.75-1-.77.48-.77 1.03ZM184.96 302.2v-1.13c-.09.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.45l.18-2.69h.54l.35 1.08a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.94l.38-1.08h.63l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_835">
                <path
                  fill="#dc2e1a"
                  d="m215.5 303.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 304.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 306.1a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 304.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="305.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="306.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="305.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_860">
              <path
                id="LINE-39"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 290H214l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_860"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_860"
                  d="M253.9 311.7h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_860"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_860")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_860"
                stroke={colors["rect_label_op5_860"]?.stroke}
                strokeWidth={colors["rect_label_op5_860"]?.strokeWidth}
              >
                <path d="M177.04 295.79a.75.75 0 0 1 .52-.7.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.65.65 0 0 1-.42.6.71.71 0 0 1 .52.67.8.8 0 0 1-.89.75c-.51.01-.87-.31-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .48-.49Zm-1-1.3c0 .26.19.4.49.48a.51.51 0 0 0 .4-.47.45.45 0 0 0-.89 0ZM180.61 294.1a1.4 1.4 0 0 0-.27 0 1 1 0 0 0-.9.92.8.8 0 0 1 1.42.54.87.87 0 0 1-.87.91c-.55 0-.92-.43-.92-1.1a1.65 1.65 0 0 1 .44-1.17 1.4 1.4 0 0 1 .83-.39 1.4 1.4 0 0 1 .26 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.58.58 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .43.2.74.57.74s.47-.25.47-.62M182.91 295.12c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.42-.53 1.12ZM184.2 293.76h.35v2.4h1.15v.29h-1.5ZM187.48 295.19h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.19v.85h1ZM188.69 296.45l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM191.72 295.19h-1v1h1.16v.29h-1.51v-2.69h1.45v.29h-1.1v.85h1ZM192.29 293.76h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op5_860">
                <path d="M177.31 282.94a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.68.68 0 0 1 .23.54.72.72 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM181.98 284.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.47-.77 1.03ZM184.67 284.5v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_860">
                <path
                  fill="#dc2e1a"
                  d="m215.5 285.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 287a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 288.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 287a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9a.45.45 0 0 1 .5 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.1h.6v.2h-.6Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="287.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="288.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="288.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="287.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_885">
              <path
                id="LINE-40"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 272.3H214l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_885"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_885"
                  d="M253.9 294h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_885"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_885")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_885"
                stroke={colors["rect_label_op5_885"]?.stroke}
                strokeWidth={colors["rect_label_op5_885"]?.strokeWidth}
              >
                <path d="M176.9 277.77a.74.74 0 0 1 .51-.7.65.65 0 0 1-.42-.58.74.74 0 0 1 .81-.7.68.68 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.8.8 0 0 1-.89.76c-.54 0-.86-.32-.86-.7m1.39 0c0-.31-.22-.47-.57-.56a.56.56 0 0 0-.47.53.48.48 0 0 0 .52.49.46.46 0 0 0 .52-.48Zm-1-1.3c0 .26.19.4.49.48a.5.5 0 0 0 .4-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.41.39ZM178.95 277.77a.74.74 0 0 1 .51-.7.65.65 0 0 1-.42-.58.74.74 0 0 1 .81-.7.68.68 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.79.79 0 0 1-.88.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.58-.56a.55.55 0 0 0-.46.53.48.48 0 0 0 .52.49.47.47 0 0 0 .57-.48Zm-1-1.3c0 .26.2.4.49.48a.5.5 0 0 0 .4-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.4.39ZM182.58 276.12h-1l-.1.67h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.66.9.9 0 0 1-1 .89 1.25 1.25 0 0 1-.65-.16l.09-.27a1.06 1.06 0 0 0 .55.15.58.58 0 0 0 .62-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM184.05 275.7h.35v2.4h1.16v.3h-1.51ZM187.34 277.16h-1.05v1h1.17v.29h-1.52v-2.75h1.46v.29h-1.11v.86h1.05ZM188.54 278.43l-.88-2.7h.37l.42 1.33a10 10 0 0 1 .29 1c.08-.31.19-.65.31-1l.45-1.34h.38l-1 2.7ZM191.57 277.16h-1v1h1.16v.29h-1.51v-2.75h1.45v.29h-1.1v.86h1ZM192.15 275.7h.34v2.4h1.16v.3h-1.5Z"></path>
              </g>
              <g id="label2_op5_885">
                <path d="M177.31 265.14a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.68.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM181.98 266.43a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM184.67 266.7v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_885">
                <path
                  fill="#dc2e1a"
                  d="m215.5 268.2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 269.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 270.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 269.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="269.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="270.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="270.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="270" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_910">
              <path
                id="LINE-41"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m223.1 260.6-9.1-5.9h-15.3"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_910"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_910"
                  d="M253.9 276.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_910"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_910")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_910"
                stroke={colors["rect_label_op5_910"]?.stroke}
                strokeWidth={colors["rect_label_op5_910"]?.strokeWidth}
              >
                <path d="M177.4 260.63a1.6 1.6 0 0 0 .29 0 .93.93 0 0 0 .54-.25 1.08 1.08 0 0 0 .34-.69.74.74 0 0 1-.61.28.75.75 0 0 1-.77-.8.9.9 0 0 1 .89-.92c.53 0 .86.43.86 1.1a1.63 1.63 0 0 1-.45 1.22 1.3 1.3 0 0 1-.76.34h-.32Zm.13-1.5a.5.5 0 0 0 .5.55.56.56 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.16-.78-.53-.78s-.47.27-.47.63ZM180.02 258.6l-.46.25-.06-.27.56-.3h.3v2.59h-.34ZM183.04 259.55c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.33.37-1.36.9-1.36.86.47.86 1.32m-1.41 0c0 .67.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.41-.53 1.12ZM184.34 258.18h.35v2.4h1.15v.29h-1.5ZM187.62 259.61h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM188.82 260.87l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM191.85 259.61h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM192.4 258.18h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op5_910">
                <path d="M177.03 247.84a5 5 0 0 1 .75-.06 1.3 1.3 0 0 1 .83.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.54a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11H177Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM181.69 249.13a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM184.4 249.4v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15a11 11 0 0 1-.27-1.05c0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.57Z"></path>
              </g>
              <g id="carrito_op5_910">
                <path
                  fill="#dc2e1a"
                  d="m215.5 250.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 251.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 253.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 251.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="252.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="253.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="252.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_935">
              <path
                id="LINE-42"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 237H214l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_935"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_935"
                  d="M253.9 258.7h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_935"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_935")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_935"
                stroke={colors["rect_label_op5_935"]?.stroke}
                strokeWidth={colors["rect_label_op5_935"]?.strokeWidth}
              >
                <path d="M176.73 242.55a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.2 1.2 0 0 0 .34-.69.79.79 0 0 1-.61.28.76.76 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.09a1.67 1.67 0 0 1-.45 1.22 1.28 1.28 0 0 1-.76.35 2 2 0 0 1-.32 0Zm.13-1.49a.5.5 0 0 0 .5.55.6.6 0 0 0 .51-.27.25.25 0 0 0 0-.13c0-.45-.16-.78-.53-.78s-.48.27-.48.63M178.66 242.4a1.2 1.2 0 0 0 .58.16.51.51 0 0 0 .59-.5c0-.37-.34-.52-.68-.52h-.19v-.27h.19c.26 0 .58-.13.58-.44s-.13-.39-.45-.39a.94.94 0 0 0-.52.17l-.1-.25a1.25 1.25 0 0 1 .68-.2c.52 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .58.66c0 .42-.33.78-.95.78a1.3 1.3 0 0 1-.67-.17ZM182.18 240.5h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.25 1.25 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .55.14.58.58 0 0 0 .62-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM183.65 240.11h.35v2.4h1.15v.29h-1.5ZM186.93 241.54h-1v1h1.17v.29h-1.52v-2.69h1.46v.28h-1.11v.86h1ZM188.14 242.8l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM191.17 241.54h-1v1h1.16v.29h-1.51v-2.69h1.45v.28h-1.1v.86h1ZM191.74 240.11h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op5_935">
                <path d="M176.75 230.24a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.48Zm.48 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.31 0ZM181.4 231.53a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.75.48-.75 1.03ZM184.11 231.8v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_935">
                <path
                  fill="#dc2e1a"
                  d="m215.5 232.8-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 234.1a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 235.5a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 234a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.3-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.1h.6v.2h-.6Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="234.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="235.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="235.4" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="234.6" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_960">
              <path
                id="LINE-43"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 219.3H214l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_960"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_960"
                  d="M253.9 241h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_960"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_960")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_960"
                stroke={colors["rect_label_op5_960"]?.stroke}
                strokeWidth={colors["rect_label_op5_960"]?.strokeWidth}
              >
                <path d="M176.57 225.05a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.2 1.2 0 0 0 .34-.69.81.81 0 0 1-.62.28.76.76 0 0 1-.76-.8.88.88 0 0 1 .88-.92c.53 0 .86.43.86 1.09a1.63 1.63 0 0 1-.45 1.22 1.22 1.22 0 0 1-.75.35 2 2 0 0 1-.32 0Zm.12-1.49a.5.5 0 0 0 .51.55.61.61 0 0 0 .51-.27.4.4 0 0 0 0-.13c0-.45-.17-.78-.53-.78a.56.56 0 0 0-.49.63M179.9 222.95a1.3 1.3 0 0 0-.27 0 1 1 0 0 0-.9.92.75.75 0 0 1 .63-.3.77.77 0 0 1 .78.84.86.86 0 0 1-.86.91c-.56 0-.92-.43-.92-1.1a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39 1.3 1.3 0 0 1 .26 0Zm-.1 1.5a.54.54 0 0 0-.54-.6.56.56 0 0 0-.5.32.34.34 0 0 0 0 .16c0 .42.2.74.57.74s.47-.25.47-.62M182.19 223.97c0 .89-.32 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM183.49 222.61h.35v2.4h1.15v.29h-1.5ZM186.77 224.04h-1v1h1.17v.29h-1.54v-2.69h1.45v.28h-1.1v.86h1ZM187.98 225.3l-.89-2.69h.38l.42 1.32c.12.37.22.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM191.01 224.04h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.28h-1.11v.86h1.05ZM191.58 222.61h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op5_960">
                <path d="M176.46 212.44a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM181.13 213.7a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.74-1-.76.51-.76 1.06ZM183.83 214v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.21-.71-.28-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_960">
                <path
                  fill="#dc2e1a"
                  d="m215.5 215.2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 216.4a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 217.8a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 216.3a4.2 4.2 0 0 0-1.2-.4h-.8v-.2h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.3h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="216.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="217.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="217.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="217" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP5_985">
              <path
                id="LINE-44"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M198.7 201.7H214l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op5_985"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op5_985"
                  d="M253.9 223.3h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op5_985"]?.color}
                  onMouseDown={(e) => handleColor("rect_op5_985")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op5_985"
                stroke={colors["rect_label_op5_985"]?.stroke}
                strokeWidth={colors["rect_label_op5_985"]?.strokeWidth}
              >
                <path d="M176.57 207.35a1.4 1.4 0 0 0 .28 0 1 1 0 0 0 .55-.25 1.2 1.2 0 0 0 .34-.69.81.81 0 0 1-.62.28.75.75 0 0 1-.76-.8.88.88 0 0 1 .88-.92c.53 0 .86.43.86 1.09a1.62 1.62 0 0 1-.45 1.22 1.25 1.25 0 0 1-.75.35 2 2 0 0 1-.32 0Zm.12-1.49a.5.5 0 0 0 .51.55.61.61 0 0 0 .51-.27.4.4 0 0 0 0-.13c0-.45-.17-.78-.53-.78s-.49.26-.49.63M178.4 206.94a.75.75 0 0 1 .52-.7.64.64 0 0 1-.42-.58.73.73 0 0 1 .81-.69.66.66 0 0 1 .75.64.65.65 0 0 1-.43.6.71.71 0 0 1 .53.67.8.8 0 0 1-.89.75c-.56.01-.87-.31-.87-.69m1.4 0c0-.31-.22-.46-.57-.56a.57.57 0 0 0-.47.53.48.48 0 0 0 .52.5.47.47 0 0 0 .5-.49Zm-1-1.3c0 .26.19.41.49.48a.5.5 0 0 0 .39-.47.44.44 0 0 0-.88 0ZM182.02 205.3h-1l-.1.66h.21a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.89.89 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.26a1.2 1.2 0 0 0 .56.14.57.57 0 0 0 .61-.56c0-.34-.22-.58-.74-.58a3 3 0 0 0-.36 0l.16-1.25h1.25ZM183.49 204.91h.35v2.4h1.15v.29h-1.5ZM186.77 206.34h-1v1h1.16v.29h-1.53v-2.69h1.45v.29h-1.1v.85h1ZM187.97 207.6l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM191.01 206.34h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM191.58 204.91h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op5_985">
                <path d="M176.18 194.64a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.59c-.07-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM180.85 195.93a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.03ZM183.55 196.2v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.44l-.36-1.15c-.1-.35-.2-.71-.27-1 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.65l.37 1.07a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op5_985">
                <path
                  fill="#dc2e1a"
                  d="m215.5 197.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M205.5 198.7a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M211.8 200.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M211.1 198.6a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.3.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="213" cy="199.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="207.5" cy="200.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="203.5" cy="200.1" r="0.1" fill="#ebb24b"></circle>
                <circle cx="213.3" cy="199.3" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <path d="M219.11 425.25a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.75 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.61.43-.61.91ZM219.49 424.12a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1.05 1.05 0 0 1-.75.26h-.21v.89h-.42Zm.42 1.1a.7.7 0 0 0 .21 0c.33 0 .52-.16.52-.43s-.18-.4-.48-.4h-.25ZM222.79 424.53h-.87l-.07.46h.17a1 1 0 0 1 .55.14.67.67 0 0 1 .29.58.83.83 0 0 1-.91.79 1.3 1.3 0 0 1-.61-.14l.09-.32a1.2 1.2 0 0 0 .5.12.45.45 0 0 0 .47-.46c0-.26-.19-.44-.64-.44h-.31l.14-1.14h1.18ZM215.4 428.23a2.76 2.76 0 0 0 0 2.83h-.31a2.35 2.35 0 0 1-.43-1.41 2.38 2.38 0 0 1 .43-1.42ZM215.73 430.18a1.2 1.2 0 0 0 .57.15c.27 0 .43-.13.43-.32s-.12-.28-.42-.39-.64-.35-.64-.69.32-.67.83-.67a1.3 1.3 0 0 1 .57.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.28 0-.39.14-.39.28s.13.27.45.39.6.36.6.7-.28.71-.89.71a1.4 1.4 0 0 1-.64-.15ZM217.98 428.29v2.41h-.43v-2.36ZM218.32 430.41l1.21-1.75h-1.13v-.36h1.65v.26l-1.18 1.73h1.2v.41h-1.78ZM221.78 429.61h-.89v.69h1v.4h-1.42v-2.36h1.37v.36h-.94v.6h.89ZM222.26 428.33a4.5 4.5 0 0 1 .69-.05 1.45 1.45 0 0 1 1 .27 1.06 1.06 0 0 1 .37.86 1.22 1.22 0 0 1-.37.94 1.6 1.6 0 0 1-1.07.32 4 4 0 0 1-.58 0Zm.43 2h.24a.8.8 0 0 0 .89-.9.75.75 0 0 0-.84-.82 1 1 0 0 0-.29 0ZM224.46 431.06a2.76 2.76 0 0 0 0-2.83h.31a2.59 2.59 0 0 1 0 2.83ZM217.4 432.97l-.41.21-.08-.33.56-.27h.35v2.27h-.42ZM218.76 434.54a1 1 0 0 0 .24 0 .8.8 0 0 0 .46-.17.82.82 0 0 0 .29-.5.71.71 0 0 1-1.19-.51.81.81 0 0 1 .82-.81c.53 0 .81.42.81 1a1.37 1.37 0 0 1-.39 1.05 1.22 1.22 0 0 1-.78.31.8.8 0 0 1-.26 0Zm.23-1.21a.37.37 0 0 0 .37.41.41.41 0 0 0 .37-.19.2.2 0 0 0 0-.12c0-.31-.11-.57-.39-.57s-.35.19-.35.47M221.27 433.7v-.5h.37v.25a.58.58 0 0 1 .52-.29.49.49 0 0 1 .47.31.7.7 0 0 1 .21-.21.6.6 0 0 1 .34-.1c.28 0 .57.19.57.74v1h-.35v-.94c0-.29-.1-.45-.3-.45a.31.31 0 0 0-.3.23.3.3 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.3-.41a.34.34 0 0 0-.31.24.7.7 0 0 0 0 .14v1h-.42ZM235.28 262.13a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.87-.22-.87-.65-.87-.65.45-.65.91ZM235.65 261a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.89h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM238.95 261.42h-.87l-.07.45h.17a1 1 0 0 1 .55.15.64.64 0 0 1 .3.57.83.83 0 0 1-.92.79 1.4 1.4 0 0 1-.6-.13l.08-.33a1.2 1.2 0 0 0 .5.12c.26 0 .5-.14.5-.41s-.2-.44-.65-.44h-.31l.15-1.14h1.17ZM233.4 266.57v-1c-.08.29-.18.61-.28.9l-.34 1h-.38l-.32-1c-.09-.3-.17-.63-.23-.92v1l-.06.95h-.4l.16-2.35h.56l.31.94c.09.28.16.56.22.82.06-.26.14-.54.23-.82l.33-.94h.56l.13 2.35h-.49ZM234.77 265.35a.23.23 0 0 1-.25.23.23.23 0 0 1-.24-.23.23.23 0 0 1 .25-.23.23.23 0 0 1 .24.23m-.46 2.18v-1.7h.43v1.7ZM236.77 265.05v2.48h-.37v-.27a.62.62 0 0 1-.56.31.78.78 0 0 1-.72-.87.81.81 0 0 1 .76-.91.57.57 0 0 1 .48.22v-1Zm-.43 1.49a.4.4 0 0 0 0-.11.37.37 0 0 0-.37-.31c-.27 0-.43.25-.43.56s.16.54.43.54a.38.38 0 0 0 .37-.3.5.5 0 0 0 0-.13ZM238.81 265.05v2.48h-.41v-.27a.61.61 0 0 1-.55.31.78.78 0 0 1-.73-.87.81.81 0 0 1 .76-.91.55.55 0 0 1 .48.22v-1Zm-.43 1.49a.4.4 0 0 0 0-.11.39.39 0 0 0-.37-.31c-.28 0-.43.25-.43.56s.15.54.42.54a.37.37 0 0 0 .37-.3.5.5 0 0 0 0-.13ZM239.27 265.05h.43v2.48h-.43ZM240.48 266.8a.46.46 0 0 0 .52.44 1.2 1.2 0 0 0 .47-.08l.06.3a1.5 1.5 0 0 1-.59.11.81.81 0 0 1-.88-.87.85.85 0 0 1 .84-.91.83.83 0 0 1 .71 1Zm.74-.3a.36.36 0 0 0-.35-.42.42.42 0 0 0-.4.42ZM232.61 269.85l-.42.21-.07-.33.55-.27h.36v2.24h-.42ZM235.4 269.46v.24l-1 2h-.46l1-1.91h-1.07v-.35ZM236.64 271.7v-.58h-1v-.28l.93-1.41h.5v1.37h.3v.32h-.3v.58Zm0-.9v-1.01c-.07.15-.13.26-.2.39l-.42.62zM238.4 270.53v-.5h.37v.25a.58.58 0 0 1 .52-.29.49.49 0 0 1 .47.31.7.7 0 0 1 .21-.21.6.6 0 0 1 .34-.1c.28 0 .57.19.57.74v1h-.42v-.94c0-.28-.1-.45-.3-.45a.31.31 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.46v-1c0-.24-.1-.41-.3-.41a.34.34 0 0 0-.3.24.4.4 0 0 0 0 .14v1h-.4ZM230.19 225.8a1.12 1.12 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.13 1.13 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.24.86.65.86s.65-.39.65-.88-.22-.86-.65-.86-.68.43-.68.91ZM230.56 224.7a3.6 3.6 0 0 1 .66-.05 1 1 0 0 1 .69.2.66.66 0 0 1 .23.52.72.72 0 0 1-.2.53 1 1 0 0 1-.74.25h-.21v.89h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.19-.4-.48-.4h-.25ZM233.87 225.08h-.88l-.06.46h.16a1 1 0 0 1 .55.14.66.66 0 0 1 .3.58.83.83 0 0 1-.92.79 1.26 1.26 0 0 1-.6-.14l.09-.32a1.14 1.14 0 0 0 .5.12.45.45 0 0 0 .49-.42c0-.26-.19-.43-.65-.43h-.31l.15-1.14h1.18ZM235.82 224.58a2.5 2.5 0 0 0-.39 1.42 2.6 2.6 0 0 0 .39 1.41h-.31a2.59 2.59 0 0 1 0-2.83ZM236.17 224.7a4 4 0 0 1 .65-.05 1.12 1.12 0 0 1 .73.19.63.63 0 0 1-.23 1.06.57.57 0 0 1 .33.46 5 5 0 0 0 .19.66h-.44a3.3 3.3 0 0 1-.16-.56c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.25c.3 0 .47-.15.47-.38s-.18-.38-.45-.38a1.3 1.3 0 0 0-.27 0ZM240.25 225.8a1.12 1.12 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.13 1.13 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.24.86.66.86s.65-.39.65-.88-.22-.86-.65-.86-.66.43-.66.91ZM242.61 226.04v-1c-.07.28-.17.6-.27.9l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.91v1l-.05 1h-.4l.15-2.36h.57l.31.95c.08.28.16.56.21.82.07-.26.15-.55.24-.82l.32-.95h.56l.14 2.36h-.42ZM243.4 227.41a2.53 2.53 0 0 0 .39-1.42 2.5 2.5 0 0 0-.39-1.41h.31a2.32 2.32 0 0 1 .43 1.41 2.46 2.46 0 0 1-.43 1.42ZM234.53 231.2v-2.36h.49l.61 1a8 8 0 0 1 .4.79v-1.8199999999999998h.4v2.36h-.45l-.61-1a7 7 0 0 1-.42-.81v1.85ZM238.49 230.33a.84.84 0 0 1-.87.91.89.89 0 0 1 0-1.78.81.81 0 0 1 .87.87m-1.28 0c0 .33.16.57.42.57s.42-.24.42-.58-.12-.57-.42-.57-.42.31-.42.6ZM230.16 235.33a1.6 1.6 0 0 1-.61.1 1.11 1.11 0 0 1-1.2-1.18 1.18 1.18 0 0 1 1.26-1.24 1.3 1.3 0 0 1 .57.1l-.1.34a1.1 1.1 0 0 0-.46-.09.78.78 0 0 0-.82.87.77.77 0 0 0 .82.84 1.3 1.3 0 0 0 .47-.08ZM232.07 234.53a.84.84 0 0 1-.87.91.89.89 0 0 1 0-1.78.81.81 0 0 1 .87.87m-1.28 0c0 .33.16.57.42.57s.42-.24.42-.58-.12-.57-.42-.57-.42.31-.42.6ZM232.4 234.2v-.5h.37v.25a.63.63 0 0 1 .63-.25c.3 0 .61.19.61.73v1h-.43v-1c0-.25-.09-.43-.33-.43a.35.35 0 0 0-.33.25.5.5 0 0 0 0 .14v1h-.52ZM234.4 234.2v-.5h.37v.25a.63.63 0 0 1 .63-.25c.29 0 .6.19.6.73v1h-.43v-1c0-.25-.09-.43-.32-.43a.37.37 0 0 0-.34.25.5.5 0 0 0 0 .14v1h-.51ZM236.74 234.7a.46.46 0 0 0 .52.44 1.2 1.2 0 0 0 .47-.08l.06.3a1.5 1.5 0 0 1-.59.1.81.81 0 0 1-.88-.86.84.84 0 0 1 .84-.91.73.73 0 0 1 .73.82 1 1 0 0 1 0 .19Zm.74-.3a.36.36 0 0 0-.35-.42.41.41 0 0 0-.39.42ZM239.49 235.35a1.3 1.3 0 0 1-.48.08.82.82 0 0 1-.88-.87.87.87 0 0 1 .95-.9 1 1 0 0 1 .41.08l-.07.32a.8.8 0 0 0-.33-.07.55.55 0 0 0 0 1.1 1 1 0 0 0 .34-.06ZM240.4 233.21v.49h.4v.32h-.4v.75c0 .2.05.31.21.31h.17v.33a1.1 1.1 0 0 1-.31 0 .48.48 0 0 1-.37-.14.66.66 0 0 1-.14-.47v-.8h-.24v-.3h.24v-.39ZM241.4 234.7a.47.47 0 0 0 .53.44 1.2 1.2 0 0 0 .47-.08l.06.3a1.6 1.6 0 0 1-.59.1.8.8 0 0 1-.88-.86.84.84 0 0 1 .83-.91.74.74 0 0 1 .74.82 1 1 0 0 1 0 .19Zm.75-.3c0-.16-.06-.42-.35-.42a.42.42 0 0 0-.4.42ZM244.4 232.92v2.48h-.39v-.27a.61.61 0 0 1-.55.31.78.78 0 0 1-.73-.87.81.81 0 0 1 .76-.91.54.54 0 0 1 .48.22v-1Zm-.43 1.48a.5.5 0 0 0 0-.11.37.37 0 0 0-.37-.3c-.27 0-.43.24-.43.56s.16.54.43.54a.37.37 0 0 0 .37-.31.5.5 0 0 0 0-.12ZM244.54 485.97a1.6 1.6 0 0 0 .74.19c.35 0 .55-.16.55-.41s-.16-.36-.54-.5-.82-.45-.82-.88.41-.88 1.07-.88a1.6 1.6 0 0 1 .73.15l-.13.45a1.3 1.3 0 0 0-.61-.14c-.35 0-.5.18-.5.36s.17.35.58.5.78.47.78.9-.37.91-1.15.91a1.8 1.8 0 0 1-.82-.19ZM247.47 484.01h-.87v-.47h2.3v.47h-.88v2.57h-.55ZM249.53 485.7l-.26.86h-.57l1-3h.7l1 3h-.59l-.28-.86Zm.87-.42-.24-.75c-.06-.19-.11-.39-.15-.57-.05.18-.09.39-.15.57l-.23.75ZM251.78 486.58v-3h.62l.78 1.3a9 9 0 0 1 .52 1c0-.41-.05-.8-.05-1.26v-1.06h.51v3h-.57l-.8-1.34a10 10 0 0 1-.54-1.05v2.38ZM255.4 484.01h-.87v-.47h2.3v.47h-.88v2.57h-.55ZM258.89 485.23h-1.15v.89h1.28v.46h-1.83v-3h1.76v.46h-1.21v.78h1.15ZM261.68 486.49a2.1 2.1 0 0 1-.78.13 1.43 1.43 0 0 1-1.55-1.53 1.53 1.53 0 0 1 1.62-1.6 1.7 1.7 0 0 1 .74.14l-.12.44a1.6 1.6 0 0 0-.6-.12 1 1 0 0 0-1.06 1.12 1 1 0 0 0 1.06 1.09 1.7 1.7 0 0 0 .6-.11ZM242.99 488.98a5.5 5.5 0 0 1 .81-.06 1.46 1.46 0 0 1 .87.19.64.64 0 0 1 .31.57.69.69 0 0 1-.5.65.76.76 0 0 1 .61.75.79.79 0 0 1-.29.63 1.73 1.73 0 0 1-1.12.27h-.69Zm.56 1.2h.28c.38 0 .6-.18.6-.44s-.22-.41-.57-.41a2 2 0 0 0-.31 0Zm0 1.39a1.2 1.2 0 0 0 .29 0c.35 0 .67-.13.67-.51s-.31-.5-.69-.5h-.27ZM246.16 491.98v-1.28l-1-1.77h.64l.36.78c.1.22.18.4.26.6.08-.19.16-.38.27-.6l.36-.78h.63l-1 1.76v1.28ZM251.69 490.43a1.43 1.43 0 0 1-1.45 1.59 1.4 1.4 0 0 1-1.4-1.54 1.45 1.45 0 0 1 1.44-1.59 1.4 1.4 0 0 1 1.41 1.54m-2.27 0c0 .62.31 1.11.84 1.11s.84-.5.84-1.13-.28-1.12-.84-1.12-.86.56-.86 1.18ZM252.62 489.41h-.86v-.47h2.29v.47h-.87v2.57h-.56ZM254.96 488.94v1.22h1.28v-1.22h.55v3h-.55v-1.34h-1.28v1.34h-.56v-3ZM259.12 490.63h-1.14v.89h1.28v.46h-1.86v-3h1.76v.46h-1.21v.78h1.14ZM259.74 488.98a5 5 0 0 1 .84-.06 1.4 1.4 0 0 1 .94.24.76.76 0 0 1 .26.61.8.8 0 0 1-.55.76.76.76 0 0 1 .42.59 8 8 0 0 0 .24.85h-.57a4.4 4.4 0 0 1-.2-.72c-.09-.4-.23-.52-.55-.53h-.28v1.25h-.55Zm.55 1.34h.33c.38 0 .61-.2.61-.5s-.23-.48-.59-.48a2 2 0 0 0-.35 0ZM262.29 491.37a1.6 1.6 0 0 0 .74.19c.35 0 .55-.16.55-.41s-.16-.36-.54-.5-.82-.45-.82-.88.41-.88 1.07-.88a1.6 1.6 0 0 1 .73.15l-.13.45a1.3 1.3 0 0 0-.61-.14c-.35 0-.5.18-.5.36s.18.35.58.5.78.46.78.9-.37.91-1.15.91a1.8 1.8 0 0 1-.82-.19ZM321.21 500.14h-.68v-.36h1.78v.36h-.67v2h-.43ZM323.02 499.78v1.38c0 .46.19.67.48.67s.5-.21.5-.67v-1.38h.4v1.35c0 .72-.38 1.05-.94 1.05s-.9-.31-.9-1.05v-1.35ZM324.92 502.14v-2.36h.48l.61 1a6.5 6.5 0 0 1 .4.79v-1.83h.4v2.36h-.45l-.61-1a7 7 0 0 1-.42-.81v1.8399999999999999ZM327.29 502.14v-2.36h.49l.61 1a8 8 0 0 1 .4.79v-1.83h.4v2.36h-.45l-.61-1a7 7 0 0 1-.43-.81v1.8399999999999999ZM330.97 501.09h-.89v.69h1v.36h-1.43v-2.36h1.37v.36h-.94v.6h.89ZM331.46 499.78h.43v2h1v.36h-1.39ZM335.6 502.07a1.6 1.6 0 0 1-.61.1 1.11 1.11 0 0 1-1.21-1.18 1.18 1.18 0 0 1 1.26-1.24 1.24 1.24 0 0 1 .57.1l-.09.34a1.1 1.1 0 0 0-.46-.09.78.78 0 0 0-.82.87.77.77 0 0 0 .82.85 1.3 1.3 0 0 0 .47-.09ZM337.96 500.94a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.14 1.14 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.25.86.66.86s.65-.38.65-.88-.22-.86-.65-.86-.66.43-.66.91ZM338.34 502.14v-2.36h.49l.61 1a8 8 0 0 1 .4.79v-1.83h.4v2.36h-.45l-.61-1a7 7 0 0 1-.43-.81v1.8399999999999999ZM341.24 502.14l-.76-2.36h.47l.32 1.07c.09.3.17.58.23.86.06-.28.15-.56.24-.85l.34-1.08h.46l-.82 2.36ZM344.12 501.09h-.88v.69h1v.36h-1.42v-2.36h1.37v.36h-.94v.6h.88ZM345.15 502.14v-1l-.74-1.38h.49l.28.61.21.46c.06-.15.13-.29.21-.46l.28-.61h.52l-.78 1.37v1ZM348.58 500.94a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.14 1.14 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.1 1.2m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM348.95 499.82a3.7 3.7 0 0 1 .65-.06 1.12 1.12 0 0 1 .73.19.61.61 0 0 1 .2.48.63.63 0 0 1-.43.59.58.58 0 0 1 .33.45 5 5 0 0 0 .19.66h-.45a3.4 3.4 0 0 1-.15-.56c-.07-.3-.18-.4-.43-.41h-.19v1h-.43Zm.43 1h.25c.29 0 .47-.16.47-.39s-.18-.38-.46-.38h-.26ZM327.4 504.02a3.4 3.4 0 0 1 .63-.06 1.2 1.2 0 0 1 .67.15.5.5 0 0 1 .24.45.55.55 0 0 1-.39.51.6.6 0 0 1 .48.59.59.59 0 0 1-.23.48 1.27 1.27 0 0 1-.87.22 3.3 3.3 0 0 1-.53 0Zm.43.93h.22c.3 0 .46-.14.46-.34s-.17-.33-.44-.33a1 1 0 0 0-.24 0Zm0 1.08h.22c.28 0 .53-.11.53-.4s-.24-.38-.54-.38h-.21ZM329.89 506.34v-1l-.74-1.38h.49l.28.61.21.46c.06-.15.13-.29.21-.46l.28-.61h.49l-.79 1.37v1ZM334.19 505.14a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.68.44-.68.91ZM334.92 504.34h-.68v-.36h1.79v.36h-.63v2h-.43ZM336.73 503.98v1h1v-1h.43v2.36h-.43v-1h-1v1h-.43v-2.36ZM339.97 505.29h-.89v.69h1v.36h-1.43v-2.36h1.37v.36h-.94v.6h.89ZM340.46 504.02a3.7 3.7 0 0 1 .65-.06 1.06 1.06 0 0 1 .73.2.61.61 0 0 1 .2.47.63.63 0 0 1-.43.59.58.58 0 0 1 .33.45 6 6 0 0 0 .18.66h-.44a4 4 0 0 1-.16-.56c-.06-.3-.18-.4-.42-.41h-.22v1h-.42Zm.42 1h.26c.29 0 .47-.16.47-.39s-.18-.38-.46-.38a1.4 1.4 0 0 0-.27 0ZM342.4 505.87a1.2 1.2 0 0 0 .57.15c.27 0 .43-.13.43-.32s-.12-.29-.42-.39-.64-.35-.64-.69.32-.67.84-.67a1.3 1.3 0 0 1 .56.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.28 0-.39.14-.39.28s.13.27.45.39.6.36.6.7-.28.7-.89.7a1.5 1.5 0 0 1-.64-.14ZM205.9 491.09a2.3 2.3 0 0 1-.76.13 1.27 1.27 0 0 1-.92-.31 1.18 1.18 0 0 1-.33-.87 1.2 1.2 0 0 1 1.31-1.22 1.7 1.7 0 0 1 .63.11l-.1.35a1.2 1.2 0 0 0-.54-.1.79.79 0 0 0-.85.84.78.78 0 0 0 .82.85 1 1 0 0 0 .32 0v-.59h-.41v-.34h.83ZM206.77 488.85v1.37c0 .46.19.67.48.67s.5-.21.5-.67v-1.37h.43v1.34c0 .73-.37 1.05-.94 1.05s-.9-.31-.9-1.05v-1.34ZM209.03 490.53l-.2.67h-.43l.75-2.35h.55l.77 2.35H210l-.21-.67Zm.68-.32-.19-.58c0-.15-.08-.31-.12-.44 0 .13-.07.3-.12.44l-.18.58ZM211.32 488.85h.43v1.52c0 .65-.32.87-.79.87a1 1 0 0 1-.36-.06l.06-.34a.9.9 0 0 0 .26 0c.25 0 .4-.11.4-.52ZM213.54 490.16h-.89v.69h1v.35h-1.42v-2.35h1.37v.35h-.94v.6h.89ZM214.01 490.7a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.64-.35-.64-.69.33-.67.84-.67a1.3 1.3 0 0 1 .56.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.15-.39.28s.14.27.45.39.61.36.61.7-.29.71-.9.71a1.3 1.3 0 0 1-.63-.15ZM216.87 489.21h-.67v-.36h1.78v.36h-.68v2h-.43ZM218.69 488.85v1.37c0 .46.19.67.48.67s.5-.21.5-.67v-1.37h.43v1.34c0 .73-.38 1.05-.95 1.05s-.89-.31-.89-1.05v-1.34ZM220.59 491.2v-2.35h.49l.61 1a7 7 0 0 1 .4.79v-1.8199999999999998h.4v2.35h-.45l-.61-1a6 6 0 0 1-.42-.81v1.8399999999999999ZM222.96 491.2v-2.35h.49l.61 1a7 7 0 0 1 .4.79v-1.8199999999999998h.39v2.35h-.45l-.62-1a8 8 0 0 1-.42-.81v1.8399999999999999ZM226.64 490.16h-.89v.69h1v.35h-1.42v-2.35h1.37v.35h-.94v.6h.89ZM227.12 488.85h.43v2h1v.36h-1.4ZM338.1 477.3a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM338.47 476.18a3.5 3.5 0 0 1 .63-.05 1.13 1.13 0 0 1 .67.15.5.5 0 0 1 .25.44.55.55 0 0 1-.4.51.6.6 0 0 1 .25 1.06 1.27 1.27 0 0 1-.87.22 3.3 3.3 0 0 1-.53 0Zm.43.93h.22c.3 0 .46-.14.46-.34s-.17-.33-.44-.33h-.24Zm0 1.08h.22c.28 0 .53-.1.53-.39s-.24-.39-.54-.39h-.21ZM340.4 478.5v-.26l.27-.25c.53-.5.79-.77.79-1.07a.36.36 0 0 0-.41-.38.78.78 0 0 0-.48.19l-.13-.31a1.15 1.15 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.68 1.08l-.2.18h.93v.36ZM335.73 482.7v-.26l.27-.25c.53-.5.78-.77.79-1.07a.36.36 0 0 0-.39-.42.78.78 0 0 0-.48.19l-.13-.31a1.13 1.13 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.69 1.08l-.19.18h.93v.4ZM337.61 482.7v-.26l.26-.25c.54-.5.79-.77.79-1.07a.36.36 0 0 0-.4-.38.83.83 0 0 0-.49.19l-.12-.31a1.12 1.12 0 0 1 .69-.23.67.67 0 0 1 .75.69c0 .4-.28.72-.68 1.08l-.2.18h.93v.36ZM340.29 481.5v-.5h.37v.25a.59.59 0 0 1 .52-.29.51.51 0 0 1 .48.31.7.7 0 0 1 .21-.21.56.56 0 0 1 .35-.1c.28 0 .56.19.56.74v1h-.38v-.94c0-.28-.09-.45-.3-.45a.33.33 0 0 0-.3.22 1 1 0 0 0 0 .15v1h-.42v-1c0-.24-.1-.41-.29-.41a.35.35 0 0 0-.31.24.4.4 0 0 0 0 .14v1h-.42ZM279.9 477.3a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.13-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM280.27 476.18a3.5 3.5 0 0 1 .63-.05 1.13 1.13 0 0 1 .67.15.5.5 0 0 1 .25.44.55.55 0 0 1-.4.51.6.6 0 0 1 .25 1.06 1.27 1.27 0 0 1-.87.22 3.3 3.3 0 0 1-.53 0Zm.43.93h.22c.3 0 .46-.14.46-.34s-.17-.33-.44-.33h-.24Zm0 1.08h.22c.28 0 .53-.1.53-.39s-.24-.39-.54-.39h-.21ZM282.86 476.62l-.42.21-.07-.33.55-.27h.36v2.27h-.42ZM277.53 482.7v-.26l.27-.25c.53-.5.79-.77.79-1.07a.36.36 0 0 0-.41-.38.78.78 0 0 0-.48.19l-.13-.31a1.13 1.13 0 0 1 .7-.23.68.68 0 0 1 .75.69c0 .4-.29.72-.69 1.08l-.19.18h.93v.36ZM279.49 482.26a1.16 1.16 0 0 0 .52.14c.33 0 .46-.19.46-.37s-.26-.38-.52-.38h-.2v-.32h.2c.19 0 .45-.09.45-.31s-.12-.29-.37-.29a.93.93 0 0 0-.46.14l-.1-.31a1.33 1.33 0 0 1 .65-.17c.47 0 .71.26.71.56a.56.56 0 0 1-.41.53.57.57 0 0 1 .49.57c0 .38-.32.69-.88.69a1.27 1.27 0 0 1-.64-.16ZM282.09 481.5v-.5h.31v.25a.59.59 0 0 1 .52-.29.51.51 0 0 1 .48.31.7.7 0 0 1 .21-.21.56.56 0 0 1 .35-.1c.28 0 .56.19.56.74v1h-.42v-.94c0-.28-.09-.45-.3-.45a.33.33 0 0 0-.3.22 1 1 0 0 0 0 .15v1h-.42v-1c0-.24-.1-.41-.29-.41a.35.35 0 0 0-.31.24.4.4 0 0 0 0 .14v1h-.42ZM346.47 483.8a3 3 0 0 1 .58-.05 1.05 1.05 0 0 1 .62.14.46.46 0 0 1 .22.41.49.49 0 0 1-.36.46.55.55 0 0 1 .44.53.57.57 0 0 1-.21.45 1.23 1.23 0 0 1-.8.2 3 3 0 0 1-.49 0Zm.39.85h.21c.27 0 .42-.13.42-.31s-.15-.3-.4-.3a1 1 0 0 0-.23 0Zm0 1h.21c.26 0 .48-.09.48-.36s-.22-.35-.49-.35h-.2ZM348.32 483.77h.39v1.83h.89v.33h-1.28Z"></path>
            <g id="RB3">
              <path
                id="container-8"
                fill="#cb9636"
                d="M313.6 412.2a2.82 2.82 0 0 1-3 2.75h-22.1a2.89 2.89 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <path
                id="container-9"
                fill="#cb9636"
                d="M285.6 412.2a2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 3 2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-8" fill="#50514e" data-name="label">
                <path d="M236.64 391.11a7 7 0 0 1 1.12-.09 1.84 1.84 0 0 1 1.24.33 1 1 0 0 1 .35.81 1.07 1.07 0 0 1-.73 1 1 1 0 0 1 .56.78 9 9 0 0 0 .32 1.12h-.76a5 5 0 0 1-.27-.95c-.12-.53-.31-.7-.73-.71h-.34v1.66h-.73Zm.73 1.78h.44c.5 0 .81-.26.81-.66s-.31-.65-.79-.65a2 2 0 0 0-.46 0ZM240.05 391.11a6 6 0 0 1 1.08-.09 2 2 0 0 1 1.16.26.85.85 0 0 1 .41.76.93.93 0 0 1-.67.87 1 1 0 0 1 .82 1 1.08 1.08 0 0 1-.39.83 2.26 2.26 0 0 1-1.5.37 6.4 6.4 0 0 1-.91-.05Zm.74 1.59h.37c.52 0 .8-.24.8-.58s-.29-.55-.75-.55a2 2 0 0 0-.42 0Zm0 1.86a2 2 0 0 0 .39 0c.47 0 .89-.18.89-.68s-.41-.66-.92-.66h-.36ZM243.49 394.33a2 2 0 0 0 .89.24c.56 0 .79-.32.79-.62 0-.46-.44-.66-.89-.66h-.33v-.54h.32c.34 0 .77-.16.77-.54s-.19-.49-.62-.49a1.6 1.6 0 0 0-.8.24l-.16-.53a2.14 2.14 0 0 1 1.12-.3c.8 0 1.22.45 1.22.95a1 1 0 0 1-.72.91 1 1 0 0 1 .85 1c0 .66-.55 1.18-1.51 1.18a2.1 2.1 0 0 1-1.09-.27Z"></path>
              </g>
            </g>
            <g id="OP5">
              <path
                id="container-10"
                fill="#cb9636"
                d="M285.23 319.86a2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75h-22.1a2.89 2.89 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-9" fill="#50514e" data-name="label">
                <path d="M239.86 300.7a1.91 1.91 0 0 1-1.94 2.13 1.87 1.87 0 0 1-1.86-2.06 1.93 1.93 0 0 1 1.92-2.11 1.87 1.87 0 0 1 1.88 2.04m-3 .06c0 .82.42 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.67-1.14 1.5ZM240.49 298.76a7.6 7.6 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.13 1.13 0 0 1 .4.9 1.25 1.25 0 0 1-.34.91 1.78 1.78 0 0 1-1.28.44 2 2 0 0 1-.36 0v1.52h-.74Zm.74 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.31-.68-.83-.68a3 3 0 0 0-.42 0ZM246.16 299.47h-1.5l-.11.78h.28a1.74 1.74 0 0 1 .94.25 1.12 1.12 0 0 1 .51 1 1.42 1.42 0 0 1-1.57 1.35 2.15 2.15 0 0 1-1-.23l.15-.56a1.9 1.9 0 0 0 .86.21.76.76 0 0 0 .84-.71c0-.45-.33-.75-1.11-.75a4 4 0 0 0-.53 0l.25-2h2Z"></path>
              </g>
            </g>
          </g>
          <g id="LEVELS_01" data-name="LEVELS 01">
            <g
              id="label_op4_720"
              stroke={colors["rect_label_op4_720"]?.stroke}
              strokeWidth={colors["rect_label_op4_720"]?.strokeWidth}
            >
              <path d="M6.2 458.7v.23l-1.13 2.37h-.36l1.12-2.3H4.56v-.3ZM6.56 461.3v-.21l.28-.27c.66-.63 1-1 1-1.36a.46.46 0 0 0-.52-.51.9.9 0 0 0-.55.22l-.11-.25a1.13 1.13 0 0 1 .74-.22.73.73 0 0 1 .8.75c0 .48-.35.87-.9 1.4l-.2.19h1.16v.29ZM10.34 459.97c0 .89-.32 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM11.64 458.61h.35v2.4h1.15v.29h-1.5ZM14.92 460.04h-1v1h1.17v.29h-1.56v-2.69h1.45v.29h-1.1v.85h1ZM16.13 461.3l-.89-2.69h.38l.42 1.32c.12.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM19.16 460.04h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM19.73 458.61h.35v2.4h1.15v.29h-1.5Z"></path>
            </g>
            <g
              id="_720"
              fill="none"
              stroke="#5e7076"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.73"
              data-name="720"
            >
              <g id="LINE-45" data-name="LINE">
                <path d="M328.3 451.3h2.5"></path>
                <path strokeDasharray="4.95 4.95" d="M335.8 451.3h96.4"></path>
                <path d="M434.7 451.3h2.5"></path>
              </g>
              <g id="LINE-46" data-name="LINE">
                <path d="M296 451.3h2.5"></path>
                <path strokeDasharray="4.07 4.07" d="M302.6 451.3h6.1"></path>
                <path d="M310.8 451.3h2.5"></path>
              </g>
              <g id="LINE-47" data-name="LINE">
                <path d="M25.3 451.3h2.5"></path>
                <path strokeDasharray="4.96 4.96" d="M32.7 451.3h245.6"></path>
                <path d="M280.7 451.3h2.5"></path>
              </g>
            </g>
            <g id="OP3_910">
              <path
                id="LINE-48"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 261.7h114.8"
                data-name="LINE"
              ></path>
              <g
                id="label_op3_910"
                stroke={colors["rect_label_op3_910"]?.stroke}
                strokeWidth={colors["rect_label_op3_910"]?.strokeWidth}
              >
                <path d="M4.55 262.21a1.5 1.5 0 0 0 .29 0 .93.93 0 0 0 .54-.25 1.13 1.13 0 0 0 .34-.69.74.74 0 0 1-.61.28.75.75 0 0 1-.77-.8.89.89 0 0 1 .89-.92c.53 0 .86.43.86 1.1a1.63 1.63 0 0 1-.45 1.22 1.3 1.3 0 0 1-.75.34 1.3 1.3 0 0 1-.33 0Zm.13-1.49a.5.5 0 0 0 .5.55.58.58 0 0 0 .51-.27.23.23 0 0 0 0-.13c0-.44-.16-.78-.53-.78s-.48.26-.48.61ZM7.16 260.19l-.46.24-.06-.26.56-.31h.3v2.6h-.34ZM10.18 261.14c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.34.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.41-.53 1.11ZM11.48 259.77h.35v2.4h1.15v.29h-1.5ZM14.76 261.2h-1v1h1.17v.29H13.4v-2.69h1.46v.29h-1.15v.85h1ZM15.96 262.46l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM18.99 261.2h-1v1h1.17v.29H17.6v-2.69h1.46v.29h-1.11v.85h1ZM19.57 259.77h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <path
                fill="#dc2e1a"
                d="m112.1 257.5-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
              ></path>
              <path
                fill="#5e7076"
                d="M102.1 258.8a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M108.3 260.2a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.4.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
              ></path>
              <path
                fill="#dc2e1a"
                d="M107.6 258.7a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.3v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.2 0 .4 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c0 .1-.1.2-.3.2"
              ></path>
              <circle cx="109.5" cy="259.2" r="0.1" fill="#ebb24b"></circle>
              <circle cx="104.1" cy="260.1" r="0.1" fill="#ebb24b"></circle>
              <circle cx="100.1" cy="260.1" r="0.1" fill="#ebb24b"></circle>
              <circle cx="109.9" cy="259.3" r="0.1" fill="#ebb24b"></circle>
            </g>
            <g id="OP1_1010">
              <path
                id="LINE-49"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 183.4h96.4"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1010"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1010"
                  d="M78 205.1H60a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1010"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1010")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op1_1010"
                stroke={colors["rect_label_op1_1010"]?.stroke}
                strokeWidth={colors["rect_label_op1_1010"]?.strokeWidth}
              >
                <path d="m1.61 188.06-.45.24-.07-.26.57-.31h.3v2.6h-.34ZM2.89 190.33v-.21l.28-.27c.66-.63 1-1 1-1.36a.46.46 0 0 0-.51-.51.9.9 0 0 0-.56.22l-.11-.25a1.16 1.16 0 0 1 .74-.26.73.73 0 0 1 .79.75c0 .49-.35.87-.9 1.4l-.2.19h1.16v.29ZM6.4 187.98a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.8.8 0 0 1 1.42.54.88.88 0 0 1-.87.92c-.55 0-.92-.44-.92-1.11a1.65 1.65 0 0 1 .44-1.17 1.4 1.4 0 0 1 .84-.39h.25Zm-.1 1.5a.52.52 0 0 0-.53-.59.57.57 0 0 0-.51.31.4.4 0 0 0 0 .16c0 .43.2.75.57.75s.5-.26.5-.63ZM8.73 189.01c0 .88-.33 1.37-.91 1.37s-.85-.48-.86-1.34.38-1.35.91-1.35.86.49.86 1.32m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.41-.53 1.11ZM10.02 187.64h.38v2.4h1.15v.29h-1.5ZM13.31 189.07h-1v1h1.09v.29h-1.49v-2.69h1.49v.29h-1.14v.85h1ZM14.51 190.33l-.88-2.69H14l.42 1.33c.12.36.22.69.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM17.54 189.07h-1v1h1.16v.29h-1.55v-2.69h1.45v.29h-1.1v.85h1ZM18.11 187.64h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op1_1010">
                <path d="M.66 177.09a5 5 0 0 1 .75-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11H.66Zm.49 1.19h.25c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM5.33 178.38a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.74-1-.76.48-.76 1.03ZM8.03 178.7v-1.13c-.08.33-.2.69-.31 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.21-.71-.28-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.54l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op1_1010_2">
                <path
                  fill="#dc2e1a"
                  d="m52.5 179.2.6.9 1.2 1.4h.6l.8.7.3.3c.1.1.2.1.2 0s-.1-.3-.1-.4v-.3a.19.19 0 0 1-.3 0l-.4-.6a1.85 1.85 0 0 0 .7-.8l.5-.9-.2-.5-1.7.9-1.4-.1-.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M61.1 181.9v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.54 1.54 0 0 0-1.5-1.5 1.61 1.61 0 0 0-1.3 1.5m.9 0a.6.6 0 1 1 .6.6.58.58 0 0 1-.6-.6M56.3 181.9v.2a.37.37 0 0 0 .1.3 1.48 1.48 0 0 0 2.9-.2v-.4a1.51 1.51 0 0 0-1.5-1.3 1.57 1.57 0 0 0-1.4.9.75.75 0 0 0-.1.5m.9 0a.6.6 0 1 1 .6.6.58.58 0 0 1-.6-.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M56.9 180.4h.2a.6.6 0 0 1 .4-.1h.9l.2.2.1.1.1.1a1.4 1.4 0 0 1 .3.4.1.1 0 0 0 .1.1v1h1.6v-.4a1.7 1.7 0 0 1 3.4 0v.4H66l.6-.4v-.4H66v-1.5h.3v-.2h-2.4v.2h-1.4v-.7h-2.3v.7h-.7v-.2H59v.3h-.8a5 5 0 0 0-1.3.4m3.3.1v.2h-.5c.1-.1.2-.2.3-.2Zm-.6.3h.6v.2h-.6zm0 .8.6-.1v.2zm0-.1v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.1.6h.5v.2H60c-.2 0-.3-.1-.3-.2"
                ></path>
                <circle cx="55.1" cy="180.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="60.6" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="64.6" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="54.7" cy="181" r="0.1" fill="#ebb24b"></circle>
              </g>
              <g id="carrito_op1_1010_1">
                <path
                  fill="#dc2e1a"
                  d="m112.2 179.2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M102.1 180.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6M108.4 181.9a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.53.53 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M107.7 180.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.2-.1.3 0 .5 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm0 .8h-.6v-.2h.6zm-.6-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c0 .1-.2.2-.3.2"
                ></path>
                <circle cx="109.6" cy="180.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="104.1" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="100.1" cy="181.8" r="0.1" fill="#ebb24b"></circle>
                <circle cx="110" cy="181" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1035">
              <path
                id="LINE-50"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 165.1h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1035"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1035"
                  d="M138.7 186.8h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1035"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1035")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1035"
                stroke={colors["rect_label_op2_1035"]?.stroke}
                strokeWidth={colors["rect_label_op2_1035"]?.strokeWidth}
              >
                <path d="m63.4 169.33-.45.24-.07-.27.57-.3h.29v2.6h-.34ZM66.4 170.27c0 .89-.33 1.37-.9 1.37s-.85-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.56.42-.56 1.12ZM66.78 171.2a1.2 1.2 0 0 0 .58.16c.45 0 .59-.29.58-.5 0-.37-.33-.52-.67-.52h-.19v-.27h.19c.26 0 .58-.13.58-.44s-.13-.39-.45-.39a.94.94 0 0 0-.52.17l-.1-.25a1.25 1.25 0 0 1 .68-.2c.52 0 .75.3.75.62a.65.65 0 0 1-.48.61.67.67 0 0 1 .58.66c0 .42-.33.78-1 .78a1.3 1.3 0 0 1-.67-.17ZM70.3 169.3h-1l-.1.66h.2a1.06 1.06 0 0 1 .56.14.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.24 1.24 0 0 1-.64-.16l.09-.26a1.15 1.15 0 0 0 .55.14.57.57 0 0 0 .61-.57c0-.33-.22-.57-.74-.57a3 3 0 0 0-.36 0l.17-1.25h1.24ZM71.77 168.91h.35v2.4h1.15v.29h-1.5ZM75.05 170.34h-1v1h1.17v.29H73.7v-2.69h1.46v.29h-1.11v.85h1ZM76.26 171.6l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM79.29 170.34h-1v1h1.11v.29h-1.5v-2.69h1.5v.29h-1.11v.85h1ZM79.86 168.91h.35v2.4h1.19v.29h-1.5Z"></path>
              </g>
              <g id="label2_op2_1035">
                <path d="M62.6 159.12a4 4 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.7.7 0 0 1 .23.54.71.71 0 0 1-.49.67.68.68 0 0 1 .37.53 6 6 0 0 0 .22.75H64a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.31c.33 0 .54-.18.54-.45s-.21-.43-.53-.43a1 1 0 0 0-.3 0ZM67.26 160.4a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.45.74-1-.25-1-.74-1-.76.49-.76 1.04ZM69.96 160.7v-1.14c-.09.33-.2.7-.32 1l-.39 1.16h-.38l-.36-1.15a10 10 0 0 1-.27-1c0 .36 0 .79-.05 1.15l-.06 1.09h-.46l.18-2.7h.65l.35 1.08c.1.32.18.64.25.94.07-.29.16-.62.27-.94l.37-1.08h.64l.15 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op2_1035">
                <path
                  fill="#dc2e1a"
                  d="m100.3 160.9-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 162.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 163.6a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 162.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.3-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="162.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="163.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="163.5" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="162.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1060">
              <path
                id="LINE-51"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 147.5h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1060"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1060"
                  d="M138.7 169.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1060"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1060")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1060"
                stroke={colors["rect_label_op2_1060"]?.stroke}
                strokeWidth={colors["rect_label_op2_1060"]?.strokeWidth}
              >
                <path d="m63.07 152.13-.46.24-.06-.27.56-.3h.3v2.6h-.34ZM66.09 153.07c0 .89-.33 1.37-.9 1.37s-.86-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM67.9 152.05a1.3 1.3 0 0 0-.27 0 1 1 0 0 0-.9.92.75.75 0 0 1 .63-.3.77.77 0 0 1 .78.84.86.86 0 0 1-.86.91c-.56 0-.92-.43-.92-1.1a1.6 1.6 0 0 1 .44-1.17 1.35 1.35 0 0 1 .83-.39 1.3 1.3 0 0 1 .26 0Zm-.1 1.5a.54.54 0 0 0-.54-.6.56.56 0 0 0-.5.32.25.25 0 0 0 0 .16c0 .42.2.74.57.74s.47-.25.47-.62M70.19 153.07c0 .89-.33 1.37-.9 1.37s-.85-.47-.86-1.33.38-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.42-.53 1.12ZM71.49 151.7h.35v2.4h1.15v.29h-1.5ZM74.77 153.14h-1v1h1.16v.29H73.4v-2.73h1.45v.28h-1.1v.86h1ZM75.97 154.4l-.88-2.69h.38l.42 1.32c.11.37.21.7.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.69ZM79.01 153.14h-1.05v1h1.17v.29h-1.52v-2.73h1.46v.28h-1.11v.86h1.05ZM79.58 151.7h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op2_1060">
                <path d="M62.28 140.7a4 4 0 0 1 .74-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.67.68.68 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3 3 0 0 1-.18-.63c-.08-.35-.21-.47-.49-.47h-.24v1.1h-.49Zm.49 1.19h.29c.33 0 .54-.18.54-.45s-.21-.43-.53-.43h-.3ZM66.94 141.97a1.28 1.28 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.04ZM69.64 142.24v-1.13c-.09.33-.2.69-.32 1l-.4 1.16h-.37l-.36-1.15a10 10 0 0 1-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94.07-.29.16-.62.27-.94l.31-.99h.64l.15 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op2_1060">
                <path
                  fill="#dc2e1a"
                  d="m100.3 143.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 144.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 145.9a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 144.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="145" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="145.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="145.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="145.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1085">
              <path
                id="LINE-52"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 129.8h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1085"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1085"
                  d="M138.7 151.5h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1085"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1085")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1085"
                stroke={colors["rect_label_op2_1085"]?.stroke}
                strokeWidth={colors["rect_label_op2_1085"]?.strokeWidth}
              >
                <path d="m62.66 134.31-.45.24-.07-.26.57-.31h.3v2.6h-.34ZM65.67 135.26c0 .88-.33 1.37-.9 1.37s-.85-.48-.86-1.34.38-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.16-1.06-.53-1.06-.53.41-.53 1.11ZM65.97 135.92a.73.73 0 0 1 .51-.69.63.63 0 0 1-.42-.58.73.73 0 0 1 .81-.69.67.67 0 0 1 .76.64.66.66 0 0 1-.43.61.72.72 0 0 1 .52.67.8.8 0 0 1-.88.76.77.77 0 0 1-.87-.72m1.39 0c0-.32-.22-.47-.57-.57a.58.58 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .56-.47Zm-1-1.3c0 .26.19.4.49.48a.52.52 0 0 0 .4-.48.41.41 0 0 0-.44-.42.41.41 0 0 0-.41.41ZM69.6 134.28h-1l-.1.67h.21a1.16 1.16 0 0 1 .56.14.75.75 0 0 1 .37.67.9.9 0 0 1-1 .89 1.25 1.25 0 0 1-.65-.16l.09-.27a1.15 1.15 0 0 0 .55.14.57.57 0 0 0 .62-.56c0-.34-.23-.58-.75-.58a3 3 0 0 0-.36 0l.17-1.25h1.24ZM71.07 133.89h.33v2.4h1.15v.29h-1.5ZM74.4 135.32h-1v1h1.17v.29h-1.52v-2.69h1.35v.29h-1.11v.85h1ZM75.56 136.58l-.88-2.69h.37l.42 1.33c.12.36.22.69.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM78.59 135.32h-1v1h1.16v.29H77.2v-2.69h1.45v.29h-1.1v.85h1ZM79.16 133.89h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op2_1085">
                <path d="M62.28 123.43a5 5 0 0 1 .74-.06 1.3 1.3 0 0 1 .84.22.7.7 0 0 1 .23.54.71.71 0 0 1-.49.67.68.68 0 0 1 .37.53 6 6 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.18.54-.44s-.21-.44-.53-.44a1.4 1.4 0 0 0-.3 0ZM66.94 124.7a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.45.74-1-.25-1-.74-1-.76.5-.76 1.05ZM69.64 124.99v-1.14c-.09.33-.2.7-.32 1l-.39 1.17h-.38l-.36-1.15c-.11-.35-.2-.72-.27-1.06v1.15l-.06 1.09h-.46l.18-2.7h.65l.35 1.08c.09.32.18.64.25.94.07-.29.16-.62.27-.94l.37-1.08h.64l.15 2.7h-.48Z"></path>
              </g>
              <g id="carrito_op2_1085">
                <path
                  fill="#dc2e1a"
                  d="m100.3 125.6-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 126.9a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 128.3a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 126.8a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .1c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="127.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="128.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="128.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="127.4" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1110">
              <path
                id="LINE-53"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 112.1h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1110"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1110"
                  d="M138.7 133.8h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1110"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1110")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1110"
                stroke={colors["rect_label_op2_1110"]?.stroke}
                strokeWidth={colors["rect_label_op2_1110"]?.strokeWidth}
              >
                <path d="m62.94 116.28-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM64.99 116.28l-.45.24-.07-.27.57-.3h.3v2.6H65ZM67.04 116.28l-.46.24-.06-.27.56-.3h.3v2.6h-.34ZM70.06 117.22c0 .89-.33 1.37-.9 1.37s-.86-.47-.86-1.33.37-1.35.9-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.53 1.06s.53-.42.53-1.08-.17-1.06-.53-1.06-.53.42-.53 1.12ZM71.4 115.86h.35v2.4h1.16v.29H71.4ZM74.64 117.29h-1.05v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1.05ZM75.84 118.55l-.88-2.69h.38l.42 1.32c.11.37.21.7.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM78.87 117.29h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM79.45 115.86h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op2_1110">
                <path d="M62 105.34a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.69.69 0 0 1 .37.52c.09.34.16.64.21.75h-.5a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.25v1.11H62Zm.48 1.19h.3c.33 0 .53-.17.53-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM66.66 106.63a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.27 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.07ZM69.4 106.9v-1.13c-.09.33-.21.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.21-.71-.28-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08a9 9 0 0 1 .25.94c.08-.3.17-.63.27-.94l.38-1.08h.64l.15 2.69h-.61Z"></path>
              </g>
              <g id="carrito_op2_1110">
                <path
                  fill="#dc2e1a"
                  d="m100.3 108-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 109.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 110.6a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 109.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zc-.1-.1 0-.1 0 0m-.1.7h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="109.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="110.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="110.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="109.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1135">
              <path
                id="LINE-54"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 94.5h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1135"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1135"
                  d="M138.7 116.1h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1135"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1135")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1135"
                stroke={colors["rect_label_op2_1135"]?.stroke}
                strokeWidth={colors["rect_label_op2_1135"]?.strokeWidth}
              >
                <path d="m62.52 98.19-.45.25-.06-.27.56-.3h.3v2.6h-.34ZM64.57 98.19l-.45.25-.07-.27.57-.3h.29v2.6h-.34ZM65.95 100.06a1.1 1.1 0 0 0 .57.16c.45 0 .59-.28.59-.5s-.33-.52-.67-.52h-.2v-.26h.2c.26 0 .58-.13.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.26a1.25 1.25 0 0 1 .68-.2c.51 0 .75.31.75.62a.67.67 0 0 1-.48.62.67.67 0 0 1 .57.67c0 .41-.32.78-.94.78a1.26 1.26 0 0 1-.68-.18ZM69.46 98.16h-1l-.1.67h.21a1.2 1.2 0 0 1 .56.15.74.74 0 0 1 .37.66.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.2 1.2 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.22-.57-.74-.57h-.36l.16-1.24h1.24ZM70.94 97.77h.35v2.4h1.11v.3h-1.5ZM74.22 99.2h-1v1h1.16v.29h-1.51v-2.7h1.45v.29h-1.1v.85h1ZM75.4 100.47l-.88-2.7h.38l.42 1.33c.11.36.21.69.29 1a10 10 0 0 1 .3-1l.46-1.33h.37l-1 2.7ZM78.46 99.2H77.4v1h1.17v.29h-1.52v-2.7h1.46v.29H77.4v.85h1.05ZM79.03 97.77h.37v2.4h1.15v.3h-1.5Z"></path>
              </g>
              <g id="label2_op2_1135">
                <path d="M61.86 87.94a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47h-.2v1.11h-.49Zm.49 1.19h.29c.34 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM66.53 89.23a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.47-.77 1.03ZM69.23 89.5v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.36-1.15c-.1-.35-.2-.71-.27-1v1.15l-.06 1.08h-.46l.18-2.69h.65l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op2_1135">
                <path
                  fill="#dc2e1a"
                  d="m100.3 90.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 91.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1V93a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 93a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 91.4a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 1 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2h-.5v-.2Zm.4.4-.6.1v-.2zm-.1.8h-.6v-.2h.6zc.1-.1 0-.1 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="92" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="92.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="92.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="92.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP2_1160">
              <path
                id="LINE-55"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M83.5 76.8h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op2_1160"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op2_1160"
                  d="M138.7 98.5h-18a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op2_1160"]?.color}
                  onMouseDown={(e) => handleColor("rect_op2_1160")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op2_1160"
                stroke={colors["rect_label_op2_1160"]?.stroke}
                strokeWidth={colors["rect_label_op2_1160"]?.strokeWidth}
              >
                <path d="m62.24 81.27-.45.25-.07-.27.57-.3h.3v2.59h-.34ZM64.29 81.27l-.45.25-.06-.27.56-.3h.3v2.59h-.34ZM67.06 81.19a1.3 1.3 0 0 0-.26 0 1 1 0 0 0-.9.92.79.79 0 0 1 1.41.54.87.87 0 0 1-.87.92c-.55 0-.91-.43-.91-1.11a1.62 1.62 0 0 1 .44-1.17 1.47 1.47 0 0 1 .83-.39 1 1 0 0 1 .25 0Zm-.1 1.5a.52.52 0 0 0-.53-.59.59.59 0 0 0-.51.32.3.3 0 0 0 0 .15c0 .43.2.75.57.75s.47-.25.47-.62ZM69.4 82.22c0 .88-.33 1.37-.9 1.37s-.86-.48-.86-1.34.37-1.35.9-1.35.86.49.86 1.32m-1.41 0c0 .67.21 1.06.53 1.06s.53-.42.53-1.09-.17-1-.53-1-.57.36-.57 1.07ZM70.66 80.85H71v2.4h1.16v.29h-1.5ZM73.94 82.28h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM75.14 83.54l-.88-2.69h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.33h.37l-1 2.69ZM78.17 82.28h-1v1h1.17v.29h-1.52v-2.69h1.46v.29h-1.11v.85h1ZM78.75 80.85h.35v2.4h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op2_1160">
                <path d="M61.58 70.49a4 4 0 0 1 .75-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .23.54.72.72 0 0 1-.49.67.71.71 0 0 1 .38.52 4.2 4.2 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.63c-.08-.35-.2-.47-.48-.47h-.25v1.1h-.49Zm.49 1.19h.33c.33 0 .54-.18.54-.45s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM66.24 71.77a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.04ZM68.94 72.05v-1.14c-.09.33-.2.7-.32 1l-.39 1.16h-.38l-.36-1.15a10 10 0 0 1-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.52l.35 1.08c.1.32.18.64.25.94.07-.29.16-.62.27-.94l.37-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op2_1160">
                <path
                  fill="#dc2e1a"
                  d="m100.3 72.6-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M90.3 73.9a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M96.6 75.3a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M95.9 73.8a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7H89v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2h-.5V74Zm.4.3-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8h-.2v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="97.8" cy="74.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="92.3" cy="75.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="88.3" cy="75.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="98.1" cy="74.4" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP1_1160">
              <path
                id="LINE-56"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 76.8h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1160"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1160"
                  d="M78 98.5H60a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1160"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1160")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op1_1160"
                stroke={colors["rect_label_op1_1160"]?.stroke}
                strokeWidth={colors["rect_label_op1_1160"]?.strokeWidth}
              >
                <path d="m2.31 81.23-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM4.4 81.23l-.45.24-.07-.27.57-.3h.3v2.6H4.4ZM7.13 81.15a1.4 1.4 0 0 0-.27 0 1 1 0 0 0-.9.92.8.8 0 0 1 1.42.54.87.87 0 0 1-.87.91c-.55 0-.92-.43-.92-1.1a1.65 1.65 0 0 1 .44-1.17 1.4 1.4 0 0 1 .83-.39 1.3 1.3 0 0 1 .26 0Zm-.1 1.5a.53.53 0 0 0-.53-.6.57.57 0 0 0-.51.32.34.34 0 0 0 0 .16c0 .42.2.74.57.74s.47-.25.47-.57ZM9.4 82.17c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.5.42-.5 1.12ZM10.72 80.81h.35v2.4h1.15v.29h-1.5ZM14 82.24h-1v1h1.17v.29h-1.56v-2.69h1.46v.29h-1.11v.85h1ZM15.21 83.5l-.88-2.69h.37l.42 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.37l-1 2.69ZM18.24 82.24h-1v1h1.16v.29h-1.55v-2.69h1.45v.29h-1.11v.85h1ZM18.81 80.81h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g id="label2_op1_1160">
                <path d="M1.51 70.44a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.68.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47H2v1.12h-.49ZM2 71.63h.29c.33 0 .54-.17.54-.44s-.21-.43-.52-.43a2 2 0 0 0-.31 0ZM6.18 71.7a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.25-1.37 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.51-.77 1.06ZM8.87 72v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.38-1.12c-.1-.35-.2-.71-.27-1v1.15l-.06 1.08h-.46l.18-2.69h.61l.35 1.08c.1.32.18.64.25.94.07-.3.17-.63.27-.94l.37-1.08h.64l.12 2.64h-.48Z"></path>
              </g>
              <g id="carrito_op1_1160">
                <path
                  fill="#dc2e1a"
                  d="m39.7 72.6-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M29.6 73.9a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M35.9 75.3a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M35.2 73.8a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3H32v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4H28v-.4a1.7 1.7 0 0 1 3.4 0v.4H33v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1a.1.1 0 0 0 .1-.1.1.1 0 0 0 .1-.1h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2H32V74Zm.4.3-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8H32v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="37.1" cy="74.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="31.6" cy="75.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="27.6" cy="75.2" r="0.1" fill="#ebb24b"></circle>
                <circle cx="37.4" cy="74.4" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP1_1185">
              <path
                id="LINE-57"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 59.1h15.3l9.1 6"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1185"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1185"
                  d="M78 80.8H60a2.43 2.43 0 0 1-2.4-2.4A2.43 2.43 0 0 1 60 76h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1185"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1185")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op1_1185"
                stroke={colors["rect_label_op1_1185"]?.stroke}
                strokeWidth={colors["rect_label_op1_1185"]?.strokeWidth}
              >
                <path d="m1.89 63.47-.49.23v-.26l.57-.3h.3v2.56h-.34ZM3.94 63.47l-.45.24-.09-.27.57-.3h.3v2.56h-.34ZM5.2 65.08a.76.76 0 0 1 .51-.7.64.64 0 0 1-.41-.58.74.74 0 0 1 .8-.7.67.67 0 0 1 .76.64.66.66 0 0 1-.43.61.73.73 0 0 1 .52.67.79.79 0 0 1-.88.76c-.54 0-.87-.32-.87-.7m1.4 0c0-.31-.22-.47-.57-.57a.56.56 0 0 0-.47.54.48.48 0 0 0 .52.49.47.47 0 0 0 .52-.48Zm-1-1.3c0 .26.2.4.5.48a.5.5 0 0 0 .39-.47.4.4 0 0 0-.44-.42.41.41 0 0 0-.42.39ZM8.83 63.43h-1l-.1.67h.21a1 1 0 0 1 .56.14.72.72 0 0 1 .37.66.9.9 0 0 1-1 .89 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.58.58 0 0 0 .61-.57c0-.33-.23-.57-.75-.57a2 2 0 0 0-.36 0l.17-1.25h1.24ZM10.3 63.04h.35v2.4h1.16v.26H10.3ZM13.59 64.47h-1v1h1.17v.23h-1.57V63h1.46v.29h-1.11v.86h1ZM14.79 65.7l-.88-2.7h.38l.42 1.33c.11.36.21.69.28 1 .08-.31.19-.65.31-1l.46-1.34h.37l-1 2.7ZM17.82 64.47h-1v1h1.17v.23H16.4V63h1.46v.29h-1.08v.86h1ZM18.4 63.04h.35v2.4h1.15v.26h-1.5Z"></path>
              </g>
              <g id="label2_op1_1185">
                <path d="M1.23 52.54a5 5 0 0 1 .74-.06 1.3 1.3 0 0 1 .84.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47h-.24v1.12h-.49Zm.49 1.16h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM5.89 53.83a1.26 1.26 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.2-1.37 1.29 1.29 0 0 1 1.28-1.41 1.25 1.25 0 0 1 1.21 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM8.59 54.1v-1.13c-.09.33-.2.69-.32 1l-.39 1.17H7.5l-.36-1.15a11 11 0 0 1-.27-1v1.15l-.06 1.08h-.46l.05-2.71h.65l.35 1.08c.09.32.18.64.25.94a9 9 0 0 1 .27-.94l.37-1.08h.64l.15 2.69H8.6Z"></path>
              </g>
              <g id="carrito_op1_1185">
                <path
                  fill="#dc2e1a"
                  d="m39.7 55-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M29.6 56.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M35.9 57.6a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.7a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M35.2 56.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3H32V55h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4H28v-.4a1.7 1.7 0 0 1 3.4 0v.4H33v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2H32v-.2Zm.4.4H32v-.2zm-.1.8h-.6v-.2h.6zm-.5-.3V57h.6v.2Zm0-.2v-.2h.6v.2Zm.2.7H32v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="37.1" cy="56.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="31.6" cy="57.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="27.6" cy="57.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="37.4" cy="56.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP1_1210">
              <path
                id="LINE-58"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 41.5h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1210"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1210"
                  d="M78 63.1H60a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1210"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1210")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op1_1210"
                stroke={colors["rect_label_op1_1210"]?.stroke}
                strokeWidth={colors["rect_label_op1_1210"]?.strokeWidth}
              >
                <path d="m1.61 45.18-.45.24-.07-.27.57-.3h.3v2.6h-.34ZM2.89 47.45v-.21l.28-.27c.66-.63 1-1 1-1.36a.46.46 0 0 0-.51-.51.9.9 0 0 0-.56.22l-.11-.25a1.16 1.16 0 0 1 .74-.26.73.73 0 0 1 .79.75c0 .48-.35.87-.9 1.4l-.2.19h1.16v.29ZM5.71 45.18l-.45.24-.06-.27.56-.3h.3v2.6h-.34ZM8.73 46.12c0 .89-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.35.91-1.35.86.49.86 1.31m-1.41 0c0 .68.21 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.53.42-.53 1.12ZM10.02 44.76h.38v2.4h1.15v.29h-1.5ZM13.31 46.19h-1v1h1.09v.29h-1.49v-2.72h1.49v.29h-1.14v.85h1ZM14.51 47.45l-.88-2.69H14l.4 1.32c.12.37.22.7.29 1 .08-.31.19-.65.31-1l.45-1.33h.38l-1 2.69ZM17.54 46.19h-1v1h1.17v.29h-1.56v-2.72h1.45v.29h-1.1v.85h1ZM18.11 44.76h.35v2.4h1.16v.29h-1.51Z"></path>
              </g>
              <g
                id="label_op2_1210"
                stroke={colors["rect_label_op2_1210"]?.stroke}
                strokeWidth={colors["rect_label_op2_1210"]?.strokeWidth}
              >
                <path d="M.95 34.84a5 5 0 0 1 .74-.06 1.25 1.25 0 0 1 .83.22.67.67 0 0 1 .24.54.72.72 0 0 1-.49.68.69.69 0 0 1 .37.52c.09.34.16.64.21.75H2.4a3.3 3.3 0 0 1-.18-.64c-.08-.35-.21-.46-.49-.47H1.4v1.12H.92Zm.45 1.19h.3c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.31 0ZM5.61 36.13a1.27 1.27 0 0 1-1.29 1.41 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.32-1.41 1.25 1.25 0 0 1 1.21 1.37m-2 0c0 .55.28 1 .75 1s.74-.44.74-1-.25-1-.74-1-.76.48-.76 1.03ZM8.31 36.4v-1.13c-.09.33-.2.69-.32 1l-.4 1.17h-.38l-.35-1.15c-.11-.35-.2-.71-.28-1v1.15L6.4 37.5h-.46l.18-2.69h.65l.35 1.08c.09.32.18.64.24.94.07-.3.16-.63.26-.94L8 34.81h.64l.15 2.69H8.4Z"></path>
              </g>
              <g id="carrito_op1_1210">
                <path
                  fill="#dc2e1a"
                  d="m39.7 37.3-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M29.6 38.5a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1V40a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M35.9 40a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M35.2 38.4A4.2 4.2 0 0 0 34 38h-.8v-.3h-.5v.3H32v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4H28v-.4a1.7 1.7 0 0 1 3.4 0v.4H33v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2H32v-.2Zm.4.4-.6.1v-.2zm-.1.8h-.6v-.2h.6zc.1-.1.1 0 0 0m-.5-.3v-.2h.6v.2Zm0-.2v-.2h.6v.2Zm.2.8H32v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="37.1" cy="39" r="0.1" fill="#ebb24b"></circle>
                <circle cx="31.6" cy="39.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="27.6" cy="39.9" r="0.1" fill="#ebb24b"></circle>
                <circle cx="37.4" cy="39.1" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP1_1235">
              <path
                id="LINE-59"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 23.8h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1235"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1235"
                  d="M78 45.5H60a2.43 2.43 0 0 1-2.4-2.4 2.43 2.43 0 0 1 2.4-2.4h18a2.43 2.43 0 0 1 2.4 2.4 2.43 2.43 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1235"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1235")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g
                id="label_op1_1235"
                stroke={colors["rect_label_op1_1235"]?.stroke}
                strokeWidth={colors["rect_label_op1_1235"]?.strokeWidth}
              >
                <path d="m1.74 27.92-.45.24-.06-.27.56-.3h.3v2.6h-.34ZM3.03 30.19v-.22l.27-.27c.67-.64 1-1 1-1.36a.46.46 0 0 0-.51-.51.87.87 0 0 0-.55.22l-.11-.25a1.1 1.1 0 0 1 .73-.26.72.72 0 0 1 .79.75c0 .48-.34.87-.89 1.4l-.21.19h1.17v.29ZM5.17 29.79a1.2 1.2 0 0 0 .57.16.52.52 0 0 0 .59-.51c0-.36-.33-.51-.67-.52h-.2v-.22h.2c.26 0 .58-.13.58-.44s-.13-.39-.46-.39a1 1 0 0 0-.52.17l-.09-.25a1.25 1.25 0 0 1 .68-.2c.51 0 .75.3.75.62a.66.66 0 0 1-.48.61.66.66 0 0 1 .57.66c0 .42-.32.78-.94.78a1.26 1.26 0 0 1-.68-.18ZM8.68 27.89h-1l-.09.66h.21a1.1 1.1 0 0 1 .6.15.74.74 0 0 1 .37.67.9.9 0 0 1-1 .88 1.3 1.3 0 0 1-.65-.16l.09-.27a1.1 1.1 0 0 0 .56.15.57.57 0 0 0 .61-.57c0-.33-.23-.57-.74-.57a2 2 0 0 0-.37 0l.13-1.24h1.24ZM10.16 27.49h.35v2.41h1.15v.29h-1.5ZM13.4 28.93h-1v1h1.16v.29h-1.51v-2.7h1.45v.29h-1.1v.86h1ZM14.64 30.19l-.88-2.7h.38l.42 1.33c.11.37.21.69.29 1a10 10 0 0 1 .3-1l.46-1.34h.37l-1 2.7ZM17.68 28.93h-1v1h1.12v.29h-1.52v-2.7h1.46v.29h-1.11v.86h1ZM18.25 27.49h.35v2.41h1.15v.29h-1.5Z"></path>
              </g>
              <g id="label2_op1_1235">
                <path d="M.66 17.7a4 4 0 0 1 .75-.06 1.2 1.2 0 0 1 .83.22.67.67 0 0 1 .23.54.71.71 0 0 1-.49.67.69.69 0 0 1 .38.52 5 5 0 0 0 .21.75h-.5a2.5 2.5 0 0 1-.18-.63c-.08-.35-.21-.47-.49-.47h-.25v1.1H.66Zm.49 1.19h.25c.34 0 .54-.18.54-.45s-.2-.43-.52-.43a1 1 0 0 0-.31 0ZM5.33 18.93a1.28 1.28 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.27 1 .74 1s.75-.44.75-1-.25-1-.74-1-.76.48-.76 1.04ZM8.03 19.21v-1.14c-.08.33-.2.7-.31 1l-.4 1.16h-.38l-.36-1.15c-.1-.34-.2-.71-.27-1.05v1.15l-.06 1.08h-.46l.18-2.69h.64l.25 1.13a9 9 0 0 1 .25.94c.08-.29.17-.62.27-.94l.38-1.08h.64l.16 2.69h-.48Z"></path>
              </g>
              <g id="carrito_op1_1235">
                <path
                  fill="#dc2e1a"
                  d="m39.7 19.6-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M29.6 20.9a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.23 1.23 0 0 0-1.3-1.5m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M35.9 22.3a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M35.2 20.8a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3H32v-.7h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4H28v-.4a1.7 1.7 0 0 1 3.4 0v.4H33v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0m-3 .2c.1 0 .2.1.3.2H32V21Zm.4.3-.6.1v-.2zm-.1.8h-.6v-.2h.6zm-.5-.2v-.2h.6v.2Zm0-.3v-.2h.6v.2Zm.2.8H32v-.2h.5c-.1.1-.2.2-.3.2"
                ></path>
                <circle cx="37.1" cy="21.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="31.6" cy="22.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="27.6" cy="22.3" r="0.1" fill="#ebb24b"></circle>
                <circle cx="37.4" cy="21.5" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <g id="OP1_1260">
              <path
                id="LINE-60"
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M22.8 6.2h15.3l9.1 5.9"
                data-name="LINE"
              ></path>
              <TooltipComponent
                nivel={colors["rect_op1_1260"]}
                datosProcesados={datosProcesados}
              >
                <path
                  id="rect_op1_1260"
                  d="M78 27.8H60a2.43 2.43 0 0 1-2.4-2.4A2.43 2.43 0 0 1 60 23h18a2.43 2.43 0 0 1 2.4 2.4 2.37 2.37 0 0 1-2.4 2.4"
                  transform="translate(-57.6 -19.3)"
                  fill={colors["rect_op1_1260"]?.color}
                  onMouseDown={(e) => handleColor("rect_op1_1260")}
                  style={{ cursor: "pointer" }}
                ></path>
              </TooltipComponent>

              <g id="label2_op1_1260">
                <path d="M.4.08a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.67.67 0 0 1 .23.54.69.69 0 0 1-.49.67.67.67 0 0 1 .38.52 6 6 0 0 0 .21.75H1.8a4 4 0 0 1-.18-.64c-.07-.35-.2-.46-.48-.47H.89V2.7H.4Zm.49 1.19h.29c.34 0 .54-.18.54-.44S1.51.4 1.2.39a1.5 1.5 0 0 0-.31 0ZM5.05 1.36a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.25-1.37A1.3 1.3 0 0 1 3.8 0a1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.49-.77 1.04ZM7.75 1.64V.51c-.09.33-.2.69-.32 1L6.99 2.7h-.38l-.36-1.15c-.1-.35-.2-.72-.27-1.05v1.15L5.86 2.7H5.4L5.58 0h.65l.35 1.09c.1.31.18.63.25.93.07-.29.17-.62.27-.94L7.47 0h.64l.16 2.7H7.8Z"></path>
              </g>
              <g
                id="label_op1_1260"
                stroke={colors["rect_label_op1_1260"]?.stroke}
                strokeWidth={colors["rect_label_op1_1260"]?.strokeWidth}
              >
                <path d="m1.33 10.43-.45.24-.07-.27.57-.3h.29v2.6h-.33ZM2.61 12.7v-.22l.28-.26c.66-.64 1-1 1-1.37a.46.46 0 0 0-.52-.5.9.9 0 0 0-.55.22l-.11-.25a1.14 1.14 0 0 1 .73-.27.74.74 0 0 1 .8.76c0 .48-.35.87-.9 1.39l-.2.2H4.3v.3ZM6.15 10.35a1.3 1.3 0 0 0-.27 0 1.06 1.06 0 0 0-.9.93.79.79 0 0 1 1.42.53.88.88 0 0 1-.87.92c-.55 0-.92-.43-.92-1.1a1.63 1.63 0 0 1 .44-1.18 1.45 1.45 0 0 1 .83-.38 1.3 1.3 0 0 1 .26 0Zm-.1 1.5a.53.53 0 0 0-.54-.6.56.56 0 0 0-.5.32.3.3 0 0 0 0 .15c0 .43.2.75.57.75s.47-.25.47-.62M8.45 11.37c0 .88-.33 1.37-.91 1.37s-.85-.47-.86-1.33.38-1.36.91-1.36.86.49.86 1.32m-1.41 0c0 .68.2 1.06.52 1.06s.53-.42.53-1.08-.16-1.06-.52-1.06-.54.41-.53 1.12ZM9.74 10h.35v2.4h1.15v.3h-1.5ZM13.02 11.43h-1v1h1.17v.27h-1.56V10h1.46v.29h-1.11v.86h1ZM14.23 12.7l-.89-2.7h.38l.42 1.33a10 10 0 0 1 .29 1 8 8 0 0 1 .31-1l.45-1.34h.37l-1 2.7ZM17.26 11.43h-1v1h1.14v.27h-1.54V10h1.46v.29h-1.11v.86h1ZM17.83 10h.35v2.4h1.15v.3h-1.5Z"></path>
              </g>
              <g id="carrito_op1_1260">
                <path
                  fill="#dc2e1a"
                  d="m39.7 2-.6.9-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1.3-.6Z"
                ></path>
                <path
                  fill="#5e7076"
                  d="M29.6 3.2a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.4a1.27 1.27 0 0 0-1.3-1.5m0 2.1a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M35.9 4.7a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3V5a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6"
                ></path>
                <path
                  fill="#dc2e1a"
                  d="M35.2 3.1a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3H32V2h-2.3v.7h-1.4v-.2h-2.4v.2h.3v1.5h-.6v.4l.6.4H28v-.4a1.7 1.7 0 0 1 3.4 0V5H33V4a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2zm-3 .2c.1 0 .2.1.3.2H32v-.2Zm.4.4H32v-.2zm-.1.8h-.6v-.2h.6zm-.5-.3V4h.6v.2Zm0-.2v-.2h.6V4Zm.2.7H32v-.2h.5c-.1.2-.2.2-.3.2"
                ></path>
                <circle cx="37.1" cy="3.7" r="0.1" fill="#ebb24b"></circle>
                <circle cx="31.6" cy="4.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="27.6" cy="4.6" r="0.1" fill="#ebb24b"></circle>
                <circle cx="37.4" cy="3.8" r="0.1" fill="#ebb24b"></circle>
              </g>
            </g>
            <path d="M116.73 89.44a1.11 1.11 0 0 1-1.13 1.26 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.17m-1.76 0c0 .48.24.86.65.86s.65-.39.65-.88-.22-.87-.65-.87-.65.44-.65.93ZM117.1 88.32a3.6 3.6 0 0 1 .66-.05 1.1 1.1 0 0 1 .69.19.67.67 0 0 1 .23.52.73.73 0 0 1-.2.54 1 1 0 0 1-.74.25h-.21v.88h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.19-.4-.48-.4h-.25ZM118.96 90.64v-.26l.27-.25c.54-.49.79-.76.79-1.06a.36.36 0 0 0-.41-.39.78.78 0 0 0-.48.19l-.13-.3a1.15 1.15 0 0 1 .7-.24.68.68 0 0 1 .75.69c0 .4-.29.72-.68 1.09l-.2.17h.93v.35ZM113.76 92.42a2.56 2.56 0 0 0-.39 1.43 2.6 2.6 0 0 0 .39 1.41h-.31a2.4 2.4 0 0 1-.42-1.42 2.4 2.4 0 0 1 .42-1.42ZM114.11 92.52a4 4 0 0 1 .65 0 1.12 1.12 0 0 1 .73.19.59.59 0 0 1 .2.47.61.61 0 0 1-.43.59.59.59 0 0 1 .33.46 5 5 0 0 0 .19.65h-.44a2.2 2.2 0 0 1-.16-.55c-.07-.31-.18-.41-.43-.41h-.21v1h-.43Zm.43 1h.25c.29 0 .47-.15.47-.39s-.18-.37-.45-.37a1.3 1.3 0 0 0-.27 0ZM118.19 93.64a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.12 1.12 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.09 1.19m-1.79.06c0 .48.24.86.66.86s.65-.39.65-.88-.22-.87-.65-.87-.66.38-.66.89M120.55 93.88v-1c-.07.29-.17.61-.27.91l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1l-.05.94h-.4l.15-2.35h.57l.3.94c.09.28.16.56.22.83.06-.26.15-.55.24-.83l.32-.94h.56l.14 2.35h-.42ZM121.31 95.26a2.78 2.78 0 0 0 0-2.84h.31a2.38 2.38 0 0 1 .43 1.42 2.5 2.5 0 0 1-.43 1.42ZM114.06 97.16l-.42.21-.07-.32.55-.28h.36v2.27h-.42ZM116.71 97.13h-.87l-.07.45h.16a1 1 0 0 1 .55.15.64.64 0 0 1 .3.58.83.83 0 0 1-.92.78 1.3 1.3 0 0 1-.6-.13l.09-.33a1 1 0 0 0 .5.12.44.44 0 0 0 .49-.41c0-.26-.19-.43-.64-.43h-.31l.14-1.15h1.18ZM117.32 98.7h.23a.82.82 0 0 0 .46-.18.78.78 0 0 0 .3-.5.64.64 0 0 1-.5.2.68.68 0 0 1-.69-.7.81.81 0 0 1 .82-.82c.53 0 .81.42.81 1a1.4 1.4 0 0 1-.39 1.06 1.27 1.27 0 0 1-.78.31h-.25Zm.22-1.22a.38.38 0 0 0 .38.42.42.42 0 0 0 .36-.19.23.23 0 0 0 0-.13c0-.3-.12-.57-.4-.57s-.34.24-.34.51ZM119.82 97.85v-.51h.37v.25a.58.58 0 0 1 .52-.29.48.48 0 0 1 .47.32.64.64 0 0 1 .21-.22.6.6 0 0 1 .34-.1c.29 0 .57.2.57.74v1h-.42v-.94c0-.28-.1-.45-.3-.45a.32.32 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.3-.41a.33.33 0 0 0-.3.25.3.3 0 0 0 0 .14v1h-.42ZM132.49 225.8a1.12 1.12 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.13 1.13 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.24.86.65.86s.65-.39.65-.88-.22-.86-.65-.86-.65.43-.65.91ZM132.86 224.7a3.6 3.6 0 0 1 .66-.05 1 1 0 0 1 .69.2.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.25h-.21v.89h-.43Zm.43 1.1h.21c.32 0 .52-.16.52-.44s-.18-.4-.48-.4h-.25ZM134.81 226.55a1.16 1.16 0 0 0 .52.14c.32 0 .46-.18.46-.36s-.26-.39-.52-.39h-.2v-.31h.19c.2 0 .45-.09.45-.32s-.11-.28-.36-.28a.93.93 0 0 0-.46.14l-.1-.31a1.23 1.23 0 0 1 .61-.16c.47 0 .71.26.71.55a.55.55 0 0 1-.42.53.57.57 0 0 1 .5.57c0 .38-.32.69-.88.69a1.24 1.24 0 0 1-.64-.16ZM129.52 228.78a2.5 2.5 0 0 0-.39 1.42 2.6 2.6 0 0 0 .39 1.41h-.31a2.59 2.59 0 0 1 0-2.83ZM129.87 228.87a4 4 0 0 1 .66 0 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .2.48.63.63 0 0 1-.42.59.62.62 0 0 1 .33.46 4 4 0 0 0 .18.66h-.44a3.3 3.3 0 0 1-.16-.56c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.25c.3 0 .48-.15.48-.38s-.18-.38-.46-.38a1.3 1.3 0 0 0-.27 0ZM133.95 230a1.12 1.12 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.13 1.13 0 0 1 1.12-1.24 1.09 1.09 0 0 1 1.09 1.2m-1.76 0c0 .48.25.86.66.86s.65-.39.65-.88-.22-.86-.65-.86-.66.43-.66.91ZM136.31 230.24v-1c-.08.28-.18.6-.28.9l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.91v1.95h-.4l.15-2.36h.57l.31 1c.08.28.16.56.21.82.07-.26.15-.55.24-.82l.33-1h.55l.14 2.36h-.5ZM137.07 231.61a2.53 2.53 0 0 0 .39-1.42 2.5 2.5 0 0 0-.39-1.41h.33a2.32 2.32 0 0 1 .43 1.41 2.46 2.46 0 0 1-.43 1.42ZM130.26 235.09a1 1 0 0 0 .24 0 .8.8 0 0 0 .46-.17.82.82 0 0 0 .29-.51.64.64 0 0 1-.5.2.67.67 0 0 1-.69-.7.8.8 0 0 1 .82-.81c.53 0 .81.41.81 1a1.4 1.4 0 0 1-.39 1 1.27 1.27 0 0 1-.78.31h-.26Zm.23-1.22a.38.38 0 0 0 .37.42.41.41 0 0 0 .37-.19.3.3 0 0 0 0-.12c0-.31-.11-.57-.39-.57s-.35.19-.35.46M132.91 235.4v-.58h-1v-.28l.93-1.41h.51v1.36h.29v.33h-.29v.58Zm0-.91v-1.01l-.2.39-.41.62zM134.65 234.2v-.5h.37v.25a.57.57 0 0 1 .52-.29.5.5 0 0 1 .48.31.8.8 0 0 1 .21-.21.58.58 0 0 1 .35-.1c.28 0 .57.19.57.74v1h-.42v-.94c0-.29-.1-.45-.31-.45a.34.34 0 0 0-.3.22.7.7 0 0 0 0 .15v1h-.42v-1c0-.24-.09-.4-.29-.4a.34.34 0 0 0-.31.24.3.3 0 0 0 0 .14v1h-.42ZM29.34 98.85a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.12 1.12 0 0 1 1.12-1.19 1.09 1.09 0 0 1 1.09 1.15m-1.76 0c0 .48.24.87.65.87s.65-.39.65-.88-.22-.87-.65-.87-.65.43-.65.91ZM29.71 97.7a3.6 3.6 0 0 1 .66 0 1 1 0 0 1 .69.19.67.67 0 0 1 .23.52.75.75 0 0 1-.2.54 1 1 0 0 1-.74.25h-.21v.89h-.43Zm.43 1.09a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.18-.4-.48-.4h-.25ZM32.25 98.17l-.42.21-.07-.33.55-.27h.36v2.27h-.41ZM34.97 97.63a2.5 2.5 0 0 0-.39 1.42 2.57 2.57 0 0 0 .39 1.41h-.31a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM35.32 97.7a4 4 0 0 1 .65 0 1.06 1.06 0 0 1 .73.19.59.59 0 0 1 .2.47.63.63 0 0 1-.42.59.57.57 0 0 1 .32.45 5 5 0 0 0 .19.66h-.44a3 3 0 0 1-.16-.55c-.07-.31-.18-.41-.42-.42h-.22v1h-.43Zm.43 1H36c.3 0 .47-.16.47-.39s-.18-.38-.45-.38a1.3 1.3 0 0 0-.27 0ZM39.4 98.85a1.11 1.11 0 0 1-1.13 1.24 1.09 1.09 0 0 1-1.08-1.2 1.12 1.12 0 0 1 1.12-1.19 1.08 1.08 0 0 1 1.09 1.15m-1.76 0c0 .48.24.87.66.87s.65-.39.65-.88-.22-.87-.65-.87-.66.43-.66.91ZM41.76 99.09v-1c-.08.29-.18.61-.28.9l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1.95h-.4l.15-2.35h.4l.31.94c.08.28.16.56.21.82.07-.26.15-.54.24-.82l.32-.94h.56l.14 2.35h-.42ZM42.52 100.46a2.5 2.5 0 0 0 .39-1.41 2.53 2.53 0 0 0-.39-1.42h.31a2.36 2.36 0 0 1 .43 1.42 2.42 2.42 0 0 1-.43 1.41ZM33.68 104.25v-2.35h.49l.61 1a6 6 0 0 1 .4.79v-1.8199999999999998h.4v2.35h-.48l-.61-1a7 7 0 0 1-.42-.82v1.8399999999999999ZM37.64 103.38a.84.84 0 0 1-.87.91.82.82 0 0 1-.85-.88.84.84 0 0 1 .88-.9.82.82 0 0 1 .84.87m-1.28 0c0 .33.16.58.42.58s.42-.24.42-.58-.12-.58-.42-.58-.38.32-.38.6ZM29.31 108.38a1.5 1.5 0 0 1-.61.11 1.11 1.11 0 0 1-1.2-1.19 1.19 1.19 0 0 1 1.26-1.24 1.5 1.5 0 0 1 .57.1l-.1.35a1.1 1.1 0 0 0-.46-.1.78.78 0 0 0-.82.87.77.77 0 0 0 .82.85 1.3 1.3 0 0 0 .47-.09ZM31.22 107.58a.84.84 0 0 1-.87.91.82.82 0 0 1-.85-.88.83.83 0 0 1 .9-.91.82.82 0 0 1 .82.88m-1.28 0c0 .33.16.58.42.58s.42-.24.42-.58-.12-.58-.42-.58-.42.32-.42.6ZM31.58 107.26v-.51h.37v.26a.61.61 0 0 1 .54-.3c.3 0 .61.19.61.73v1h-.43v-1c0-.24-.09-.43-.33-.43a.35.35 0 0 0-.33.25.6.6 0 0 0 0 .14v1h-.43ZM33.58 107.26v-.51h.37v.26a.62.62 0 0 1 .55-.3c.29 0 .6.19.6.73v1h-.43v-1c0-.24-.09-.43-.32-.43a.37.37 0 0 0-.34.25.6.6 0 0 0 0 .14v1h-.43ZM35.89 107.7a.46.46 0 0 0 .52.44 1.2 1.2 0 0 0 .47-.08l.06.3a1.5 1.5 0 0 1-.59.11.81.81 0 0 1-.88-.86.85.85 0 0 1 .84-.92.83.83 0 0 1 .71 1Zm.74-.3a.35.35 0 0 0-.35-.41.41.41 0 0 0-.39.41ZM38.64 108.4a1.3 1.3 0 0 1-.48.09.82.82 0 0 1-.88-.87.88.88 0 0 1 1-.91 1.2 1.2 0 0 1 .41.08l-.07.32a.8.8 0 0 0-.33-.06.55.55 0 0 0 0 1.1.75.75 0 0 0 .34-.07ZM39.51 106.26v.49h.4v.32h-.4v.75c0 .21 0 .32.22.32h.16v.32a.8.8 0 0 1-.31.05.52.52 0 0 1-.37-.14.7.7 0 0 1-.14-.48v-.8h-.24v-.32h.24v-.39ZM40.52 107.7c0 .31.25.44.53.44a1.2 1.2 0 0 0 .47-.08l.06.3a1.6 1.6 0 0 1-.59.11.81.81 0 0 1-.88-.86.85.85 0 0 1 .83-.92.83.83 0 0 1 .72 1Zm.75-.3c0-.16-.06-.41-.35-.41a.42.42 0 0 0-.4.41ZM43.59 105.97v2.48h-.38v-.27a.61.61 0 0 1-.55.31.78.78 0 0 1-.73-.87.81.81 0 0 1 .76-.91.57.57 0 0 1 .48.22v-1Zm-.43 1.49a.4.4 0 0 0 0-.11.37.37 0 0 0-.37-.31c-.27 0-.43.25-.43.56s.16.55.43.55a.37.37 0 0 0 .37-.31.5.5 0 0 0 0-.13ZM128.4 298.55a1.11 1.11 0 0 1-1.13 1.24 1.1 1.1 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.09 1.09 0 0 1 1.1 1.19m-1.76 0c0 .48.24.86.65.86s.65-.38.65-.88-.22-.86-.65-.86-.67.43-.67.91ZM128.75 297.42a5 5 0 0 1 .66 0 1 1 0 0 1 .69.19.66.66 0 0 1 .23.52.7.7 0 0 1-.2.53 1 1 0 0 1-.74.26h-.21v.89h-.43Zm.43 1.1a.6.6 0 0 0 .21 0c.32 0 .52-.16.52-.43s-.19-.4-.48-.4h-.25ZM131.56 299.75v-.58h-1v-.28l.93-1.41h.5v1.37h.3v.32h-.3v.58Zm0-.9v-1.02c-.07.15-.13.26-.2.39l-.42.62h.62ZM124.65 301.53a2.76 2.76 0 0 0 0 2.83h-.31a2.35 2.35 0 0 1-.42-1.41 2.4 2.4 0 0 1 .42-1.42ZM124.99 303.48a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.64-.35-.64-.69.33-.67.84-.67a1.3 1.3 0 0 1 .56.11l-.1.35a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.14-.39.28s.14.27.45.39.61.36.61.7-.29.71-.9.71a1.3 1.3 0 0 1-.63-.15ZM127.25 301.59v2.36h-.43v-2.36ZM127.59 303.7l1.2-1.75h-1.1v-.36h1.71v.26l-1.19 1.73h1.19v.36h-1.78ZM131.04 302.91h-.89v.69h1v.35h-1.42v-2.36h1.37v.36h-.94v.6h.89ZM131.52 301.63a5 5 0 0 1 .69-.05 1.45 1.45 0 0 1 1 .27 1 1 0 0 1 .37.86 1.22 1.22 0 0 1-.37.94 1.58 1.58 0 0 1-1.06.32 4.5 4.5 0 0 1-.59 0Zm.43 2h.24a.8.8 0 0 0 .89-.9.74.74 0 0 0-.83-.82 1.1 1.1 0 0 0-.3 0ZM133.72 304.36a2.76 2.76 0 0 0 0-2.83h.31a2.36 2.36 0 0 1 .43 1.42 2.42 2.42 0 0 1-.43 1.41ZM125.71 306.27l-.42.21-.07-.33.55-.27h.36v2.27h-.42ZM127.09 307.84a1 1 0 0 0 .24 0 .83.83 0 0 0 .46-.17.82.82 0 0 0 .29-.5.63.63 0 0 1-.49.19.66.66 0 0 1-.69-.7.8.8 0 0 1 .82-.81c.53 0 .81.42.81 1a1.37 1.37 0 0 1-.4 1.05 1.2 1.2 0 0 1-.77.31.8.8 0 0 1-.26 0Zm.23-1.21a.37.37 0 0 0 .37.41.4.4 0 0 0 .36-.19.2.2 0 0 0 0-.12c0-.31-.11-.57-.39-.57s-.34.19-.34.47M128.76 307.56a.62.62 0 0 1 .43-.58.57.57 0 0 1-.35-.51.68.68 0 0 1 .76-.62c.49 0 .71.29.71.57a.56.56 0 0 1-.35.52.61.61 0 0 1 .44.57c0 .41-.35.68-.83.68s-.81-.31-.81-.63m1.2 0c0-.24-.17-.36-.42-.43a.41.41 0 0 0-.34.4.37.37 0 0 0 .38.37.35.35 0 0 0 .38-.35Zm-.71-1.11c0 .19.15.3.37.36a.36.36 0 0 0 .28-.34.33.33 0 0 0-.65 0ZM131.47 306.95v-.5h.37v.25a.58.58 0 0 1 .52-.29.47.47 0 0 1 .47.31.7.7 0 0 1 .21-.21.6.6 0 0 1 .34-.1c.28 0 .57.19.57.74v1h-.42v-.94c0-.29-.1-.45-.3-.45a.31.31 0 0 0-.3.23.6.6 0 0 0 0 .14v1h-.42v-1c0-.24-.1-.41-.3-.41a.32.32 0 0 0-.3.24.4.4 0 0 0 0 .14v1h-.42ZM28.03 164.27a4 4 0 0 1 .65 0 1.12 1.12 0 0 1 .73.19.59.59 0 0 1 .2.47.62.62 0 0 1-.43.59.62.62 0 0 1 .33.46 6 6 0 0 0 .18.65h-.44a4 4 0 0 1-.16-.55c-.06-.31-.17-.41-.42-.41h-.22v1h-.42Zm.42 1h.26c.29 0 .47-.15.47-.39s-.18-.37-.46-.38a.8.8 0 0 0-.27 0ZM31.34 165.55h-.89v.69h1v.35h-1.43v-2.35h1.38v.35h-.94v.61h.89ZM33.81 165.63v-1c-.08.29-.17.61-.28.91l-.34 1h-.33l-.31-1a8 8 0 0 1-.24-.92v1l-.06.94h-.4l.16-2.35h.57l.3.94c.09.28.16.56.22.82.06-.25.14-.54.23-.82l.33-.94h.56l.14 2.35h-.42ZM35.14 164.24v1.37c0 .46.19.68.49.68s.49-.22.49-.68v-1.37h.43v1.34c0 .73-.37 1.05-.94 1.05s-.9-.3-.9-1v-1.35ZM38.74 166.52a1.5 1.5 0 0 1-.61.11 1.12 1.12 0 0 1-1.21-1.19 1.19 1.19 0 0 1 1.26-1.24 1.2 1.2 0 0 1 .57.11l-.09.34a1.1 1.1 0 0 0-.46-.09.78.78 0 0 0-.82.86.77.77 0 0 0 .82.85 1.1 1.1 0 0 0 .47-.09ZM39.1 164.24h.43v1.08l.17-.25.62-.83h.53l-.81 1 .86 1.35h-.5l-.67-1.08-.21.26v.82h-.42ZM30.93 168.37a2.5 2.5 0 0 0-.4 1.43 2.54 2.54 0 0 0 .4 1.41h-.32a2.61 2.61 0 0 1 0-2.84ZM31.27 168.47a4 4 0 0 1 .66-.05 1.1 1.1 0 0 1 .72.19.6.6 0 0 1 .21.47.62.62 0 0 1-.46.62.62.62 0 0 1 .33.46 4 4 0 0 0 .18.65h-.41a3 3 0 0 1-.16-.55c-.07-.31-.18-.41-.42-.41h-.22v1h-.43Zm.43 1h.26c.29 0 .47-.15.47-.39s-.18-.37-.46-.38a1 1 0 0 0-.27 0ZM35.4 169.59a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.76 0c0 .48.25.86.66.86s.65-.39.65-.88-.22-.87-.65-.87-.71.44-.71.93ZM37.71 169.83v-1c-.08.29-.18.61-.28.91l-.35 1h-.33l-.31-1c-.09-.3-.18-.62-.24-.92v1.94h-.4l.15-2.35h.45l.31.94c.08.28.16.56.21.82.07-.25.15-.54.24-.82l.33-.94h.55l.14 2.35h-.42ZM38.47 171.21a2.78 2.78 0 0 0 0-2.84h.31a2.36 2.36 0 0 1 .43 1.42 2.4 2.4 0 0 1-.43 1.42ZM108.64 247.49a4 4 0 0 1 .65-.05 1.06 1.06 0 0 1 .73.19.59.59 0 0 1 .2.47.63.63 0 0 1-.43.59.6.6 0 0 1 .33.45 5 5 0 0 0 .19.66h-.44a2.4 2.4 0 0 1-.16-.55c-.07-.31-.18-.41-.43-.42h-.21v1h-.43Zm.43 1h.25c.29 0 .47-.16.47-.39s-.18-.38-.46-.38h-.26ZM111.95 248.77h-.89v.69h1v.35h-1.42v-2.35h1.37v.35h-.94v.61h.89ZM114.4 248.85v-1c-.07.29-.17.61-.27.9l-.35 1h-.38l-.31-1c-.09-.3-.18-.62-.24-.92v1l-.05.95h-.4l.15-2.35h.57l.3.94a7 7 0 0 1 .22.82c.06-.26.15-.54.24-.82l.32-.94h.56l.14 2.35h-.42ZM115.76 247.46v1.37c0 .46.19.67.48.67s.49-.21.49-.67v-1.37h.43v1.34c0 .73-.37 1-.94 1s-.89-.31-.89-1v-1.34ZM119.4 249.7a1.5 1.5 0 0 1-.61.11 1.11 1.11 0 0 1-1.2-1.19 1.19 1.19 0 0 1 1.26-1.24 1.5 1.5 0 0 1 .57.1l-.1.35a1.1 1.1 0 0 0-.46-.1.78.78 0 0 0-.82.87.77.77 0 0 0 .82.85 1.3 1.3 0 0 0 .47-.09ZM119.72 247.46h.42v1.08l.18-.25.61-.83h.53l-.81 1 .86 1.35h-.5l-.61-1.11-.22.25v.83h-.42Z"></path>
            <g id="RB2">
              <path
                id="container-11"
                fill="#cb9636"
                d="M184.4 194.2a2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75h-22.1a2.89 2.89 0 0 1-2.95-2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-10" fill="#50514e" data-name="label">
                <path d="M135.4 173.11a7 7 0 0 1 1.12-.09 1.84 1.84 0 0 1 1.24.33 1 1 0 0 1 .35.81 1.07 1.07 0 0 1-.73 1 1 1 0 0 1 .56.79 9 9 0 0 0 .32 1.12h-.76a5 5 0 0 1-.27-.95c-.12-.53-.31-.7-.73-.71h-.37v1.66h-.73Zm.73 1.78h.44c.5 0 .81-.26.81-.66s-.31-.65-.79-.65a2 2 0 0 0-.46 0ZM138.85 173.11a6 6 0 0 1 1.08-.09 2 2 0 0 1 1.16.26.85.85 0 0 1 .41.76.93.93 0 0 1-.67.87 1 1 0 0 1 .82 1 1.08 1.08 0 0 1-.39.83 2.26 2.26 0 0 1-1.5.37 6.4 6.4 0 0 1-.91-.05Zm.74 1.59h.37c.52 0 .8-.24.8-.58s-.29-.55-.75-.55a2 2 0 0 0-.42 0Zm0 1.86a2 2 0 0 0 .39 0c.47 0 .89-.18.89-.68s-.41-.66-.92-.66h-.36ZM142.15 177.09v-.39l.46-.43c.91-.85 1.35-1.32 1.35-1.83a.62.62 0 0 0-.7-.66 1.42 1.42 0 0 0-.83.32l-.21-.52a2 2 0 0 1 1.19-.4 1.16 1.16 0 0 1 1.29 1.18c0 .69-.49 1.24-1.17 1.87l-.34.29h1.6v.61Z"></path>
              </g>
            </g>
            <g id="OP4">
              <path
                id="container-12"
                fill="#cb9636"
                d="M224.15 404.36h-22.1a2.89 2.89 0 0 1-3-2.75 2.89 2.89 0 0 1 3-2.75h22.1a2.89 2.89 0 0 1 2.95 2.75 2.81 2.81 0 0 1-2.95 2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-11" fill="#50514e" data-name="label">
                <path d="M153.73 382.45a1.91 1.91 0 0 1-1.94 2.12 1.87 1.87 0 0 1-1.86-2.05 1.94 1.94 0 0 1 1.92-2.12 1.87 1.87 0 0 1 1.88 2.05m-3 .05c0 .83.42 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.71-1.14 1.51ZM154.4 380.52a6.3 6.3 0 0 1 1.13-.09 1.84 1.84 0 0 1 1.19.33 1.16 1.16 0 0 1 .4.9 1.24 1.24 0 0 1-.35.92 1.78 1.78 0 0 1-1.27.43 2 2 0 0 1-.36 0v1.53h-.74Zm.74 1.88a1.2 1.2 0 0 0 .36 0c.55 0 .89-.28.89-.75s-.32-.69-.83-.69a1.8 1.8 0 0 0-.42 0ZM159.18 384.51v-1h-1.78v-.48l1.59-2.43h.87v2.35h.54v.56h-.51v1Zm0-1.55v-1.7400000000000002l-.35.66-.71 1.07h1.06Z"></path>
              </g>
            </g>
            <g id="OP3">
              <path
                id="container-13"
                fill="#cb9636"
                d="M209.45 229.55h-22.1a2.89 2.89 0 0 1-2.95-2.75 2.89 2.89 0 0 1 2.95-2.75h22.1a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-12" fill="#50514e" data-name="label">
                <path d="M139.03 207.63a1.91 1.91 0 0 1-1.94 2.13 1.87 1.87 0 0 1-1.86-2.06 1.93 1.93 0 0 1 1.92-2.11 1.87 1.87 0 0 1 1.88 2.04m-3 .06c0 .82.41 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.68-1.14 1.52ZM139.66 205.7a7.6 7.6 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.16 1.16 0 0 1 .4.9 1.2 1.2 0 0 1-.35.91 1.74 1.74 0 0 1-1.27.44 2 2 0 0 1-.36 0v1.5h-.74Zm.74 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.32-.68-.83-.68a3 3 0 0 0-.42 0ZM143 208.93a2 2 0 0 0 .89.24c.56 0 .79-.32.79-.62 0-.46-.44-.66-.89-.66h-.34v-.54h.33c.34 0 .77-.16.77-.54s-.19-.49-.62-.49a1.55 1.55 0 0 0-.8.24l-.16-.53a2.14 2.14 0 0 1 1.12-.3c.8 0 1.21.45 1.21.95a1 1 0 0 1-.71.91 1 1 0 0 1 .85 1c0 .66-.55 1.18-1.51 1.18a2.1 2.1 0 0 1-1.1-.27Z"></path>
              </g>
            </g>
            <g id="OP2">
              <path
                id="container-14"
                fill="#cb9636"
                d="M195 134.15h-22.1a2.89 2.89 0 0 1-2.95-2.75 2.89 2.89 0 0 1 2.95-2.75H195a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-13" fill="#50514e" data-name="label">
                <path d="M124.53 112.23a1.91 1.91 0 0 1-1.94 2.13 1.87 1.87 0 0 1-1.86-2.06 1.93 1.93 0 0 1 1.92-2.11 1.87 1.87 0 0 1 1.88 2.04m-3 .06c0 .82.41 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.68-1.14 1.51ZM125.16 110.3a7.6 7.6 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.16 1.16 0 0 1 .4.9 1.2 1.2 0 0 1-.35.91 1.74 1.74 0 0 1-1.27.44 2 2 0 0 1-.36 0v1.52h-.74Zm.74 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.32-.68-.83-.68a3 3 0 0 0-.42 0ZM128.4 114.29v-.44l.47-.43c.91-.85 1.35-1.32 1.35-1.83a.62.62 0 0 0-.7-.66 1.42 1.42 0 0 0-.83.32l-.29-.55a2 2 0 0 1 1.2-.4 1.16 1.16 0 0 1 1.29 1.18c0 .69-.49 1.24-1.18 1.87l-.31.35h1.59v.61Z"></path>
              </g>
            </g>
            <g id="OP1">
              <path
                id="container-15"
                fill="#cb9636"
                d="M133.35 56.81h-22.1a2.89 2.89 0 0 1-3-2.75 2.89 2.89 0 0 1 3-2.75h22.1a2.89 2.89 0 0 1 3 2.75 2.82 2.82 0 0 1-3 2.75"
                data-name="container"
                transform="translate(-57.6 -19.3)"
              ></path>
              <g id="label-14" fill="#50514e" data-name="label">
                <path d="M62.93 34.89a1.91 1.91 0 0 1-1.94 2.13 1.87 1.87 0 0 1-1.86-2.06 1.93 1.93 0 0 1 1.92-2.11 1.87 1.87 0 0 1 1.88 2.04m-3 .06c0 .82.41 1.48 1.12 1.48s1.12-.66 1.12-1.51-.38-1.48-1.12-1.48-1.14.68-1.14 1.51ZM63.56 32.96a7.6 7.6 0 0 1 1.13-.08 1.78 1.78 0 0 1 1.19.33 1.16 1.16 0 0 1 .4.9 1.2 1.2 0 0 1-.35.91 1.74 1.74 0 0 1-1.27.44 2 2 0 0 1-.36 0v1.52h-.74Zm.74 1.89a1.7 1.7 0 0 0 .36 0c.55 0 .89-.27.89-.75s-.32-.68-.83-.68a3 3 0 0 0-.42 0ZM67.91 33.7l-.72.36-.12-.56 1-.46h.61v3.89h-.71Z"></path>
              </g>
            </g>
          </g>
          <g id="GRIZZLY">
            <g id="maquina_rb_5">
              <path
                fill="#397979"
                d="M546.9 398.2h1.6v.9h-1.6zM554.8 398.2h1.6v.9h-1.6zM549.1 398.2h1.4v.9h-1.4zM551 398.2h1.4v.9H551zM552.9 398.2h1.4v.9h-1.4z"
              ></path>
              <circle cx="552.5" cy="390.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="554.1" cy="391.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="558.2" cy="392.2" r="0.1" fill="#ebb24b"></circle>
              <circle cx="560.4" cy="395.4" r="0.1" fill="#ebb24b"></circle>
              <path
                fill="#397979"
                d="M551.7 397.4a.32.32 0 0 1-.3-.3v-1.3h.4v1.3c.1.2 0 .3-.1.3"
              ></path>
              <path
                fill="#63afcf"
                d="m551.22 390.904 5.332-.852.032.198-5.332.852zM552.212 388.37l.014-.2 4.2.294-.014.2zM558.012 392.17l.164-.116 2.42 3.433-.164.115z"
              ></path>
              <path
                fill="#397979"
                d="M544.3 382.2h-6.5a.79.79 0 0 1-.8-.8.79.79 0 0 1 .8-.8h6.5a.79.79 0 0 1 .8.8.79.79 0 0 1-.8.8"
              ></path>
              <TooltipGComponent
                nivel={gruasColors["RB5"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("RB5")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_rb5_2"
                    fill={gruasColors["RB5"].color}
                    d="M621.4 412.7h-.4v-.3a.27.27 0 0 0-.3-.3h-.5a.27.27 0 0 0-.3.3v.3h-.4v1.1h-.5v-.8a1 1 0 0 0-.5-.8l-3.3-2.2-1.2-.8-1.1.5-2.6 1.2v-.7a.43.43 0 0 0-.4-.4h-1.5a.43.43 0 0 0-.4.4l.3 5h1.7l.2-3.5 3.7-1.3.4-.1 3.8 3.7-.4 1.1h4.6v-1.3a1 1 0 0 0-.9-1.1m-12.8-2.2h1.4v.7l-.7.3h-.5Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                  <g id="maquina_rb5_1" fill={gruasColors["RB5"].color}>
                    <path d="M550.6 381.4a.47.47 0 0 0-.5-.5h-6v1h5.4l-1.4 6.7c-.1.3.1.5.4.6s.5-.1.6-.4l1.5-7.3zM545.6 384.8l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.3-.2h-.2v.2l.3.2v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c-.1-.1-.1-.2-.2-.3M545.7 386.5l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3h-.2v.2l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c-.1-.1-.1-.2-.2-.3"></path>
                  </g>
                </g>
              </TooltipGComponent>
            </g>
            <g id="maquina_rb4">
              <path
                fill="#397979"
                d="M436.4 398.2h1.6v.9h-1.6zM430.7 398.2h1.4v.9h-1.4zM432.6 398.2h1.4v.9h-1.4zM428.5 398.2h1.6v.9h-1.6zM434.5 398.2h1.4v.9h-1.4z"
              ></path>
              <circle cx="434.1" cy="390.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="435.6" cy="391.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="439.8" cy="392.2" r="0.1" fill="#ebb24b"></circle>
              <circle cx="442" cy="395.4" r="0.1" fill="#ebb24b"></circle>
              <path
                fill="#397979"
                d="M433.3 397.4a.32.32 0 0 1-.3-.3v-1.3h.4v1.3c.1.2 0 .3-.1.3M425.9 382.2h-6.5a.79.79 0 0 1-.8-.8.79.79 0 0 1 .8-.8h6.5a.79.79 0 0 1 .8.8.79.79 0 0 1-.8.8"
              ></path>
              <path
                fill="#63afcf"
                d="m432.814 390.89 5.332-.851.032.197-5.333.852zM434.373 388.71l.014-.2 4.2.294-.014.2zM439.618 392.165l.164-.115 2.42 3.433-.164.115z"
              ></path>
              <TooltipGComponent
                nivel={gruasColors["RB4"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("RB4")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_rb4_2"
                    fill={gruasColors["RB4"].color}
                    d="M503 412.7h-.4v-.3a.27.27 0 0 0-.3-.3h-.5a.27.27 0 0 0-.3.3v.3h-.5v1.1h-.4v-.8a1 1 0 0 0-.5-.8l-3.3-2.2-1.2-.8-1.1.5-2.6 1.2v-.7a.43.43 0 0 0-.4-.4H490a.43.43 0 0 0-.4.4l.3 5h1.7l.2-3.5 3.7-1.3.4-.1 3.8 3.7-.4 1.1h4.6v-1.3a1 1 0 0 0-.9-1.1m-12.8-2.2h1.4v.7l-.7.3h-.5Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                  <g id="maquina_rb4_1" fill={gruasColors["RB4"].color}>
                    <path d="m427.3 386.5-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3h-.2v.2l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c-.1-.1-.1-.2-.2-.3M427.2 384.8l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.3-.2h-.2v.2l.3.2v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c-.1-.1-.1-.2-.2-.3M432.2 381.4a.47.47 0 0 0-.5-.5h-6v1h5.4l-1.4 6.7c-.1.3.1.5.4.6s.5-.1.6-.4l1.5-7.3z"></path>
                  </g>
                </g>
              </TooltipGComponent>
            </g>
            <g id="maquina_rb3">
              <path
                fill="#397979"
                d="M234.1 415.6h1.6v.9h-1.6zM242 415.6h1.6v.9H242zM236.3 415.6h1.4v.9h-1.4zM238.2 415.6h1.4v.9h-1.4zM240.1 415.6h1.4v.9h-1.4z"
              ></path>
              <circle cx="245.4" cy="409.5" r="0.1" fill="#ebb24b"></circle>
              <circle cx="239.7" cy="408.1" r="0.1" fill="#ebb24b"></circle>
              <circle cx="241.3" cy="409.2" r="0.1" fill="#ebb24b"></circle>
              <path
                fill="#397979"
                d="M238.9 414.8a.32.32 0 0 1-.3-.3v-1.3h.4v1.3c.2.2.1.3-.1.3"
              ></path>
              <path
                fill="#63afcf"
                d="m238.396 408.273 5.332-.852.032.198-5.332.852zM241.063 406.473l.014-.2 4.2.294-.014.2zM245.207 409.568l.163-.115 2.42 3.433-.163.115z"
              ></path>
              <path
                fill="#397979"
                d="M231.5 399.6H225a.79.79 0 0 1-.8-.8.79.79 0 0 1 .8-.8h6.5a.79.79 0 0 1 .8.8c.1.4-.3.8-.8.8"
              ></path>
              <TooltipGComponent
                nivel={gruasColors["RB3"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("RB3")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_rb3_2"
                    fill={gruasColors["RB3"].color}
                    d="M308.6 430.1h-.4v-.3a.27.27 0 0 0-.3-.3h-.5a.27.27 0 0 0-.3.3v.3h-.4v1.1h-.4v-.8a1 1 0 0 0-.5-.8l-3.3-2.2-1.2-.8-1.1.5-2.6 1.2v-.7a.43.43 0 0 0-.4-.4h-1.5a.43.43 0 0 0-.4.4l.3 5h1.7l.2-3.5 3.7-1.3.4-.1 3.8 3.7-.4 1.1h4.6v-1.3a1 1 0 0 0-1-1.1m-12.8-2.2h1.4v.7l-.7.3h-.5Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                  <g id="maquina_rb3_1" fill={gruasColors["RB3"].color}>
                    <path d="M237.9 398.8a.47.47 0 0 0-.5-.5h-6v1h5.4l-1.4 6.7c-.1.3.1.5.4.6s.5-.1.6-.4l1.5-7.3zM232.8 402.2l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.3-.2h-.2v.2l.3.2v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c0-.1 0-.2-.2-.3M232.9 403.9l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3h-.2v.2l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c0-.1-.1-.2-.2-.3"></path>
                  </g>
                </g>
              </TooltipGComponent>
            </g>
            <g id="maquina_rb2">
              <path
                fill="#397979"
                d="M119 189.2h1.6v.9H119zM126.8 189.2h1.6v.9h-1.6zM121.1 189.2h1.4v.9h-1.4zM123 189.2h1.4v.9H123zM124.9 189.2h1.4v.9h-1.4zM123.7 188.4a.32.32 0 0 1-.3-.3v-1.3h.4v1.3c.2.2.1.3-.1.3"
              ></path>
              <path
                fill="#63afcf"
                d="m123.219 181.85 5.332-.852.032.198-5.332.852zM126.1 182.956l.015-.2 4.189.315-.015.2z"
              ></path>
              <path
                fill="#63afcf"
                d="m130.015 183.162.163-.116 2.42 3.433-.163.115z"
              ></path>
              <path
                fill="#397979"
                d="M116.4 173.2h-6.5a.79.79 0 0 1-.8-.8.79.79 0 0 1 .8-.8h6.5a.79.79 0 0 1 .8.8.86.86 0 0 1-.8.8"
              ></path>
              <circle cx="124.5" cy="181.7" r="0.1" fill="#ebb24b"></circle>
              <circle cx="126.1" cy="182.7" r="0.1" fill="#ebb24b"></circle>
              <circle cx="130.2" cy="183.1" r="0.1" fill="#ebb24b"></circle>
              <circle cx="132.5" cy="186.4" r="0.1" fill="#ebb24b"></circle>
              <TooltipGComponent
                nivel={gruasColors["RB2"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("RB2")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_rb2_2"
                    fill={gruasColors["RB2"].color}
                    d="M193.4 203.7h-.4v-.3a.27.27 0 0 0-.3-.3h-.5a.27.27 0 0 0-.3.3v.3h-.4v1.1h-.5v-.8a1 1 0 0 0-.5-.8l-3.3-2.2-1.2-.8-1.1.5-2.6 1.2v-.7a.43.43 0 0 0-.4-.4h-1.5a.43.43 0 0 0-.4.4l.3 5h1.7l.2-3.5 3.7-1.3.4-.1 3.8 3.7-.4 1.1h4.6v-1.3a.9.9 0 0 0-.9-1.1m-12.8-2.2h1.4v.7l-.7.3h-.5Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                  <g id="maquina_rb2_1" fill={gruasColors["RB2"].color}>
                    <path d="m117.7 177.5-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3h-.2v.2l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c0-.1-.1-.2-.2-.3M117.7 175.8l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.3-.2h-.2v.2l.3.2v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c-.1-.1-.1-.2-.2-.3M122.7 172.3a.47.47 0 0 0-.5-.5h-6v1h5.4l-1.4 6.7c-.1.3.1.5.4.6s.5-.1.6-.4l1.5-7.3z"></path>
                  </g>
                </g>
              </TooltipGComponent>
            </g>
            <g id="maquina_rb1">
              <path
                fill="#397979"
                d="M334.2 398.2h1.6v.9h-1.6zM342.1 398.2h1.6v.9h-1.6zM336.4 398.2h1.4v.9h-1.4zM338.3 398.2h1.4v.9h-1.4zM340.2 398.2h1.4v.9h-1.4z"
              ></path>
              <circle cx="339.8" cy="390.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="341.4" cy="391.8" r="0.1" fill="#ebb24b"></circle>
              <circle cx="345.5" cy="392.2" r="0.1" fill="#ebb24b"></circle>
              <circle cx="347.8" cy="395.4" r="0.1" fill="#ebb24b"></circle>
              <path
                fill="#397979"
                d="M339 397.4a.32.32 0 0 1-.3-.3v-1.3h.4v1.3c.2.2.1.3-.1.3"
              ></path>
              <path
                fill="#63afcf"
                d="m338.516 390.883 5.332-.852.031.197-5.332.852zM340.63 388.971l.013-.2 4.2.294-.014.2zM345.3 392.17l.164-.115 2.42 3.433-.164.115z"
              ></path>
              <path
                fill="#397979"
                d="M331.6 382.2h-6.5a.79.79 0 0 1-.8-.8.79.79 0 0 1 .8-.8h6.5a.79.79 0 0 1 .8.8c.1.4-.3.8-.8.8"
              ></path>
              <TooltipGComponent
                nivel={gruasColors["RB1"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("RB1")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_rb1_2"
                    fill={gruasColors["RB1"].color}
                    d="M408.7 412.7h-.4v-.3a.27.27 0 0 0-.3-.3h-.5a.27.27 0 0 0-.3.3v.3h-.4v1.1h-.4v-.8a1 1 0 0 0-.5-.8l-3.3-2.2-1.2-.8-1.1.5-2.6 1.2v-.7a.43.43 0 0 0-.4-.4h-1.5a.43.43 0 0 0-.4.4l.3 5h1.7l.2-3.5 3.7-1.3.4-.1 3.8 3.7-.4 1.1h4.6v-1.3a1 1 0 0 0-1-1.1m-12.8-2.2h1.4v.7l-.7.3h-.6Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                  <g id="maquina_rb1_1" fill={gruasColors["RB1"].color}>
                    <path d="m333 386.5-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3h-.2v.2l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c0-.1-.1-.2-.2-.3M332.9 384.8l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.4-.3v-.1c.1-.1 0-.2-.1-.3l-1.1-.7c-.1-.1-.2 0-.3.1v.1l-.3-.2h-.2v.2l.3.2v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1v-.1l.4.3v.1c-.1.1 0 .2.1.3l1.1.7c.1.1.2 0 .3-.1l.3-.4c0-.1 0-.2-.2-.3M338 381.4a.47.47 0 0 0-.5-.5h-6v1h5.4l-1.4 6.7c-.1.3.1.5.4.6s.5-.1.6-.4l1.5-7.3z"></path>
                  </g>
                </g>
              </TooltipGComponent>
            </g>
          </g>
          <g
            id="MATERIAL_PILE_ROM_AND_SIZED_"
            data-name="MATERIAL PILE (ROM AND SIZED)"
          >
            <path
              fill="#7c6956"
              d="m49.1 176.8-1 .3-.6 1.7 1.1.9 2.2-.5z"
            ></path>
            <path fill="#665242" d="m47.5 178.8-.3.8 1.1.4.3-.3z"></path>
            <path fill="#8e7e70" d="M48.3 180h2.1l.4-.8-2.2.5z"></path>
            <path
              fill="#7c6956"
              d="m42.7 179.5 2-.3 2.3.7.1 1-1.2.7-2.2-.5z"
            ></path>
            <path fill="#8e7e70" d="m42.7 179.5-.1 2 1.1-.4z"></path>
            <path fill="#665242" d="m42.6 181.5.7.7 2.6-.6-2.2-.5z"></path>
            <path fill="#8e7e70" d="m47.1 180.9-.9 1.2-2.9.1 2.6-.6z"></path>
            <path
              fill="#7c6956"
              d="m50.8 182.5-.2-1.3.5-1.7h.8l.4.9-.3 1.4z"
            ></path>
            <path fill="#665242" d="m50.8 182.5 1.4.1-.2-.8z"></path>
            <path fill="#8e7e70" d="m52.2 182.6.5-.4-.4-1.8-.3 1.4z"></path>
            <path fill="#665242" d="m51.9 179.5.8.7v2l-.4-1.8z"></path>
            <path fill="#7c6956" d="M47.1 182h.9l1-.5.6-.8-.9.1-.8.5z"></path>
            <path
              fill="#665242"
              d="M48 182v.3l-1 .2.1-.5zM49.6 180.7l.4 1-.7.4-.3-.6z"
            ></path>
            <path fill="#8e7e70" d="m48 182.3 1.3-.2-.3-.6-1 .5z"></path>
            <path
              fill="#7c6956"
              d="m47 177.6-1.3 1.1-1.1-.9.4-1.5 2.5-1.2z"
            ></path>
            <path fill="#665242" d="m47.5 175.1-.8-.5-1.5 1.1-.2.6z"></path>
            <path fill="#8e7e70" d="m45.2 175.7-1.1 1.8.5.3z"></path>
            <path fill="#665242" d="m45.7 178.7-1.1-.4-.5-.8.5.3z"></path>
            <path
              fill="#7c6956"
              d="m52.2 175.9.4 1.3-1.1.7-1.2-.6-.1-2.4z"
            ></path>
            <path fill="#665242" d="m50.2 174.9-.7.5.3 1.6.5.3z"></path>
            <path fill="#8e7e70" d="m49.8 177 1.2 1.3.5-.4z"></path>
            <path fill="#665242" d="m52.6 177.2-.7.9-.9.2.5-.4z"></path>
            <path fill="#7c6956" d="m42.2 175.3.5 2.9-1.8 3.1-1.3-1.9z"></path>
            <path fill="#665242" d="m42.2 175.3-3.2 3.5.6.6z"></path>
            <path fill="#8e7e70" d="m39 178.8.3 2 1.6.5-1.3-1.9z"></path>
            <path fill="#665242" d="m42.7 178.2-1.2 3-.6.1z"></path>
            <path
              fill="none"
              stroke="#5e7076"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.3"
              d="M34.7 172.7a2.84 2.84 0 0 0 .7 1.7 4.28 4.28 0 0 0 3 1.9"
            ></path>
            <path
              fill="#7c6956"
              d="m507.8 248.6-1 .4-.7 1.6 1.2.9 2.2-.4z"
            ></path>
            <path fill="#665242" d="m506.1 250.6-.2.9 1.1.4.3-.4z"></path>
            <path fill="#8e7e70" d="M507 251.9h2.1l.4-.8-2.2.4z"></path>
            <path
              fill="#7c6956"
              d="m501.4 251.4 1.9-.4 2.4.8.1 1-1.2.6-2.2-.4z"
            ></path>
            <path fill="#8e7e70" d="m501.4 251.4-.1 1.9 1.1-.3z"></path>
            <path fill="#665242" d="m501.3 253.3.7.8 2.6-.7-2.2-.4z"></path>
            <path fill="#8e7e70" d="m505.8 252.8-1 1.2-2.8.1 2.6-.7z"></path>
            <path
              fill="#7c6956"
              d="m509.4 254.4-.2-1.4.6-1.6h.7l.5.8-.4 1.5z"
            ></path>
            <path fill="#665242" d="m509.4 254.4 1.5.1-.3-.8z"></path>
            <path fill="#8e7e70" d="m510.9 254.5.5-.5-.4-1.8-.4 1.5z"></path>
            <path fill="#665242" d="m510.5 251.4.9.6v2l-.4-1.8z"></path>
            <path
              fill="#7c6956"
              d="M505.8 253.9h.9l.9-.5.6-.9-.8.2-.9.5z"
            ></path>
            <path
              fill="#665242"
              d="M506.7 253.9v.3l-1 .1.1-.4zM508.2 252.5l.4 1.1-.7.3-.3-.5z"
            ></path>
            <path fill="#8e7e70" d="m506.7 254.2 1.2-.3-.3-.5-.9.5z"></path>
            <path
              fill="#7c6956"
              d="m505.7 249.5-1.3 1-1.1-.8.4-1.5 2.5-1.2z"
            ></path>
            <path fill="#665242" d="m506.2 247-.8-.5-1.6 1-.1.7z"></path>
            <path fill="#8e7e70" d="m503.8 247.5-1.1 1.8.6.4z"></path>
            <path fill="#665242" d="m504.4 250.5-1.2-.3-.5-.9.6.4z"></path>
            <path
              fill="#7c6956"
              d="m510.9 247.8.4 1.3-1.1.7-1.2-.7-.1-2.4z"
            ></path>
            <path fill="#665242" d="m508.9 246.7-.7.6.3 1.6.5.2z"></path>
            <path fill="#8e7e70" d="m508.5 248.9 1.1 1.3.6-.4z"></path>
            <path fill="#665242" d="m511.3 249.1-.7.9-1 .2.6-.4z"></path>
            <path fill="#7c6956" d="m500.9 247.2.5 2.9-1.8 3.1-1.3-2z"></path>
            <path fill="#665242" d="m500.9 247.2-3.3 3.5.7.5z"></path>
            <path fill="#8e7e70" d="m497.6 250.7.4 2 1.6.5-1.3-2z"></path>
            <path fill="#665242" d="m501.4 250.1-1.2 3-.6.1z"></path>
            <path
              fill="none"
              stroke="#5e7076"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="0.3"
              d="M493.4 244.6a2.84 2.84 0 0 0 .7 1.7 4.28 4.28 0 0 0 3 1.9M113.9 251.2a2.84 2.84 0 0 0 .7 1.7 4.28 4.28 0 0 0 3 1.9"
            ></path>
            <path
              fill="#7c6956"
              d="M119.5 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M119.5 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1.1.1.1.1.2"
            ></path>
            <path fill="#8e7e70" d="m118.2 258.4-.9.7c.1-.4.4-.6.9-.7"></path>
            <path
              fill="#7c6956"
              d="M122.3 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M122.3 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1.1.1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m120.9 258.4-.9.7a1.27 1.27 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M125 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M125 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1.1.1.1.1.2"
            ></path>
            <path fill="#8e7e70" d="m123.7 258.4-.9.7c.1-.4.4-.6.9-.7"></path>
            <path
              fill="#7c6956"
              d="M127.8 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M127.8 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1.1.1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m126.4 258.4-.9.7a1.11 1.11 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M130.5 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M130.5 259.6a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1.1.1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m129.1 258.4-.9.7a1.27 1.27 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M120.9 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M120.9 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1 0 .1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m119.5 255.8-.9.7a1.27 1.27 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M123.6 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M123.6 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1 0 .1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m122.3 255.8-.9.7a1.11 1.11 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M126.4 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M126.4 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1 0 .1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m125 255.8-.9.7a1.27 1.27 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M129.1 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M129.1 257a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1c.1 0 .1.1.1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m127.8 255.8-.9.7a1.11 1.11 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M122.3 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M122.3 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1 .3.3 0 0 1 .1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m120.9 253.3-.9.7a1.07 1.07 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M125 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M125 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1 .3.3 0 0 1 .1.2"
            ></path>
            <path
              fill="#8e7e70"
              d="m123.7 253.3-.9.7a.88.88 0 0 1 .9-.7"
            ></path>
            <path
              fill="#7c6956"
              d="M127.8 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2 1.23 1.23 0 0 1-.5-1 .9.9 0 0 1 .1-.5 1.27 1.27 0 0 1 .9-.7h.2a1.19 1.19 0 0 1 1.2 1Z"
            ></path>
            <path
              fill="#665242"
              d="M127.8 254.4a1.16 1.16 0 0 1-1.2 1.2 1.9 1.9 0 0 1-.7-.2.76.76 0 0 0 .4-.2 3 3 0 0 0 1.4-1 .3.3 0 0 1 .1.2"
            ></path>
            <path fill="#8e7e70" d="m126.4 253.3-.9.7a1 1 0 0 1 .9-.7"></path>
          </g>
          <g id="STK">
            <g id="STK-2" data-name="STK">
              <path
                fill="#5e7076"
                d="M655.2 495.7v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3c.1.1 0 .3 0 .5m.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5M648.6 495.7v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3zm.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5"
              ></path>
              <path
                fill="#ebb24b"
                d="m653.8 494.7-6.3-1 1 .4.3.6a1.74 1.74 0 0 1 1.1-.6 1.51 1.51 0 0 1 1.5 1.2v.7l.1.1h1.8l.1-.3h.7l-.1.3h1.2v-.6a.9.9 0 0 1 .1-.5 1.47 1.47 0 0 1 2.8.3v.4a.37.37 0 0 1-.1.3h2l.7-.4v-1.8h-.8l-.2-.7h-2.1l-.3.7h-2.5l-.2.4h-.8l.2-.6.7-.3v-.4h-.7v.1h-6.4l-.5.5 6.5 1 .1-.1h.8l-.2.4h-.7Zm.4.7h-.7l.1-.2h.7Zm.2-.4-.1.2h-.7l.1-.2Zm-1 .8.1-.2h.7l-.1.2Z"
              ></path>
              <circle cx="654.7" cy="495.9" r="0.1" fill="#a50011"></circle>
              <circle cx="654" cy="493.4" r="0.1" fill="#a50011"></circle>
              <circle cx="653.7" cy="494.4" r="0.1" fill="#a50011"></circle>
            </g>
            <g id="STK-3" data-name="STK">
              <path
                fill="#5e7076"
                d="M655.2 473.4v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3c.1.2 0 .4 0 .5m.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5M648.6 473.4v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3zm.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5"
              ></path>
              <path
                fill="#ebb24b"
                d="m653.8 472.5-6.3-1 1 .4.3.6a1.74 1.74 0 0 1 1.1-.6 1.51 1.51 0 0 1 1.5 1.2v.7l.1.1h1.8l.1-.3h.7l-.1.3h1.2v-.6a.9.9 0 0 1 .1-.5 1.47 1.47 0 0 1 2.8.3v.4a.37.37 0 0 1-.1.3h2l.7-.4v-1.7h-.8l-.2-.7h-2.1l-.3.7h-2.5l-.2.4h-.8l.2-.6.7-.3v-.4h-.7v.1h-6.4l-.5.5 6.5 1 .1-.1h.8l-.2.4h-.7Zm.4.7h-.7l.1-.2h.7Zm.2-.5-.1.2h-.7l.1-.2Zm-1 .8.1-.2h.7l-.1.2Z"
              ></path>
              <circle cx="654.7" cy="473.6" r="0.1" fill="#a50011"></circle>
              <circle cx="654" cy="471.1" r="0.1" fill="#a50011"></circle>
              <circle cx="653.7" cy="472.1" r="0.1" fill="#a50011"></circle>
            </g>
          </g>
          <g id="MLL_ETC_0684_01">
            <TooltipPComponent
              nivel={pyramidColors["MLL_ETC_0684_01"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("MLL_ETC_0684_01")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_stk_684_2"
                  fill={pyramidColors["MLL_ETC_0684_01"].color_2}
                  d="m215.23 539.1-14.43-13.26a5.31 5.31 0 0 0-7.46 0L178.9 539.1"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_stk_684_1"
                  fill={pyramidColors["MLL_ETC_0684_01"].color_1}
                  d="M187.47 539.1c15.39-5.31 8.09-14.69 8.09-14.69a5.17 5.17 0 0 1 5.24 1.43l14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_stk_684">
                  <path d="M132.02 502.31a1.4 1.4 0 0 0 .65.17c.31 0 .49-.15.49-.37s-.14-.32-.48-.44-.73-.4-.73-.79.37-.77 1-.77a1.4 1.4 0 0 1 .64.13l-.12.4a1.1 1.1 0 0 0-.53-.13c-.32 0-.45.17-.45.33s.16.3.52.44.69.41.69.8-.33.81-1 .81a1.6 1.6 0 0 1-.73-.17ZM134.62 500.57h-.77v-.42h2v.42h-.78v2.28h-.49ZM138.48 501.47a1.27 1.27 0 0 1-1.29 1.42 1.25 1.25 0 0 1-1.24-1.37 1.29 1.29 0 0 1 1.28-1.41 1.24 1.24 0 0 1 1.25 1.36m-2 0c0 .55.28 1 .75 1s.74-.45.74-1-.25-1-.74-1-.76.49-.76 1.04ZM140.84 502.77a1.7 1.7 0 0 1-.7.12 1.27 1.27 0 0 1-1.37-1.36 1.36 1.36 0 0 1 1.44-1.42 1.6 1.6 0 0 1 .65.12l-.1.39a1.5 1.5 0 0 0-.53-.1.89.89 0 0 0-.94 1 .88.88 0 0 0 .93 1 1.4 1.4 0 0 0 .54-.1ZM141.26 500.15h.49v1.24a3 3 0 0 1 .2-.29l.7-.95h.61l-.93 1.15 1 1.55h-.58l-.76-1.24-.24.29v.95h-.49ZM145.89 500.6h-.25a.91.91 0 0 0-.87.76.72.72 0 0 1 .58-.25.78.78 0 0 1 .8.84.91.91 0 0 1-.92.93 1 1 0 0 1-1-1.12 1.56 1.56 0 0 1 .45-1.16 1.5 1.5 0 0 1 .93-.39h.25Zm-.23 1.39a.45.45 0 0 0-.45-.51.48.48 0 0 0-.43.27.3.3 0 0 0 0 .15c0 .34.17.62.49.62s.39-.22.39-.53M146.4 502.18a.73.73 0 0 1 .48-.68.63.63 0 0 1-.39-.57.77.77 0 0 1 .86-.72c.56 0 .82.34.82.66a.66.66 0 0 1-.4.59.7.7 0 0 1 .49.66c0 .46-.39.77-.94.77s-.92-.35-.92-.71m1.36 0c0-.27-.19-.41-.48-.49a.47.47 0 0 0-.38.45.41.41 0 0 0 .43.42.39.39 0 0 0 .45-.4Zm-.81-1.26c0 .21.18.34.43.41a.44.44 0 0 0 .32-.4.38.38 0 0 0-.75 0ZM149.68 502.85v-.66h-1.18v-.32l1.06-1.62h.58v1.56h.34v.38h-.34v.66Zm0-1v-1.15c-.08.16-.15.29-.23.43l-.48.72z"></path>
                </g>
              </g>
            </TooltipPComponent>

            <g id="carrito_stk_684">
              <path
                fill="#dc2e1a"
                d="m116.09 516.83-1.2 1.4h-.6l-.8.7-.3.3c-.1.1-.2.1-.2 0s.1-.3.1-.4v-.3a.19.19 0 0 0 .3 0l.4-.6a1.85 1.85 0 0 1-.7-.8l-.5-.9.2-.5 1.7.9 1.4-.1"
              ></path>
              <path
                fill="#5e7076"
                d="M106.69 517.23a1.54 1.54 0 0 0-1.5 1.5v.4a1.5 1.5 0 0 0 1.4 1.1 1.41 1.41 0 0 0 1.4-1.1v-.43a1.23 1.23 0 0 0-1.3-1.47m0 2a.6.6 0 1 1 .6-.6.65.65 0 0 1-.6.6M112.99 518.63a.9.9 0 0 0-.1-.5 1.46 1.46 0 0 0-1.4-.9 1.5 1.5 0 0 0-1.5 1.3v.4a1.51 1.51 0 0 0 1.5 1.3 1.39 1.39 0 0 0 1.4-1.1.37.37 0 0 1 .1-.3zm-1.5.6a.6.6 0 1 1 .6-.6.58.58 0 0 1-.6.6"
              ></path>
              <path
                fill="#dc2e1a"
                d="m102.69 518.63.6.4h1.8v-.4a1.7 1.7 0 0 1 3.4 0v.4h1.6v-1a.1.1 0 0 1 .1-.1c.1-.1.2-.3.3-.4l.1-.1.1-.1.2-.2h.9c.1-.1.3 0 .5 0a4.2 4.2 0 0 0-1.2-.4h-.8v-.3h-.5v.3h-.7v-.7h-2.3v.7h-1.39v-.2H103v.2h.3v1.5h-.6"
              ></path>
              <path
                fill="#dc2e1a"
                d="M109.29 517.33c.1 0 .2.1.3.2h-.5v-.2ZM109.59 517.63l-.6.1v-.2zM109.59 518.43h-.6v-.2h.6z"
              ></path>
              <path
                fill="#dc2e1a"
                d="M109.09 518.03h.6v.2h-.6zM109.09 517.73h.6v.2h-.6zM109.29 518.7h-.2v-.2h.5c-.1.13-.19.2-.3.2"
              ></path>
              <circle cx="114.19" cy="517.63" r="0.1" fill="#ebb24b"></circle>
              <circle cx="108.69" cy="518.63" r="0.1" fill="#ebb24b"></circle>
              <circle cx="104.69" cy="518.63" r="0.1" fill="#ebb24b"></circle>
              <circle cx="114.49" cy="517.83" r="0.1" fill="#ebb24b"></circle>
            </g>
          </g>
          <g id="STK-4" data-name="STK">
            <path
              fill="#5e7076"
              d="M166.91 519.1v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3c.1.1 0 .3 0 .5m.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5M160.31 519.1v.3a1.29 1.29 0 0 0 2.5-.2v-.3a1.31 1.31 0 0 0-2.5-.3zm.8 0a.5.5 0 1 1 .5.5.47.47 0 0 1-.5-.5"
            ></path>
            <path
              fill="#ebb24b"
              d="m165.51 518.1-6.3-1 1 .4.3.6a1.74 1.74 0 0 1 1.1-.6 1.51 1.51 0 0 1 1.5 1.2v.7l.1.1h1.8l.1-.3h.7l-.1.3h1.2v-.6a.9.9 0 0 1 .1-.5 1.47 1.47 0 0 1 2.8.3v.4a.37.37 0 0 1-.1.3h2l.7-.4v-1.8h-.8l-.2-.7h-2.1l-.3.7h-2.5l-.2.4h-.8l.2-.6.7-.3v-.4h-.7v.1h-6.4l-.5.5 6.5 1 .1-.1h.8l-.2.4h-.7Zm.4.7h-.7l.1-.2h.7Zm.2-.4-.1.2h-.7l.1-.2Zm-1 .8.1-.2h.7l-.1.2Z"
            ></path>
            <circle cx="166.41" cy="519.3" r="0.1" fill="#a50011"></circle>
            <circle cx="165.71" cy="516.8" r="0.1" fill="#a50011"></circle>
            <circle cx="165.41" cy="517.8" r="0.1" fill="#a50011"></circle>
          </g>
          <g id="ML_05">
            <TooltipPComponent
              nivel={pyramidColors["ML_05"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("ML_05")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_ml_05_2"
                  fill={pyramidColors["ML_05"].color_2}
                  d="m829 400.37-14.43 13.26h36.32l-14.43-13.26a5.31 5.31 0 0 0-7.46 0"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_ml_05_1"
                  fill={pyramidColors["ML_05"].color_1}
                  d="M850.86 413.63H823.1c15.39-5.3 8.09-14.69 8.09-14.69a5.17 5.17 0 0 1 5.24 1.43Z"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_ml_05">
                  <path d="M772.94 376.28v-1.13c-.09.33-.2.69-.32 1l-.39 1.17h-.38l-.45-1.12c-.1-.35-.2-.72-.27-1.05v1.14l-.06 1.09h-.45l.17-2.7h.61l.35 1.09a9 9 0 0 1 .25.93c.07-.29.17-.62.27-.94l.37-1.08h.64l.16 2.7h-.48ZM773.97 374.7h.49v2.28h1.11v.42h-1.6ZM778.49 376.06c0 .84-.32 1.36-1 1.36s-.91-.54-.92-1.33.35-1.35.95-1.35.97.56.97 1.32m-1.37 0c0 .64.17 1 .44 1s.44-.35.44-1-.14-1-.44-1-.44.38-.44 1.02ZM780.45 375.19h-1l-.05.51h.19a1.23 1.23 0 0 1 .63.16.77.77 0 0 1 .34.66 1 1 0 0 1-1 .9 1.44 1.44 0 0 1-.69-.15l.1-.37a1.3 1.3 0 0 0 .57.13.5.5 0 0 0 .56-.47c0-.3-.22-.49-.73-.49h-.36l.17-1.31h1.34Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="ML_04">
            <TooltipPComponent
              nivel={pyramidColors["ML_04"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("ML_04")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_ml_04_2"
                  fill={pyramidColors["ML_04"].color_2}
                  d="m783.77 431-14.43 13.3h36.32L791.23 431a5.31 5.31 0 0 0-7.46 0"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_ml_04_1"
                  fill={pyramidColors["ML_04"].color_1}
                  d="M805.66 444.3H777.9c15.39-5.3 8.09-14.69 8.09-14.69a5.17 5.17 0 0 1 5.24 1.43Z"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_ml_04">
                  <path d="M727.54 406.95v-1.13c-.08.33-.18.69-.29 1l-.37 1.17h-.35l-.33-1.15c-.09-.35-.18-.71-.25-1.05v1.15l-.06 1.08h-.49l.16-2.7h.6l.33 1.09a8 8 0 0 1 .22.93c.06-.29.15-.62.24-.94l.35-1.08h.59l.14 2.7h-.44ZM728.49 405.35h.45v2.29h1v.41h-1.48ZM732.66 406.7c0 .84-.3 1.36-.88 1.36s-.84-.54-.85-1.33.32-1.35.88-1.35.85.59.85 1.32m-1.27 0c0 .63.16 1 .41 1s.41-.35.41-1-.14-1-.41-1-.4.41-.4 1.06ZM733.94 408.05v-.66h-1.08v-.32l1-1.62h.54v1.57h.31v.37h-.31v.66Zm0-1v-1.16c-.07.16-.13.29-.21.44l-.44.71h.65Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="ML_02">
            <TooltipPComponent
              nivel={pyramidColors["ML_02"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("ML_02")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_ml_02_2"
                  fill={pyramidColors["ML_02"].color_2}
                  d="m805.8 470.63-14.44-13.26a5.3 5.3 0 0 0-7.45 0l-14.44 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_ml_02_1"
                  fill={pyramidColors["ML_02"].color_1}
                  d="M778 470.63c15.39-5.31 8.09-14.69 8.09-14.69a5.16 5.16 0 0 1 5.23 1.43l14.44 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_ml_02">
                  <path d="M727.87 433.28v-1.14c-.09.33-.2.7-.32 1l-.39 1.16h-.38l-.36-1.15c-.1-.34-.2-.71-.27-1.05 0 .35 0 .78-.05 1.15l-.06 1.08h-.46l.18-2.69h.64l.35 1.08c.1.32.18.64.25.94.07-.29.16-.62.27-.94l.37-1.08h.64l.15 2.69h-.47ZM728.91 431.7h.49v2.28h1.11v.41h-1.6ZM733.4 433.06c0 .83-.33 1.36-.95 1.36s-.92-.55-.92-1.34.34-1.35 1-1.35.87.56.87 1.33m-1.38 0c0 .64.18 1 .45 1s.44-.35.44-1-.15-1-.44-1-.42.37-.42 1.02ZM733.74 434.37v-.29l.31-.29c.61-.57.9-.88.9-1.22a.41.41 0 0 0-.46-.44 1 1 0 0 0-.56.22l-.14-.35a1.3 1.3 0 0 1 .8-.27.77.77 0 0 1 .85.79c0 .46-.32.82-.78 1.24l-.22.2h1.06v.4Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="ML_01">
            <TooltipPComponent
              nivel={pyramidColors["ML_01"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("ML_01")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_ml_01_2"
                  fill={pyramidColors["ML_01"].color_2}
                  d="m805.26 493.9-14.43-13.26a5.31 5.31 0 0 0-7.46 0l-14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_ml_01_1"
                  fill={pyramidColors["ML_01"].color_1}
                  d="M777.5 493.9c15.39-5.3 8.09-14.69 8.09-14.69a5.17 5.17 0 0 1 5.24 1.43l14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_ml_01">
                  <path d="M727.34 456.55v-1.13c-.09.33-.2.69-.31 1l-.4 1.17h-.38l-.36-1.15c-.1-.35-.2-.72-.27-1v1.15l-.06 1.08h-.46l.18-2.7h.65l.35 1.09a9 9 0 0 1 .25.94c.07-.3.17-.63.27-.95l.37-1.08h.64l.16 2.7h-.57ZM728.4 454.95h.49v2.29H730v.46h-1.6ZM732.89 456.33c0 .84-.32 1.36-1 1.36s-.91-.54-.92-1.33.35-1.35 1-1.35.92.56.92 1.32m-1.37 0c0 .63.17 1 .44 1s.44-.35.44-1-.14-1-.44-1-.44.37-.44 1.03ZM733.97 455.49l-.48.24-.09-.37.64-.31h.41v2.65h-.48Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="STK_02">
            <TooltipPComponent
              nivel={pyramidColors["STK_02"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("STK_02")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_stk_02_2"
                  fill={pyramidColors["STK_02"].color_2}
                  d="m730.56 486.37-14.43-13.26a5.31 5.31 0 0 0-7.46 0l-14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_stk_02_1"
                  fill={pyramidColors["STK_02"].color_1}
                  d="M702.8 486.37c15.39-5.3 8.09-14.68 8.09-14.68a5.17 5.17 0 0 1 5.24 1.42l14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_stk2_02">
                  <path d="M645.48 478.96a1.35 1.35 0 0 0 .65.17c.31 0 .49-.14.49-.36s-.14-.33-.48-.45-.73-.4-.73-.78.37-.78 1-.78a1.4 1.4 0 0 1 .65.14l-.12.39a1.2 1.2 0 0 0-.54-.12c-.31 0-.44.16-.44.32s.15.3.51.44.7.42.7.8-.33.81-1 .81a1.54 1.54 0 0 1-.73-.17ZM648.08 477.22h-.77v-.41h2v.41h-.78v2.28h-.49ZM649.91 478.7l-.23.76h-.51l.86-2.69h.63l.88 2.69h-.53l-.24-.76Zm.77-.37-.21-.67c-.05-.16-.09-.35-.14-.5l-.13.5-.21.67ZM653.76 479.42a1.7 1.7 0 0 1-.7.12 1.27 1.27 0 0 1-1.37-1.36 1.36 1.36 0 0 1 1.44-1.42 1.5 1.5 0 0 1 .65.12l-.1.4a1.3 1.3 0 0 0-.53-.11.89.89 0 0 0-.94 1 .88.88 0 0 0 .94 1 1.4 1.4 0 0 0 .53-.1ZM654.18 476.81h.49v1.23c.06-.1.13-.19.2-.29l.7-.94h.61l-.93 1.14 1 1.55h-.58l-.76-1.23-.24.28v.95h-.49ZM658.02 478.3h-1v.8h1.14v.4h-1.63v-2.69h1.57v.4H657v.69h1ZM658.57 476.84a5 5 0 0 1 .75-.06 1.27 1.27 0 0 1 .83.22.7.7 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.34c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM663.4 478.18c0 .84-.33 1.36-1 1.36s-.92-.54-.92-1.33.34-1.35 1-1.35.92.56.92 1.32m-1.38 0c0 .63.17 1 .44 1s.44-.35.44-1-.14-1-.43-1-.45.38-.45 1.03ZM663.71 479.5v-.3l.31-.29c.61-.56.9-.87.9-1.22a.41.41 0 0 0-.47-.43.9.9 0 0 0-.55.21l-.14-.35a1.33 1.33 0 0 1 .79-.26.77.77 0 0 1 .86.78c0 .46-.33.83-.78 1.25l-.23.2h1.07v.41Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="STK_01">
            <TooltipPComponent
              nivel={pyramidColors["STK_01"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("STK_01")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_stk_01_2"
                  fill={pyramidColors["STK_01"].color_2}
                  d="m730.56 537.36-14.43-13.26a5.31 5.31 0 0 0-7.46 0l-14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_stk_01_1"
                  fill={pyramidColors["STK_01"].color_1}
                  d="M702.8 537.36c15.39-5.3 8.09-14.69 8.09-14.69a5.17 5.17 0 0 1 5.24 1.43l14.43 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_stk_01-2" data-name="label_stk_01">
                  <path d="M645.04 488.36a1.35 1.35 0 0 0 .65.17c.31 0 .49-.14.49-.36s-.14-.33-.48-.45-.73-.4-.73-.78.37-.78.95-.78a1.4 1.4 0 0 1 .65.14l-.12.39a1.16 1.16 0 0 0-.54-.12c-.31 0-.44.16-.44.32s.15.31.51.44.7.42.7.8-.33.81-1 .81a1.54 1.54 0 0 1-.73-.17ZM647.64 486.62h-.77v-.41h2v.41h-.78v2.28h-.49ZM649.47 488.14l-.23.76h-.51l.87-2.69h.62l.88 2.69h-.53l-.24-.76Zm.77-.37-.21-.67c0-.16-.09-.35-.13-.5 0 .15-.08.34-.13.5l-.21.67ZM653.32 488.82a1.7 1.7 0 0 1-.7.12 1.27 1.27 0 0 1-1.37-1.36 1.36 1.36 0 0 1 1.44-1.42 1.5 1.5 0 0 1 .65.12l-.1.4a1.3 1.3 0 0 0-.53-.11.89.89 0 0 0-.94 1 .88.88 0 0 0 .94 1 1.4 1.4 0 0 0 .53-.1ZM653.74 486.21h.49v1.24c.07-.11.13-.2.2-.29l.7-.95h.61l-.93 1.14 1 1.55h-.58l-.76-1.23-.24.28v.95h-.49ZM657.58 487.7h-1v.8h1.14v.4h-1.63v-2.69h1.57v.4h-1.08v.69h1ZM658.13 486.24a5 5 0 0 1 .75-.05 1.27 1.27 0 0 1 .83.21.68.68 0 0 1 .23.54.72.72 0 0 1-.49.68.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4 4 0 0 1-.18-.64c-.08-.35-.2-.46-.48-.47h-.25v1.11h-.49Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43h-.3ZM662.96 487.58c0 .84-.33 1.36-.95 1.36s-.92-.54-.92-1.33.34-1.35.95-1.35.92.56.92 1.32m-1.38 0c0 .63.17 1 .44 1s.45-.35.45-1-.15-1-.44-1-.45.38-.45 1.03ZM664.04 486.75l-.47.24-.09-.38.63-.31h.41v2.6h-.47Z"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g id="SUP">
            <TooltipPComponent
              nivel={pyramidColors["SUP_TP0"]}
              datosProcesados={datosProcesados}
            >
              <g
                onMouseDown={(e) => handlePyramidColor("SUP_TP0")}
                style={{ cursor: "pointer" }}
              >
                <path
                  id="piramide_sup_tpo_1800"
                  fill={pyramidColors["SUP_TP0"].color_2}
                  d="m126.26 412.37-14.44-13.26a5.3 5.3 0 0 0-7.45 0l-14.44 13.26"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <path
                  id="piramide_sup_tpo_1800-2"
                  fill={pyramidColors["SUP_TP0"].color_1}
                  d="M98.5 412.37c15.39-5.31 8.09-14.69 8.09-14.69a5.16 5.16 0 0 1 5.23 1.43l14.44 13.26"
                  data-name="piramide_sup_tpo_1800"
                  transform="translate(-57.6 -19.3)"
                ></path>
                <g id="label_sup_tpo_720">
                  <path d="M41.4 376.35a1.2 1.2 0 0 0 .57.15c.28 0 .43-.13.43-.32s-.12-.28-.42-.39-.63-.35-.63-.68.32-.68.83-.68a1.26 1.26 0 0 1 .56.12l-.1.34a1.1 1.1 0 0 0-.47-.11c-.27 0-.39.15-.39.29s.14.26.45.38.61.36.61.7-.29.71-.9.71a1.36 1.36 0 0 1-.63-.15ZM43.69 374.47v1.37c0 .46.19.67.48.67s.49-.21.49-.67v-1.37h.43v1.34c0 .73-.37 1.05-.94 1.05s-.89-.3-.89-1v-1.35ZM45.59 374.5a3.6 3.6 0 0 1 .66-.05 1 1 0 0 1 .69.19.67.67 0 0 1 .23.52.73.73 0 0 1-.2.54 1 1 0 0 1-.74.25.7.7 0 0 1-.21 0v.89h-.43Zm.43 1.1h.21c.32 0 .51-.17.51-.44s-.18-.4-.48-.4h-.24ZM48.58 374.83h-.67v-.36h1.78v.36h-.68v2h-.43ZM49.97 374.5a3.5 3.5 0 0 1 .66-.05 1 1 0 0 1 .69.19.67.67 0 0 1 .23.52.73.73 0 0 1-.2.54 1 1 0 0 1-.74.25.7.7 0 0 1-.22 0v.89h-.42Zm.42 1.1h.22c.32 0 .51-.17.51-.44s-.18-.4-.48-.4h-.25ZM54.01 375.62a1.11 1.11 0 0 1-1.12 1.24 1.09 1.09 0 0 1-1.09-1.2 1.13 1.13 0 0 1 1.12-1.23 1.08 1.08 0 0 1 1.09 1.19m-1.75 0c0 .48.24.87.65.87s.65-.39.65-.88-.22-.87-.65-.87-.65.43-.65.96ZM55.71 374.94l-.41.21-.08-.33.56-.27h.35v2.27h-.41ZM56.88 376.24a.62.62 0 0 1 .42-.59.57.57 0 0 1-.34-.5.68.68 0 0 1 .76-.63c.49 0 .71.3.71.57a.56.56 0 0 1-.35.52.61.61 0 0 1 .43.57c0 .41-.34.68-.82.68s-.81-.3-.81-.62m1.2 0c0-.23-.17-.36-.43-.43a.41.41 0 0 0-.33.4.36.36 0 0 0 .38.37.35.35 0 0 0 .38-.36Zm-.71-1.1c0 .18.15.29.37.36a.38.38 0 0 0 .28-.35.3.3 0 0 0-.33-.32.3.3 0 0 0-.29.29ZM60.4 375.7c0 .73-.29 1.19-.83 1.19s-.8-.48-.81-1.17.3-1.18.84-1.18.8.46.8 1.16m-1.2 0c0 .56.15.84.38.84s.39-.3.39-.85-.13-.84-.39-.84-.39.27-.39.85ZM62.27 375.7c0 .73-.29 1.19-.83 1.19s-.81-.48-.81-1.17.3-1.18.83-1.18.81.46.81 1.16m-1.21 0c0 .56.15.84.39.84s.38-.3.38-.85-.12-.84-.38-.84-.39.27-.39.85"></path>
                </g>
              </g>
            </TooltipPComponent>
          </g>
          <g
            id="Transportadora"
            fill="none"
            stroke="#5e7076"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.73"
          >
            <path
              strokeDasharray="4.96 4.96"
              d="M425.21 520.3h245.6M178.21 520.06h245.6"
            ></path>
            <path
              strokeDasharray="4.07 4.07"
              d="M704.5 490.6v-6.1M704.5 497.55v-6.1M704.5 505v-6.1M704.5 512.37v-6.1M704.5 518.47v-6.1"
            ></path>
            <g id="LINE-63" data-name="LINE">
              <path d="M673.85 520.3h2.5"></path>
              <path strokeDasharray="4.07 4.07" d="M680.45 520.3h6.1"></path>
              <path d="M688.65 520.3h2.5"></path>
            </g>
            <g id="LINE-64" data-name="LINE">
              <path d="M694.27 520.3h2.5"></path>
              <path strokeDasharray="4.07 4.07" d="M699.87 520.3h6.1"></path>
            </g>
          </g>

          <g id="DOME">
            <g id="g1936">
              <path
                id="polygon1935"
                fill="#C3C3C3"
                d="m656.72 281.85-45.78 7.22 9.55-31.58z"
              ></path>
              <path
                id="path1935"
                fill="#397979"
                d="m678.49 277.24 34.64 23.91-44.19 6.77zm-.4-1.35-10.35 32.93 47.78-7.67Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1937">
              <path
                id="polygon1936"
                fill="#C3C3C3"
                d="m657.12 282.75-29.06 44.22-17.12-37z"
              ></path>
              <path
                id="path1936"
                fill="#397979"
                d="m713.93 303-27.87 42.86-17.12-36.1Zm1.59-1.36-47.78 7.67 17.92 38.35Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1938">
              <path
                id="polygon1937"
                fill="#C3C3C3"
                d="m610.14 290.43 17.12 36.99-36.23-6.77z"
              ></path>
              <path
                id="path1937"
                fill="#397979"
                d="m667.74 310.63 16.33 35.19-35-6.32 18.71-28.87m0-1.36-19.9 31.13 37.82 6.77Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1939">
              <path
                id="polygon1938"
                fill="#C3C3C3"
                d="m609.75 289.97-19.12 29.78.8-34.29z"
              ></path>
              <path
                id="path1938"
                fill="#397979"
                d="m649.43 305.21 17.12 4.51-17.92 28 .8-32.48m-.8-.9-.79 36.09 19.9-31.13Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1940">
              <path
                id="polygon1939"
                fill="#C3C3C3"
                d="m619.7 257.94-9.56 31.13-18.31-4.51z"
              ></path>
              <path
                id="path1939"
                fill="#397979"
                d="m676.5 278.6-9.16 29.32-17.11-4.51Zm1.59-2.71-29.46 28.42 19.11 5Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1941">
              <path
                id="polygon1940"
                fill="#C3C3C3"
                d="m657.92 283.21 29.06 44.21h-58.12z"
              ></path>
              <path
                id="path1940"
                fill="#397979"
                d="m715.52 303 28.26 43.31h-56.53zm0-1.36-29.86 45.57h59.72Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1942">
              <path
                id="polygon1941"
                fill="#C3C3C3"
                d="m694.15 257.04-36.23 24.81-36.23-24.81z"
              ></path>
              <path
                id="path1941"
                fill="#397979"
                d="m750.15 276.79-34.63 23.46-34.64-23.46zm2.79-.9h-74.85l37.43 25.71Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1943">
              <path
                id="polygon1942"
                fill="#C3C3C3"
                d="m657.92 240.8 35.43 15.34h-70.86z"
              ></path>
              <path
                id="path1942"
                fill="#397979"
                d="m715.52 260.55 33 14.44h-66.05l33-14.44m0-.9-37.43 16.24h74.85Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1944">
              <path
                id="polygon1943"
                fill="#C3C3C3"
                d="m695.34 257.49 9.56 31.58-45.79-7.22z"
              ></path>
              <path
                id="path1943"
                fill="#397979"
                d="m752.54 277.24 9.56 30.68-44.19-6.77zm.4-1.35-37.42 25.71 47.77 7.67Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1945">
              <path
                id="polygon1944"
                fill="#C3C3C3"
                d="m704.9 289.97-17.12 37-29.07-44.22z"
              ></path>
              <path
                id="path1944"
                fill="#397979"
                d="m717.11 303 44.59 7.22-16.7 35.6zm-1.59-1.36 29.86 45.57 17.91-38.35Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1946">
              <path
                id="polygon1945"
                fill="#C3C3C3"
                d="m724.8 320.65-36.23 6.77 17.12-36.99z"
              ></path>
              <path
                id="path1945"
                fill="#397979"
                d="m763.29 310.63 18.32 28.87-35 6.32 16.72-35.19m0-1.36-17.91 38.35 37.82-6.77Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1947">
              <path
                id="polygon1946"
                fill="#C3C3C3"
                d="m724.4 285.46.8 34.29-19.11-29.78z"
              ></path>
              <path
                id="path1946"
                fill="#397979"
                d="m781.61 305.21.79 32-17.91-27.52 17.12-4.51m.79-.9-19.11 5 19.91 31.12Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g id="g1948">
              <path
                id="polygon1947"
                fill="#C3C3C3"
                d="m724.01 284.56-18.32 4.51-9.55-31.13z"
              ></path>
              <path
                id="path1947"
                fill="#397979"
                d="m754.93 278.6 25.88 24.81-17.12 4.51zm-2-2.71 10.35 32.93 19.11-5Z"
                transform="translate(-57.6 -19.3)"
              ></path>
            </g>
            <g
              id="transportadora_generadora_a_100"
              fill="none"
              stroke="#5e7076"
              strokeDasharray="4.07 4.07"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.73"
            >
              <path d="M657.12 333.5v-6.1M771.63 355.27h6.1M759.34 355.27h6.1M657.12 340.45v-6.1M753.24 355.27h6.1M657.12 347.9v-6.1M657.12 355.27v-6.1M659.65 355.27h6.1M765.84 355.27h6.1M666.14 355.27h6.1M673.96 355.27h6.1M681.46 355.27h6.1M687.78 355.27h6.1M694.27 355.27h6.1M701.09 355.27h6.1M707.59 355.27h6.1M713.69 355.27h6.1M720.18 355.27h6.1M727.01 355.27h6.1M733.5 355.27h6.1M739.6 355.27h6.1M746.09 355.27h6.1"></path>
            </g>
            <g id="label_quebradora_100">
              <path d="M771.03 332.25a10 10 0 0 1-1-.34.4.4 0 0 0-.18 0 1.26 1.26 0 0 1-1.18-1.37 1.3 1.3 0 0 1 1.29-1.42 1.24 1.24 0 0 1 1.24 1.36 1.27 1.27 0 0 1-.69 1.25c.23.07.49.12.71.17Zm-.4-1.78c0-.52-.25-1-.74-1s-.75.47-.75 1 .27 1 .74 1 .75-.44.75-1M772.07 329.13v1.57c0 .52.21.77.55.77s.57-.24.57-.77v-1.57h.49v1.57c0 .83-.43 1.2-1.08 1.2s-1-.35-1-1.2v-1.54ZM775.75 330.63h-1v.79h1.14v.4h-1.63v-2.69h1.57v.4h-1.08v.7h1ZM776.3 329.16a4.5 4.5 0 0 1 .72 0 1.26 1.26 0 0 1 .77.17.56.56 0 0 1 .28.5.64.64 0 0 1-.45.59.67.67 0 0 1 .54.66.72.72 0 0 1-.25.56 1.58 1.58 0 0 1-1 .25 4 4 0 0 1-.6 0Zm.49 1.07h.25c.34 0 .53-.16.53-.39s-.19-.37-.5-.37a1.4 1.4 0 0 0-.28 0Zm0 1.23a1 1 0 0 0 .26 0c.31 0 .6-.12.6-.45s-.28-.44-.62-.44h-.24ZM778.6 329.16a5 5 0 0 1 .75 0 1.25 1.25 0 0 1 .83.21.69.69 0 0 1 .23.55.71.71 0 0 1-.49.67.67.67 0 0 1 .38.52 5 5 0 0 0 .21.75h-.5a3 3 0 0 1-.19-.63c-.07-.36-.2-.47-.48-.48h-.25v1.11h-.49Zm.49 1.19h.31c.34 0 .54-.17.54-.44s-.2-.43-.52-.43a2 2 0 0 0-.31 0ZM781.45 331.06l-.23.76h-.51l.86-2.69h.63l.88 2.69h-.53l-.25-.76Zm.77-.37-.21-.67c-.05-.16-.1-.35-.14-.5 0 .16-.08.34-.12.5l-.21.67ZM783.45 329.16a6 6 0 0 1 .79 0 1.6 1.6 0 0 1 1.09.31 1.18 1.18 0 0 1 .43 1 1.4 1.4 0 0 1-.42 1.07 1.83 1.83 0 0 1-1.22.37 5 5 0 0 1-.67 0Zm.49 2.29h.28a.93.93 0 0 0 1-1 .86.86 0 0 0-1-.94 1.5 1.5 0 0 0-.34 0ZM788.58 330.45a1.28 1.28 0 0 1-1.29 1.42 1.26 1.26 0 0 1-1.25-1.38 1.3 1.3 0 0 1 1.29-1.41 1.25 1.25 0 0 1 1.25 1.37m-2 0c0 .54.28 1 .75 1s.75-.44.75-1-.26-1-.75-1-.77.48-.77 1.04ZM789 329.16a5 5 0 0 1 .75 0 1.27 1.27 0 0 1 .83.21.69.69 0 0 1 .23.55.72.72 0 0 1-.49.67.66.66 0 0 1 .37.52 5 5 0 0 0 .22.75h-.51a4.4 4.4 0 0 1-.18-.63c-.08-.36-.2-.47-.48-.48h-.25v1.11H789Zm.49 1.19h.29c.33 0 .54-.17.54-.44s-.21-.43-.53-.43a2 2 0 0 0-.3 0ZM791.84 331.06l-.23.76h-.5l.86-2.69h.63l.87 2.69h-.53l-.24-.76Zm.78-.37-.21-.67c-.06-.16-.1-.35-.14-.5 0 .16-.08.34-.13.5l-.21.67ZM795.22 331.06l-.23.76h-.51l.86-2.69h.63l.87 2.69h-.52l-.25-.76Zm.77-.37-.21-.67c0-.16-.1-.35-.14-.5 0 .16-.08.34-.13.5l-.2.67ZM797.88 329.7l-.47.24-.09-.37.64-.32h.44v2.6h-.48ZM801.09 330.5c0 .84-.33 1.37-1 1.37s-.92-.55-.92-1.34.34-1.35.95-1.35.97.52.97 1.32m-1.38 0c0 .63.17 1 .44 1s.45-.35.45-1-.15-1-.44-1-.45.38-.45 1.03ZM803.23 330.5c0 .84-.32 1.37-1 1.37s-.91-.55-.92-1.34.35-1.35.95-1.35.97.52.97 1.32m-1.37 0c0 .63.17 1 .44 1s.44-.35.44-1-.14-1-.44-1-.44.38-.44 1.03Z"></path>
            </g>
            <g id="quebradora_a_100">
              <circle cx="774.38" cy="337.67" r="0.1" fill="#ebb24b"></circle>
              <circle cx="772.78" cy="338.67" r="0.1" fill="#ebb24b"></circle>
              <circle cx="768.68" cy="339.07" r="0.1" fill="#ebb24b"></circle>
              <circle cx="766.48" cy="342.27" r="0.1" fill="#ebb24b"></circle>
              <path
                fill="#397979"
                d="M775.18 344.28a.32.32 0 0 0 .3-.3v-1.28h-.4v1.3c-.1.18 0 .28.1.28"
              ></path>
              <path
                fill="#63afcf"
                d="m770.2 337.02.032-.197 5.332.852-.031.198zM768.688 338.987l4.188-.314.015.2-4.188.313z"
              ></path>
              <path
                fill="#63afcf"
                d="m766.25 342.26 2.42-3.434.163.116-2.42 3.432z"
              ></path>
              <TooltipGComponent
                nivel={gruasColors["GENERADORA100"]}
                datosProcesados={datosProcesados}
              >
                <g
                  onMouseDown={(e) => handGruasColor("GENERADORA100")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    id="maquina_generadora_100"
                    fill={gruasColors["GENERADORA100"].color}
                    d="M820.68 359.58h.4v-.3a.27.27 0 0 1 .3-.3h.5a.27.27 0 0 1 .3.3v.3h.4v1.1h.5v-.8a1 1 0 0 1 .5-.8l3.3-2.2.78-.53a.9.9 0 0 1 .87-.07l.65.3 2.6 1.2v-.7a.43.43 0 0 1 .4-.4h1.5a.43.43 0 0 1 .4.4l-.25 4.15a.91.91 0 0 1-.9.85.91.91 0 0 1-.9-.85l-.12-2.06a.9.9 0 0 0-.6-.79l-3.13-1.1-.4-.1-3.8 3.7.4 1.1h-4.6v-1.3a1 1 0 0 1 .9-1.1m12.8-2.2h-1.4v.7l.7.3h.5Z"
                    transform="translate(-57.6 -19.3)"
                  ></path>
                </g>
              </TooltipGComponent>
              <path
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m768.48 346.17 4.1 4M781.28 346.17l-4.1 4"
              ></path>
              <path
                fill="#397979"
                d="M770.08 346.77v-.89h1.6v.89M777.98 346.77v-.89h1.6v.89M772.28 346.77v-.89h1.4v.89M774.18 346.77v-.89h1.4v.89M776.08 346.77v-.89h1.4v.89"
              ></path>
              <path
                fill="none"
                stroke="#5e7076"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="m774.9 349.78-.03 2.51"
              ></path>
              <path
                fill="none"
                stroke="#5e7076"
                strokeDasharray="4.07 4.07"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.73"
                d="M779.64 343.31h6.1"
              ></path>
            </g>
          </g>


        </g>
      </BaseSvg>
    </div>
  );
}

export default Svg2Component;
